import type { SeedStore } from '../utils/storeSeed';

export const generatedScaleoStores: SeedStore[] = [
  {
    "id": "938",
    "name": "Compensair",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f08e3551daa.png",
    "description": "Reward rate $10 for a confirmed compensation application to Aer Lingus, Air Baltic, Air Serbia, Austrian Airlines, Brussels Airlines, Bulgaria Air, Easyjet, Eurowings, Finnair, Lot Polish Airlines, Lufthansa, Ryanair, Sc",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "937",
    "name": "GetTransfer.com",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f08aa9e85e9.png",
    "description": "Reward rate 20,83% of the order amount for the sale to the new customer who has not used Gettransfer before. If the new customer makes the next bookings in the next 270 days, the order will not be rewarded. 10,41% of the",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "936",
    "name": "Radical Storage",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f08a1cf0050.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web & app",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "935",
    "name": "TicketNetwork",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f0886c3527f.png",
    "description": "Reward rate 5% of the order amount for partners who qualify as ticket comparison sites. 10.41% for other parters. Partner reward is calculated based on the ticket price and not including price of services and extras. Coo",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "934",
    "name": "Aviasales",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f0879fa5e35.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web & app",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "933",
    "name": "Yesim",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f086e804399.png",
    "description": "Cookie lifetime 90 days Mobile tracking Mobile web & app",
    "promocodesCount": 0,
    "category": "Mobile Services & Telecommunications",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "932",
    "name": "Economybookings.com",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f064af9a5d3.png",
    "description": "60% of the revenue received by EconomyBookings from car rental providers (exluding any additional services such as insurance, second driver, cancellation protection, etc.). Commisison is approximately 4.58% of the bookin",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "931",
    "name": "intui.travel",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f064131c050.png",
    "description": "Cookie lifetime 35 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "930",
    "name": "EKTA",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f0622b164a4.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "929",
    "name": "WeGoTrip",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f060a577b58.png",
    "description": "Reward rate 34,58% commission for Custom On-demand Audio Tours powered by AI; 25% commission for Self-guided Audio Tours without tickets to museums 16,66% commision for Self-guided Audio Tours with included tickets to mu",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "928",
    "name": "BikesBooking.com",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f05febcff09.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "927",
    "name": "GetRentacar.com",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f05ebde63c5.png",
    "description": "Cookie lifetime 90 days Mobile tracking Mobile web & app",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "926",
    "name": "Kiwitaxi",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f05d35b78aa.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "925",
    "name": "AutoEurope (EU,UK)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f05c80c4baf.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "924",
    "name": "Airalo (WEB)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69f05bd6e3a15.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web & app",
    "promocodesCount": 0,
    "category": "Mobile Services & Telecommunications",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "923",
    "name": "QEEQ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef84f47a83b.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "922",
    "name": "AirHelp",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef83df74fae.png",
    "description": "Cookie lifetime 45 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "921",
    "name": "SEARADAR",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef804faab6d.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web only",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "920",
    "name": "Tiqets",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef7dbd198ca.png",
    "description": "Cookie lifetime 30 days Mobile tracking Mobile web & app",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "749",
    "name": "lk.sberhealth.ru (telemed)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png",
    "description": "Описание оффера СберЗдоровье – это быстрый и удобный online-сервис по подбору врачей для онлайн консультаций. Сервис СберЗдоровье (ранее - DocDoc) появился в декабре 2011 года в Москве. Портал оказывает услуги по подбору",
    "promocodesCount": 7,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "749-99184",
        "title": "Скидка 20% на заказ",
        "code": "ADV1AC9D4",
        "discount": "20%",
        "description": "Скидка 20% на любые анализы",
        "expiryDate": "2026-07-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2024-12-25",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      },
      {
        "id": "749-99002",
        "title": "Скидка 20% на любые анализы",
        "code": "ADV",
        "discount": "20%",
        "description": "Скидка 20% на сдачу анализов",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2024-12-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      },
      {
        "id": "749-121834",
        "title": "Скидка 35% на заказ",
        "code": "CAKE3235",
        "discount": "35%",
        "description": "Скидка 35% на одну любую онлайн-консультацию. Промокод вводится на сайте, после его применения цены автоматически изменятся.",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2026-02-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      },
      {
        "id": "749-28404",
        "title": "Скидка 20% на сдачу анализов",
        "code": "",
        "discount": "20%",
        "description": "Условия оффера:20% скидка на любые анализы, а также бесплатная расшифровка полученных результатов с врачом.Как сдать анализы:1. Скопируйте промокод и перейдите по ссылке https://lk.sberhealth.ru/laboratory-analyses на сайт СберЗдоровья2. Зарегистрируйте/Авторизуйтесь3. Выберите необходимые анализы и лабораторию4. Введите промокод5. Оформите заказ со скидкой",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2024-12-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      },
      {
        "id": "749-36956",
        "title": "Скидка 35% на онлайн-консультацию",
        "code": "",
        "discount": "35%",
        "description": "Скидка 35% на одну любую онлайн-консультацию. Промокод вводится на сайте, после его применения цены автоматически изменятся.",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2026-02-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      },
      {
        "id": "749-34328",
        "title": "-35% на одну любую онлайн-консультацию",
        "code": "",
        "discount": "35%",
        "description": "Скидка 35% на одну любую онлайн-консультацию. Промокод вводится на сайте, после его применения цены автоматически изменятся.",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2026-02-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      },
      {
        "id": "749-37943",
        "title": "Скидка 20% на любые анализы",
        "code": "",
        "discount": "20%",
        "description": "-20% на любые анализы, а также бесплатная расшифровка результатов с врачом. Действует для всех клиентов.",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=749&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce675c27.png"
      }
    ]
  },
  {
    "id": "748",
    "name": "zarina.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce2c56fa.png",
    "description": "Описание оффера ZARINA - первый российский фэшн-бренд с 30-летней историей. Бренд вдохновлен сильными и талантливыми женщинами, которые создали первую в России модную марку одежды. Сегодня ZARINA - это стильный капсульны",
    "promocodesCount": 4,
    "category": "Women's Apparel",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "748-38991",
        "title": "Скидка 20% на заказ",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на заказ.Суммируется с другими акциями.Не действует на лимитированные коллекции, коллаборации, Iconic и т.д.Без ограничения скидки.",
        "expiryDate": "2026-06-14",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=748&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce2c56fa.png"
      },
      {
        "id": "748-39064",
        "title": "Скидка 25% на брюки, джинсы, футболки",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% при покупке брюк, джинс, футболок.Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Действует на все товары, кроме лимитированных коллекций, коллабораций, Iconic и т.д. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=748&a=79",
        "isActive": true,
        "createdAt": "2026-05-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce2c56fa.png"
      },
      {
        "id": "748-39065",
        "title": "Скидка 25% на футболки, топы, шорты",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% при футболок, топов, шорт.Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Действует на все футболки, топы, шорты, кроме лимитированные коллекции, коллаборации, Iconic и т.д.Без ограничения скидки.",
        "expiryDate": "2026-05-27",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=748&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce2c56fa.png"
      },
      {
        "id": "748-39066",
        "title": "Скидка 25% на раздел Вечеринка",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% рублей при покупке товаров из раздела Вечеринка.Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Действует на все товары из раздела Вечеринка, кроме лимитированных коллекций, коллабораций, Iconic и т.д..Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=748&a=79",
        "isActive": true,
        "createdAt": "2026-05-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0ce2c56fa.png"
      }
    ]
  },
  {
    "id": "746",
    "name": "nonton.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cdbd71c9.png",
    "description": "Описание оффера «НОНТОН» — это не просто онлайн-гипермаркет мебели, это целая экосистема для создания идеального интерьера. Здесь вы найдете широкий выбор решений для оформления вашего пространства — от бюджетных до диза",
    "promocodesCount": 2,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "746-38452",
        "title": "Скидка 50%",
        "code": "",
        "discount": "50%",
        "description": "Скидка до 50% на кухниДля всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=746&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cdbd71c9.png"
      },
      {
        "id": "746-38785",
        "title": "Скидка 70%",
        "code": "",
        "discount": "70%",
        "description": "Скидка до 70%Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Не действует на выделенный список товаров.",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=746&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cdbd71c9.png"
      }
    ]
  },
  {
    "id": "744",
    "name": "pecom.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png",
    "description": "Описание оффера ПЭК — мультисервисный оператор логистических услуг, эксперт в сфере комплексных решений и организации грузоперевозок на территории России и за рубежом. Преимущества для покупателей Все акции на сайте http",
    "promocodesCount": 21,
    "category": "Business & Services",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "744-37474",
        "title": "Калькулятор доставки",
        "code": "",
        "discount": "Акция",
        "description": "Рассчитайте стоимость доставки по России и за рубеж",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-03-10",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38383",
        "title": "КАМЕННЫЙ ЦВЕТОК Акция на забор и доставку грузов в Екатеринбурге",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38382",
        "title": "АВТОЛАЙН Акция на перевозку автозапчастей и автоаксессуаров",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38374",
        "title": "ВОРОТА СИБИРИ Акция на перевозку грузов из Москвы в Омск",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38375",
        "title": "ЗА УРАЛОМ Акция на перевозку грузов из Москвы в Новосибирск",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38376",
        "title": "УРАЛЬСКАЯ МАГИСТРАЛЬ Акция на перевозку грузов из Москвы в Екатеринбург",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38391",
        "title": "БОНУСЫ ЗА РЕГИСТРАЦИЮ!",
        "code": "",
        "discount": "Акция",
        "description": "Новым участникам программы лояльности в рамках акции начислим 1000 приветственных баллов. Вместо обычных 200!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38377",
        "title": "ПУТЬ ЧЕМПИОНОВ Акция на перевозку спортивного оборудования, инвентаря и тренажеров",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38390",
        "title": "ТУРИЗМ И АЛЬПИНИЗМ Акция на перевозку туристического и альпинистского снаряжения, рыболовных товаров, чемоданов и рюкзаков",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38389",
        "title": "ДОМ ПОСТРОИТЬ Акция на перевозку строительных материалов",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38378",
        "title": "ТЕХНИЧНО НА ОТЛИЧНО! Акция на перевозку инструментов",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38379",
        "title": "УДАЧНЫЙ СЕЗОН Акция на перевозку саженцев и удобрений, грилей и мангалов, качелей и беседок",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38388",
        "title": "БИЗНЕС ТЕХ Акция на перевозку различных видов оборудования",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38387",
        "title": "МОТО Акция на перевозку мотоциклов и квадроциклов, самокатов и велосипедов, лодок",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38372",
        "title": "СИБИРСКАЯ ВЕСНА Акция на забор и доставку грузов в Омске",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38386",
        "title": "МЕДИКА Акция на перевозку медицинских товаров и санитарно-гигиенических средств",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38385",
        "title": "ВЕТЕР СЕВЕРНЫЙ Акция на перевозку грузов из Санкт-Петербурга в Москву",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38380",
        "title": "КОМФОРТ ПЛЮС Акция на перевозку мебели, дверей, каминов, картин и осветительных приборов",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38373",
        "title": "ДОРОГА МЕТАЛЛУРГА Акция на перевозку грузов из Москвы в Липецк",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38384",
        "title": "СЕРДЦЕ СИБИРИ Акция на забор и доставку грузов в Новосибирске",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары по направлению, участвующему в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      },
      {
        "id": "744-38381",
        "title": "В ТРЕНДЕ! Акция на перевозку одежды и обуви",
        "code": "",
        "discount": "Акция",
        "description": "Перевозите товары из списка наименований, участвующих в акции, и получайте дополнительный кешбэк баллами** в рамках программы лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ» Как получить кешбэк? Зарегистрируйтесь в программе лояльности «ПЭК: КИЛОМЕТРЫ ПРИВИЛЕГИЙ». После регистрации акция будет активирована автоматически. Оформите и оплатите услугу в период действия акции, при оформлении выберите услугу, участвующую в акции. При оплате назовите номер телефона участника программы лояльности – дополнительные баллы* у вас на счету!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=744&a=79",
        "isActive": true,
        "createdAt": "2026-04-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd46c2a9.png"
      }
    ]
  },
  {
    "id": "743",
    "name": "euro-diski.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd126d0b.png",
    "description": "Описание оффера Компания Euro-Diski с 2009 года успешно занимается продажей летних и зимних автомобильных шин, колесных дисков и мотошин в РФ. Преимущества для покупателей - Только прямые поставки. Мы работаем без посред",
    "promocodesCount": 2,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "743-37574",
        "title": "Скидка 50% на хранение шин",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% на хранение шин при покупке нового комплекта шин или дисков",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=743&a=79",
        "isActive": true,
        "createdAt": "2026-03-16",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd126d0b.png"
      },
      {
        "id": "743-37575",
        "title": "Бесплатный шиномонтаж",
        "code": "",
        "discount": "100%",
        "description": "Бесплатный шиномонтаж при покупке комплекта шин или дисков",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=743&a=79",
        "isActive": true,
        "createdAt": "2026-03-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cd126d0b.png"
      }
    ]
  },
  {
    "id": "742",
    "name": "360.yandex.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png",
    "description": "Описание оффера Яндекс 360 Премиум — набор сервисов для повседневных задач: Яндекс Диск (до 3 ТБ, безлимит для фото/видео с телефона), Почта (уникальный адрес, защита от спама), Телемост (видеозвонки без ограничений), За",
    "promocodesCount": 6,
    "category": "Компьютеры и интернет",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "742-127534",
        "title": "Скидка 35% на заказ",
        "code": "adv35s",
        "discount": "35%",
        "description": "Скидка 35% на тарифы 200 ГБ/1ТБ/3ТБ, Семейный 1 ТБ на месяц/год. Предложение доступно для всех, кроме пользователей с действующей Лицензией.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=742&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png"
      },
      {
        "id": "742-36021",
        "title": "Скидка 40% на годовые тарифы Яндекс 360",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на годовые тарифы 200 ГБ/1ТБ и Семейный 1 ТБ. Предложение доступно для всех, кроме пользователей с действующей Лицензией. Промокод чувствителен к регистру, просьба размещать в том виде, который добавлен в систему.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=742&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png"
      },
      {
        "id": "742-36016",
        "title": "Яндекс Диск со скидкой 35%",
        "code": "",
        "discount": "35%",
        "description": "Скидка 35% на тарифы 200 ГБ/1ТБ/3ТБ, Семейный 1 ТБ на месяц/год. Предложение доступно для всех, кроме пользователей с действующей Лицензией.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=742&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png"
      },
      {
        "id": "742-36017",
        "title": "Яндекс Диск - 1 ТБ со скидкой 20% на первые три месяца",
        "code": "",
        "discount": "20%",
        "description": "Тариф \"Для себя\" 1 ТБ со скидкой 20% на первые три месяца. Предложение доступно для всех, кроме пользователей с действующей Лицензией.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=742&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png"
      },
      {
        "id": "742-36018",
        "title": "Яндекс Диск - 1 ТБ со скидкой 16% на первые три месяца. Выгодное предложение для вашей Семьи!",
        "code": "",
        "discount": "16%",
        "description": "Тариф \"Для семьи\" 1 ТБ со скидкой 16% на первые три месяца. Предложение доступно для всех, кроме пользователей с действующей Лицензией.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=742&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png"
      },
      {
        "id": "742-36019",
        "title": "Яндекс Диск - 1 ТБ со скидкой до 50% на первые три месяца. Выгодное предложение для работы!",
        "code": "",
        "discount": "50%",
        "description": "Скидка до 50% на тариф \"Для работы\" 1 ТБ на первые три месяца. Предложение доступно для всех, кроме пользователей с действующей Лицензией.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=742&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc715f3a.png"
      }
    ]
  },
  {
    "id": "741",
    "name": "onliner.by",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ef0cc3712b8.png",
    "description": "Описание оффера Каталог Onlíner - это крупнейший маркетплейс Беларуси. Мы охватываем 2/3 всей интернет-аудитории страны. И даём возможность заказать 1 миллион товаров от 1500 интернет-магазинов. Умный выбор в каталоге: с",
    "promocodesCount": 0,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "740",
    "name": "Poison Drop",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69eb664ab8fa2.png",
    "description": "Poison Drop — это мультибрендовый универмаг дизайнерских украшений. В ассортименте представлено 100 брендов от мировых суперзвезд до нишевых марок. Основанный в 2013 году, Poison Drop вырос из небольшого шоу‑рума в масшт",
    "promocodesCount": 0,
    "category": "Подарочные сертификаты и карты",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "739",
    "name": "Whatnot Affiliates",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea2a533fcf4.png",
    "description": "Whatnot is a social marketplace where you can discover some of your favorite products like sports cards, sneakers, luxury handbags, women&#x27;s thrift, and Pokémon cards.",
    "promocodesCount": 0,
    "category": "E-commerce & Retail",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "738",
    "name": "Vidline Inc. - Creator",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea2c8c7dd69.png",
    "description": "Sider is an AI sidebar designed to enhance workflow with advanced AI tools like o1-preview, GPT-4o, Claude 3.5, and Gemini 1.5 Pro. It helps users search, read, and write efficiently, and was recognized as one of Chrome&",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "737",
    "name": "UniPin Affiliate Hub",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea2e010d7e2.png",
    "description": "UniPin Affiliate Hub",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "736",
    "name": "Thrifty Car Rental MX (MX, US & CA)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea2f8690dc5.png",
    "description": "Promote Thrifty Rent a Car&#x27;s affiliate program! Offer your audience the best deals and special offers on affordable, reliable car rentals worldwide. Earn commissions on confirmed bookings with top-tier customer serv",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "735",
    "name": "Talkpal - AI Language Learning",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea309250951.png",
    "description": "Talkpal is a language learning Web, iOS, and Android education app, powered by the latest AI technologies, that provides engaging experiences to its customers in 130+ different languages to help them improve their langua",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "734",
    "name": "SportsBreaks",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea32a120a44.png",
    "description": "SportsBreaks offers unforgettable sports travel experiences to many of the world&#x27;s top events including UK and European football, Formula 1 and many more!",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "733",
    "name": "Simply Sensitivity Checks UK",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea33fa2e231.png",
    "description": "Simply Sensitivity Checks have conducted thousands of food sensitivity tests across the world. We provide you with test results, that you can make positive changes to your lifestyle and start a journey to a happier and h",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "731",
    "name": "The Palace Company",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea372c88d07.png",
    "description": "Explore the ultimate collection of luxury resorts across Mexico and the Caribbean. At The Palace Company, gourmet dining, top-notch entertainment, and five-star service come together to create unforgettable stays for eve",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "730",
    "name": "Novakid TR",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea38128e41d.png",
    "description": "Kitlenizin çocuklarının İngilizce öğrenmesine yardım edip gerçek para kazanın. Ortağımız olarak, ebeveylerin çocuklarını kaydettireceği her deneme dersi için kazanç sağlayacaksınız. Novakid ortaklık programı hızlı, kolay",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "729",
    "name": "Novakid IL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea3b6902405.png",
    "description": "הקהל שלך ייקבל שיעורי אנגלית לילדים ואתה תוכל להרוויח כסף אמיתי. בתור שותף אתה תרוויח על כל שיעור ניסיון שהורים ישריינו עבור הילד שלהם. הצטרפות לתכנית שותפים של נובאקיד מהירה, קלה ולא עולה גרוש. הגש מועמדות עוד היום!",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "728",
    "name": "Novakid Global ARABIC",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea3c769e5ea.png",
    "description": "ساعد جمهورك على تطوير لغة أطفالهم الإنجليزية واكسب المال في نفس الوقت. سوف تحصل على عمولة على كل درس تجريبي يحجزه الوالدين لطفلهم. الانضمام إلى برنامج نوفاكيد للتسويق بالعمولة مجاني وسريع وسهل. سجل اليوم!",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "727",
    "name": "MFI Medical",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea3dbec026e.png",
    "description": "MFI Medical is an award-winning, customer service oriented company dedicated to offering high-quality products at affordable prices. MFI is a preferred trusted vendor of healthcare providers and more.",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "726",
    "name": "ManyChat",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea3ee27e471.png",
    "description": "ManyChat is the #1 bot platform for Facebook Messenger. We grew 500% over the last 12 months by helping 500,000 small businesses connect in real time at scale with millions of customers. Affiliates earn 100% of the first",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "725",
    "name": "Lenovo Colombia",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea40bb6ab95.png",
    "description": "Lenovo es líder global en tecnología innovadora para consumidores finales, para el sector comercial y para las empresas. Hoy, Lenovo ocupa la posición N°1 en PC, con una participación de mercado récord de casi 20%.",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "724",
    "name": "KKday Australia",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea41bde8a2d.png",
    "description": "Australian program for travel platform KKday offering 10,000+ experiences (admission tickets, transportation, outdoor hiking, cooking classes, day tours, spas, dining, etc.) around the world. We also offer local commodit",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "723",
    "name": "Joybuy",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea436c38f34.png",
    "description": "Joybuy is JD.com’s European full-category online retail brand designed to bring customers a faster, more convenient, and cost-effective shopping experience. Offering same-day and next-day delivery across the UK, Germany,",
    "promocodesCount": 0,
    "category": "E-commerce & Retail",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "722",
    "name": "iDefend",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea4535b1f74.png",
    "description": "Join us on our mission to defend children and families across America from the growing digital threats to their online safety, personal privacy, and mental well-being. Choose payouts that fit your style—one-time, monthly",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "721",
    "name": "Hotels VIVA ( GLOBAL )",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea46a450f3a.png",
    "description": "Join Hotels VIVA Affiliate Program: Promote 7 stunning Mallorca hotels in sought-after Balearic Islands. Modern, good facilities near the beach, in breathtaking island locations. Don&#x27;t miss the opportunity to partne",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "720",
    "name": "Modlily",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ea47fb867d5.png",
    "description": "We are an online store doing women&#x27;s clothing for global customers. We have 13 years of experience, and our customers are concentrated in the United States, Canada, Australia and the United Kingdom",
    "promocodesCount": 0,
    "category": "E-commerce & Retail",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "703",
    "name": "ZONE 51",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69cf71a367db4.png",
    "description": "ZONE 51 – это компьютерные кресла, столы, комплектующие, периферия и другие продукты, столь нужные современному человеку. Бренд ZONE 51 – результат работы профессионалов со всего мира, которые создавали и продавали компь",
    "promocodesCount": 2,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "703-132394",
        "title": "20% на все кресла, столы и девайсы ZONE 51 для всех на любой заказ",
        "code": "SALE01",
        "discount": "20%",
        "description": "20% на все кресла, столы и девайсы ZONE 51 для всех на любой заказ",
        "expiryDate": "2026-05-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=703&a=79",
        "isActive": true,
        "createdAt": "2026-04-27",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69cf71a367db4.png"
      },
      {
        "id": "703-37817",
        "title": "20% на все кресла, столы и девайсы ZONE 51",
        "code": "",
        "discount": "20%",
        "description": "20% на все кресла, столы и девайсы ZONE 51 для всех на любой заказ",
        "expiryDate": "2026-05-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=703&a=79",
        "isActive": true,
        "createdAt": "2026-04-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69cf71a367db4.png"
      }
    ]
  },
  {
    "id": "702",
    "name": "Дикси",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ce2629ca770.png",
    "description": "«Дикси» – один из крупнейших российских ретейлеров. Почти 30 лет, с 1992 года, компания занимается розничной торговлей продуктами питания и товарами повседневного спроса. Заслуженный обладатель наград \"\"Гарантия качества",
    "promocodesCount": 2,
    "category": "Потребительские товары",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "702-134531",
        "title": "Скидка до 17% при покупке от 1700 рублей",
        "code": "BLADV1900",
        "discount": "17%",
        "description": "Выгодная неделя покупок от 1700 рублей в Дикси! Чем больше покупаете в период акции, тем больше скидка: -7% на 1 покупку за период акции -10% на 2 покупку за период акции -14% на 3 покупку за период акции -17% на 4 покупку за период акции Скидка на заказ в мобильном приложении Дикси или на сайте dixy.ru, не действует на соцтовары, лотерейные билеты, алкогольную и табачную продукцию.",
        "expiryDate": "2026-05-22",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=702&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ce2629ca770.png"
      },
      {
        "id": "702-39021",
        "title": "Скидка до 17% при покупке от 1700 рублей",
        "code": "",
        "discount": "17%",
        "description": "Выгодная неделя покупок от 1700 рублей в Дикси!Чем больше покупаете в период акции, тем больше скидка:-7% на 1 покупку за период акции-10% на 2 покупку за период акции-14% на 3 покупку за период акции-17% на 4 покупку за период акцииСкидка на заказ в мобильном приложении Дикси или на сайте dixy.ru, не действует на соцтовары, лотерейные билеты, алкогольную и табачную продукцию.",
        "expiryDate": "2026-05-22",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=702&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69ce2629ca770.png"
      }
    ]
  },
  {
    "id": "696",
    "name": "Ясно",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69cceabeee385.png",
    "description": "Ясно — первый и самый крупный в России сервис онлайн-психотерапии, созданный психологами. С 2017 года нам доверились больше 360 000 клиентов. Сейчас на платформе 4400 специалистов — только 9% проходят строгий отбор. Сесс",
    "promocodesCount": 2,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "696-126898",
        "title": "​Скидка 20% на первую сессию",
        "code": "ADVCAKE20",
        "discount": "20%",
        "description": "Скидка 20% на первую сессию",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=696&a=79",
        "isActive": true,
        "createdAt": "2025-12-31",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69cceabeee385.png"
      },
      {
        "id": "696-35998",
        "title": "​Скидка 20% на первую сессию (о)",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на первую сессию",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=696&a=79",
        "isActive": true,
        "createdAt": "2025-12-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69cceabeee385.png"
      }
    ]
  },
  {
    "id": "695",
    "name": "REDMOND",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69b80e16c3e6c.png",
    "description": "РЕДМОНД — международный бренд-производитель бытовой техники и электроники российского происхождения. Создает мультифункциональные и умные устройства для кухни и дома, помогая автоматизировать повседневные задачи и упрост",
    "promocodesCount": 0,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "694",
    "name": "Леонардо",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69b7f54680fe4.png",
    "description": "«Леонардо» — крупнейшая в России сеть хобби-гипермаркетов в России, предлагающая свыше 60 000 товаров для творчества, рукоделия и искусства. Магазины подходят для профессионалов и новичков, предлагая материалы для вязани",
    "promocodesCount": 0,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "693",
    "name": "Много Мебели",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69b295c92c19b.png",
    "description": "Много Мебели — один из лидеров на рынке магазинов мягкой мебели в России. Производство и продажа без посредников, а это значит, цены от производителя и огромный выбор мебели! Доставка по всей РФ, рассрочка без переплат, ",
    "promocodesCount": 0,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "692",
    "name": "ПрезиДЕНТ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a58b1334511.png",
    "description": "ПрезиДЕНТ - одна из крупнейших медицинских организаций Москвы, объединяющая 39 стоматологических клиник, 4 медицинских центра и 3 зуботехнические лаборатории. Более 27 лет Ассоциация развивает современную стоматологию, д",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "691",
    "name": "FUNDAY",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a583df128ba.png",
    "description": "FUNDAY – это магазины яркой, доступной и практичной одежды для всей семьи! Первые магазины FUNDAY в России открыли свои двери в сентябре 2013 года. Сейчас FUNDAY – это уже 200 розничных магазинов и интернет–магазин. Мага",
    "promocodesCount": 0,
    "category": "Дом",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "690",
    "name": "Preply - Creator",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69823c39e6f26.png",
    "description": "We believe that learning a language with a great tutor is life-changing. That’s why Preply app matches online tutors from across the globe with learners. With over 30,000 tutors, everyone can find their perfect match. Wh",
    "promocodesCount": 0,
    "category": "Apps",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "686",
    "name": "Viju",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981ce9e1b68e.png",
    "description": "Viju — это онлайн-кинотеатр группы компаний Виасат, который предлагает доступ к тысячам фильмов и сериалов, а также популярным ТВ-каналам, известным и любимым миллионами россиян, таким как viju TV1000, viju+ megahit и vi",
    "promocodesCount": 3,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "686-126206",
        "title": "30 дней подписки бесплатно",
        "code": "PROMO30D",
        "discount": "Акция",
        "description": "30 дней подписки Viju бесплатно. Требуется указание данных банковской карты. Только для новых пользователей, ранее не имевших подписку или оформленный бесплатный период",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=686&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981ce9e1b68e.png"
      },
      {
        "id": "686-35982",
        "title": "30 дней подписки бесплатно на Viju",
        "code": "",
        "discount": "Акция",
        "description": "30 дней подписки Viju бесплатно. Требуется указание данных банковской карты. Только для новых пользователей, ранее не имевших подписку или оформленный бесплатный период",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=686&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981ce9e1b68e.png"
      },
      {
        "id": "686-37541",
        "title": "Полугодовая подписка на Viju за 999 руб.",
        "code": "",
        "discount": "999₽",
        "description": "Полугодовая подписка на Viju за 999 рублей.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=686&a=79",
        "isActive": true,
        "createdAt": "2026-03-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981ce9e1b68e.png"
      }
    ]
  },
  {
    "id": "685",
    "name": "Doctor Slon",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png",
    "description": "Doctor Slon — интернет-магазин, специализирующийся на продаже ирригаторов, зубных щёток и всех видов средств для ухода за полостью рта. Мы стараемся предложить нашим покупателям максимальный выбор продукции с лучшим соот",
    "promocodesCount": 7,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "685-132260",
        "title": "​Скидка 8% на все товары Revyline без ограничений",
        "code": "revylineds7",
        "discount": "8%",
        "description": "Скидка 8% на все товары Revyline без ограничений",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      },
      {
        "id": "685-134331",
        "title": "2=3 на товары для путешествий",
        "code": "ПОЛЕТ",
        "discount": "Акция",
        "description": "2=3 на товары для путешествий Собирайтесь в поездку с выгодой: добавьте три товара для путешествий — и получите один из них в подарок. Условия акции: 1. Акция 2=3 действует на товары из списка ниже 2. Добавьте 3 товара в корзину и введите промокод при оформлении заказа 3. Скидка применяется к наименьшему по стоимости товару.",
        "expiryDate": "2026-06-04",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      },
      {
        "id": "685-134574",
        "title": "10% скидка на первую покупку все товары от 15000",
        "code": "dctrslon10",
        "discount": "10%",
        "description": "Скидка 10% при покупке от 15000 рублей Для всех пользователей. Без ограничений на количество покупок",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-05-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      },
      {
        "id": "685-37657",
        "title": "​Скидка 8% на все товары Revyline без ограничений",
        "code": "",
        "discount": "8%",
        "description": "Скидка 8% на все товары Revyline без ограничений",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      },
      {
        "id": "685-37408",
        "title": "​Скидка 7% на все товары Revyline без ограничений",
        "code": "",
        "discount": "7%",
        "description": "Скидка 7% на все товары Revyline. Ирригаторы, зубные щётки, насадки и аксессуары для идеальной гигиены полости рта. Уход за улыбкой теперь ещё выгоднее.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      },
      {
        "id": "685-38797",
        "title": "2=3 на товары для путешествий",
        "code": "",
        "discount": "Акция",
        "description": "2=3 на товары для путешествийСобирайтесь в поездку с выгодой: добавьте три товара для путешествий — и получите один из них в подарок.Условия акции:1. Акция 2=3 действует на товары из списка ниже2. Добавьте 3 товара в корзину и введите промокод при оформлении заказа3. Скидка применяется к наименьшему по стоимости товару.",
        "expiryDate": "2026-06-04",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      },
      {
        "id": "685-39061",
        "title": "10% скидка на первую покупку все товары от 15000",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% при покупке от 15000 рублейДля всех пользователей.Без ограничений на количество покупок",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=685&a=79",
        "isActive": true,
        "createdAt": "2026-05-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6981c99356e78.png"
      }
    ]
  },
  {
    "id": "635",
    "name": "Joom",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6978cb720eb3b.png",
    "description": "Joom Marketplace helps consumers to make shopping easy and entertaining and gives access to high quality goods from around the world. More details about our company values and mission you may find on our official website",
    "promocodesCount": 0,
    "category": "Software",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "608",
    "name": "Brain.fm",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a7145fbeee2.png",
    "description": "Brain.fm provides human-made, scientifically-engineered music that combats distraction and enhances flow state instantly.",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "596",
    "name": "Сотка (средняя школа)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69709aba8e683.png",
    "description": "Сотка — одна из самых популярных онлайн-школ, которая помогает улучшить школьные оценки и подготовиться к ОГЭ. Резидент «Сколково» с лицензией от Минобрнауки России. - Более 80% наших учеников поднимают итоговые оценки д",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "596-18509",
        "title": "Всего от 3 990 ₽ за 4 предмета в месяц",
        "code": "",
        "discount": "990₽",
        "description": "Подготовка к ЕГЭ и ОГЭ 2026 с любого уровня на нужный балл всего от 3 990 ₽ за 4 предмета в месяц без доплат за 2-ой, 3-ий и 4-ый предмет!",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=596&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69709aba8e683.png"
      },
      {
        "id": "596-38825",
        "title": "2 месяца обучения без оплат!",
        "code": "",
        "discount": "Акция",
        "description": "Запишитесь на бесплатную проверку реального уровня знаний вашего ребенка и получите 2 месяца обучения без оплат!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=596&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69709aba8e683.png"
      }
    ]
  },
  {
    "id": "595",
    "name": "italki Global",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fccf010f8d.png",
    "description": "italki is a global language learning community that connects students and teachers for 1-on-1 online language lessons. We&#x27;re passionate about giving everyone the opportunity to learn languages, in the most personali",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "593",
    "name": "Oojo",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fca10612a2.png",
    "description": "Join the OOJO.com Affiliate Program & earn by promoting top airline tickets & exclusive travel deals with a wide selection of flights & destinations worldwide, you can help travelers find the best fares & enjoy seamless ",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "592",
    "name": "CreditVana",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc82887d74.png",
    "description": "CreditVana - 100% Free Credit Scores CreditVana https://creditvana.com Get your free credit score with CreditVana. Trusted by 1M+ users. Monitor daily, build credit, and save on loans. No fees, just results.",
    "promocodesCount": 0,
    "category": "Finance & Insurance",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "591",
    "name": "Keeprix",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc7482f451.png",
    "description": "Keeprix is an innovative platform offering comprehensive streaming download solutions to users worldwide. With cutting-edge technology, we simplify access to multimedia content for entertainment, creativity, and work.",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "590",
    "name": "WPS SOFTWARE PTE.LTD.",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc5b574a23.png",
    "description": "WPS Office is a leading global office suite that provides a free and efficient document processing solution. Fully compatible with Microsoft Office, it supports Windows, Mac, iOS, Android, and Linux, ensuring seamless pr",
    "promocodesCount": 0,
    "category": "Software",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "589",
    "name": "EssayDone - AI Writer & Humanizer",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc4b85d55a.png",
    "description": "EssayDone simplifies academic writing with one-click articles, auto-citations, PDF chat, and AI-safe text. Site: https://www.essaydone.ai Average order price: $20 Commission rate: 50%",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "588",
    "name": "ArkThinker",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc47cc8d92.png",
    "description": "ArkThinker is an international software company dedicated to providing leading PC and Internet applications to users worldwide. Join our partner program and monetize your referrals on a scale.",
    "promocodesCount": 0,
    "category": "Software",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "587",
    "name": "365 Financial Analyst",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc1fa0194f.png",
    "description": "The ultimate finance certification platform to enhance your career. Obtain the necessary skills, tools, and resources to become a certified financial analyst, investment banker, or investment analyst.",
    "promocodesCount": 0,
    "category": "Finance & Insurance",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "586",
    "name": "SafeShellVPN",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696fc13705578.png",
    "description": "Our App Mode enables the use of different apps in different regions at the same time, making it very easy to recommend. Enjoy higher conversion rates and commission rates than other VPNs, all backed by professionally des",
    "promocodesCount": 0,
    "category": "Software & Mobile Apps",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "585",
    "name": "GearUP",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696f98306280c.png",
    "description": "Want to get rid of high ping, packet loss, spikes, and jitters? Here we are! As your game network guardian, GearUP will never let a poor internet connection stop your thrill gaming.",
    "promocodesCount": 0,
    "category": "Gaming",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "584",
    "name": "BadCreditLoans.com",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696f93f5a19d6.png",
    "description": "BadCreditLoans.com connects consumers with direct lenders in minutes",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "583",
    "name": "Easyship Ambassador Program",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img696f90637c874.png",
    "description": "Easyship is an All in One Shipping Platform trusted by 100k+ businesses to enable cross border shipping; making it simpler, more cost-effective & seamless. Print labels, issue returns, share tracking info & automate taxe",
    "promocodesCount": 0,
    "category": "Business & Services",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "582",
    "name": "TVOЁ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930175b95392.png",
    "description": "TVOЁ — это новый онлайн-кинотеатр с мировыми премьерами фильмов и сериалов от ведущих студий, которые недоступны на других площадках России, где еженедельно выходят крутые новинки кино. Весь контент доступен в единой под",
    "promocodesCount": 4,
    "category": "Музыка и видео",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "582-128995",
        "title": "30 дней подписки за 1 рубль",
        "code": "TVOELV",
        "discount": "1₽",
        "description": "30 дней за 1 рубль, далее 399 рублей в месяц. Акция доступна только для новых пользователей. Подписку можно отменить в любой момент.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=582&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930175b95392.png"
      },
      {
        "id": "582-36205",
        "title": "7 дней пробной подписки на TVOЁ",
        "code": "",
        "discount": "Акция",
        "description": "Подключай пробную бесплатную подписку на 7 дней. Смотри самые горячие новинки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=582&a=79",
        "isActive": true,
        "createdAt": "2026-01-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930175b95392.png"
      },
      {
        "id": "582-36219",
        "title": "30 дней подписки за 1 рубль",
        "code": "",
        "discount": "1₽",
        "description": "30 дней за 1 рубль, далее 399 рублей в месяц. Акция доступна только для новых пользователей. Подписку можно отменить в любой момент.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=582&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930175b95392.png"
      },
      {
        "id": "582-37694",
        "title": "30 дней подписки за 1 рубль (б)",
        "code": "",
        "discount": "1₽",
        "description": "30 дней за 1 рубль, далее 399 рублей в месяц. Акция доступна только для новых пользователей. Подписку можно отменить в любой момент.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=582&a=79",
        "isActive": true,
        "createdAt": "2026-03-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930175b95392.png"
      }
    ]
  },
  {
    "id": "581",
    "name": "НАРХСИ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930116a71dc5.png",
    "description": "Национальный архитектурно-строительный институт (НАРХСИ) проводит дистанционное обучение для специалистов в области строительства, архитектуры и смежных отраслей. Мы предлагаем: - Профессиональную переподготовку для полу",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "581-36854",
        "title": "Скидка 5% на любую программу",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% для новых пользователей. Не суммируется c другими скидками, акциями и рассрочкой (исключение: акционная цена на сайте). Действует на все курсы.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=581&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6930116a71dc5.png"
      }
    ]
  },
  {
    "id": "579",
    "name": "Умскул.net",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69300859a4fe0.png",
    "description": "Онлайн-школа «Умскул» — один из лидеров онлайн-образования с 9-летним опытом подготовки к ЕГЭ и ОГЭ. 600 000+ учеников Умскул — самая крупная онлайн-школа по подготовке к ЕГЭ и ОГЭ 83,1 балла — Средний результат наших уч",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "579-38823",
        "title": "Набор на Легендарный курс «Предбанник»",
        "code": "",
        "discount": "100%",
        "description": "Повторение всего материала ЕГЭ и ОГЭ на интенсивном курсе «Предбанник» за 5-10 днейПредложения на этот период:- 4 предмета по цене 2!- Повтори 100% материала ЕГЭ/ОГЭ за 4-10 дней перед экзаменом!- Добавь до 20 баллов к своему результатуДоп. бонусы, которые идут с курсом Предбанник:БОНУС 1 - Разбор реальных заданий ЕГЭ/ОГЭ в день экзаменаБОНУС 2 - Помощь с апелляцией после экзаменовБОНУС 3 - От 1 до 6 мини-курсов от каждого преподавателя (в зависимости от предмета)БОНУС 4 - 5 доп. уроков по поступлению и подаче документов в вуз или колледжБОНУС 5 - Консультация по профориентации (только на тарифе ПРО)",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=579&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69300859a4fe0.png"
      }
    ]
  },
  {
    "id": "578",
    "name": "KOMUS",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img692ffe1e4248c.png",
    "description": "Компания Комус — один из лидеров российского рынка по продажам товаров для офиса и бизнеса. Снабжаем канцелярией, компьютерной техникой, продуктами и мебелью, обеспечиваем всем необходимым производственные площадки. Такж",
    "promocodesCount": 2,
    "category": "Продукты для офиса",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "578-131476",
        "title": "Подарок к первому заказу для юр.лиц",
        "code": "ПЕРВЫЙ",
        "discount": "000₽",
        "description": "Подарок за первый заказ для юр.лиц: От 5 000 ₽ — карта Комус 500 ₽ От 10 000 ₽ — карта Комус 1 000 ₽ От 15 000 ₽ — карта Комус 2 000 ₽ Только для онлайн-заказов юрлиц, ранее не совершавших заказов. Принять участие можно один раз. Не действует на личный заказ.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=578&a=79",
        "isActive": true,
        "createdAt": "2026-02-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img692ffe1e4248c.png"
      },
      {
        "id": "578-37200",
        "title": "Подарок за первый заказ для юр.лиц",
        "code": "",
        "discount": "000₽",
        "description": "Подарок за первый заказ для юр.лиц:От 5 000 ₽ — карта Комус 500 ₽От 10 000 ₽ — карта Комус 1 000 ₽От 15 000 ₽ — карта Комус 2 000 ₽Только для онлайн-заказов юрлиц, ранее не совершавших заказов. Принять участие можно один раз. Не действует на личный заказ.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=578&a=79",
        "isActive": true,
        "createdAt": "2026-02-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img692ffe1e4248c.png"
      }
    ]
  },
  {
    "id": "577",
    "name": "NIKIFILINI",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936a4b0bec94.png",
    "description": "NIKIFILINI — это динамично развивающийся бренд уличной одежды, вдохновленный японской аниме-культурой и современным streetwear. Мы создаем уникальные коллекции, сочетающие яркий дизайн, высокое качество и глубокие культу",
    "promocodesCount": 4,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "577-121777",
        "title": "Скидка 25% на заказ",
        "code": "skidka",
        "discount": "25%",
        "description": "Воспользуйтесь скидкой 25% на первую покупку и погрузитесь в мир уличной моды.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=577&a=79",
        "isActive": true,
        "createdAt": "2025-10-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936a4b0bec94.png"
      },
      {
        "id": "577-34264",
        "title": "Скидка 25% на одну покупку",
        "code": "",
        "discount": "25%",
        "description": "Воспользуйтесь скидкой 25% на первую покупку и погрузитесь в мир уличной моды.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=577&a=79",
        "isActive": true,
        "createdAt": "2025-10-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936a4b0bec94.png"
      },
      {
        "id": "577-34445",
        "title": "Скидки до 90%",
        "code": "",
        "discount": "90%",
        "description": "Скидки до 90% в разделе Sale.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=577&a=79",
        "isActive": true,
        "createdAt": "2025-10-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936a4b0bec94.png"
      },
      {
        "id": "577-37939",
        "title": "Все акции Nikifilini",
        "code": "",
        "discount": "Акция",
        "description": "На странице собраны все скидки и промокоды магазина. Выбирайте свой!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=577&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936a4b0bec94.png"
      }
    ]
  },
  {
    "id": "576",
    "name": "Happylook",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png",
    "description": "«Счастливый взгляд» – это федеральная сеть оптик, занимаем ~30% рынка Москвы и Санкт-Петербурга. Наши салоны находятся более чем в 50-ти городах России. У нас есть интернет-магазин с огромным ассортиментом оправ, солнцез",
    "promocodesCount": 31,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "576-121853",
        "title": "Купон на первый заказ",
        "code": "new500",
        "discount": "500₽",
        "description": "Купон на 500 ₽ на первый заказ в нашем интернет-магазине. Действует на корзину от 5000 руб. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-121889",
        "title": "Скидка 5% на контактные линзы",
        "code": "хэппилук26",
        "discount": "5%",
        "description": "Скидка 5% на контактные линзы в интернет-магазине. Не суммируется с действующими акциями и спецценами. Скидка не действует на: -ACUVUE® OASYS MAX 1-Day (30 шт.) -ACUVUE® OASYS MAX 1-Day MULTIFOCAL (30 шт.) -ACUVUE® OASYS with HYDRACLEAR PLUS® (6 шт.) -ACUVUE® OASYS with HYDRACLEAR PLUS® for Astigmatism (6 шт.) -ACUVUE® OASYS MULTIFOCAL (6 шт.)",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-121856",
        "title": "Скидка 5% на заказ",
        "code": "ONE_DAY",
        "discount": "5%",
        "description": "Скидка 5% на однодневные контактные линзы. Действует на все бренды кроме Acuvue. Если вас затрудняет выбор линз - можете записаться на бесплатную проверку зрения с подбором линз на нашем сайте!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-121855",
        "title": "Скидка 5% на заказ",
        "code": "ASTIGMATIC",
        "discount": "5%",
        "description": "Скидка 5% на астигматические контактные линзы. Действует на бренды Aculife и AIR OPTIX. Если вас затрудняет выбор линз - можете записаться на бесплатную проверку зрения с подбором линз на нашем сайте!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-121852",
        "title": "Купон на первый заказ",
        "code": "new700",
        "discount": "700₽",
        "description": "Купон на 700 ₽ на первый заказ в нашем интернет-магазине. Действует на корзину от 7000 руб. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-121854",
        "title": "Скидка 5% на заказ",
        "code": "MULTIFOCAL",
        "discount": "5%",
        "description": "Скидка 5% на мультифокальные контактные линзы. Действует на бренды Aculife, AIR OPTIX, DAILIES TOTAL. Если вас затрудняет выбор линз - можете записаться на бесплатную проверку зрения с подбором линз на нашем сайте!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-121851",
        "title": "Скидка 5% на заказ",
        "code": "COLOR",
        "discount": "5%",
        "description": "Скидка 5% на цветные и бьюти линзы. Действует только при заказе в нашем интернет-магазине.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-133283",
        "title": "Скидка 15% на заказ от 3000 руб.",
        "code": "ВЕСНА",
        "discount": "15%",
        "description": "Чтобы ею воспользоваться, положите в корзину контактные линзы, растворы или капли на сумму 3000 руб. и введите промокод.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-134311",
        "title": "Скидка до 10% на контактные линзы",
        "code": "ЗАПАС",
        "discount": "10%",
        "description": "Скидка 5% при покупке контактных линз, растворов и капель в нашем интернет-магазине при покупке на сумму от 4500 руб. Скидка 10% при покупке контактных линз, растворов и капель в нашем интернет-магазине при покупке на сумму от 9500 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-134313",
        "title": "Скидка до 25% на Aculife",
        "code": "ВЫГОДА",
        "discount": "25%",
        "description": "Используйте скидку 25% на линзы, растворы и капли Aculife с промокодом ВЫГОДА при оформлении заказа на сумму от 5000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34363",
        "title": "Бесплатная примерка очков при заказе онлайн.",
        "code": "",
        "discount": "Акция",
        "description": "Закажите очки или оправу на сайте - оплатите только те, что вам подошли! Оформляйте каждую модель отдельным заказом с самовывозом. Так скидка, действующая на сайте, сработает при выкупе товара.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34365",
        "title": "Купон на 700 ₽ на первый заказ в нашем интернет-магазине",
        "code": "",
        "discount": "700₽",
        "description": "Действует на корзину от 7000 руб. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34364",
        "title": "Покупайте в рассрочку при сумме заказа от 5000 ₽!",
        "code": "",
        "discount": "5000₽",
        "description": "Доступна рассрочка через Яндекс Сплит на 2, 4 и 6 месяцев. Рассрочка действует на оправы, корригирующие и солнцезащитные очки. Для оплаты выберите Сплит при оформлении.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34369",
        "title": "Скидка 5% на астигматические контактные линзы",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на астигматические контактные линзы. Действует на бренды Aculife и AIR OPTIX. Если вас затрудняет выбор линз - можете записаться на бесплатную проверку зрения с подбором линз на нашем сайте!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34360",
        "title": "Бесплатная проверка зрения",
        "code": "",
        "discount": "Акция",
        "description": "Бесплатная проверка зрения с подбором очков или контактных линз (18+) включает:• Сбор анамнеза и исследование на авторефрактометре.• Проверка вдаль и вблизи, выявление астигматизма и нарушений бинокулярного зрения.• Измерение межзрачкового расстояния.• Осмотр переднего отрезка глаза.• Рекомендации по типу очковых или контактных линз.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34362",
        "title": "1000 бонусов за подписку на рассылку",
        "code": "",
        "discount": "20%",
        "description": "В нашей рассылке только самые большие скидки и секретные акции!Бонусами можно оплатить часть суммы покупки:- 20% на корригирующие линзы для очков, оправы, солнцезащитные очки, аксессуары.- 10% на мягкие контактные линзы, растворы и капли.Бонусами нельзя оплатить услуги врача, мастера и покупку подарочных карт.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34388",
        "title": "Скидка 5% на контактные линзы для всех",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на контактные линзы в интернет-магазине. Не суммируется с действующими акциями и спецценами.Скидка не действует на:-ACUVUE® OASYS MAX 1-Day (30 шт.)-ACUVUE® OASYS MAX 1-Day MULTIFOCAL (30 шт.)-ACUVUE® OASYS with HYDRACLEAR PLUS® (6 шт.)-ACUVUE® OASYS with HYDRACLEAR PLUS® for Astigmatism (6 шт.)-ACUVUE® OASYS MULTIFOCAL (6 шт.)",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34366",
        "title": "Купон на 500 ₽ на первый заказ в нашем интернет-магазине",
        "code": "",
        "discount": "500₽",
        "description": "Действует на корзину от 5000 руб. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34367",
        "title": "Скидка 5% на цветные и бьюти линзы",
        "code": "",
        "discount": "5%",
        "description": "Действует только при заказе в нашем интернет-магазине.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34368",
        "title": "Скидка 5% на мультифокальные контактные линзы",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на мультифокальные контактные линзы. Действует на бренды Aculife, AIR OPTIX, DAILIES TOTAL. Если вас затрудняет выбор линз - можете записаться на бесплатную проверку зрения с подбором линз на нашем сайте!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-34370",
        "title": "Скидка 5% на однодневные контактные линзы",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на однодневные контактные линзы. Действует на все бренды кроме Acuvue. Если вас затрудняет выбор линз - можете записаться на бесплатную проверку зрения с подбором линз на нашем сайте!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2025-10-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-36731",
        "title": "Электронные подарочные сертификаты в продаже!",
        "code": "",
        "discount": "Акция",
        "description": "Теперь можно приобрести полезный подарок не выходя из дома. Выбирайте дизайн под событие, и идеальный подарок отправится получателю на почту или в смс в выбранное время. Номинал гибкий - подарок полностью настраиваете вы сами.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-02-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38008",
        "title": "Скидка 15% на первый заказ в интернет-магазине!",
        "code": "",
        "discount": "15%",
        "description": "Чтобы ею воспользоваться, положите в корзину контактные линзы, растворы или капли на сумму 3000 руб. и введите промокод.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38338",
        "title": "Очки для зрения по вашим параметрам от 2490 руб.",
        "code": "",
        "discount": "2490₽",
        "description": "Все включено: проверка зрения, оправа, очковые линзы, сборка, гарантия. Записывайтесь на бесплатную проверку зрения и мы изготовим для вас очки по фиксированной цене. Корригирующие очки под ключ за 2490, 3490, 4490, 5490 или 7490 рублей по акции «Выбери свой пакет». Акция «Выбери свой пакет» не суммируется с другими скидками и акциями сети. Пакетное предложение действует на определенный ассортимент акционных оправ и очковых линз",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-04-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38339",
        "title": "Закажите очки по вашим параметрам прямо на сайте с доставкой!",
        "code": "",
        "discount": "2500₽",
        "description": "Вы можете заказать очки на сайте по вашему рецепту по минимальной цене - от 2500 руб. Мы изготовим их и доставим в ближайший салон.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-04-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38699",
        "title": "Скидка до 10% на контактные линзы",
        "code": "",
        "discount": "10%",
        "description": "Скидка 5% при покупке контактных линз, растворов и капель в нашем интернет-магазине при покупке на сумму от 4500 руб. Скидка 10% при покупке контактных линз, растворов и капель в нашем интернет-магазине при покупке на сумму от 9500 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38706",
        "title": "Скидка –25% на японские однодневные линзы Miru",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% действует при покупке 4-х упаковок 1-Day Miru Menicon Flat Pack (30 линз). Акция действует в интернет-магазине, нужно положить необходимое количество товара в корзину",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38707",
        "title": "Скидка 50% на цветные линзы Adria",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% действует на вторую упаковку цветных контактных линз Adria. Просто положите товар в корзину – скидка применится автоматически.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38701",
        "title": "Скидка 15% на линзы Alcon",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на линзы-бестселлеры от Alcon – Dailies Total 1, Precission и Air Optix. Акция действует только при заказе в интернет-магазине.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-38702",
        "title": "Скидка до 25% на линзы, растворы и капли Aculife",
        "code": "",
        "discount": "25%",
        "description": "Используйте скидку 25% на линзы, растворы и капли Aculife с промокодом ВЫГОДА при оформлении заказа на сумму от 5000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      },
      {
        "id": "576-39027",
        "title": "Скидка 30% на все очки!",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на все очки. Для всех пользователей. Скидки уже на сайте!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=576&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6936aafe6cd53.png"
      }
    ]
  },
  {
    "id": "574",
    "name": "Samson-pharma",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png",
    "description": "Аптека Самсон-Фарма - сеть аптек низких цен с большим ассортиментом лекарственных средств и товаров для здоровья и красоты, была основана в 1993 году. Преимущества для покупателей: - Качество товара. - Бонусная программа",
    "promocodesCount": 12,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "574-38655",
        "title": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38664",
        "title": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38653",
        "title": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38654",
        "title": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38663",
        "title": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38656",
        "title": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38657",
        "title": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38658",
        "title": "Скидка 25% на список товаров Виши Део",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на список товаров Виши Део",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38659",
        "title": "Скидка 30% на список товаров Виши Капиталь Солей",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Капиталь Солей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38660",
        "title": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38661",
        "title": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      },
      {
        "id": "574-38662",
        "title": "Кешбэк 20% бонусную карту при покупке Рокс",
        "code": "",
        "discount": "20%",
        "description": "Кешбэк 20% бонусную карту при покупке Рокс",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=574&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69134c930aafc.png"
      }
    ]
  },
  {
    "id": "573",
    "name": "Stoletov",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png",
    "description": "«Доктор Столетов» – это аптеки с широким ассортиментом лекарственных средств, лечебной косметики, диетических и диабетических продуктов, витаминов и спортивного питания. Аптечная сеть «Доктор Столетов» входит в федеральн",
    "promocodesCount": 12,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "573-38641",
        "title": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38646",
        "title": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38638",
        "title": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38642",
        "title": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38645",
        "title": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38643",
        "title": "Скидка 25% на список товаров Виши Део",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на список товаров Виши Део",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38649",
        "title": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38648",
        "title": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38647",
        "title": "Кешбэк 20% бонусную карту при покупке Рокс",
        "code": "",
        "discount": "20%",
        "description": "Кешбэк 20% бонусную карту при покупке Рокс",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38639",
        "title": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38644",
        "title": "Скидка 30% на список товаров Виши Капиталь Солей",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Капиталь Солей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      },
      {
        "id": "573-38640",
        "title": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=573&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6913455c874eb.png"
      }
    ]
  },
  {
    "id": "572",
    "name": "Superapteka",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png",
    "description": "Superapteka — актуальные промокоды и предложения в категории здоровье и красота.",
    "promocodesCount": 12,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "572-38631",
        "title": "Скидка 25% на список товаров Виши Део",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на список товаров Виши Део",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38636",
        "title": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38637",
        "title": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38632",
        "title": "Скидка 30% на список товаров Виши Капиталь Солей",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Капиталь Солей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38635",
        "title": "Кешбэк 20% бонусную карту при покупке Рокс",
        "code": "",
        "discount": "20%",
        "description": "Кешбэк 20% бонусную карту при покупке Рокс",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38634",
        "title": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38626",
        "title": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38627",
        "title": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38628",
        "title": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38633",
        "title": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38629",
        "title": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      },
      {
        "id": "572-38630",
        "title": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=572&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img691341c72413f.png"
      }
    ]
  },
  {
    "id": "571",
    "name": "Ozerki",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png",
    "description": "Аптека Озерки - сеть аптек низких цен с большим ассортиментом лекарственных средств и товаров для здоровья и красоты, была основана в 1998 году. Преимущества для покупателей: - Качество товара. - Бонусная программа. - Уд",
    "promocodesCount": 12,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "571-38670",
        "title": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на список товаров Ля Рош-Позе Цикапласт",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38669",
        "title": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на гель Долгитблок 5%+3% туба 150г",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38668",
        "title": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Ля Рош-Позе Гиалу, Гидрафаз",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38672",
        "title": "Скидка 30% на список товаров Виши Капиталь Солей",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Капиталь Солей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38676",
        "title": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на 2-ую упаковку капли Валемидин 25мл",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38666",
        "title": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на список товаров Виши Минерал 89, Аквалия Термаль",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38677",
        "title": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке 2-х любых упаковок Постеризан",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38674",
        "title": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на Чай и Кофе \"Худеем за неделю\" из списка",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38673",
        "title": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Ля Рош-Позе Антгелиос",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38667",
        "title": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на список товаров Виши Лифтактив, Неовадиол",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38671",
        "title": "Скидка 25% на список товаров Виши Део",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на список товаров Виши Део",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      },
      {
        "id": "571-38675",
        "title": "Кешбэк 20% бонусную карту при покупке Рокс",
        "code": "",
        "discount": "20%",
        "description": "Кешбэк 20% бонусную карту при покупке Рокс",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=571&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69133da0adde1.png"
      }
    ]
  },
  {
    "id": "569",
    "name": "CapCut Affiliate Program",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6905d8b3850ff.png",
    "description": "The campaign allows you to earn commissions by referring customers to CapCut Pro through tracked affiliate links and creatives. Create fun and engaging content for CapCut Pro edit tools, templates or AI features. Start r",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "568",
    "name": "Preply Learners",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6905d21b72d7f.png",
    "description": "Preply is an online language learning platform with 32,000+ tutors teaching 50 languages in 180 countries. Personalized plans, interactive 1-on-1 lessons and test preparation for exams like IELTS and TOEFL available. Joi",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "567",
    "name": "AppSumo",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6905cbc231263.png",
    "description": "Founded in 2010, AppSumo is the software marketplace 1.25M+ entrepreneurs trust to grow their businesses. The platform offers high-value, low-cost deals on software and has helped launch thousands of top tools like Mailc",
    "promocodesCount": 0,
    "category": "Software",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "566",
    "name": "LingChat",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6902230eaee23.png",
    "description": "You’ve been learning a language for a while, but when it comes to speaking, you freeze up. Sound familiar? LingChat is here to break that barrier! The secret to fluency is simple: speaking.",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "565",
    "name": "Jackery FR",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img690220d305f13.png",
    "description": "Jackery a été fondée en 2012 par un groupe d&#x27;ingénieurs aventureux animés par leur passion de révolutionner l&#x27;électricité en la rendant portable, propre et accessible, tout en embrassant la vie en plein air.",
    "promocodesCount": 0,
    "category": "Consumer Electronics",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "564",
    "name": "Jackery NL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6901fb3dedc6c.png",
    "description": "Over Jackery Jackery werd in 2012 opgericht door een groep baanbrekende innovators op het gebied van batterijtechnologie met een gedurfde visie: hernieuwbare energie toegankelijk maken voor zowel woningen als buitenactiv",
    "promocodesCount": 0,
    "category": "Consumer Electronics",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "563",
    "name": "Jackery ES",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6901f73a022df.png",
    "description": "Jackery fue fundada en 2012 por un grupo de ingenieros aventureros impulsados por su pasión de revolucionar la electricidad haciéndola portátil, limpia y accesible, todo ello mientras abrazan la naturaleza al aire libre.",
    "promocodesCount": 0,
    "category": "Consumer Electronics",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "562",
    "name": "Jackery",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68e8f4b10289f.png",
    "description": "Jackery was founded in 2012 by a group of adventurous engineers who believe in making electricity portable, clean, outdoors-oriented, and accessible.",
    "promocodesCount": 0,
    "category": "Consumer Electronics",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "558",
    "name": "Снежная Королева",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbd32b9ad59.png",
    "description": "«Снежная Королева» — российский бренд модной одежды, который более 26ти лет предлагает своим покупателям широкий ассортимент верхней и повседневной одежды, а также аксессуаров для женщин и мужчин. «Снежная Королева» - эт",
    "promocodesCount": 2,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "558-39051",
        "title": "Скидка до 85% на заказ",
        "code": "",
        "discount": "85%",
        "description": "Распродажа в Снежной Королеве! Скидка до 85% на товары из подборки.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=558&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbd32b9ad59.png"
      },
      {
        "id": "558-39052",
        "title": "Скидка 5% на заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% при оплате онлайн картой или по СБП",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=558&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbd32b9ad59.png"
      }
    ]
  },
  {
    "id": "557",
    "name": "МАСХ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbcf696caaa.png",
    "description": "Московская Академия Сельского Хозяйства (МАСХ) обучает дистанционно профессиям в сфере сельского хозяйства. Все курсы имеют практическую направленность, включают общение с преподавателями и единомышленниками, онлайн-веби",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "557-121654",
        "title": "Скидка 5% по промокоду",
        "code": "Cake5",
        "discount": "5%",
        "description": "- Скидка 5% для новых пользователей - Не суммируется c другими скидками, акциями и рассрочкой. Исключение: акционная цена на сайте. - Действует на все курсы",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=557&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbcf696caaa.png"
      },
      {
        "id": "557-34147",
        "title": "Скидка 5% по промокоду",
        "code": "",
        "discount": "5%",
        "description": "- Скидка 5% для новых пользователей- Не суммируется c другими скидками, акциями и рассрочкой. Исключение: акционная цена на сайте.- Действует на все курсы",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=557&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbcf696caaa.png"
      }
    ]
  },
  {
    "id": "555",
    "name": "TeachMeSkills (BY)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbb0b448aeb.png",
    "description": "TeachMeSkills - это школа программирования, где мы научим тебя востребованным сегодня знаниям. Все наши программы составлены Senior и Lead разработчиками ведущих IT компаний специально для новичков в IT. Преимущества для",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "555-133306",
        "title": "Скидка 10% на обучение",
        "code": "adv10",
        "discount": "10%",
        "description": "Скидка до 10% на весь курс и оплата со второго месяца обучения.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=555&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbb0b448aeb.png"
      },
      {
        "id": "555-38052",
        "title": "Весеннее обновление с teachmeskills. Скидка 10%.",
        "code": "",
        "discount": "10%",
        "description": "Скидка до 10% на весь курс и оплата со второго месяца обучения.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=555&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dbb0b448aeb.png"
      }
    ]
  },
  {
    "id": "554",
    "name": "TeachMeSkills",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba98a8b28f.png",
    "description": "IT-школа TeachMeSkills — это новое и свежее дыхание в обучении программированию. Здесь нет места скучным лекциям, нудному объяснению материала и постоянным заучиваниям. Неформальная атмосфера, молодые и талантливые менто",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "554-133299",
        "title": "Скидка 10% на обучение",
        "code": "adv10",
        "discount": "10%",
        "description": "Скидка до 10% на весь курс и оплата со второго месяца обучения.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=554&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba98a8b28f.png"
      },
      {
        "id": "554-38049",
        "title": "Весеннее обновление с teachmeskills. Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка до 10% на весь курс и оплата со второго месяца обучения.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=554&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba98a8b28f.png"
      }
    ]
  },
  {
    "id": "553",
    "name": "POMPA",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png",
    "description": "POMPA – бренд женской одежды с собственным производством в Санкт-Петербурге, представленный на рынке более 27 лет. Мы предлагаем своим клиентам сформированные капсулы: от повседневной одежды до деловых образов. Коллекции",
    "promocodesCount": 12,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "553-127642",
        "title": "Скидка 10% на заказ",
        "code": "SALE03",
        "discount": "10%",
        "description": "Скидка 10% на новинки (товары по полной цене).",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2026-02-24",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-33472",
        "title": "Новая осенняя коллекция Осень 2025 MINIMALISM ART",
        "code": "",
        "discount": "Акция",
        "description": "Новая осенняя коллекция Осень 2025 MINIMALISM ART",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-09-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-33471",
        "title": "Новая коллекция осень 2025 GRUNGE MOOD",
        "code": "",
        "discount": "Акция",
        "description": "Новая коллекция осень 2025 GRUNGE MOOD",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-09-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-33469",
        "title": "7 SILK ROAD",
        "code": "",
        "discount": "Акция",
        "description": "Обновление новой коллекции 7 SILK ROAD",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-09-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-33561",
        "title": "Раздел SALE",
        "code": "",
        "discount": "40%",
        "description": "Новая линейка, скидки до 40%",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-09-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-33653",
        "title": "Линейка PREMIUM",
        "code": "",
        "discount": "Акция",
        "description": "Новая линейка PREMIUM, успей купить",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-09-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-34050",
        "title": "Линейка AMBITION",
        "code": "",
        "discount": "Акция",
        "description": "Новая линейка AMBITION. Успейте купить!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-10-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-34760",
        "title": "Новая коллекция - Lotus Garden",
        "code": "",
        "discount": "Акция",
        "description": "Новая коллекция - Lotus Garden",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2025-11-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-36040",
        "title": "Скидка 10% на новинки новым клиентам на первую покупку",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на новинки новым клиентам на первую покупку",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2026-02-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-37457",
        "title": "Новинки весны! Новинки женской одежды",
        "code": "",
        "discount": "Акция",
        "description": "Новинки весны! Новинки женской одежды",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-37563",
        "title": "Новая коллекция ВЕСНА 2026",
        "code": "",
        "discount": "Акция",
        "description": "Новая коллекция ВЕСНА 2026",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2026-03-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      },
      {
        "id": "553-39032",
        "title": "Новая коллекция. Плащи. Скидки до 50% на хиты",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% Для всех пользователей. Без ограничений на количество покупок",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=553&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68dba4c1f03cc.png"
      }
    ]
  },
  {
    "id": "552",
    "name": "Sider",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68da9c3e72770.png",
    "description": "Promote one of the fastest-growing productivity tools on the market. With over 10 million active users weekly , Sider is redefining how people work with AI. Now you can be part of this success — and earn while you do it.",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "551",
    "name": "Bongacams PerSignup + RevShare",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68da6f9ac3ce4.png",
    "description": "BongaCams is a fast-growing webcam site with some of the world's most beautiful models. BongaCams lets members watch and interact with thousands of webcam girls around the world. With the best converting models online, B",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "550",
    "name": "DeWALT",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png",
    "description": "Официальный интернет-магазин DeWALT DeWALT — американский бренд инновационных высокотехнологичных электроинструментов, оснастки, принадлежностей, одежды для строительства, производства и деревообрабатывающей промышленнос",
    "promocodesCount": 16,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "550-128197",
        "title": "Скидка 10% на заказ",
        "code": "DEW5",
        "discount": "10%",
        "description": "Скидка 10% на все кроме сертификатов и предзаказа",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-01-13",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-134518",
        "title": "Скидка 15%",
        "code": "DWMAY15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-134519",
        "title": "Скидка 20%",
        "code": "DWMAY20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-134586",
        "title": "15%",
        "code": "MAYFDW15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-134587",
        "title": "20%",
        "code": "MAYFDW20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-36128",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все кроме сертификатов и предзаказа",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-01-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-38257",
        "title": "Весенняя распродажа (баннеры)",
        "code": "",
        "discount": "Акция",
        "description": "Весенняя распродажа в DeWalt!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-04-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-38906",
        "title": "Сертификаты DeWalt",
        "code": "",
        "discount": "Акция",
        "description": "С DEWALT делать подарки просто!1. Подберите дизайн подарочного сертификата 2. Выберите номинал сертификата или введите свой3. Отправьте сразу или запланируйте время отправкиЛегко использовать1. Добавьте в корзину нужные вам товары и начните оформление заказа2. Введите в поле «Сертификат или купон» в Корзине промо-код, указанный в сертификате3. Номинал сертификата будет вычтен из суммы вашего заказа",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-38905",
        "title": "Скидка до 17%",
        "code": "",
        "discount": "17%",
        "description": "Предложение мая:1. Выберите размер скидки (13%/15%/17%)2. Добавьте товар в корзину3. Дополнительная скидка применится автоматически",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-38907",
        "title": "Подарок при покупке от 5000 рублей",
        "code": "",
        "discount": "5000₽",
        "description": "Получите подарок при покупке от 5000 рублей!1. Соберите корзину на сумму от 5 000 рублей2. Выберите один товар из подборки в качестве подарка",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-38996",
        "title": "Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-38995",
        "title": "Скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-39081",
        "title": "Скидка 20% - распродажа",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-39080",
        "title": "Скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-134586",
        "title": "0.15",
        "code": "MAYFDW15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      },
      {
        "id": "550-134587",
        "title": "0.2",
        "code": "MAYFDW20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=550&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67d6b4f24d.png"
      }
    ]
  },
  {
    "id": "549",
    "name": "Hansgrohe",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png",
    "description": "Официальный интернет-магазин hansgrohe hansgrohe - немецкий производитель продукции премиум-класса для душа, ванны и кухни. Компания была основана в 1901 году и является одним из крупнейших в мире поставщиков сантехники.",
    "promocodesCount": 15,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "549-128206",
        "title": "Скидка 10% на заказ",
        "code": "HGE10",
        "discount": "10%",
        "description": "Скидка 10% на все кроме сертификатов и предзаказа",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-01-13",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-134520",
        "title": "Скидка 10%",
        "code": "HGMAY15",
        "discount": "10%",
        "description": "Скидка 10% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-134521",
        "title": "Скидка 20%",
        "code": "HGMAY20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-134588",
        "title": "15%",
        "code": "HGFMAY15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-134589",
        "title": "20%",
        "code": "HGFMAY20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-36130",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все кроме сертификатов и предзаказа",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-01-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-38265",
        "title": "Весенняя распродажа (баннеры)",
        "code": "",
        "discount": "Акция",
        "description": "Весенняя распродажа Hansgrohe",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-04-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-38908",
        "title": "Сертификаты Hansgrohe",
        "code": "",
        "discount": "Акция",
        "description": "С Hansgrohe делать подарки просто!1. Подберите дизайн подарочного сертификата2. Выберите номинал сертификата или введите свой3. Отправьте сразу или запланируйте время отправкиЛегко использовать1. Добавьте в корзину нужные вам товары и начните оформление заказа2. Введите в поле «Сертификат или купон» в Корзине промо-код, указанный в сертификате3. Номинал сертификата будет вычтен из суммы вашего заказа",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-38909",
        "title": "Уцененные товары с гарантией",
        "code": "",
        "discount": "72%",
        "description": "Уцененные товары с гарантией: скидки до 72%Обратите внимание:Причина уценки всегда указана в карточке товара.На товары данной категории не распространяется действие промокодов и других предложений.На товары данной категории действуют особые условия:Возврат в течение 7 днейГарантия: 30 днейИспользуйте возможность приобрести премиальную сантехнику по выгодной стоимости!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-38998",
        "title": "Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-38997",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-39082",
        "title": "Скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-39083",
        "title": "Скидка 20% - распродажа",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-134588",
        "title": "0.15",
        "code": "HGFMAY15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      },
      {
        "id": "549-134589",
        "title": "0.2",
        "code": "HGFMAY20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=549&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d67a07d6759.png"
      }
    ]
  },
  {
    "id": "548",
    "name": "GROHE",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png",
    "description": "Официальный интернет-магазин GROHE Стильные и высокотехнологичные смесители, душевые гарнитуры, системы инсталляции, аксессуары и другие продукты GROHE. Официальные поставки, сертифицированная продукция. С доставкой по в",
    "promocodesCount": 15,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "548-128196",
        "title": "Скидка 10% на заказ",
        "code": "GRH10",
        "discount": "10%",
        "description": "Скидка 10% на все кроме сертификатов и предзаказа.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-01-13",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-134516",
        "title": "Скидка 15%",
        "code": "GROHEMAY15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-134517",
        "title": "Скидка 20%",
        "code": "GROHEMAY20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-134584",
        "title": "15%",
        "code": "GRMAYF15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-134585",
        "title": "20%",
        "code": "GRMAYF20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-36127",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все кроме сертификатов и предзаказа.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-01-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-38262",
        "title": "Весенняя распродажа (баннеры)",
        "code": "",
        "discount": "Акция",
        "description": "Весенняя распродажа Grohe",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-04-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-38910",
        "title": "Сертификаты GROHE",
        "code": "",
        "discount": "Акция",
        "description": "С GROHE делать подарки просто!Остаток средств останется на счету сертификатаГод, чтобы активировать и три года, чтобы воспользоватьсяОтправьте сразу или запланируйте время отправки",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-38911",
        "title": "Скидка 15% на внешние душевые системы",
        "code": "",
        "discount": "15%",
        "description": "Дарим скидку 15% на внешние душевые системыДобавьте товар в корзину и дополнительная скидка -15% применится автоматически",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-38994",
        "title": "Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-38993",
        "title": "Скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-39079",
        "title": "Скидка 20% - распродажа",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-39078",
        "title": "Скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей.Для всех клиентов.Действует без ограничений на количество покупок.Не суммируется с другими акциями и промокодами.Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-134584",
        "title": "0.15",
        "code": "GRMAYF15",
        "discount": "15%",
        "description": "Скидка 15% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары, кроме подарочных сертификатов, наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      },
      {
        "id": "548-134585",
        "title": "0.2",
        "code": "GRMAYF20",
        "discount": "20%",
        "description": "Скидка 20% при покупке от 0 рублей. Для всех клиентов. Действует без ограничений на количество покупок. Не суммируется с другими акциями и промокодами. Действует на все товары из категории Распродажа, кроме наборов и товаров из предзаказа. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=548&a=79",
        "isActive": true,
        "createdAt": "2026-05-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68d6755a79894.png"
      }
    ]
  },
  {
    "id": "545",
    "name": "ЦВЕТ ДИВАНОВ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68bebb26c2b50.png",
    "description": "Цвет Диванов - одна из крупнейших сетей по продаже мягкой и корпусной мебели. Уже более 20 лет компания Цвет Диванов разрабатывает и производит мебель для дома, многие наши модели сегодня являются хитами продаж. Ежегодно",
    "promocodesCount": 0,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "543",
    "name": "Стимголд",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be92a722cbd.png",
    "description": "Стимголд предоставляет пользователям возможность легко и безопасно пополнить свои аккаунты в Стиме. Мы гарантируем мгновенное пополнение и высокий уровень безопасности, поскольку все операции проходят через защищенные се",
    "promocodesCount": 4,
    "category": "Игры",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "543-118827",
        "title": "Скидка 3% на заказ",
        "code": "BONUS3",
        "discount": "3%",
        "description": "Скидка 3% на комиссию при пополнении Steam",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=543&a=79",
        "isActive": true,
        "createdAt": "2025-07-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be92a722cbd.png"
      },
      {
        "id": "543-118826",
        "title": "Скидка 3% на заказ",
        "code": "STEAMGOLD",
        "discount": "3%",
        "description": "Скидка 3% на комиссию при пополнении Steam",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=543&a=79",
        "isActive": true,
        "createdAt": "2025-07-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be92a722cbd.png"
      },
      {
        "id": "543-118828",
        "title": "Скидка 3% на заказ",
        "code": "SALE3",
        "discount": "3%",
        "description": "Скидка 3% на комиссию при пополнении Steam",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=543&a=79",
        "isActive": true,
        "createdAt": "2025-07-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be92a722cbd.png"
      },
      {
        "id": "543-32093",
        "title": "Скидка 3% на комиссию при пополнении Steam",
        "code": "",
        "discount": "3%",
        "description": "Скидка 3% на комиссию при пополнении Steam по промокоду.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=543&a=79",
        "isActive": true,
        "createdAt": "2025-07-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be92a722cbd.png"
      }
    ]
  },
  {
    "id": "542",
    "name": "GroupPrice",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be8813d25dc.png",
    "description": "GroupPrice — это большой выбор качественной, стильной и доступной одежды от российских и белорусских производителей. Мы работаем с 2011 года. За это время мы наладили тесный контакт со многими российскими и белорусскими ",
    "promocodesCount": 2,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "542-130599",
        "title": "Скидка 5% на заказ",
        "code": "ОНЛАЙН5",
        "discount": "5%",
        "description": "Скидка -5% на товары при онлайн оплате на сайте. Условия применения: Перейти на страницу https://groupprice.ru/profile/promocodes При онлайн оплате на сайте. Многократное использование в период действия.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=542&a=79",
        "isActive": true,
        "createdAt": "2026-02-05",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be8813d25dc.png"
      },
      {
        "id": "542-36751",
        "title": "​Скидка -5% на товары при онлайн оплате",
        "code": "",
        "discount": "5%",
        "description": "Скидка -5% на товары при онлайн оплате на сайте. Условия применения:Перейти на страницу https://groupprice.ru/profile/promocodesПри онлайн оплате на сайте.Многократное использование в период действия.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=542&a=79",
        "isActive": true,
        "createdAt": "2026-02-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68be8813d25dc.png"
      }
    ]
  },
  {
    "id": "540",
    "name": "Onlineschool-1",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b717217b90d.png",
    "description": "Онлайн школа с 1 по 11 класс Преимущества для покупателей: - Одна из ведущих онлайн-школ России, которая даёт полноценное обучение с 1 по 11 класс. - Живые уроки в мини-классах - Аттестат государственного образца - От 2-",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "540-38553",
        "title": "Пробная неделя обучение",
        "code": "",
        "discount": "Акция",
        "description": "Попробуйте неделю бесплатно!Начните учиться уже сегодня и оцените возможности и преимущества онлайн-обучения!",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=540&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b717217b90d.png"
      }
    ]
  },
  {
    "id": "539",
    "name": "АКВАФОР",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png",
    "description": "АКВАФОР — бренд водоочистителей №1 в России. Уже более 30 лет производим качественные и технологичные фильтры для воды, помогая миллионам семей вести здоровую и полноценную жизнь. В собственных лабораториях компании осущ",
    "promocodesCount": 6,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "539-38687",
        "title": "Комплекты В200 и В200 для жесткой воды. Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20%Для всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=539&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png"
      },
      {
        "id": "539-38686",
        "title": "Модерн исп.1, исп.4 насадка на кран. Скидка 21%",
        "code": "",
        "discount": "21%",
        "description": "Скидка 21%Для всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=539&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png"
      },
      {
        "id": "539-38689",
        "title": "Кристалл H. Снижает избыточную жесткость воды. Скидка 40%",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40%Для всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=539&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png"
      },
      {
        "id": "539-38690",
        "title": "Викинг Pro. Предварительная очистка холодной воды. Скидка 31%",
        "code": "",
        "discount": "31%",
        "description": "Скидка 31%Для всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=539&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png"
      },
      {
        "id": "539-38688",
        "title": "Модуль сменный фильтрующий А5 (4 шт). Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10%Для всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=539&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png"
      },
      {
        "id": "539-38684",
        "title": "Кувшин Инди. Скидка 18%",
        "code": "",
        "discount": "18%",
        "description": "Скидка 18%Для всех пользователей.Без ограничений на количество покупок.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=539&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b70843b007c.png"
      }
    ]
  },
  {
    "id": "538",
    "name": "МИПО",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b701db1d74d.png",
    "description": "Московский институт профессионального образования – институт, нацеленный на предоставление самых актуальных знаний, которые будут полезны как практикующим специалистам, так и тем, кто делает первые шаги в профессии. Для ",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "538-118082",
        "title": "Скидка 10% на заказ",
        "code": "MIPO_10",
        "discount": "10%",
        "description": "Скидка 10% от цены на сайте, не суммируется с другими акциями",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=538&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b701db1d74d.png"
      },
      {
        "id": "538-32012",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% от цены на сайте, не суммируется с другими акциями",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=538&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b701db1d74d.png"
      },
      {
        "id": "538-38548",
        "title": "Весенняя распродажа со скидкой 30%",
        "code": "",
        "discount": "30%",
        "description": "Московский диплом + курс в подарок от МИПО!Получите курс в подарок + выгоду до 30% с возможностью отложенного обучения!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=538&a=79",
        "isActive": true,
        "createdAt": "2026-04-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b701db1d74d.png"
      }
    ]
  },
  {
    "id": "536",
    "name": "Fitomarket",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png",
    "description": "Fitomarket.ru — маркетплейс товаров для красоты и здоровья от «Эвалар». На площадке больше 10 000 сертифицированных товаров с документами, подтверждающие их безопасность: витамины и БАД суперфуды, косметика, ЗОЖ-питания,",
    "promocodesCount": 16,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "536-122071",
        "title": "Скидка 10% на заказ",
        "code": "gift",
        "discount": "10%",
        "description": "Скидка по промокоду 10% на один заказ до 20 000 ₽. Скидка суммируется и распространяется на весь ассортимент. Промокод многоразовый.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2025-10-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-134417",
        "title": "фито300/фито400",
        "code": "ФИТО300",
        "discount": "5%",
        "description": "Скидка 300 ₽ по промокоду при заказе от 3000 ₽ Промокоды распространяются на весь ассортимент Фитомаркет и суммируются с действующими скидками на сайте и в приложении. А с каждого заказа вернётся 5% кешбэка баллами (сможете оплатить до 50% следующего заказа)Предложение действительно до 31.05.2026. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-134418",
        "title": "фито300/фито400",
        "code": "ФИТО400",
        "discount": "5%",
        "description": "Скидка 400 ₽ по промокоду при заказе от 4000 ₽ Промокоды распространяются на весь ассортимент Фитомаркет и суммируются с действующими скидками на сайте и в приложении. А с каждого заказа вернётся 5% кешбэка баллами (сможете оплатить до 50% следующего заказа)Предложение действительно до 31.05.2026. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-33515",
        "title": "Скидка 10% на заказ",
        "code": "",
        "discount": "10%",
        "description": "Промокод на 10% скидку распространяется на неограниченное количество заказов. Скидка по промокоду идёт на весь ассортимент и суммируется с действующими ценами на сайте fitomarket.ru.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2025-09-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-34524",
        "title": "​Скидка 10% на один заказ до 20 000 ₽",
        "code": "",
        "discount": "10%",
        "description": "Скидка по промокоду 10% на один заказ до 20 000 ₽. Скидка суммируется и распространяется на весь ассортимент. Промокод многоразовый.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2025-10-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-37551",
        "title": "Фитомаркет - маркетплейс от Эвалар",
        "code": "",
        "discount": "Акция",
        "description": "Фитомаркет - маркетплейс от Эвалар10 000+ товаров для здоровья",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-03-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-38304",
        "title": "Скидка 55%",
        "code": "",
        "discount": "55%",
        "description": "ЛЕГКОСТЬ ДВИЖЕНИЯ СУСТАВОВ - скидки до 55%В этой подборке мы собрали витамины и БАД со скидками до 55%, направленные на поддержку здоровья суставов, связок и хрящевой ткани с содержанием коллагена, глюкозамина, хондроитина, МСМ, гиалуроновой кислоты, чтобы заботиться о суставах в долгосрочной перспективе. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-38869",
        "title": "Защита от солнца",
        "code": "",
        "discount": "Акция",
        "description": "Приобретайте средства с SPF по выгодным ценам в Fitomarket.Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-38868",
        "title": "БАД для фокуса и внимания со скидками до 50%",
        "code": "",
        "discount": "50%",
        "description": "Собрали витамины и БАД для фокуса, внимания и ясности мышления со скидками до 50%, которые способствуют поддержанию работоспособности.Сохраняйте фокус, учитесь легче и достигайте большего вместе с Фитомаркет! Предложение действительно до 14.06.2026. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-06-14",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-38865",
        "title": "Скидка 300 и 400 рублей",
        "code": "",
        "discount": "5%",
        "description": "Скидка 300 ₽ и 400 ₽ по промокоду при заказе от 3000/4000 ₽Промокоды распространяются на весь ассортимент Фитомаркет и суммируются с действующими скидками на сайте и в приложении. А с каждого заказа вернётся 5% кешбэка баллами (сможете оплатить до 50% следующего заказа)Предложение действительно до 31.05.2026. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-38871",
        "title": "Скидка до 50% на 137 Degrees",
        "code": "",
        "discount": "50%",
        "description": "Любимые растительные напитки 137 Degrees со скидками до 50%.Напитки 137 Degrees изготавливаются из тщательно отобранных орехов и семян без лишних добавок, поэтому они отлично подходят для сбалансированного рациона. Их можно добавлять в кофе, смузи, каши или просто наслаждаться мягким насыщенным вкусом в любое время дня.Предложение действительно до 05.06.2026. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-06-05",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-38870",
        "title": "Скидки до 50% на Celimax",
        "code": "",
        "discount": "50%",
        "description": "Горячие скидки до 50% на Celimax, популярный корейский бренд, в период с 23.04 по 31.05.Предложение распространяется на неограниченное количество заказов, совершенных одним клиентом. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-39059",
        "title": "Успей похудеть к лету!",
        "code": "",
        "discount": "Акция",
        "description": "Лето близко — есть шанс успеть привести себя в форму, почувствовать легкость и уверенность в теле. Важно подойти к этому комплексно ☀️ В этой подборке мы собрали косметику, гаджеты и БАД, которые которые могут дополнительно поддержать организм, особенно если замедлен метаболизм, беспокоят отёки и хроническая усталость, есть гормональные колебания, повышающие тягу к сладкому, рыхлость кожи.Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-39055",
        "title": "Скидка 30% на Solgar",
        "code": "",
        "discount": "30%",
        "description": "Скидки до 30% действуют на ассортимент SolgarАкция распространяется на неограниченное количество заказов, совершенных одним клиентом в период акции. Акция может завершиться раньше по решению Организатора Акции. Скидки сохраняются, пока товар есть в наличии.",
        "expiryDate": "2026-06-12",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-39056",
        "title": "Сыворотка с PDRN от AROCELL в ПОДАРОК!",
        "code": "",
        "discount": "3000₽",
        "description": "Получите двухфазную коллагеновую сыворотку-мист с розовым маслом и PDRN в подарок при покупке продуктов бренда AROCELL от 3000 руб. Предложение действительно, пока подарки есть в наличии. Подарок добавится в заказ автоматически, максимальное количество подарков в одном заказе 1 шт. Действие акции может быть приостановлено на усмотрение Организатора. Количество заказов по акции, оформленных одним клиентом, не ограничено.",
        "expiryDate": "2026-06-15",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      },
      {
        "id": "536-39058",
        "title": "Скидки до 50%: БАДы от отёков",
        "code": "",
        "discount": "50%",
        "description": "Отёки, тяжесть, уставший вид? Собрали подборку БАД и косметики со скидками до 50%, которая работает сразу в двух направлениях — изнутри и снаружи. Не терпите дискомфорт — возвращайте лёгкость, стройность и уверенность уже сейчас. Дополняйте приём нутрицевтиков правильным режимом сна, обильным питьём и активностями. Акция может завершиться раньше по решению Организатора Акции.",
        "expiryDate": "2026-06-15",
        "isExclusive": false,
        "partnerUrl": "",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68b03671da98c.png"
      }
    ]
  },
  {
    "id": "534",
    "name": "Art for introvert",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68adadcdab58f.png",
    "description": "Правое полушарие Интроверта — платформа гуманитарных знаний c приложением для смартфонов и планшетов. Более 2000 лекций по гуманитарным темам по подписке за 299 ₽/мес. Курсы профессиональной переподготовки от 6 месяцев с",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "533",
    "name": "MIIN",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png",
    "description": "Международный институт интегративной нутрициологии — это первый в России проект, аккредитованный Союзом «Здоровье Здоровых», который предлагает инновационные образовательные продукты в области нутрициологии. Мы обучаем н",
    "promocodesCount": 8,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "533-132405",
        "title": "Скидка 5% на обучение",
        "code": "CAKE5",
        "discount": "5%",
        "description": "Скидка 5% на все курсы от цены сайта, суммируется с другими акциями (Кроме ЧП)",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2025-11-25",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-134564",
        "title": "Скидка до 148.000 рублей",
        "code": "ВЕЛНЕС26",
        "discount": "148.000₽",
        "description": "Скидка 148000 рублей при покупке только для специалистов сферы здоровья и красоты Для всех пользователей. Действует на 1 покупку. Не суммируется с другими акциями. Не действует на вашу категорию Максимальный размер скидки по промокоду 148.000 рублей",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-134565",
        "title": "Скидка до 148.000 рублей",
        "code": "ЗОЖ26",
        "discount": "148.000₽",
        "description": "Скидка 148000 рублей при покупке только для врачей и медицинских работников. Для всех пользователей. Действует на 1 покупку. Не суммируется с другими акциями. Не действует на вашу категорию Максимальный размер скидки по промокоду 148.000 рублей",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-134563",
        "title": "Скидка до 148.000 рублей",
        "code": "МАМА26",
        "discount": "148.000₽",
        "description": "Скидка 148000 рублей при покупке только для мам в декрете. Для всех пользователей. Действует на 1 покупку. Не суммируется с другими акциями. Не действует на вашу категорию Максимальный размер скидки по промокоду 148.000 рублей",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-134562",
        "title": "Скидка до 148.000 рублей",
        "code": "НУТРИ26",
        "discount": "148.000₽",
        "description": "Скидка 148000 рублей при покупке новой профессии Для всех пользователей. Действует на 1 покупку. Не суммируется с другими акциями. Не действует на вашу категорию Максимальный размер скидки по промокоду 148.000 рублей",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-35118",
        "title": "Скидка 5% на все курсы",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на все курсы от цены сайта, суммируется с другими акциями (Кроме ЧП)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2025-11-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-37815",
        "title": "Онлайн-курс «Нутрициолог для себя»",
        "code": "",
        "discount": "Акция",
        "description": "Освойте принципы здорового питания, решите свой запрос с нутрициологом и составьте сбалансированный рацион для всей семьи",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2026-03-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      },
      {
        "id": "533-39050",
        "title": "Скидка до 148.000 рублей",
        "code": "",
        "discount": "148.000₽",
        "description": "Скидка 148000 рублей при покупке только для вышей категории.Для всех пользователей.Действует на 1 покупку. Не суммируется с другими акциями.Не действует на вашу категориюМаксимальный размер скидки по промокоду 148.000 рублей",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=533&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ada7be2e783.png"
      }
    ]
  },
  {
    "id": "532",
    "name": "EasyCode",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ad9ef8d5df4.png",
    "description": "EasyCode — ведущая онлайн-школа программирования и IT для детей и подростков 7–17 лет. Мы обучаем детей востребованным навыкам, создавая условия для их успешного старта в мире технологий. EasyCode заняла первое место в р",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "532-38965",
        "title": "Бесплатный вводный урок!",
        "code": "",
        "discount": "Акция",
        "description": "Запишитесь на бесплатный вводный урок!Определим сильные качества ребенка, сделаем первый совместный проект и покажем нашу работу изнутри!",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=532&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ad9ef8d5df4.png"
      }
    ]
  },
  {
    "id": "530",
    "name": "Merion Academy",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68ad7b2b86a80.png",
    "description": "Merion Academy – это платформа доступного IT образования, где можно найти курсы по программированию, DevOps, Кибербезопасности, Системному и Сетевому администрированию, QA и многим другим направлениям. - На все наши курс",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "529",
    "name": "Точка Знаний",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a83a061f07a.png",
    "description": "Занятия в онлайн-школе Точка Знаний проходят по школьной программе для учеников 1–11 классов. Уроки проводятся в прямом эфире на учебной платформе, а подключиться можно с телефона или ноутбука. Запись урока доступна уже ",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "528",
    "name": "Российский институт дополнительного профессионального образования «ИПО»",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a83587c7c32.png",
    "description": "Российский институт дополнительного профессионального образования «ИПО» – это удобное и быстрое получение дополнительного профобразования и повышения квалификации онлайн по востребованным на рынке гуманитарным, техническ",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "528-118086",
        "title": "Скидка 10% на заказ",
        "code": "IPO_10",
        "discount": "10%",
        "description": "Скидка 10% от цены на сайте, не суммируется с другими акциями",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=528&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a83587c7c32.png"
      },
      {
        "id": "528-32013",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% от цены на сайте, не суммируется с другими акциями",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=528&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a83587c7c32.png"
      },
      {
        "id": "528-38547",
        "title": "Весенняя корзина знаний со скидкой до 30%",
        "code": "",
        "discount": "30%",
        "description": "Московский диплом с выгодой 30% + повышение квалификации в подарок!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=528&a=79",
        "isActive": true,
        "createdAt": "2026-04-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a83587c7c32.png"
      }
    ]
  },
  {
    "id": "527",
    "name": "Учебный центр «НЦПО»",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png",
    "description": "«НЦПО» — учебный центр с лицензией Минобрнауки. Предлагаем обучение по рабочим специальностям, профпереподготовку и повышение квалификации – дистанционно или очно с практикой. Все курсы соответствуют профстандартам и тре",
    "promocodesCount": 8,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "527-119021",
        "title": "Скидка 1000 рублей на курсы профессиональной переподготовки",
        "code": "Skidka1000",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей на курсы профессиональной переподготовки. Для этого необходимо ввести промокод в форме заявки или сообщить менеджеру",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-119020",
        "title": "Скидка 500 рублей на любое обучение",
        "code": "Skidka500",
        "discount": "500₽",
        "description": "Скидка 500 рублей на любое обучение. Для этого необходимо ввести промокод в форме заявки или сообщить менеджеру",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-32867",
        "title": "Три курса со скидкой 15%",
        "code": "",
        "discount": "15%",
        "description": "В рамках акции доступны все курсы. Чтобы воспользоваться скидкой, необходимо оплатить все три программы обучения одним платежом. Обратите внимание, что скидки по разным акциям не суммируются.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-32866",
        "title": "Скидка 1000 рублей на курсы профессиональной переподготовки",
        "code": "",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей на курсы профессиональной переподготовки. Для этого необходимо ввести промокод в форме заявки или сообщить менеджеру",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-32869",
        "title": "Скидка 10% на обучение группы в 3-5 человек",
        "code": "",
        "discount": "10%",
        "description": "В рамках акции доступны все курсы. Чтобы воспользоваться скидкой, необходимо оплатить от 3 до 5 программ обучения одним платежом. Обратите внимание, что скидки по разным акциям не суммируются.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-32868",
        "title": "Скидка 20% при покупке от 5-ти курсов",
        "code": "",
        "discount": "20%",
        "description": "В рамках акции доступны все курсы. Чтобы воспользоваться скидкой, необходимо оплатить от 5 программ обучения одним платежом. Обратите внимание, что скидки по разным акциям не суммируются.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-32865",
        "title": "Скидка 500 рублей на любое обучение",
        "code": "",
        "discount": "500₽",
        "description": "Скидка 500 рублей на любое обучение. Для этого необходимо ввести промокод в форме заявки или сообщить менеджеру",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-07-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      },
      {
        "id": "527-35098",
        "title": "Скидка 25% на вторую программу переподготовки по психологии",
        "code": "",
        "discount": "25%",
        "description": "Дарим скидку 25% на вторую программу профпереподготовки для психологов! Акция действует с 24 ноября до 31 декабря 2025 года. Скидка 25% на вторую программу профессиональной переподготовки при одновременной оплате двух. Участвуют только программы объёмом 256, 512 или 1600 часов. Программы могут быть оплачены в рассрочку 0% на 3 месяца. Программы идут по утверждённым учебным планам и не подлежат изменению. Скидка действует только при оплате в период действия акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=527&a=79",
        "isActive": true,
        "createdAt": "2025-11-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a82f06981ab.png"
      }
    ]
  },
  {
    "id": "526",
    "name": "AMAZING RED",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a5c6f5216e8.png",
    "description": "AMAZING RED – это сеть мультибрендовых магазинов по всей России, которая предлагает любителям спорта и уличного стиля одежду, обувь и аксессуары от таких брендов, как PUMA, Nike, Asics и Hoka. Следуя своему девизу «Спорт",
    "promocodesCount": 0,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "525",
    "name": "Mark Formelle (Казахстан)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c7736388c.png",
    "description": "Mark Formelle – это крупная розничная сеть, насчитывающая более 300 магазинов в Беларуси, России, Казахстане и Узбекистане, онлайн-покупки в интернет-магазине и на всех популярных маркетплейсах. Сила Mark Formelle в уник",
    "promocodesCount": 0,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "523",
    "name": "BAON",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c0c6c5e2f.png",
    "description": "BAON.ru — популярный интернет-магазин одежды и аксессуаров для всей семьи. Уже более 30 лет компания создает функциональные, технологичные, комфортные и стильные линии одежды и аксессуаров для женщин, мужчин и детей. Ком",
    "promocodesCount": 5,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "523-115276",
        "title": "Скидка 10% на заказ.",
        "code": "advcake",
        "discount": "10%",
        "description": "Скидка 10% на заказ. Суммируется со скидками, но не суммируется с другими промокодами.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=523&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c0c6c5e2f.png"
      },
      {
        "id": "523-31209",
        "title": "Скидка 10% на заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на заказ. Суммируется со скидками, но не суммируется с другими промокодами.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=523&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c0c6c5e2f.png"
      },
      {
        "id": "523-37677",
        "title": "1000 бонусов для ВСЕХ!",
        "code": "",
        "discount": "50%",
        "description": "Дарим 1000 бонусов для всех клиентов при регистрации в программе лояльности.1. Для получения бонусов необходимо зарегистрироваться по ссылке https://baon.ru/privilege/ в программе лояльности.2. 500 приветственных бонусов начисляются автоматически сразу после регистрации.3. Срок действия баллов 30 дней с момента начисления.4. Бонусами можно оплатить до 50% от первоначальной стоимости. 1 бонус = 1 рубль.5. Неиспользованные баллы сгорают.При подтверждении электронного адреса дарим дополнительно 500 бонусов.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=523&a=79",
        "isActive": true,
        "createdAt": "2026-03-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c0c6c5e2f.png"
      },
      {
        "id": "523-37697",
        "title": "Скидка 15% (б)",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на все при покупке на сайте (суммируется со скидками на сайте, но не суммируется с промокодами). Распространяется на всех клиентов. Кол-во заказов и сумма скидки не ограничены.",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=523&a=79",
        "isActive": true,
        "createdAt": "2026-03-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c0c6c5e2f.png"
      },
      {
        "id": "523-38400",
        "title": "Скидка 15% (топ)",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на все при покупке на сайте (суммируется со скидками на сайте, но не суммируется с промокодами). Распространяется на всех клиентов. Кол-во заказов и сумма скидки не ограничены.",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=523&a=79",
        "isActive": true,
        "createdAt": "2026-04-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a4c0c6c5e2f.png"
      }
    ]
  },
  {
    "id": "522",
    "name": "Xcom-shop",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68a450db1a954.png",
    "description": "Xcom-Shop - крупный интернет-магазин компьютерной техники, серверного оборудования, периферии, расходных материалов, сетевого, мультимедийного оборудования, мобильных телефонов и многого другого. Ассортимент насчитывает ",
    "promocodesCount": 0,
    "category": "Игры",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "521",
    "name": "Kassir",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img689f4f61b4da7.png",
    "description": "KASSIR.RU - крупнейший билетный оператор Восточной Европы. На нашем сайте представлено более 3 500 мероприятий, которые придутся по вкусу любому человеку. Ежегодно нас посещает более 70 000 000 человек. KASSIR.RU сотрудн",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "520",
    "name": "Ormatek",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img689b5b05d161f.png",
    "description": "ОRМАТЕК — ведущий российский производитель товаров для сна. Компания занимает уверенные позиции на мебельном рынке и входит в тройку лидеров в своей отрасли. Широкий ассортимент продукции, комплектность и многообразие цв",
    "promocodesCount": 0,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "518",
    "name": "Авторусь",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68593fba0743b.png",
    "description": "АВТОРУСЬ — это надежный и проверенный поставщик автотоваров российских и зарубежных производителей. Компания успешно работает с 1992 года и занимает лидирующую позицию в сфере автомобильного бизнеса. На сегодняшний день ",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "516",
    "name": "Aravia",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6850318dd6111.png",
    "description": "ARAVIA — официальный интернет-магазин производителя косметики ARAVIA Professional. Специалисты лаборатории ARAVIA Professional 14 лет создают уникальные линии косметических продуктов. Сегодня ARAVIA Professional имеет 26",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "514",
    "name": "Polza.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6846ee805d574.png",
    "description": "POLZA.ru - проект «Фармацевтической Компании ПУЛЬС», которая по итогам 2024 года стала ведущим фармацевтическим дистрибьютором в России. Организация присутствует на рынке с 2001 года, имеет 14 крупных логистических центр",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "512",
    "name": "2MOOD",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6846bff1b9152.png",
    "description": "2MOOD – российский модный бренд женской одежды, обуви и аксессуаров. На рынке с 2017 года. На данный момент работают уже 17 магазинов в России, бренд представлен в 6 крупных городах: Москва, Санкт-Петербург, Екатеринбург",
    "promocodesCount": 0,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "511",
    "name": "4 Лапы",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68388e0f92b2c.png",
    "description": "Четыре Лапы — крупнейшая розничная сеть зоомагазинов в России. Наша работа помогает сделать этот мир лучше, потому что домашние питомцы приносят радостные эмоции и ощущение полноты жизни. Более 25 лет мы заботимся о полн",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "510",
    "name": "PULT.RU",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68388679adb1d.png",
    "description": "ПУЛЬТ.РУ – лидер в продаже Hi-Fi и High End техники для тех, кто ценит достойное качество звука и изображения, высокий сервис и мнение экспертов. Интернет-магазин ПУЛЬТ.РУ был основан в 2003 году. Все годы своего существ",
    "promocodesCount": 0,
    "category": "Электроника",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "509",
    "name": "ШЕФМАРКЕТ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6835d4880819a.png",
    "description": "Шефмаркет – первый в России сервис доставки продуктов с рецептами (с 2012 года). Вы выбираете блюда, а мы привозим столько ингредиентов, сколько нужно для приготовления. Каждую неделю шеф-повара и диетологи создают 60 но",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "507",
    "name": "КОЛЕСО",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68230bd7b606d.png",
    "description": "ОПИСАНИЕ: КОЛЕСО.ру — более 20-ти лет на шинном рынке: компания прошла длинный путь развития от небольших торговых точек по продаже автомобильных шин и автозапчастей до сети профессиональных шинных и сервисных центров. П",
    "promocodesCount": 2,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "507-38068",
        "title": "Скидка до 1100 рублей на АКБ",
        "code": "",
        "discount": "1100₽",
        "description": "Скидка на новый аккумулятор до 1100 рублей предоставляется за один сданный старый аккумулятор с целым корпусом. Скидка зависит от ёмкости сданной АКБ.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=507&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68230bd7b606d.png"
      },
      {
        "id": "507-38069",
        "title": "Скидки до 30% на все секретки",
        "code": "",
        "discount": "30%",
        "description": "Купите любые шины или диски (от 1 шт) в сети Колесо.ру. и получите купон на скидку 30% на секретки",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=507&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68230bd7b606d.png"
      }
    ]
  },
  {
    "id": "506",
    "name": "Pharmacosmetica",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img68230152ac7a3.png",
    "description": "Pharmacosmetica",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "500",
    "name": "СберЗдоровье Анализы",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab906a7da8b.png",
    "description": "СберЗдоровье – это быстрый и удобный online-сервис по подбору лабораторий. Сервис СберЗдоровье (ранее - DocDoc) появился в декабре 2011 года в Москве. Портал оказывает услуги по подбору врачей из клиник Москвы, Московско",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "499",
    "name": "ВсеИнструменты.ру",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png",
    "description": "ВсеИнструменты.ру – один из крупнейших онлайн-игроков на российском DIY-рынке. Компания предлагает более 1,5 млн товаров для дома, дачи, стройки и ремонта. В ассортименте более 15 000 надежных мировых брендов с товарами ",
    "promocodesCount": 17,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "499-132310",
        "title": "Скидка до 25% на первый заказ для юр.лиц",
        "code": "EWN25B2B",
        "discount": "25%",
        "description": "Скидка до 25% по промокоду на первый заказ для юр.лиц. Регистрируйтесь на сайте и применяйте промокод в корзине! Максимальный размер скидки — 8 000 руб. Суммируется с другими акциями",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-03-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-134120",
        "title": "Скидка 4% на заказ",
        "code": "UXTPCFU8",
        "discount": "4%",
        "description": "Скидка 4% на заказ Для всех пользователей. Суммируется с другими акциями Только для физ.лиц Максимальный размер скидки по промокоду 3000 рублей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-134365",
        "title": "Скидка 10% на товары REDVERG​ из подборки",
        "code": "RDVMIN10",
        "discount": "10%",
        "description": "Скидка 10% на товары REDVERG из подборки. Для всех пользователей. Без ограничений на количество покупок. Суммируется с другими акциями. Без ограничения скидки.",
        "expiryDate": "2026-05-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-134366",
        "title": "Скидка 5% на все товары ASILAK, ECO и WORTEX",
        "code": "DCH05025",
        "discount": "5%",
        "description": "Скидка 5% на все товары ASILAK, ECO и WORTEX. Для всех пользователей. Без ограничений на количество покупок. Не суммируется с другими акциями. Действует на все товары ASILAK, ECO и WORTEX. Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-134509",
        "title": "Скидка 15% на все для организации рабочих мест",
        "code": "H1TN0V15",
        "discount": "15%",
        "description": "Скидка 15% при покупке товаров из подборки. Для всех пользователей. Без ограничений на количество покупок. Суммируется с другими акциями. Действует на все товары из подборки. Без ограничения скидки.",
        "expiryDate": "2026-06-12",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-37623",
        "title": "Товары месяца",
        "code": "",
        "discount": "Акция",
        "description": "Мы собрали популярные товары с высоким рейтингом в одну подборку и добавили хорошие скидки. Рекомендуем обратить внимание.Пусть ваш год начинается с качественных покупок. Выбирайте, а мы доставим точно в срок!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-03-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-37710",
        "title": "Скидка до 25% на первый заказ для юр.лиц",
        "code": "",
        "discount": "25%",
        "description": "Скидка до 25% по промокоду на первый заказ для юр.лиц. Регистрируйтесь на сайте и применяйте промокод в корзине! Максимальный размер скидки — 8 000 руб. Суммируется с другими акциями",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-03-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38601",
        "title": "Лови момент! Скидки до 53%",
        "code": "",
        "discount": "53%",
        "description": "Скидки до 53%Каждый день мы обновляем эту подборку популярных позиций с ценами ниже рынка.Есть одно но: вы можете купить не более одного товара в сутки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38583",
        "title": "Брендфест. Скидки до 40%",
        "code": "",
        "discount": "40%",
        "description": "Скидка до 40% на товары наших собственных марок и импортных брендов – с реальной выгодой!Доступна всем клиентам бренда",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38504",
        "title": "Скидка 4% на заказ",
        "code": "",
        "discount": "4%",
        "description": "Скидка 4% на заказДля всех пользователей.Суммируется с другими акциями Только для физ.лицМаксимальный размер скидки по промокоду 3000 рублей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38839",
        "title": "Закрытая распродажа - скидки до 50% на топ-товары",
        "code": "",
        "discount": "50%",
        "description": "Предлагаем выгоду до 50% авторизованным пользователям. Инструменты, техника, расходные материалы – ассортимент подойдет для профессиональных задач и хобби.Чтобы увидеть скидки, войдите в личный кабинет – и выбирайте товары с этой страницы!Только для физ. лиц.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38836",
        "title": "Распродажа остатков",
        "code": "",
        "discount": "80%",
        "description": "Распродажа остатков. Скидки до 80% на выделенный ассортимент.Успевай купить",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38835",
        "title": "REDVERG: более 40 товаров для дачи – со скидкой 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на товары REDVERG из подборки.Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Без ограничения скидки.",
        "expiryDate": "2026-05-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38838",
        "title": "Скидка 5% на все товары ASILAK, ECO и WORTEX",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на все товары ASILAK, ECO и WORTEX.Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на все товары ASILAK, ECO и WORTEX.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38834",
        "title": "Скидки до 39% на товары Hoegert Technik",
        "code": "",
        "discount": "39%",
        "description": "Больше 130 – столько товаров со скидками в подборке от Hoegert Technik.Ручной и пневмоинструментРабочая одеждаЭлектротоварыМебельная фурнитура и многое другоеИнженеры Hoegert Technik уделяют внимание каждой детали, чтобы создать максимально эргономичный продукт для решения ваших задач.",
        "expiryDate": "2026-06-05",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38837",
        "title": "Сэкономьте при покупке инструментов - скидки до 35% на товары брендов Procraft, Vega и Kubis",
        "code": "",
        "discount": "35%",
        "description": "На распродаже от Procraft, Vega и Kubis вы найдете все необходимое для строительства, ремонта и работы на даче. Выбирайте инструменты со скидками до 35%. Предложение действует до 31 мая 2026.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      },
      {
        "id": "499-38963",
        "title": "Скидка 15% на все для организации рабочих мест",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% при покупке товаров из подборки.Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Действует на все товары из подборки.Без ограничения скидки.",
        "expiryDate": "2026-06-12",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=499&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img686647cab9777.png"
      }
    ]
  },
  {
    "id": "498",
    "name": "Институт Медицины",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab8ac76be97.png",
    "description": "«Институт Медицины» — система дистанционного обучения «Национальной академии медицинского образования» имени Н.А. Бородина. Проводим курсы по всей России для врачей, среднего медперсонала, фармацевтических работников, ну",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "496",
    "name": "ЭКОДПО",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab853162b7e.png",
    "description": "«ЭКОДПО» — учебный центр, предоставляющий высококачественное образование: профессиональную переподготовку и повышение квалификации. Мы организуем законное обучение специалистов в дистанционной форме, предоставляя только ",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "496-28059",
        "title": "Скидка 10% льготным категориям граждан",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% предоставляется следующим категориям граждан:Героям СССР и Героям РоссииВетеранам ВОВЛицам с ОВЗ и родителям детей с ОВЗМногодетным семьямМатерям-одиночкамМалоимущим семьямПочетным донорамИнвалидам I группыИнвалидам II группы (независимо от степени ограничения трудоспособности)Ликвидаторам последствий аварии на Чернобыльской АЭС или на ПО \"Маяк\"Членам многодетных семейВетеранам и участникам боевых действийГражданам, подвергшимся радиации вследствие катастрофы на Чернобыльской АЭС, и лица, приравненные к ним*Для получения скидки требуется предоставить документ, подтверждающий принадлежность к льготной категории.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=496&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab853162b7e.png"
      },
      {
        "id": "496-28060",
        "title": "2=3 или скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "При оплате курса переподготовки и курса повышения квалификации скидка 15% на обучение. Например: цена профподготовки 30000 руб. и цена курса повышения квалификации 10000 руб., сумма равна 40000 руб. Но по условиям акции вы получите скидку и итоговая стоимость обучения составит 34000 рублей!При покупке двух дистанционных курсов переподготовки для одного пользователя Мы дарим вам курс повышения переквалификации совершенно бесплатно. Ваша выгода составит 13000 рублей!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=496&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab853162b7e.png"
      },
      {
        "id": "496-28061",
        "title": "Выгода до -90%",
        "code": "",
        "discount": "90%",
        "description": "Учебный центр «ЭКОДПО» предоставляет возможность пройти профессиональную переподготовку в дистанционном формате с большой скидкой! Поступите на профессиональную переподготовку с товарищами или коллегами группой от 7 человек и получите скидку от 70% на свой курс.Условия акции: 90 % лицам, приведшим с собой группу лиц из 9 человек, желающих заключить договор на обучение;80 % лицам, приведшим с собой группу лиц из 8 человек, желающих заключить договор на обучение;70 % лицам, приведшим с собой группу лиц из 7 человек, желающих заключить договор на обучение",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=496&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab853162b7e.png"
      },
      {
        "id": "496-28062",
        "title": "10% скидка за повторную покупку",
        "code": "",
        "discount": "10%",
        "description": "«ЭКОДПО» предлагает 10% скидку на любой курс профессиональной переподготовки или повышения квалификации для слушателей, закончивших обучение не более чем три месяца назад. Чтобы воспользоваться этим предложением, вам достаточно связаться с вашим менеджером и уведомить его о том, что это не ваше первое обращение.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=496&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab853162b7e.png"
      }
    ]
  },
  {
    "id": "495",
    "name": "АПОК (Академия Профессионального Образования Кадров)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png",
    "description": "Учебный центр АПОК (Академия Профессионального Образования Кадров) — лидер в профессиональной переподготовке и повышении квалификации кадров по всей России. АПОК — это команда опытных методистов и менеджеров, готовых в л",
    "promocodesCount": 6,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "495-28058",
        "title": "10% скидка льготным категориям граждан",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% предоставляется следующим категориям граждан:Ветеранам ВОВИнвалидам I группыГероям СССР и Героям РоссииИнвалидам II группы (независимо от степени ограничения трудоспособности)Ликвидаторам последствий аварии на Чернобыльской АЭС или на ПО \"Маяк\"Ветеранам и участникам боевых действийЧленам многодетных семейПочетным донорамГражданам, подвергшимся радиации вследствие катастрофы на Чернобыльской АЭС, и лица, приравненные к ним. *Для получения скидки слушателям требуется предоставить документ, подтверждающий принадлежность к льготной категории.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=495&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png"
      },
      {
        "id": "495-28056",
        "title": "«Ученая семья» до -40% скидка на обучение",
        "code": "",
        "discount": "40%",
        "description": "Учиться вместе — выгодно! При обучении двух и более человек из одной семьи* скидка второму (третьему) составляет 40%.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=495&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png"
      },
      {
        "id": "495-28053",
        "title": "2=3 или скидка 15%",
        "code": "",
        "discount": "15%",
        "description": "Закажи профессиональную подготовку и повышение квалификации и получи скидку до 15%Подробнее об акции - https://apokdpo.ru/akcii-i-skidki/skidka-dva-ravno...",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=495&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png"
      },
      {
        "id": "495-28055",
        "title": "Бесплатное обучение или выгода от -70%",
        "code": "",
        "discount": "70%",
        "description": "Образовательный центр «АПОК» предоставляет возможность пройти профессиональную переподготовку в дистанционном формате бесплатно или с большой скидкой! Поступите на профпереподготовку с друзьями или коллегами группой от 7 человек и получите скидку от 70% на свой курс.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=495&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png"
      },
      {
        "id": "495-28054",
        "title": "10% скидка за повторную покупку",
        "code": "",
        "discount": "10%",
        "description": "Слушателям, которые завершили обучение не более трех месяцев назад, образовательная организация «АПОК» предоставляет скидку в размере 10% на любое направление профессиональной переподготовки или курса повышения квалификации.Для получения скидки, просто свяжитесь со своим менеджером и сообщите, что это ваше повторное обращение.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=495&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png"
      },
      {
        "id": "495-28057",
        "title": "Учимся вместе",
        "code": "",
        "discount": "15%",
        "description": "Закажи обучение на 3 и более человек и получи скидку до 15%",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=495&a=79",
        "isActive": true,
        "createdAt": "2024-11-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab833a2c17e.png"
      }
    ]
  },
  {
    "id": "494",
    "name": "ОСЭК (Открытый социально-экономический колледж)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab80587afc7.png",
    "description": "Открытый социально-экономический колледж (ОСЭК) предлагает возможность получения современного среднего профессионального образования в дистанционном формате. Учебные программы охватывают широкий спектр специальностей, та",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "494-36829",
        "title": "Скидка 5% на любую программу",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% для новых пользователей. Не суммируется c другими скидками, акциями и рассрочкой (исключение: акционная цена на сайте). Действует на все курсы.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=494&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab80587afc7.png"
      }
    ]
  },
  {
    "id": "493",
    "name": "KANZLER",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png",
    "description": "На сегодняшний день работает более 100 магазинов KANZLER в 55 городах России: от Санкт-Петербурга до Улан-Удэ. Также в KANZLER есть интернет-магазин с удобной доставкой даже в самые удаленные уголки страны. Коллекции мар",
    "promocodesCount": 9,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "493-131314",
        "title": "Скидка 10% на заказ",
        "code": "ADVcake",
        "discount": "10%",
        "description": "Скидка 10% на все, кроме подарочных карт и носков. Промокод суммируется с другими акциями и скидками на сайте, но не действует с другими промокодами.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-02-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-134507",
        "title": "Скидка до 20% на костюмы",
        "code": "МАЙ",
        "discount": "20%",
        "description": "Скидка до 20 % рублей на выделенный ассортимент костюмов Для всех пользователей. Без ограничений на количество покупок. Не суммируется с другими акциями.",
        "expiryDate": "2026-05-27",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-134576",
        "title": "20% аксессуары",
        "code": "АКС20",
        "discount": "20%",
        "description": "Дополнительная скидка -20% на аксессуары по промокоду* * В акции участвует выделенный ассортимент, представленный на странице. Итоговая скидка после применения промокода не превышает 50%. Акция действительна в интернет-магазине и приложении KANZLER.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-05-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-37107",
        "title": "Скидка 10% на все, кроме подарочных карт и носков",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все, кроме подарочных карт и носков. Промокод суммируется с другими акциями и скидками на сайте, но не действует с другими промокодами.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-02-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-37106",
        "title": "Скидка 10% на все, кроме подарочных карт и носков",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все, кроме подарочных карт и носков. Промокод суммируется с другими акциями и скидками на сайте, но не действует с другими промокодами.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-02-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-38066",
        "title": "Скидки до 67% на выделенный ассортимент",
        "code": "",
        "discount": "67%",
        "description": "Скидки до 67% на выделенный ассортимент",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-38650",
        "title": "Скидка до 50% на мужскую одежду",
        "code": "",
        "discount": "50%",
        "description": "Скидка до 50%Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Действует на выделенный ассортимент товаров",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-38961",
        "title": "Скидка до 20% на костюмы",
        "code": "",
        "discount": "20%",
        "description": "Скидка до 20 % рублей на выделенный ассортимент костюмовДля всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.",
        "expiryDate": "2026-05-27",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      },
      {
        "id": "493-39063",
        "title": "Скидка 20% на аксессуары",
        "code": "",
        "discount": "20%",
        "description": "Дополнительная скидка -20% на аксессуары по промокоду** В акции участвует выделенный ассортимент, представленный на странице. Итоговая скидка после применения промокода не превышает 50%. Акция действительна в интернет-магазине и приложении KANZLER.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=493&a=79",
        "isActive": true,
        "createdAt": "2026-05-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab7dc62207b.png"
      }
    ]
  },
  {
    "id": "492",
    "name": "Technopark",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png",
    "description": "Технопарк – сеть магазинов премиальной техники и электроники. Наша команда уже 30 лет предлагает только самые качественные товары, способные сделать жизнь комфортнее и технологичнее. Мы внимательно собираем данные о брен",
    "promocodesCount": 13,
    "category": "Электроника",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "492-36384",
        "title": "Соединительная полка для сушильной и стиральной машины в подарок",
        "code": "",
        "discount": "10%",
        "description": "Соединительная полка для сушильной и стиральной машины в подарок Уход за одеждой — неотъемлемая часть заботы о себе. Сделать этот процесс максимально удобным, легким и качественным можно с брендом Midea. До конца января при покупке комплекта из стиральной и сушильной машины вы получите в подарок соединительную полку, а также выгоду 10% на технику из комплекта.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-01-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-36381",
        "title": "Расширенная гарантия на товары бренда Liebherr",
        "code": "",
        "discount": "Акция",
        "description": "Расширенная гарантия на Liebherr. Правильное хранение продуктов актуально в течение всего года. Холодильники Liebherr позволяют распределить еду по разным контейнерам и отсекам, поддерживая необходимую влажность и температуру, а винные шкафы поддерживают идеальную температуру вашего любимого вина. До конца года дарим расширенную гарантию 5 лет на технику Liebherr из нашей подборки, а также гарантию 10 лет на избранные модели.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-01-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-36882",
        "title": "Выгода до 20% на бытовую технику",
        "code": "",
        "discount": "20%",
        "description": "Пора обновить бытовую технику? Специальные цены уже ждут вас. Выбирайте технику для дома и экономьте до 20%.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-36944",
        "title": "Выгода на Roborock до 25%",
        "code": "",
        "discount": "25%",
        "description": "Roborock — интеллектуальные технологии уборки. Устройства Roborock созданы для тех, кто ценит технологии и безупречную чистоту. Роботы-пылесосы бренда самостоятельно выстраивают маршруты, точно ориентируются в пространстве и поддерживают порядок с минимальным участием пользователя. До 28 февраля модели из подборки можно купить с выгодой до 25%.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-02-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-37380",
        "title": "Выгода до 40% на саундбар при покупке ТВ TCL",
        "code": "",
        "discount": "40%",
        "description": "Выгода на саундбар от TCL при покупке ТВ. Возможность собираться вместе дома с семьей и друзьями — часть настоящей весенней атмосферы. Идеальный вариант — позвать всех близких на просмотр любимых фильмов или сериалов в ваш домашний кинотеатр от бренда TCL. При покупке телевизора TCL вы получите выгоду до 40% на саундбар из нашей подборки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-03-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38076",
        "title": "Выгода на комплект от Midea до 25%",
        "code": "",
        "discount": "25%",
        "description": "Создать комфортную и современную кухню проще, чем кажется, — благодаря Технопарку. При покупке духового шкафа и посудомоечной машины в комплекте с микроволновой печью, варочной панелью, вытяжкой или встраиваемым холодильником мы подарим выгоду 15% на духовой шкаф и 25% на посудомоечную машину.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38079",
        "title": "Беспроцентная рассрочка",
        "code": "",
        "discount": "Акция",
        "description": "Теперь рассрочка на сроки 6 и 12 месяцев будет полностью беспроцентной для клиенте. -0-0-6 от брокера \"Всегда да\"-0-0-12 от Т-БанкаДля клиента данные программы работают без переплат, комиссий и первоначального взноса. Процент оформления и пути клиента абсолютно никак не меняется.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38074",
        "title": "Комфортная кухня от Gorenje",
        "code": "",
        "discount": "30%",
        "description": "Весна — самое время создать комфортную атмосферу у себя дома. При покупке комплекта техники из трёх приборов: варочная поверхность, посудомоечная машина и на выбор духовой шкаф вы получите выгоду 30% на посудомоечную машину, 20% на варочную поверхность и 10% на духовой шкаф.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38844",
        "title": "Выгода 20% на встраиваемые холодильники",
        "code": "",
        "discount": "20%",
        "description": "Обустройте свою кухню выгодноПри ремонте кухни важно подумать и о качественной бытовой технике. Чтобы холодильник не испортил ваш дизайн-проект, вам точно понадобятся встраиваемые модели. До 31 мая встраиваемые холодильники Gorenje доступны с выгодой 20%.После добавления товара в корзину, вам необходимо активировать купон «Выгода на холодильники Gorenje» в разделе «Программа лояльности».",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38842",
        "title": "Выгода до 15% при покупке КБТ",
        "code": "",
        "discount": "15%",
        "description": "Обновить дом к началу нового года — это не только приятно, но и выгодно. Дарим выгоду до 15% при покупке крупной бытовой техники. Как это работает?При покупке двух товаров на второй, меньший по стоимости дарим выгоду 10%.При покупке трех и более товаров на второй по стоимости – выгоду 10%, на остальные наименьшие по стоимости – по 15%.Аксессуары в предложении не участвуют.Для доступа к предложению необходимо авторизоваться и выбрать акцию в разделе «Программа лояльности» при оформлении заказа в корзине.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38845",
        "title": "Скидка 20% при покупке от двух единиц техники Haier",
        "code": "",
        "discount": "20%",
        "description": "Техника для дома от HaierДом — место силы. Чтобы делать свое пространство еще комфортнее, важно подобрать правильную технику. До конца мая при покупке от двух товаров Haier из нашей подборки вы получаете выгоду 20%. Выгода не действует на покупку одинаковых моделей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38858",
        "title": "Выгода 20% на бытовую технику Vard",
        "code": "",
        "discount": "20%",
        "description": "Чтобы дома было всегда комфортно, важно обустроить его функциональной и надежной техникой. Например, от бренда VARD, который заботится не только о качестве, но и о том, чтобы каждое устройство идеально вписывалось в любой интерьер. До конца мая дарим выгоду до 20% на технику из нашей подборки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      },
      {
        "id": "492-38859",
        "title": "Выгода 15% на холодильники Midea",
        "code": "",
        "discount": "15%",
        "description": "Холодильники Midea оснащены функцией регулировки температуры — можно настроить её под ваши индивидуальные потребности. А также идеально подходят для хранения скоропортящихся продуктов — во встроенной зоне свежести поддерживается особый микроклимат, чтобы вы могли наслаждаться вкусом овощей и фруктов как можно дольше. Воспользуйтесь специальным предложением на выделенный ассортимент Midea.После добавления товара в корзину, вам необходимо активировать купон «Выгода на холодильники Midea» в разделе «Программа лояльности».",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=492&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab54811155d.png"
      }
    ]
  },
  {
    "id": "491",
    "name": "Litres",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png",
    "description": "Литрес — это крупнейший в России цифровой сервис электронных и аудиокниг. В нашем книжном каталоге более миллиона книг на русском и иностранных языках. Ежемесячно в Литрес 12,5 млн человек скачивают более 1,5 млн книг. М",
    "promocodesCount": 80,
    "category": "Книги",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "491-133527",
        "title": "Скидка 50% на подборку о саморазвитии и психологии",
        "code": "BUSINESSTIPS",
        "discount": "50%",
        "description": "Скидка по промокоду 50% на подборку литературы по бизнесу, психологии и саморазвитию.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-04-09",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-134072",
        "title": "Скидка 20% на подборку \"Слушайте до выхода бумажной книги\"",
        "code": "beforebook26",
        "discount": "20%",
        "description": "Скидка 20% по промокоду на подборку \"Слушайте до выхода бумажной книги\".",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-04-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-134436",
        "title": "Скидка 30% на подборку книг к 9 мая",
        "code": "9mayy",
        "discount": "30%",
        "description": "Книги — это про память 🕊️ Читайте хронику былых времён, исторические романы и мемуары. Литрес собрал отдельную подборку книг к этой дате. По промокоду 9MAY — скидка 30% на всё, что внутри. Погрузитесь в историю!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-134499",
        "title": "Скидка 40% на подборку комиксов по промокоду",
        "code": "comicss",
        "discount": "40%",
        "description": "Скидка 40% на подборку комиксов по промокоду. Для любых типов пользователей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-29370",
        "title": "Подборка. Что читают CEO? Подборка книг Юрия Дрогана по созданию и реализации амбициозных стратегий",
        "code": "",
        "discount": "Акция",
        "description": "Один из авторов новинки, написанной лидерами Университата Эволюции, при поддержке «Альфа-банка». Издание для тех, кто уперся в потолок и спрашивает себя: Что дальше? Как найти большую идею, чтобы вывести бизнес на следующий уровень",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-02-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32108",
        "title": "Подборка. Искусственный интеллект: от идеи к реальности",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг, посвященная тому, как нашу жизни меняет ИИ, как с ним работать и существовать.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-07-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32206",
        "title": "Подборка Ведьмы, лешие и их друзья",
        "code": "",
        "discount": "Акция",
        "description": "Ведьмы, лешие и князья: young adult со славянским флёром.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32216",
        "title": "Подборка. ТОП-20 книг для уверенности в себе",
        "code": "",
        "discount": "Акция",
        "description": "ТОП-20 книг для уверенности в себе",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32217",
        "title": "Подборка. Для тех, кто хочет успевать",
        "code": "",
        "discount": "Акция",
        "description": "Для тех, кто хочет все успевать : саммари",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32218",
        "title": "Подборка. ТОП-30 self-help книг",
        "code": "",
        "discount": "Акция",
        "description": "ТОП-30 self-help книг",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32221",
        "title": "Подборка. Ваша корпоративная библиотека",
        "code": "",
        "discount": "Акция",
        "description": "Ваша корпоративная библиотека: книги для создания сильных команд",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32213",
        "title": "Подборка. Бестселлеры в бизнесе и саморазвитии",
        "code": "",
        "discount": "Акция",
        "description": "Бестселлеры в бизнесе и саморазвитии",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32214",
        "title": "Подборка. Плейлист 2025",
        "code": "",
        "discount": "Акция",
        "description": "Плейлист 2025: новинки нон-фикшн в аудио",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32204",
        "title": "Подборка. Титулованная фантастика",
        "code": "",
        "discount": "Акция",
        "description": "Титулованная фантастика: подборка книг-лауреатов премий.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32215",
        "title": "Подборка. Личная эффективность",
        "code": "",
        "discount": "Акция",
        "description": "Личная эффективность на пути к совершенству",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32210",
        "title": "Подборка. На пару вечеров",
        "code": "",
        "discount": "Акция",
        "description": "На пару вечеров: истории для тех, кому надоели длинные циклы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32209",
        "title": "Подборка. Уютное волшебство",
        "code": "",
        "discount": "Акция",
        "description": "Уютное волшебство: 55 книг в жанре cozy fantasy.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32208",
        "title": "Подборка Из Китая, Кореи и России",
        "code": "",
        "discount": "Акция",
        "description": "Из Китая, Кореи и России: самые интересные новеллы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32220",
        "title": "Подборка. Бизнес по-русски",
        "code": "",
        "discount": "Акция",
        "description": "Бизнес по-русски",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32219",
        "title": "Подборка. Развитие мышления",
        "code": "",
        "discount": "Акция",
        "description": "Развитие мышления",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32207",
        "title": "Подборка. С чего начать фэнтези",
        "code": "",
        "discount": "Акция",
        "description": "С чего начать: первые книги самых знаковых фэнтези-циклов.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32203",
        "title": "Подборка. Книжные антидепрессанты",
        "code": "",
        "discount": "Акция",
        "description": "Книжные антидепрессанты, которые вернут вкус к жизни.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32212",
        "title": "Подборка. Личные финансы",
        "code": "",
        "discount": "Акция",
        "description": "Личные финансы: все о накоплении вашего капитала",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32202",
        "title": "Подборка. Главные новинки современной прозы",
        "code": "",
        "discount": "Акция",
        "description": "Главные новинки современной прозы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32205",
        "title": "Подборка. Ведьмы, лешие и их друзья",
        "code": "",
        "discount": "Акция",
        "description": "Историческая фантастика: от машины времени до попаданца.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-32211",
        "title": "Подборка. Бестселлеры саморазвития",
        "code": "",
        "discount": "Акция",
        "description": "Бестселлеры саморазвития международного рынка",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33020",
        "title": "Подарочные сертификаты. Подписка",
        "code": "",
        "discount": "30%",
        "description": "Много книг ваши на время:800 000+ книг, аудиокниг, подкастов и комиксов1000+ новинок каждый месяц (тысячи бестселлеров разных жанров – психология, саморазвитие, детективы, романы, биографии)Синхронизированные книги: переключайтесь с текста на аудио в 1 кликПосле окончания Подписки доступ к книгам прекратитсяСкидка до 30% на бумажные книги в сети магазинов «Читай-город»",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33018",
        "title": "Литрес. Подрочные сертификаты: Номиналы",
        "code": "",
        "discount": "100₽",
        "description": "Откройте близким мир книг и аудиокниг, выберите свой вариант электронного сертификата.Можно купить сертификат на любую выбранную сумму от 100 руб.Обладатель сертификата сможет пополнить свой счет в личном кабинете Литрес и распоряжаться по выбору: покупать отдельные книги навсегда или оплатить Абонемент",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33019",
        "title": "Подарочные сертификаты. Промо",
        "code": "",
        "discount": "Акция",
        "description": "Подарочные сертификаты Литрес: подарите близким мир книг и аудиокниг.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33048",
        "title": "Подборка. Книги в жанре Проза",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Проза - современная проза",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33050",
        "title": "Подборка. Книги в жанре Бизнес",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Бизнес - лёгкий способ узнать всё о предпринимательстве",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33041",
        "title": "Подборка. Книги в жанре Фантастики",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Фантастики - титулованная классика и яркие новости",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33046",
        "title": "Подборка. Книги в жанре Саморазвитие",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Саморазвитие - точка погружения в саморазвитие",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33045",
        "title": "Подборка. Книги в жанре СЛР/Эротика",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре СЛР/Эротика - книги про любовь",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33049",
        "title": "Подборка. Книги в жанре Детективы",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Детективы - загадки на каждый день",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33053",
        "title": "Подборка. Книги в жанре Эзотерика",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Эзотерика - начните управлять судьбой",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33052",
        "title": "Подборка. Книги в жанре История",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре История - книги по истории",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33051",
        "title": "Подборка. Книги в жанре Биографии и мемуары",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Биографии и мемуары",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33054",
        "title": "Подборка. Книги в жанре Ужасы / мистика",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Ужасы и Мистика",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33043",
        "title": "Подборка. Книги в жанре Фэнтези",
        "code": "",
        "discount": "Акция",
        "description": "Подборка книг в жанре Фэнтези - современное фэнтези и бессмертная классика",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33066",
        "title": "Подборка. ОГЭ и ЕГЭ на 100 баллов.",
        "code": "",
        "discount": "Акция",
        "description": "ОГЭ и ЕГЭ на 100 баллов. Лучшие книги для подготовки к экзаменам 2026",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-33067",
        "title": "Подборка. Никогда не поздно!",
        "code": "",
        "discount": "Акция",
        "description": "Учебники для студентов",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-08-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36070",
        "title": "Бумажные книги Литрес",
        "code": "",
        "discount": "Акция",
        "description": "Теперь в специальном разделе Литрес вы можете купить бумажные книги!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36424",
        "title": "Подборка. Премия Просветитель: от длинных списков до лауреатов",
        "code": "",
        "discount": "Акция",
        "description": "Книги-участники премии Просветитель, попавшие в длинный список, шортлис и ставшие лауреатами. Все книги премии Просветитель с 2008 по 2025 год.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36416",
        "title": "Подборка. 20 бестселлеров зарубежной литературы",
        "code": "",
        "discount": "Акция",
        "description": "Книжная сокровищница: 20 бестселлеров зарубежной прозы.Хотите пополнить библиотеку только самыми важными книгами? Мы уже сделали эту работу за вас! В этой подборке — 20 проверенных временем и миллионами читателей бестселлеров, которые точно не разочаруют. Отличный способ начать читать больше и с умом.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36417",
        "title": "Подборка. Фэнтези и фантастика на века",
        "code": "",
        "discount": "Акция",
        "description": "Откройте для себя мир, отмеченный высшими наградами фантастики и фэнтези. Эта подборка собрала произведения, удостоенные премий «Хьюго», «Локус», «Небьюла» и других знаков отличия. Каждая книга - это эталон своего жанра, признанный как критиками, так и миллионами читателей по всему миру.Вы найдете здесь эталонные космические оперы, философскую научную фантастику, эпическое фэнтези и интеллектуальные триллеры, перевернувшие представление о возможном. Эти истории задали новые стандарты, повлияли на культуру и продолжают удивлять глубиной идей и мастерством повествования.Погрузитесь в чтение проверенной классики и современных бестселлеров, чтобы понять, какие тренды определяют развитие жанров сегодня. Это ваш шанс оценить лучшие образцы мировой литературы, собранные в одной коллекции. Откройте книги, завоевавшие главные литературные премии в мире фантастики.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36418",
        "title": "Подборка. Комиксы и новеллы: что почитать?",
        "code": "",
        "discount": "Акция",
        "description": "Ищете захватывающие истории в формате комиксов и новелл? Эта подборка - ваш проводник в мир графических романов и иллюстрированной прозы, где каждая книга становится уникальным визуальным и сюжетным путешествием. Здесь собраны истории, способные увлечь любого: от эпичных фэнтези и научной фантастики до напряженных детективов и трогательных любовных драм. Вы найдете мрачные мистические триллеры, ироничные современные сюжеты и захватывающие приключения, где судьбы героев решаются в невероятных битвах или хитросплетениях чувств. Ценность подборки - в разнообразии миров и эмоций. Уникальность - в мощном синтезе слова и рисунка, который усиливает впечатление от чтения. Погрузитесь в истории о перерождении, силе духа, сложных отношениях и вечных противостояниях, где каждая страница дарит новые открытия. Начните знакомство с этими произведениями, чтобы найти свою следующую любимую вселенную.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36419",
        "title": "Подборка. Топ-50 в фэнтези",
        "code": "",
        "discount": "Акция",
        "description": "Откройте для себя самые ожидаемые миры 2025 года! Наша эксклюзивная подборка собрала главные фэнтези-новинки, где магия переплетается с современными сюжетами. Здесь вас ждут захватывающие приключения, эпические битвы со злом, остроумные истории с элементами романтики и иронии, а также запутанные детективные расследования в мистических вселенных.Каждая книга - это уникальный авторский мир, где герои сталкиваются с невероятными вызовами. Станьте первым, кто погрузится в новые саги и продолжения культовых серий. Эта коллекция - ваш проводник в самые обсуждаемые фэнтези-истории года, которые зададут тренды на весь сезон.Не упустите шанс начать чтение с самого актуального. Найдите свою следующую любимую книгу среди лучших новинок, которые уже покоряют сердца читателей.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36420",
        "title": "Подборка. Прослушать за 1 вечер!",
        "code": "",
        "discount": "Акция",
        "description": "Не хватает времени на чтение? Мы подобрали аудиокниги, которые умещаются в один вечер. Мощные повести, гениальные рассказы и лаконичные нон-фикшн книги — идеальный формат для дороги, пробежки или отдыха после работы. Начните и закончите историю сегодня.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36422",
        "title": "Подборка. Лучшие книги 21 века по версии The New York Times",
        "code": "",
        "discount": "Акция",
        "description": "Откройте для себя литературный канон нового тысячелетия. Эта подборка - квинтэссенция самых значимых произведений, отобранных авторитетными критиками The New York Times. Здесь собраны романы, которые формировали читательское сознание, задавали тон эпохи и становились мировыми бестселлерами.Вы найдете глубокие семейные саги, пронзительную психологическую прозу, интеллектуальную научную фантастику и мощные исторические реконструкции. Каждая книга - это уникальный взгляд на ключевые вопросы современности: этику, любовь, память, выживание и природу человека.Это ваш шанс составить исчерпывающее представление о главных литературных тенденциях 21 века. Идеальная основа для формирования личной библиотеки современной классики. Погрузитесь в чтение, которое меняет восприятие мира.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36425",
        "title": "Подборка. Must-read на английском",
        "code": "",
        "discount": "Акция",
        "description": "Подборка must-read на английском - ваш ключ к мировым бестселлерам по саморазвитию, бизнесу и психологии. Это тщательно отобранные произведения, которые меняют мышление и дают практические инструменты для карьеры и личной жизни.Чтение в оригинале позволяет глубже понять идеи авторов, прокачать язык и получить доступ к знаниям без искажений перевода. Каждая книга - это уникальная концепция, проверенная временем и успехом миллионов.Откройте для себя стратегии лидерства, финансовой грамотности, эффективного общения и личной эффективности. Начните читать, чтобы расти быстрее и принимать более мудрые решения. Ваш путь к новым вершинам начинается здесь.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36426",
        "title": "Подборка. 100 самых влиятельных духовных лидеров Watkins’ Spiritual list 2024-2025",
        "code": "",
        "discount": "Акция",
        "description": "Журнал Watkins публикует ежегодный список 100 самых духовно влиятельных ныне живущих людей – духовных учителей, активистов, авторов и мыслителей, которые меняют мир. В список могут попасть только те, кто вносит уникальный и духовный вклад в мировом масштабе, является ныне живущим и максимально заметным в информационном пространстве. В подборке книги тех, кто вошел в списки 2024-2025г.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36428",
        "title": "Подборка. ТОП-20 книг для исцеления травм",
        "code": "",
        "discount": "Акция",
        "description": "Эта подборка - ваш проводник на пути исцеления от психологических травм. Она собрала ключевые работы, которые помогают понять природу травмы, ее влияние на тело, разум и жизнь.Вы найдете книги, объясняющие, как детские переживания и семейные сценарии формируют наше настоящее. Практические руководства предложат техники для восстановления чувства безопасности, работы со страхом, стыдом и тревогой.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36430",
        "title": "Подборка. ТОП-30 self-help книг",
        "code": "",
        "discount": "Акция",
        "description": "Ищете проверенные инструменты для работы над собой? Эта подборка - ваш персональный гид в мире саморазвития и психологической помощи. Она объединяет ключевые идеи современных экспертов, чтобы вы могли осознанно менять свою жизнь к лучшему.Здесь собраны книги, которые отвечают на самые актуальные вопросы: как справиться с тревогой и выгоранием, выстроить личные границы, исцелить травмы прошлого и обрести внутреннюю опору. Вы найдете научно обоснованные методики и практичные стратегии для преодоления стресса, построения здоровых отношений и обретения душевного равновесия.Это не просто список, а тщательно отобранная коллекция, охватывающая все аспекты ментального здоровья.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36432",
        "title": "Подборка. ТОП-20 книг для уверенности в себе",
        "code": "",
        "discount": "Акция",
        "description": "Эта подборка - ваш личный навигатор к внутренней опоре и гармонии. Она создана для тех, кто стремится обрести уверенность, научиться отстаивать свои границы и ценить собственную уникальность без осуждения и перфекционизма.Здесь собраны ключевые работы, которые предлагают не просто теорию, а практические инструменты. Вы освоите навыки ассертивности, научитесь управлять эмоциями, разберетесь в тонкостях здоровой самооценки и поймете, как развить харизму. Книги помогут перестать зависеть от чужого мнения, обрести внутренний баланс и смелость двигаться к своим целям.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36431",
        "title": "Подборка. ТОП-20 книг для поиска предназначения",
        "code": "",
        "discount": "Акция",
        "description": "Ищете свой путь и смысл? Эта подборка - ваш проводник. Она создана для тех, кто чувствует внутренний зов к переменам, но не знает, с чего начать. Здесь собраны ключевые произведения, объединяющие практическую психологию, современный коучинг и глубокую философию поиска себя.Вы найдете не просто теории, а конкретные методики: от agile-подходов к жизни и нейрофизиологии до техник экспоненциального коучинга. Книги помогут расшифровать свои истинные желания, преодолеть страхи и выйти из состояния «никогда-нибудь». Вы научитесь отличать «хочу» от «надо», найдете свои сильные стороны и сформулируете личное «Почему».",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36433",
        "title": "Подборка. ТОП-25. Бизнес, финансы, карьера",
        "code": "",
        "discount": "Акция",
        "description": "Инвестируйте в себя правильно. ТОП-25 книг по бизнесу, финансам и карьере.Знания — самая надёжная валюта. Эта подборка — концентрированный опыт успешных предпринимателей, инвесторов и карьерных консультантов. От основ финансовой грамотности до продвинутых техник переговоров и построения личного бренда. Ваш следующий шаг к цели — здесь.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36434",
        "title": "Подборка. Топ 10 книг по психологии и саморазвитию от издательства МИФ",
        "code": "",
        "discount": "Акция",
        "description": "Ищете проверенные инструменты для личностного роста? Эта подборка от издательства МИФ - ваш персональный гид в мире психологии и саморазвития. Здесь собраны ключевые работы, которые меняют взгляд на себя, свои возможности и жизненные стратегии.Вы узнаете, как развить гибкое сознание, укрепить силу воли и построить здоровую самооценку. Книги помогут преодолеть внутренние барьеры, научат управлять временем и эмоциями, а также находить опору в себе.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36436",
        "title": "Подборка. Топ-20 книг по психологии в России по версии Psychologies.ru",
        "code": "",
        "discount": "Акция",
        "description": "Эксперты одного из самых авторитетных психологических изданий в стране отобрали 20 ключевых книг для понимания себя и других. От классики Юнга и Фрейда до современных бестселлеров о ментальном здоровье, отношениях и саморазвитии. Проверенный гид в мире психологической литературы — на Литрес.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36435",
        "title": "Подборка. ТОП-15 Деловая книга года 2025",
        "code": "",
        "discount": "Акция",
        "description": "Премия «Деловая книга года в России» – это ежегодный профессиональный конкурс, который выявляет самые значимые и влиятельные бизнес-книги, изданные в стране. Она учреждена компанией «Технологии Доверия» и рассматривается как одно из ключевых событий для авторов, издателей и экспертов деловой литературы. Премия формирует авторитетные рейтинги, отражающие актуальные тенденции и потребности российской бизнес-среды.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36427",
        "title": "Подборка. Must read. Только бестселлеры",
        "code": "",
        "discount": "Акция",
        "description": "Ценные идеи из лучших книг в саммари.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36423",
        "title": "Подборка. 50 бестселлеров всех времен по версии Amazon",
        "code": "",
        "discount": "Акция",
        "description": "Отличный ориентир, если не знаете, что почитать дальше.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-01-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-36916",
        "title": "Скидка 15% на весь каталог Литрес",
        "code": "",
        "discount": "15%",
        "description": "Дарим скидку 15% на весь каталог Литрес по промокоду.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-02-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37648",
        "title": "Акция. –20% на книги по саморазвитию, психологии и бизнесу",
        "code": "",
        "discount": "20%",
        "description": "По промокоду скидки –20% на книги по саморазвитию, психологии и бизнесу.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37800",
        "title": "Подборка. \"Точка опоры: здесь и сейчас\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Точка опоры: здесь и сейчас\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37806",
        "title": "Подборка. \"Трудный разговор? Легко!\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Трудный разговор? Легко!\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37804",
        "title": "Подборка. \"Тело как дом\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Тело как дом\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37799",
        "title": "Подборка. \"Вы — Ваша самая главная роль\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Вы — Ваша самая главная роль\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37805",
        "title": "Подборка. \"Не потерять свое \"Я\" и построить крепкий союз\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Не потерять свое \"Я\" и построить крепкий союз\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37802",
        "title": "Подборка. \"Свой путь: определяем желания и достигаем цели\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Свой путь: определяем желания и достигаем цели\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37798",
        "title": "Подборка. \"Основной государственный экзамен (ОГЭ)\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Основной государственный экзамен (ОГЭ)\"",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37803",
        "title": "Подборка. \"Диалог с собой: определяем вектор счастья\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Диалог с собой: определяем вектор счастья\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37801",
        "title": "Подборка. \"Нежные аудио-проводники к поиску себя\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Нежные аудио-проводники к поиску себя\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-37797",
        "title": "Подборка \"Единый государственный экзамен (ЕГЭ)\"",
        "code": "",
        "discount": "Акция",
        "description": "Подборка \"Единый государственный экзамен (ЕГЭ)\"",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-38253",
        "title": "Скидка 50% на подборку о саморазвитии и психологии",
        "code": "",
        "discount": "50%",
        "description": "Скидка по промокоду 50% на подборку литературы по бизнесу, психологии и саморазвитию.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-04-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-38426",
        "title": "Скидка 100% на 2 месяца Литрес Подписки",
        "code": "",
        "discount": "100%",
        "description": "Скидка 100% на 2 месяца Литрес Подписки по промокоду.Только для новых пользователей Литрес Подписки.Промокод действует 3 дня после активации.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-04-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-38491",
        "title": "Скидка 20% на подборку \"Слушайте до выхода бумажной книги\"",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% по промокоду на подборку \"Слушайте до выхода бумажной книги\".",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-04-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-38893",
        "title": "Скидка 30% на подборку книг к 9 мая",
        "code": "",
        "discount": "30%",
        "description": "Книги — это про память 🕊️Читайте хронику былых времён, исторические романы и мемуары. Литрес собрал отдельную подборку книг к этой дате. По промокоду 9MAY — скидка 30% на всё, что внутри.Погрузитесь в историю!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-38955",
        "title": "Скидка 40% на подборку комиксов по промокоду",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на подборку комиксов по промокоду.Для любых типов пользователей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      },
      {
        "id": "491-39036",
        "title": "Акция. Время читать. Коллекция со скидкой до 70%",
        "code": "",
        "discount": "70%",
        "description": "Скидки до 70% на коллекцию",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=491&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab5192346f3.png"
      }
    ]
  },
  {
    "id": "488",
    "name": "Московская Бизнес Академия",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab44fb72464.png",
    "description": "Московская Бизнес Академия — ведущая бизнес-школа на территории РФ и стран СНГ, имеющая аккредитацию академии. Обучение по программам MBA в Московской Бизнес Академии проходит на базе всех необходимых лицензий и аккредит",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "488-121327",
        "title": "Скидка 10% на заказ",
        "code": "ADVCAKE",
        "discount": "10%",
        "description": "Скидка 10% на все курсы",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=488&a=79",
        "isActive": true,
        "createdAt": "2025-09-03",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab44fb72464.png"
      },
      {
        "id": "488-33308",
        "title": "Скидка 10% на все курсы",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все курсы",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=488&a=79",
        "isActive": true,
        "createdAt": "2025-09-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67ab44fb72464.png"
      }
    ]
  },
  {
    "id": "477",
    "name": "AST.Wine",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png",
    "description": "На сегодняшний день компания AST – один из лидеров алкогольного рынка. Всю историю существования мы успешно и качественно сочетаем дистрибуцию крупнейших мировых брендов, являясь партнерами таких Компаний как Бакарди Рус",
    "promocodesCount": 6,
    "category": "Потребительские товары",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "477-131777",
        "title": "30% скидки на весь ассортимент AST.wine",
        "code": "Y606KGE2XO63",
        "discount": "30%",
        "description": "30% скидки на весь ассортимент AST.wine, не суммируется с другими акциями и предложениями.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=477&a=79",
        "isActive": true,
        "createdAt": "2026-04-28",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png"
      },
      {
        "id": "477-38137",
        "title": "Крепкий выбор. Скидка 35%",
        "code": "",
        "discount": "35%",
        "description": "Скидка 35%Для всех пользователей.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=477&a=79",
        "isActive": true,
        "createdAt": "2026-04-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png"
      },
      {
        "id": "477-37428",
        "title": "30% скидки на весь ассортимент AST.wine",
        "code": "",
        "discount": "30%",
        "description": "30% скидки на весь ассортимент AST.wine, не суммируется с другими акциями и предложениями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=477&a=79",
        "isActive": true,
        "createdAt": "2026-04-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png"
      },
      {
        "id": "477-38885",
        "title": "Скидки до 50%. Готовимся к летнему сезону.",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% Для всех пользователей.Без ограничений на количество покупок",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=477&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png"
      },
      {
        "id": "477-38887",
        "title": "Скидка 25%. Под солнцем Армении",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25%Для всех пользователей.Без ограничений на количество покупок",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=477&a=79",
        "isActive": true,
        "createdAt": "2026-05-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png"
      },
      {
        "id": "477-38886",
        "title": "Скидка 25%. World Cocktail Day - 13 мая",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25%Для всех пользователей.Без ограничений на количество покупок",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=477&a=79",
        "isActive": true,
        "createdAt": "2026-05-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720c46a135e0.png"
      }
    ]
  },
  {
    "id": "475",
    "name": "BUNGLY",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png",
    "description": "Детская одежда BUNGLY — российский бренд, созданный мамами. Преимущества для покупателей: - Бангли-комбинезон — идеальная одежда для прогулок и детского сада. - Только самые качественные и безопасные материалы. - Легко п",
    "promocodesCount": 6,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "475-127567",
        "title": "Скидка 7% на заказ",
        "code": "bngly26",
        "discount": "7%",
        "description": "Скидка 7%, не суммируется с другими скидками.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=475&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png"
      },
      {
        "id": "475-29684",
        "title": "Старт женской коллекции!",
        "code": "",
        "discount": "Акция",
        "description": "Встречайте первая женская коллекция 2025!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=475&a=79",
        "isActive": true,
        "createdAt": "2025-03-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png"
      },
      {
        "id": "475-34053",
        "title": "Скидки до 50% на раздел OUTLET",
        "code": "",
        "discount": "50%",
        "description": "Постоянно действующий раздел OUTLET со скидками до -50% (пополнение раздела раз в месяц)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=475&a=79",
        "isActive": true,
        "createdAt": "2025-10-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png"
      },
      {
        "id": "475-36026",
        "title": "Скидка ​7%",
        "code": "",
        "discount": "7%",
        "description": "Скидка 7%, не суммируется с другими скидками.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=475&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png"
      },
      {
        "id": "475-38323",
        "title": "Вне времени. Весна 2026. Новая коллекция",
        "code": "",
        "discount": "Акция",
        "description": "Вне времени. Весна 2026. Новая коллекция",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=475&a=79",
        "isActive": true,
        "createdAt": "2026-04-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png"
      },
      {
        "id": "475-39031",
        "title": "Межсезонная распродажа. Скидка до 40%. Дети и взрослые",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Акция действует только на выделенный ассортимент из раздела «Межсезонная распродажа» Оплата бонусами и начисление бонусов за покупки не действует на товары из выделенного раздела",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=475&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6720bac6bd5bb.png"
      }
    ]
  },
  {
    "id": "472",
    "name": "Profieng",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b5407194fb.png",
    "description": "Онлайн-школа английского языка Profieng Преимущества для покупателей: - Учитесь у преподавателей c сертификатом Cambridge University - Научитесь думать и даже видеть сны на английском языке - Говорите на английском языке",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "472-115622",
        "title": "Скидка 20% на заказ",
        "code": "profiengadv",
        "discount": "20%",
        "description": "Получите скидку 20% на первый платеж при использовании промокода для пакетов от 4 до 12 уроков. Также ученик получит один урок в подарок и бесплатный чек-ап с преподавателем.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=472&a=79",
        "isActive": true,
        "createdAt": "2024-08-19",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b5407194fb.png"
      },
      {
        "id": "472-38555",
        "title": "Месяц до свободного общения: 10 разговорных уроков в подарок!",
        "code": "",
        "discount": "Акция",
        "description": "Говорите уверенно уже через месяц!🎁 Получите 10 бесплатных разговорных уроков — только для новых учениковПогрузитесь в живое общение:Мини-группы с преподавателемАктуальные темы без скучной грамматикиГибкое расписание под ваш график",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=472&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b5407194fb.png"
      }
    ]
  },
  {
    "id": "469",
    "name": "KATA.academy",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b4dac566f1.png",
    "description": "KATA — это единственная в России школа программирования с оплатой обучения уже ПОСЛЕ трудоустройства по специальности. Миссия Kata — дать возможность каждому человеку за короткий срок получить востребованную, высокооплач",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "469-95393",
        "title": "Гайд \"Как вырасти в доходе\" в подарок при покупке",
        "code": "advcake24",
        "discount": "Акция",
        "description": "По промокоду \"Advcake24\" получи в подарок гайд \"Как вырасти в доходе\". Промокод необходимо ввести при оформлении заявки или назвать менеджеру.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=469&a=79",
        "isActive": true,
        "createdAt": "2024-11-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b4dac566f1.png"
      },
      {
        "id": "469-27859",
        "title": "Гайд в подарок по промокоду",
        "code": "",
        "discount": "Акция",
        "description": "По промокоду \"Advcake24\" получи в подарок гайд \"Как вырасти в доходе\". Промокод необходимо ввести при оформлении заявки или назвать менеджеру.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=469&a=79",
        "isActive": true,
        "createdAt": "2024-11-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b4dac566f1.png"
      },
      {
        "id": "469-38550",
        "title": "Гарантия трудоустройства или вернем 110% от стоимости курса",
        "code": "",
        "discount": "110%",
        "description": "Теперь не просто гарантируем трудоустройство - иначе вернем деньги. Возвращаем 110% от стоимости курса, если выпускник не устроился на работу после курса.С нуля до выхода на работуПоддержка ментораСопровождение карьерного консультантаГарантия трудоустройства прописана в договоре",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=469&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671b4dac566f1.png"
      }
    ]
  },
  {
    "id": "468",
    "name": "Ruli.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a3b051515a.png",
    "description": "Ruli.ru — интернет-магазин автотоваров, запчастей, автоаксессуаров по выгодным ценам. Компания в первую очередь ориентирована на продажу автооптики и кузовных запчастей. Ассортимент более 200 000 товаров, доставка в любу",
    "promocodesCount": 1,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "468-38981",
        "title": "Актуальные автотовары по выгодным ценам от 60 рублей",
        "code": "",
        "discount": "60₽",
        "description": "Актуальные автотовары по выгодным ценам от 60 рублейДля всех пользователейБез ограничений на количество покупок.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=468&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a3b051515a.png"
      }
    ]
  },
  {
    "id": "466",
    "name": "GIPFEL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png",
    "description": "Компания GIPFEL International – один из ведущих мировых производителей качественной посуды и аксессуаров для кухни. На сегодняшний день занимает первое место по количеству магазинов посуды и товаров для дома в России. С ",
    "promocodesCount": 6,
    "category": "Кухонные принадлежности и бытовая техника",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "466-130618",
        "title": "Скидка 10% на заказ от 5000 руб.",
        "code": "ADVCAKE",
        "discount": "10%",
        "description": "Скидка 10% от 5000 руб. на товары со скидкой не более 30%.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=466&a=79",
        "isActive": true,
        "createdAt": "2026-02-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png"
      },
      {
        "id": "466-36769",
        "title": "Скидка ​10% от 5000 руб.",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% от 5000 руб. на товары со скидкой не более 30%.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=466&a=79",
        "isActive": true,
        "createdAt": "2026-02-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png"
      },
      {
        "id": "466-38062",
        "title": "Скидки до 65% на выделенный ассортимент",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65%! На посуду для приготовления, сервировки и кухонные аксессуары.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=466&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png"
      },
      {
        "id": "466-38064",
        "title": "Скидки до 50% на посуду Werner",
        "code": "",
        "discount": "50%",
        "description": "На весь ассортимент бренда Werner скидки 50%",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=466&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png"
      },
      {
        "id": "466-38063",
        "title": "Скидки до 65% на подборку товаров для кухни",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65% на подборку товаров для кухни",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=466&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png"
      },
      {
        "id": "466-38726",
        "title": "Скидка 50% на посуду из керамики",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% на посуду из керамикиДля всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Действует на выделенный ассортимент товаров.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=466&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a358db81bc.png"
      }
    ]
  },
  {
    "id": "464",
    "name": "Bvdshop",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2e1e45bec.png",
    "description": "Bvdshop – это широкий ассортимент электротранспорта и мототехники для детей и взрослых. Мы специализируемся на продаже детских электромобилей, квадроциклов, электросамокатов, электровелосипедов, толокаров и питбайков. Пр",
    "promocodesCount": 3,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "464-115316",
        "title": "Скидка 1000 руб. на заказ от 20000 руб.",
        "code": "BVD1000",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей при покупке от 20 000 рублей.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=464&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2e1e45bec.png"
      },
      {
        "id": "464-31251",
        "title": "Скидка 1000 рублей на заказ",
        "code": "",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей при покупке от 20 000 рублей.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=464&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2e1e45bec.png"
      },
      {
        "id": "464-38968",
        "title": "Большая распродажа техники: скидки до 50% и цены ниже рынка",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% Для всех пользователей.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=464&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2e1e45bec.png"
      }
    ]
  },
  {
    "id": "463",
    "name": "ShinSale",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2bce8637d.png",
    "description": "ShinSale - крупнейший интернет-магазин б/у и новых шин. На сайте shinsale.ru можно приобрести только качественные Б/У шины с минимальным износом - мы продаем только резину, которая прослужит вам не один сезон. Преимущест",
    "promocodesCount": 2,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "463-128996",
        "title": "Скидка 5% на заказ",
        "code": "advcake",
        "discount": "5%",
        "description": "Выгода 5% на весь товар для вашего автомобиля — надежные шины, стильные диски и аксессуары теперь доступнее.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=463&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2bce8637d.png"
      },
      {
        "id": "463-36220",
        "title": "Скидка 5% на весь товар",
        "code": "",
        "discount": "5%",
        "description": "Выгода 5% на весь товар для вашего автомобиля — надежные шины, стильные диски и аксессуары теперь доступнее.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=463&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a2bce8637d.png"
      }
    ]
  },
  {
    "id": "462",
    "name": "ОГО1",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a259d0afb5.png",
    "description": "Описание оффера ОГО! – онлайн-гипермаркет на рынке с 2010 г. Более 50 000 товаров электроники, товаров для дома и ремонта, для детей и мам, и много другое. Бонусы за каждую покупку, гарантия от производителя, доставка по",
    "promocodesCount": 3,
    "category": "Потребительские товары",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "462-38545",
        "title": "Лучший момент для приобретения садовой техники",
        "code": "",
        "discount": "Акция",
        "description": "Самый важный момент для покупки садовой техники — сейчас.Мы отобрали лучшие газонокосилки от лидеров рынка, чтобы ваш газон выглядел как с обложки журнала. 🏅Наш топ-лист:🏆 Элитный класс: Безупречные Makita и технологичные Einhell.👍 Рабочие лошадки: Выносливые Denzel и PATRIOT.💖 Народный выбор: Проверенные временем Champion.Все модели в наличии и ждут своих владельцев.",
        "expiryDate": "2026-08-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=462&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a259d0afb5.png"
      },
      {
        "id": "462-38543",
        "title": "Бренд Thermos",
        "code": "",
        "discount": "Акция",
        "description": "Thermos — старейший мировой производитель изотермической продукции, основанный в 1904 году в Германии.🔥 Нужен горячий кофе в офисе, домашний суп в школе или согревающий чай в горах? Thermos — это база, которая никогда не подводит.☕ Классические стальные термосы для больших компаний и долгих поездок.🍱 Компактные термосы для еды, чтобы любимые блюда всегда были под рукой.🥤 Стильные термокружки для тех, кто постоянно в движении.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=462&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a259d0afb5.png"
      },
      {
        "id": "462-38542",
        "title": "Забудьте о графике отключения воды!",
        "code": "",
        "discount": "Акция",
        "description": "Надоело греть кастрюли или надеяться на милость коммунальщиков?Пора брать ситуацию в свои руки. 🛁У нас в наличии огромный ассортимент водонагревателей, которые обеспечат вам комфорт 365 дней в году!Почему покупать нужно именно у нас?🔹 Выбор под любые задачи: от компактных моделей для кухни до мощных бойлеров для всей семьи.🔹 Надёжность: только проверенные бренды с официальной гарантией.🔹 Решения для каждого: подберем вариант под ваш бюджет и размеры ванной или кухни.🟦 В квартиру: Чтобы не зависеть от сезонных отключений.🟦 На дачу: Для горячего душа после работы в саду.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=462&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671a259d0afb5.png"
      }
    ]
  },
  {
    "id": "459",
    "name": "Digital Skills Academy",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180b32b7a1a.png",
    "description": "Digital Skills Academy – это новая онлайн-школа, которая базируется на богатом опыте и знаниях команды SF Education. На протяжении 8 лет SF Education успешно обучает специалистов в сфере образования, и теперь мы применяе",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "459-121320",
        "title": "Скидка 15% на курсы",
        "code": "advcake60",
        "discount": "15%",
        "description": "Дополнительная скидка 15% на все курсы по промокоду",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=459&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180b32b7a1a.png"
      },
      {
        "id": "459-31189",
        "title": "48 часов бесплатного демо-доступа от Digital Skills Academy",
        "code": "",
        "discount": "Акция",
        "description": "Выбирайте любой курс или профессию и получите полный доступ на 48 часов ко всему контенту, а не к отдельной части. Так вы лучше поймете, подойдет ли вам курс.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=459&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180b32b7a1a.png"
      },
      {
        "id": "459-33832",
        "title": "Скидка 15% на курсы",
        "code": "",
        "discount": "15%",
        "description": "Дополнительная скидка 15% на все курсы по промокоду",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=459&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180b32b7a1a.png"
      },
      {
        "id": "459-33831",
        "title": "Скидка 15% на курсы",
        "code": "",
        "discount": "15%",
        "description": "Дополнительная скидка 15% на все курсы по промокоду",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=459&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180b32b7a1a.png"
      }
    ]
  },
  {
    "id": "458",
    "name": "Суши Мастер",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png",
    "description": "Федеральная сеть ресторанов доставки Суши Мастер с 2013 года занимает лидирующие позиции на рынке общественного питания. В меню представлен широкий ассортимент блюд японской кухни: суши, роллы, ВОК и поке, приготовленные",
    "promocodesCount": 15,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "458-118102",
        "title": "Скидка 10% на заказ",
        "code": "ДЕНЬРОЖДЕНИЯ",
        "discount": "10%",
        "description": "Дарим скидку 10% всем именинникам на основное меню! Промокод: ДЕНЬРОЖДЕНИЯ (не забудьте эти волшебные слова, когда будете делать заказ, иначе скидки не будет) Внимание! Проверьте, что в вашем личном кабинете указана дата рождения. Это важное условие, без него промокод работать не будет. Воспользоваться именинным предложением можно за 3 дня до Дня рождения и еще 3 дня после него, но не более одного раза в год. Важно! Акция не распространяется на меню по акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-119818",
        "title": "Скидка 11% на заказ от 1600 руб.",
        "code": "Home",
        "discount": "11%",
        "description": "Скидка 11% при покупке от 1600 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-119820",
        "title": "Ролл Чеддер в подарок при покупке от 1400 руб.",
        "code": "halyavshik",
        "discount": "1400₽",
        "description": "Ролл Чеддер в подарок при покупке от 1400 р., не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-119821",
        "title": "​Ролл Темпурный с беконом в подарок при покупке от 1400 руб.",
        "code": "box8",
        "discount": "1400₽",
        "description": "​Ролл Темпурный с беконом в подарок при покупке от 1400 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-119819",
        "title": "Скидка 10% на заказ от 1500 руб.",
        "code": "monetka",
        "discount": "10%",
        "description": "Скидка 10% при покупке от 1500 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-132562",
        "title": "Скидка до 20% на заказ",
        "code": "ЯМАСТЕР",
        "discount": "20%",
        "description": "Скидка до 20% на сеты по промокоду: -10% при покупке 4-х порций роллов -15% при покупке 6-ти порций роллов -20% при покупке 8-ми порций роллов",
        "expiryDate": "2026-12-25",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-32023",
        "title": "Скидка 10% в день рождения",
        "code": "",
        "discount": "10%",
        "description": "Дарим скидку 10% всем именинникам на основное меню! Промокод: ДЕНЬРОЖДЕНИЯ (не забудьте эти волшебные слова, когда будете делать заказ, иначе скидки не будет) Внимание! Проверьте, что в вашем личном кабинете указана дата рождения. Это важное условие, без него промокод работать не будет. Воспользоваться именинным предложением можно за 3 дня до Дня рождения и еще 3 дня после него, но не более одного раза в год. Важно! Акция не распространяется на меню по акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-32026",
        "title": "У нас бесплатно!",
        "code": "",
        "discount": "Акция",
        "description": "Приятное дополнение к вкусным роллам и сетам! Мелочь, а приятно) Заказывайте любимые роллы и сеты, а соевый соус, васаби и имбирь будут бесплатными к вашему заказу! Бесплатно идёт определенное количество специй, которое указано в корзине при добавлении сета и набора роллов. И да, вы всегда можете дозаказать отдельно нужное вам количество дополнительных специй и соусов. Приятного аппетита!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-32022",
        "title": "100 баллов и ролл в подарок за подписку на рассылку",
        "code": "",
        "discount": "1350₽",
        "description": "Хочешь получить 100 бонусных рублей? А популярный ролл в подарок? Выбирать не нужно, тебе достанутся все призы ;) Простая инструкция «Как стать богаче на 100 баллов»: 1. Авторизуйся на сайте Суши Мастер. 2. Перейди в личный кабинет и заполни данные: e-mail, имя и дату рождения. 3. Поздравляем! Бонусные рубли появятся на твоем счете через 24 часа – не забудь проверить (и потратить :) ) Не терпится заказать любимые роллы? А нам не терпится сделать для тебя еще один подарок! Популярный ролл Калифорния Микс добавим к заказу от 1350 рублей. Не суммируется с другими скидками и промокодами.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-32021",
        "title": "Подарок при самовывозе из ресторана",
        "code": "",
        "discount": "15%",
        "description": "При самовывозе из ресторана можно получить подарок на выбор по промокоду: ЗАБЕРУ15 - Подарит Кэшбэк 15% с заказа на твой бонусный счетЗАБЕРУКАЛИФА - Добавит к твоему заказу популярный ролл Калифорния каппа маки в кунжутеАкция не совместима с акционным меню",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-33144",
        "title": "Скидка 11% при заказе от 1600 руб.",
        "code": "",
        "discount": "11%",
        "description": "Скидка 11% при покупке от 1600 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-33145",
        "title": "Скидка 10% при заказе от 1500 руб.",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% при покупке от 1500 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-33146",
        "title": "Ролл Чеддер в подарок при покупке от 1400 руб.",
        "code": "",
        "discount": "1400₽",
        "description": "Ролл Чеддер в подарок при покупке от 1400 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-33147",
        "title": "​Ролл Темпурный с беконом в подарок при покупке от 1400 руб.",
        "code": "",
        "discount": "1400₽",
        "description": "Ролл Темпурный с беконом в подарок при покупке от 1400 руб, не действует на акционные блюда, не сочетается с бонусными баллами",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2025-08-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      },
      {
        "id": "458-37938",
        "title": "Скидка до 20% на сеты",
        "code": "",
        "discount": "20%",
        "description": "Скидка до 20% на сеты по промокоду:-10% при покупке 4-х порций роллов-15% при покупке 6-ти порций роллов-20% при покупке 8-ми порций роллов",
        "expiryDate": "2026-12-25",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=458&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67180a2f9c1ab.png"
      }
    ]
  },
  {
    "id": "457",
    "name": "Академия «Синергия»",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png",
    "description": "Академия «Синергия» — проект Университета «Синергия», крупнейшего частного вуза России с 30-летней историей. В академии обучают самым востребованным и актуальным профессиям в наиболее перспективных сферах и областях (IT ",
    "promocodesCount": 9,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "457-126098",
        "title": "Дополнительные 5% скидки по промокоду",
        "code": "academy55",
        "discount": "5%",
        "description": "Дополнительные 5% скидки по промокоду. Итоговая скидка с применением промокода составит 65% на всё. Для применения скидки назвать промокод менеджеру по телефону.",
        "expiryDate": "2026-08-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35394",
        "title": "Топовый курс: Графический дизайнер",
        "code": "",
        "discount": "60%",
        "description": "УТП:- 60% программы — практическая работа на реальных кейсах и проектах- 12 проектов для вашего портфолио на Behance- Оплачиваемая стажировка для лучших студентов- Доступ к современным инструментам и сервисам для графического дизайна- Обучение применению ИИ в работе- Персональная обратная связь и поддержка от практикующих дизайнеров- Преподаватели - практикующие эксперты и собственники студий дизайна- Участие в воркшопах и мастер-классах от ведущих экспертов- Оперативная обратная связь и индивидуальная поддержка тьюторов- Обучение на современной онлайн-платформе Synergy LMS- Комьюнити единомышленников в социальной сети Synergy",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35390",
        "title": "Топовый курс: Python-разработчик",
        "code": "",
        "discount": "60%",
        "description": "УТП:- 60% программы — практическая работа на реальных веб-дизайн проектах- 10+ работ в портфолио- Оплачиваемая стажировка для лучших студентов- Дополнительные курсы в подарок- Личные консультации с куратором- Живые вебинары с ответами на вопросы- Интерактивное обучение (система прогресса, упражнения и тесты и т.д.)- Хакатон и лайвкодинг-вебинары для того, чтобы выделиться в будущем при поиске работы- Оперативная обратная связь и индивидуальная поддержка тьюторов- Обучение на современной онлайн-платформе Synergy LMS- Комьюнити единомышленников в социальной сети Synergy",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35393",
        "title": "Топовый курс: Интернет-маркетолог",
        "code": "",
        "discount": "70%",
        "description": "УТП:- 70% программы — отработка навыков на реальных кейсах и задачах- изучите базу по 7 основным маркетинговым направлениям (от копирайтинга до seo)- 11 проектов в портфолио- Оплачиваемая стажировка для лучших студентов- Бесплатный доступ к платным сервисам- Возможность посещения профильных мероприятий и воркшопов- Обучение применению ИИ в работе- Схема эффективной воронки продаж от сооснователя Гильдии разработчиков чат-ботов- Шаблоны с рабочими формулами для оценки эффективности рекламы- Преподаватели - практикующие эксперты и собственники маркетинговых агентств- Оперативная обратная связь и индивидуальная поддержка тьюторов- Обучение на современной онлайн-платформе Synergy LMS- Комьюнити единомышленников в социальной сети Synergy",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35395",
        "title": "Топовый курс: Дизайнер интерьеров",
        "code": "",
        "discount": "60%",
        "description": "УТП:- 60% программы — практическая работа на реальных дизайн-проектах интерьеров- 10+ готовых проектов для вашего портфолио на Behance- Оплачиваемая стажировка для лучших студентов- Преподаватели — опытные практикующие специалисты в области дизайна интерьеров- Персональная поддержка и обратная связь от практикующих дизайнеров интерьеров- Участие в воркшопах и мастер-классах от ведущих экспертов в сфере интерьеров- Обучение на современной онлайн-платформе Synergy LMS- Комьюнити единомышленников в социальной сети Synergy",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35391",
        "title": "Топовый курс: Менеджер маркетплейсов",
        "code": "",
        "discount": "70%",
        "description": "УТП:- 70% программы — отработка навыков на реальных кейсах и задачах- 5 дополнительных курсов в подарок- Готовое портфолио с 5 проектами уже на 3 месяце обучения - Оплачиваемая стажировка для лучших студентов- Индивидуальный график обучения, личные проекты и персональная обратная связь от преподавателя- Запуск продаж во время обучения на Wildberries, Ozon, Яндекс Маркете, Мегамаркете, Авито, Lamoda- 4 специализации по конкурентным нишам для старта продаж на маркетплейсах- Преподаватели —ТОП-эксперты из рынка E-commerce и практикующие селлеры- Трехдневный интенсив с экспертами MPSTATS для старта продаж на маркетплейсах- Посещение крупных E-commerce форумов и воркшопов: MPSTATS Expo, Оборот, ComeOn Forum, Ecom Сфера Yandex, Ecom Retail Week- Оперативная обратная связь и индивидуальная поддержка тьюторов- Обучение на современной онлайн-платформе Synergy LMS- Комьюнити единомышленников в социальной сети Synergy",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35392",
        "title": "Топовый курс: Интернет-маркетолог",
        "code": "",
        "discount": "70%",
        "description": "УТП:- 70% программы — отработка навыков на реальных кейсах и задачах- изучите базу по 7 основным маркетинговым направлениям (от копирайтинга до seo)- 11 проектов в портфолио- Оплачиваемая стажировка для лучших студентов- Бесплатный доступ к платным сервисам- Возможность посещения профильных мероприятий и воркшопов- Обучение применению ИИ в работе- Схема эффективной воронки продаж от сооснователя Гильдии разработчиков чат-ботов- Шаблоны с рабочими формулами для оценки эффективности рекламы- Преподаватели - практикующие эксперты и собственники маркетинговых агентств- Оперативная обратная связь и индивидуальная поддержка тьюторов- Обучение на современной онлайн-платформе Synergy LMS- Комьюнити единомышленников в социальной сети Synergy",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-35943",
        "title": "Дополнительные 5% скидки по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Дополнительные 5% скидки по промокоду. Итоговая скидка с применением промокода составит 65% на всё.Для применения скидки назвать промокод менеджеру по телефону.",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      },
      {
        "id": "457-36760",
        "title": "Скидка 60% на обучение в Академии «Синергия»",
        "code": "",
        "discount": "60%",
        "description": "Скидка 60% на все программы дополнительного профессионального образования Академии «Синергия»",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=457&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6718072edfcf1.png"
      }
    ]
  },
  {
    "id": "456",
    "name": "Emka",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671804fcbf64f.png",
    "description": "Emka — это российский бренд женской одежды, история которого началась в 2002 году. Мы совместили отечественное производство с европейским качеством, предлагая стильные вещи для офиса, удобные модели на каждый день и наря",
    "promocodesCount": 5,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "456-131717",
        "title": "Скидка 10% на заказ от 10000 руб.",
        "code": "EmkaBonus",
        "discount": "10%",
        "description": "Скидка -10% при заказе от 10 000 рублей по проомокоду.",
        "expiryDate": "2026-05-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=456&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671804fcbf64f.png"
      },
      {
        "id": "456-38328",
        "title": "Скидки до 50%",
        "code": "",
        "discount": "50%",
        "description": "Скидки до 50%Для всех пользователейБез ограничений на количество покупок",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=456&a=79",
        "isActive": true,
        "createdAt": "2026-04-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671804fcbf64f.png"
      },
      {
        "id": "456-38326",
        "title": "Новая коллекция. Весна-лето 2026",
        "code": "",
        "discount": "Акция",
        "description": "Новая коллекция. Весна-лето 2026",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=456&a=79",
        "isActive": true,
        "createdAt": "2026-04-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671804fcbf64f.png"
      },
      {
        "id": "456-37375",
        "title": "Скидка -10% при заказе от 10 000 руб.",
        "code": "",
        "discount": "10%",
        "description": "Скидка -10% при заказе от 10 000 рублей по проомокоду.",
        "expiryDate": "2026-05-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=456&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671804fcbf64f.png"
      },
      {
        "id": "456-38960",
        "title": "Актуальные новинки сезона",
        "code": "",
        "discount": "Акция",
        "description": "Актуальные новинки сезона",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=456&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img671804fcbf64f.png"
      }
    ]
  },
  {
    "id": "453",
    "name": "START",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717fbd926fe8.png",
    "description": "START — это доступный по всему миру онлайн-кинотеатр лучших фильмов и сериалов. А ещё это первый российский онлайн-кинотеатр с собственными сериалами и фильмами, созданными специально для подписчиков. Среди оригинальных ",
    "promocodesCount": 5,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "453-131781",
        "title": "25 дней подписки бесплатно",
        "code": "adv2",
        "discount": "499₽",
        "description": "25 дней отличных фильмов и сериалов бесплатно для новых пользователей. Далее 499 ₽ за месяц.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=453&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717fbd926fe8.png"
      },
      {
        "id": "453-37438",
        "title": "START - 30 дней бесплатного доступа для новых пользователей (б)",
        "code": "",
        "discount": "499₽",
        "description": "30 дней отличных фильмов и сериалов бесплатно для новых пользователей. Далее 499 ₽ за месяц.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=453&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717fbd926fe8.png"
      },
      {
        "id": "453-37434",
        "title": "START - 25 дней бесплатного доступа для новых пользователей (об)",
        "code": "",
        "discount": "499₽",
        "description": "25 дней отличных фильмов и сериалов бесплатно для новых пользователей. Далее 499 ₽ за месяц.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=453&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717fbd926fe8.png"
      },
      {
        "id": "453-37436",
        "title": "START - 25 дней бесплатного доступа для новых пользователей (атр)",
        "code": "",
        "discount": "499₽",
        "description": "25 дней отличных фильмов и сериалов бесплатно для новых пользователей. Далее 499 ₽ за месяц.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=453&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717fbd926fe8.png"
      },
      {
        "id": "453-39010",
        "title": "Инспектор Гаврилов 3 - Премьера нового сезона на START!",
        "code": "",
        "discount": "Акция",
        "description": "Инспектор Гаврилов возвращается!Премьера 3-го сезона на START — уже доступные первые серии!«Гаврилов — наш мэр».История о воре в мундире подполковника близится к развязке: Саша Медный идет на повышение!Встречаемся на START и смотрим продолжение «Инспектора Гаврилова».",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=453&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717fbd926fe8.png"
      }
    ]
  },
  {
    "id": "451",
    "name": "Нутрициолог с 0 до PRO",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f668d7d19.png",
    "description": "Откройте мир нутрициологии с курсом \"Нутрициолог с 0 до PRO\"! В эпоху растущего интереса к здоровому образу жизни, профессия нутрициолога становится все более востребованной. По данным Института труда, спрос на специалис",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "450",
    "name": "Anecole",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png",
    "description": "Anecole — онлайн-школа иностранных языков для взрослых и детей. На выбор предоставляются занятия по таким языкам, как: французский, английский, испанский, немецкий, китайский, итальянский, португальский. Уроки проходят в",
    "promocodesCount": 7,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "450-126092",
        "title": "Скидка 20%",
        "code": "УЧИСЬ",
        "discount": "20%",
        "description": "Скидка 20% на покупку по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      },
      {
        "id": "450-29067",
        "title": "Марафон ко Дню всех влюбленных",
        "code": "",
        "discount": "Акция",
        "description": "Узнайте, как говорить о своих чувствах на 7 языках, погрузитесь в культуру разных стран и найдите тот самый язык, который захочется изучать.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2025-02-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      },
      {
        "id": "450-34864",
        "title": "Черная Пятница в Anecole!",
        "code": "",
        "discount": "25%",
        "description": "-Скидки до 25% на индивидуальные языковые уроки-Бесплатный пробный урок,-Разговорный клуб и доступ к онлайн-комьюнити учеников-Марафон по любимым музыкальным хитам на языке оригинала в подарок-Выгодные предложения от партнеровЛендинг - https://anecole.com/blackfriday2025Баннеры - https://drive.google.com/file/d/1IU_JYnZw4KHF5jnU3...",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2025-11-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      },
      {
        "id": "450-35143",
        "title": "Языковые разговорные клубы",
        "code": "",
        "discount": "Акция",
        "description": "У нас есть отдельное направление языковые разговорные клубы, где ученики погружаются в культуру изучаемого языка, снимают языковой барьер и прокачивают словарный запас:Французский https://anecole.com/anparleАнглийский https://anecole.com/speaking-club/englishИспанский https://anecole.com/club_de_conversacionНемецкий https://anecole.com/speaking-club/germanИтальянский https://anecole.com/speaking-club/italianКитайский https://anecole.com/speaking-club/chinese",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2025-11-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      },
      {
        "id": "450-36057",
        "title": "Интенсив по иностранным языкам во вселенной Гарри Поттера",
        "code": "",
        "discount": "Акция",
        "description": "Магический интенсив по иностранным языкам во вселенной Гарри Поттера на 9 языках✅Разбор 500+ слов и выражений из вселенной, которая покорила мир✅Просмотр культовых моментов истории на разных языках",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      },
      {
        "id": "450-35929",
        "title": "Скидка 20% на покупку",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на покупку по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      },
      {
        "id": "450-39011",
        "title": "Бесплатный пробный урок по корейскому языку!",
        "code": "",
        "discount": "Акция",
        "description": "Заговори на корейском языке уже через два месяца!Записывайся на первый бесплатный пробный урок!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=450&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6717f2e9b41a7.png"
      }
    ]
  },
  {
    "id": "447",
    "name": "Psycholesson",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67169ae562e23.png",
    "description": "Psycholesson — школа, предоставляющая профессиональное обучение для психологов. Преимущества для покупателей: - Актуальная программа. Все видеоматериалы курсов полностью пересняты в 2024 году. - Читают курс и проводят пр",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "445",
    "name": "EKONIKA",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66fe5f4bde202.png",
    "description": "EKONIKA — модная сеть обуви и аксессуаров. В коллекции всегда есть как эффектные трендовые решения, так и базовые варианты на каждый день — высокого качества на любой случай. В коллекции представлены три торговые марки: ",
    "promocodesCount": 1,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "445-38681",
        "title": "Лето 2026. Новая коллекция",
        "code": "",
        "discount": "Акция",
        "description": "EKONIKA Лето 2026 новая женственность в коллекции",
        "expiryDate": "2026-08-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=445&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66fe5f4bde202.png"
      }
    ]
  },
  {
    "id": "444",
    "name": "SKILLBOX",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png",
    "description": "Skillbox — образовательная платформа, которая объединяет ведущих экспертов и практиков рынка, методистов и продюсеров образовательного контента. Платформа была запущена в 2016 году и на сегодняшний день предлагает более ",
    "promocodesCount": 13,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "444-127186",
        "title": "5% по промокоду",
        "code": "PARTNER",
        "discount": "5%",
        "description": "скидка 5% к текущей скидке по промокоду. Суммируется со скидкой на странице распродажи",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-134286",
        "title": "Скидка 75% по промокоду (СНГ)",
        "code": "SKILLBOX26",
        "discount": "75%",
        "description": "Скидка 75% по промокоду от полной стоимости. Промокод распространяется на покупку во всех странах СНГ, где есть Скиллбокс.",
        "expiryDate": "2026-06-02",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32096",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Молдова)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32097",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Азербайджан)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32099",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Кыргызстан)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32095",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Армения)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32100",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Узбекистан)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32094",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Беларусь)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-32098",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок (Казахстан)",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2024-06-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-33321",
        "title": "Весенняя акция Skillbox – скидка до 60% и подписка на 90+ курсов в подарок",
        "code": "",
        "discount": "60%",
        "description": "Skillbox запускает распродажу, где можно успеть купить любой курс со скидкой до 60%. А ещё — каждый, кто выберет обучение в этот период, получит в подарок подписку на 90+ курсов на месяц",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2025-09-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-36003",
        "title": "Дополнительная скидка 5% по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Примени промокод и получи дополнительную скидку 5% на обучение!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-37498",
        "title": "Скидка 5% дополнительно по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Дополнительная скидка 5% по промокоду. Суммируется со скидками на сайте.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2026-03-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      },
      {
        "id": "444-38605",
        "title": "Скидка 75% по промокоду (СНГ)",
        "code": "",
        "discount": "75%",
        "description": "Скидка 75% по промокоду от полной стоимости. Промокод распространяется на покупку во всех странах СНГ, где есть Скиллбокс.",
        "expiryDate": "2026-06-02",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=444&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66deaae73861b.png"
      }
    ]
  },
  {
    "id": "443",
    "name": "NAOS",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png",
    "description": "NAOS — французская дерматологическая компания, в которую входят бренды Bioderma, Institut Esthederm и Etat Pur. В разработке своих продуктов NAOS придерживается принципов экобиологии: уважения экосистемы организма и биол",
    "promocodesCount": 7,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "443-131292",
        "title": "Скидка 20% на заказ",
        "code": "NAOSNEW",
        "discount": "Бесплатная доставка",
        "description": "Скидка 20% на все для новых клиентов. На заказ от любой суммы. Действует на бренды BIODERMA, Institut Esthederm и Etat Pur. Исключения - новинки, наборы, Age Proteom. Скидка не суммируется с другими акциями (кроме бесплатной доставки от 4000 руб. и скидки 3% при оплате онлайн).",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-02-19",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      },
      {
        "id": "443-37083",
        "title": "​Скидка 20% на все для новых клиентов",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Скидка 20% на все для новых клиентов. На заказ от любой суммы. Действует на бренды BIODERMA, Institut Esthederm и Etat Pur. Исключения - новинки, наборы, Age Proteom. Скидка не суммируется с другими акциями (кроме бесплатной доставки от 4000 руб. и скидки 3% при оплате онлайн).",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-02-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      },
      {
        "id": "443-38790",
        "title": "Подарочные наборы Institut Esthederm с выгодой 28%",
        "code": "",
        "discount": "28%",
        "description": "Мы объединили наши бестселлеры антивозрастной линейки в готовые комплексы для интенсивного восстановления и сияния кожи. Порадуйте себя или близких подарочными наборами Institut Esthederm с выгодой 28%.",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      },
      {
        "id": "443-38786",
        "title": "Скидка 20% на избранные товары гаммы Node Bioderma",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на средства28438A НОДЭ DS+ шампунь ,125 мл28442B Нодэ K Шампунь, 150 мл28428I Нодэ Шампунь 400 мл",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      },
      {
        "id": "443-38787",
        "title": "-20% на средства PHOTODERM и солнцезащитные продукты в подарок",
        "code": "",
        "discount": "20%",
        "description": "-20% на все средства PHOTODERM.PHOTODERM Гель-крем после солнца в подарок при покупке 3-х средств BIODERMA, 1 из которых Photoderm; PHOTODERM Солнцезащитный антиоксидантный увлажняющий спрей SPF50 в подарок при покупке от 4-х средств, 1 из которых Photoderm.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      },
      {
        "id": "443-38788",
        "title": "Пляжная сумка в подарок при покупке Institut Esthederm",
        "code": "",
        "discount": "000₽",
        "description": "С 1 по 31 мая при покупке от 2-х средств Institut Esthederm, одно из которых Suncare, пляжная сумка в подарок.* Общая сумма заказа от 10 000 рублей. Полные условия представлены на странице предложения в разделе Акции.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      },
      {
        "id": "443-38792",
        "title": "-20% на избранные средства Etat Pur",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на избранные продукты бренда Etat Pur",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=443&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c497170f9dd.png"
      }
    ]
  },
  {
    "id": "442",
    "name": "Hello world",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c49d6c6e254.png",
    "description": "Мы – детская онлайн-школа программирования \"Hello world\". Помогаем ребятам от 7 до 17 лет с пользой проводить время за компьютером, а кому-то даже определиться с будущей профессией. Отвлекаем ребят от тик-тока и ютуба на",
    "promocodesCount": 1,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "442-38441",
        "title": "Подарки к уроку",
        "code": "",
        "discount": "1400₽",
        "description": "При оплате вводного урока стоимостью 1400 рублей, получаете бессрочный доступ к 10+ тренажерам в личном кабинете школы.Ребенок получит не просто занятие, а целый набор интерактивных тренажеров:- на развитие логики и алгоритмического мышления;- на прокачку памяти и концентрации;- на внимание и усидчивость;- на скорость реакции и принятие решений.Это игровые задания, которые увлекают и одновременно формируют навыки, важные для учебы.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=442&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c49d6c6e254.png"
      }
    ]
  },
  {
    "id": "441",
    "name": "Горздрав",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c4841d93142.png",
    "description": "Горздрав — сеть аптек с круглосуточным доступом к каталогу лекарственных средств. Более 20 лет мы обеспечиваем жителей Москвы и других городов новинками фармацевтического рынка, проверенными препаратами, редкими жизненно",
    "promocodesCount": 4,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "441-125023",
        "title": "Скидка 5% на заказ от 1500 руб.",
        "code": "5-adc",
        "discount": "5%",
        "description": "Скидка 5% на первый заказ на сайте от 1500 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=441&a=79",
        "isActive": true,
        "createdAt": "2025-11-21",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c4841d93142.png"
      },
      {
        "id": "441-35051",
        "title": "Скидка 5% на первый заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на первый заказ на сайте от 1500 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=441&a=79",
        "isActive": true,
        "createdAt": "2025-11-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c4841d93142.png"
      },
      {
        "id": "441-38781",
        "title": "Скидка 50%",
        "code": "",
        "discount": "50%",
        "description": "СОЛНЕЧНЫЕ СКИДКИ ДО 50%Для всех пользователей.При покупке акционного товара применяется максимальная скидка, действующая на этот товар. Скидки по акции не суммируются с другими скидками на товары, в том числе по социальной карте.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=441&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c4841d93142.png"
      },
      {
        "id": "441-38782",
        "title": "КОПИБАЛЛЫ",
        "code": "",
        "discount": "10%",
        "description": "Совершаете покупки в сумме на 10 000 ₽ за 3 календарных месяца.Платите бонусами за онлайн-заказы в следующем месяце (до 10% стоимости)Для всех пользователей. Условия иных бонусных/дисконтных программ не действуют.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=441&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c4841d93142.png"
      }
    ]
  },
  {
    "id": "439",
    "name": "Trivago AU",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66b32792a6c06.png",
    "description": "trivago’s hotel search allows users to compare hotel prices in just a few clicks from hundreds of booking sites for more than 5.0 million hotels and other types of accommodation in over 190 countries.",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "437",
    "name": "WowTickets-US",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6694e77e0976d.png",
    "description": "Our benefits - Top-notch commissions and incentives User-friendly interface Quick response to your queries Timely and automatic payments Wowtickets is a leading innovator in travel solutions. Our cutting-edge platform is",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "436",
    "name": "AirAsia Travel",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img668ffba3ea647.png",
    "description": "Airasia is a Malaysian multinational low-cost airline headquartered near Kuala Lumpur, Malaysia. It is the largest airline in Malaysia by fleet size and destinations. airasia operates scheduled domestic and international",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "433",
    "name": "585*Золотой",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf12d6cb16d.png",
    "description": "«585*Золотой» — российская франчайзинговая федеральная розничная ювелирная сеть. На сегодняшний день «585*Золотой» имеет собственные ювелирные производства под брендом «Талант» в Санкт-Петербурге, Ленинградской обл. и г.",
    "promocodesCount": 1,
    "category": "Украшения и аксессуары ",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "433-38146",
        "title": "Золотые цепи от 5990 руб.",
        "code": "",
        "discount": "5990₽",
        "description": "Чувствуете эту золотую искру? Она здесь — ваша идеальная цепь, которая добавит блеска любому образу. И всего от 5 990 рублей!Разные плетения, все размеры, собственное производство и привлекательные цены!",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=433&a=79",
        "isActive": true,
        "createdAt": "2026-04-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf12d6cb16d.png"
      }
    ]
  },
  {
    "id": "430",
    "name": "Edwica",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf1ed8e5dfe.png",
    "description": "Edwica - это уникальный сервис для планирования карьеры. Система анализирует ваши навыки и цели, предлагает оптимальный план развития и подбирает подходящие вакансии. Благодаря анализу данных с более 8 сайтов занятости, ",
    "promocodesCount": 0,
    "category": "Услуги",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "429",
    "name": "CDEK",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf27989df75.png",
    "description": "Международная компания CDEK предлагает комплекс услуг «под ключ»: логистика, курьерская доставка, фулфилмент, постаматы, COD, интеграции и IT-сервисы, продвижение на маркетплейсах. Более 5000 офисов компании открыты в 20",
    "promocodesCount": 3,
    "category": "Услуги",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "429-131104",
        "title": "Скидка 15% на заказ",
        "code": "CDEK15A",
        "discount": "15%",
        "description": "Для всех новых пользователей — скидка 15% на первую отправку. Отправляйте посылки, документы и грузы с надёжным партнёром и сразу чувствуйте выгоду.",
        "expiryDate": "2026-07-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=429&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf27989df75.png"
      },
      {
        "id": "429-37305",
        "title": "Баннеры общие cdek.ru от 2026 года",
        "code": "",
        "discount": "Акция",
        "description": "Баннеры общие cdek.ru от 2026 года",
        "expiryDate": "2027-01-07",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=429&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf27989df75.png"
      },
      {
        "id": "429-37010",
        "title": "Скидка ​15% для новых пользователей",
        "code": "",
        "discount": "15%",
        "description": "Для всех новых пользователей — скидка 15% на первую отправку. Отправляйте посылки, документы и грузы с надёжным партнёром и сразу чувствуйте выгоду.",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=429&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf27989df75.png"
      }
    ]
  },
  {
    "id": "427",
    "name": "Otello",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66bf3005d0120.png",
    "description": "Отелло — это удобный сервис бронирования отелей и гостиниц по всему миру. Более 2 млн объектов: отели, гостиницы, хостелы, базы отдыха и апартаменты. Реальные отзывы гостей, надежная поддержка 24/7 и бесплатный апгрейд н",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "423",
    "name": "SIBERINA",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c46d5f3aa58.png",
    "description": "SIBERINA – это российская компания, которая создает уникальную косметику на основе сибирских трав. СЕГОДНЯ В АССОРТИМЕНТЕ БОЛЕЕ 300 НАИМЕНОВАНИЙ, СРЕДИ КОТОРЫХ: Средства для очищения кожи лица – мицеллярная вода, молочко",
    "promocodesCount": 2,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "423-132187",
        "title": "Скидка 20%",
        "code": "advcake20",
        "discount": "20%",
        "description": "Скидка 20% на заказ по промокоду Для всех клиентов. Без ограничений на количество покупок. Не суммируется с другими акциями. Действует на все товары. Без ограничения по размеру скидки.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=423&a=79",
        "isActive": true,
        "createdAt": "2026-03-13",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c46d5f3aa58.png"
      },
      {
        "id": "423-37549",
        "title": "Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на заказ по промокодуДля всех клиентов.Без ограничений на количество покупок.Не суммируется с другими акциями.Действует на все товары.Без ограничения по размеру скидки.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=423&a=79",
        "isActive": true,
        "createdAt": "2026-03-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c46d5f3aa58.png"
      }
    ]
  },
  {
    "id": "421",
    "name": "Xpresent",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c471831f968.png",
    "description": "Xpresent — агрегатор подарочных сертификатов на впечатления. Человек получает подарочный набор, в который входит от 15 до 30 впечатлений, и он сможет сам выбрать 1 услугу, о которой он может быть давно мечтал. Прежде чем",
    "promocodesCount": 5,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "421-128985",
        "title": "Скидка 5% на заказ",
        "code": "advcake",
        "discount": "5%",
        "description": "Скидка 5% на все сертификаты. Минимальная сумма заказа 1000 руб.",
        "expiryDate": "2027-01-01",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=421&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c471831f968.png"
      },
      {
        "id": "421-36215",
        "title": "​Скидка 5% на все сертификаты",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на все сертификаты. Минимальная сумма заказа 1000 руб.",
        "expiryDate": "2027-01-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=421&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c471831f968.png"
      },
      {
        "id": "421-38290",
        "title": "Бесплатная доставка",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Получите бесплатную курьерскую доставку в пределах КАД при заказе от 7000 рублей",
        "expiryDate": "2027-02-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=421&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c471831f968.png"
      },
      {
        "id": "421-38289",
        "title": "Кешбэк 5% с каждого заказа",
        "code": "",
        "discount": "5%",
        "description": "С каждого заказа начисляем кешбэк 5%. Копите бонусы и оплачивайте ими до 50% суммы заказов.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=421&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c471831f968.png"
      },
      {
        "id": "421-38760",
        "title": "Второй сертификат в подарок",
        "code": "",
        "discount": "5000₽",
        "description": "Дарим сертификат “Набор Х” при заказе от 5000 рублей или подарочные набор “Лови момент” при заказе от 10 000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=421&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c471831f968.png"
      }
    ]
  },
  {
    "id": "420",
    "name": "Московский Институт Психологии",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66a8a45d8a792.png",
    "description": "Московский Институт Психологии - это онлайн-институт психологии, где можно освоить востребованную профессию психолога или повысить квалификацию. Наша цель - создать комфортную среду обучения и предоставить слушателям сам",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "418",
    "name": "IntimShop",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c70b23a06f5.png",
    "description": "IntimShop.ru — первый в России интернет-магазин для взрослых и бессменный лидер рынка 18+ уже на протяжении 24 лет. Более 40000 товаров на сайте от официальных производителей из США, Германии, Франции, России и пр. Все т",
    "promocodesCount": 5,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "418-115317",
        "title": "Скидка 10% на заказ",
        "code": "CAKE10",
        "discount": "10%",
        "description": "​Скидка 10% на весь ассортимент. Без ограничения количества применений, без минимальной цены.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=418&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c70b23a06f5.png"
      },
      {
        "id": "418-31253",
        "title": "Скидка 10% на весь ассортимент",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на весь ассортимент. Без ограничения количества применений, без минимальной цены.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=418&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c70b23a06f5.png"
      },
      {
        "id": "418-38191",
        "title": "Гарантия удовольствия с брендами We-Vibe и Womanizer",
        "code": "",
        "discount": "Акция",
        "description": "Грандиозная акция совместно с premium-брендами We-Vibe и Womanizer: приобретите флагманские продукты из списка совершенно безопасно для своего бюджета! Ведь в случае, если товар не принесет удовольствия, мы вернем затраченные средства на ваш личный счет в личном кабинете. Подробную информацию об акции вы найдете в карточке товара.В акции участвуют Womanizer Next Sensual Collection и Womanizer Next Duo.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=418&a=79",
        "isActive": true,
        "createdAt": "2026-04-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c70b23a06f5.png"
      },
      {
        "id": "418-38192",
        "title": "Скидка 20% на бренд Fleshlight",
        "code": "",
        "discount": "20%",
        "description": "Покупайте товары бренда Fleshligh со скидкой 20%",
        "expiryDate": "2026-07-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=418&a=79",
        "isActive": true,
        "createdAt": "2026-04-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c70b23a06f5.png"
      },
      {
        "id": "418-38697",
        "title": "-20% на премиум-бренды!",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на премиум-бренды: Arcwave, Bathmate, Fleshlight, Kiiroo, Tenga, We-vibe, Womanizer",
        "expiryDate": "2026-07-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=418&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c70b23a06f5.png"
      }
    ]
  },
  {
    "id": "417",
    "name": "GrownAlchemist",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c712af5569f.png",
    "description": "Grown Alchemist — это австралийский бренд инновационных средств по уходу за кожей, основанных на качественных и эффективных природных компонентах, которые направлены на улучшение здоровья кожи на клеточном уровне. Бренд ",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "415",
    "name": "Будь здоров!",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png",
    "description": "Аптеки сети «Будь здоров!» - это аптеки, удобно расположенные в шаговой доступности от дома, где всегда можно найти широкий ассортимент лекарств, способный удовлетворить не только первичные нужды, но и потребность в редк",
    "promocodesCount": 19,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "415-28661",
        "title": "500 бонусов на День рождения!",
        "code": "",
        "discount": "20%",
        "description": "В честь Вашего дня рождения дарим Вам 500 бонусов на карту лояльности «Аптечная семья».Бонусы начисляются автоматически за 7 дней до Вашего дня рождения.Начисленные бонусы позволяют вам оплатить до 20% от стоимости товара.Срок действия бонусов составляет 14 дней с даты начисления.Бонусы можно использовать в аптеках и при заказе в интернет-аптеке.Ограничения по акции:Для получения бонусов необходимо не менее чем за 8 дней до фактической даты рождения иметь:Активированную карту «Аптечная Семья»;Указанные в профиле Дату рождения и действующий E-mail;Активную подписку на email-рассылку.В случае отсутствия перечисленных данных, вы можете указать их в Личном кабинете на сайте, в мобильном приложении, или при регистрации карты в аптеке.Изменение даты рождения в течение года не предусмотрено для повторного начисления бонусов.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2025-01-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-30781",
        "title": "Велком-бонусы новым клиентам!",
        "code": "",
        "discount": "30%",
        "description": "Дарим 700 бонусов всем новым клиентам!Карта лояльности «Аптечная семья» оформляется бесплатно.300 бонусов сразу за оформление карты лояльности в аптеке, на сайте или в мобильном приложении и подписку на уведомления (E-mail и/или Push)200 бонусов за первую покупку в течение 15 дней после получения карты200 бонусов за вторую покупку в течение 15 дней после первой покупкиВажно знать:При подписке на push убедитесь, что у вас включены уведомления от приложения «Будь здоров» в настройках вашего телефонаПри подписке на e-mail проверьте корректность указанного вами e-mail адресаКак потратить бонусы?У каждого начисления срок действия 15 дней с даты полученияОплачивайте бонусами до 30% стоимости покупкиИспользуйте бонусы при покупке любых товаров, кроме исключений**Проверить баланс можно в личном кабинете на сайте, в мобильном приложении или в аптекеБонусы начисляются однократно, при отмене и повторном разрешении на уведомления бонусы не начисляютсяС картой лояльности «Аптечная семья» покупать выгодно!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2025-05-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-30924",
        "title": "500 бонусов за подписку",
        "code": "",
        "discount": "20%",
        "description": "Выберите один из способов и получите 500 бонусов на вашу карту лояльности «Аптечная семья»:Способ №1 Установите мобильное приложение «Ригла» и подпишитесь на pushШаг 1: Скачайте и установите приложение «Ригла» (если приложение у вас еще не установлено)Шаг 2: Подпишитесь на push-уведомления в разделе «Уведомления» в личном кабинетеШаг 3: Проверьте, что уведомления от приложения разрешены в настройках телефонаШаг 4: Получите 500 бонусов — информация о начислении придет в push-сообщенииСпособ №2 Подпишитесь на email-рассылкуШаг 1: Подпишитесь на email-рассылку в личном кабинете на сайте или в приложении «Ригла»шаг 2: Проверьте корректность указанного вами email-адресаШаг 3: Получите 500 бонусов — уведомление о начислении придет на вашу электронную почтуВажно знать:1 бонус = 1 рубльБонусами можно оплатить до 20% стоимости товара в аптеках, мобильном приложении или на сайте «Ригла»Срок действия бонусов — 30 дней с даты начисленияБонусы начисляются однократно на карту лояльности (500 бонусов можно получить только один раз, выбрав любой из двух способов)При удалении приложения и повторной установке, а также при отписке и повторной подписке на уведомления бонусы повторно не начисляются.Будьте в курсе лучших предложений от «Ригла» и получите 500 бонусов прямо сейчас!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2025-06-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-36976",
        "title": "Распродажа в первую и последнюю пятницу месяца!",
        "code": "",
        "discount": "30%",
        "description": "Акция проводится первую и последнюю пятницу ежемесячно в 2026 г. Скидка 30% предоставляется на выделенный ассортимент. Скидка не суммируется с другими акциями, кроме начисления и списания бонусов по программе лояльности «Аптечная семья».",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-02-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38763",
        "title": "Скидка до 50% на средства для здоровья суставов",
        "code": "",
        "discount": "50%",
        "description": "Выгодное предложение на средства для здоровья суставов. Становитесь участником бонусной программы «Аптечная семья», приобретайте товары со скидкой до 50% и возвращайте 5% стоимости на следующие покупки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38765",
        "title": "Скидка 50% на средства для ухода за полостью рта",
        "code": "",
        "discount": "50%",
        "description": "Выгодное предложение на средства для ухода за полостью рта. Становитесь участником бонусной программы «Аптечная семья» и приобретайте вторую упаковку товара со скидкой 50%.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38764",
        "title": "Скидка до 50% на средства для комфортного пищеварения",
        "code": "",
        "discount": "50%",
        "description": "Выгодное предложение на средства для комфортного пищеварения. Становитесь участником бонусной программы «Аптечная семья», приобретайте товары со скидкой до 50% и возвращайте 5% стоимости на следующие покупки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38768",
        "title": "-20% на Фотодерм Биодерма!",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на выделенный ассортимент Фотодерм Биодерма.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38769",
        "title": "-25% на Виши!",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на выделенный ассортимент Виши.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38770",
        "title": "-20% на Ля Рош-позе!",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на средства гамм Цикапласт и Антгелиос Ля Рош-Позе.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38771",
        "title": "-25% на Эуцерин!",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на выделенный ассортимент Эуцерин.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38772",
        "title": "-25% на Нивея!",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на выделенный ассортимент Нивея.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38761",
        "title": "Товар дня!",
        "code": "",
        "discount": "Акция",
        "description": "Горячая подборка товаров по специальным ценам!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38766",
        "title": "Специальные цены на Тева!",
        "code": "",
        "discount": "20%",
        "description": "Специальные цены, скидка 20% на выделенный ассортимент торговой марки Тева.Дополнительные скидки на Товар дня действуют в выделенных регионах.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38762",
        "title": "Стоп-цена май",
        "code": "",
        "discount": "Акция",
        "description": "Ассортимент товаров по фиксированной выгодной цене.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38938",
        "title": "-20% на гели-масло для душа!",
        "code": "",
        "discount": "20%",
        "description": "Cкидка 20% на акционный ассортимент ТМ Аромабио!Это роскошный уход для вашей кожи! Подарите себе ощущение гладкости, здорового сияния и жизненной энергии.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38935",
        "title": "Скидка 30% на экспресс-тест Витамин Д3!",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на экспресс-тест Витамин Д3!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38936",
        "title": "Скидка от 20 до 50% на шипучие витамины",
        "code": "",
        "discount": "50%",
        "description": "Скидки от 20% до 50% на акционный ассортимент!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      },
      {
        "id": "415-38937",
        "title": "Скидка 20% на тонометры и термометры",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на тонометры и термометры бренда 4ForCare",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=415&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c7254d92e6d.png"
      }
    ]
  },
  {
    "id": "414",
    "name": "BridgeResort(brsochi)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67051ba0bbe25.png",
    "description": "Санаторно-курортный комплекс Bridge Resort – семейный курорт, который включает в себя четырёхзвёздочный отель, Клинику семейной медицины Bridge, Wellness Club BR, комплекс бассейнов Breeze, пляжный комплекс, рестораны, б",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "411",
    "name": "MarkFormelle",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67051e185d507.png",
    "description": "\"Mark Formelle\" – это крупная розничная сеть, насчитывающая более 300 магазинов в России, Беларуси, Казахстане и Узбекистане, онлайн-покупки в интернет-магазине и на всех популярных маркетплейсах. Сила \"Mark Formelle\" в ",
    "promocodesCount": 2,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "411-115354",
        "title": "Скидка 10% на заказ.",
        "code": "yourpromokod",
        "discount": "10%",
        "description": "Скидка 10% на заказ. Не распространяется на подарочные сертификаты, акционные и распродажные товары, косметику и аксессуары. Промокоды не суммируются.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=411&a=79",
        "isActive": true,
        "createdAt": "2025-06-13",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67051e185d507.png"
      },
      {
        "id": "411-31292",
        "title": "Скидка 10% на заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на заказ. Не распространяется на подарочные сертификаты, акционные и распродажные товары, косметику и аксессуары. Промокоды не суммируются.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=411&a=79",
        "isActive": true,
        "createdAt": "2025-06-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img67051e185d507.png"
      }
    ]
  },
  {
    "id": "410",
    "name": "Karpov.courses",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6706441f9c3d4.png",
    "description": "Karpov.courses - ваш путь в Data Science. Обучаем с нуля востребованным IT-профессиям и помогаем построить новую карьеру. 89% наших выпускников уже нашли интересную работу. Преимущества для покупателей: - УЧИТЕСЬ В УДОБН",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "410-120708",
        "title": "Скидка 10% на заказ",
        "code": "kcreferral",
        "discount": "10%",
        "description": "Cкидку 10% на все курсы (не распространяется на курсы с вузами и ML Design)",
        "expiryDate": "2099-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=410&a=79",
        "isActive": true,
        "createdAt": "2025-09-18",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6706441f9c3d4.png"
      },
      {
        "id": "410-126032",
        "title": "​Скидка 5%",
        "code": "advcake",
        "discount": "5%",
        "description": "Скидка 5% на курсы по промокоду на все курсы (не распространяется на курс ML ENGINEERING: ИТМО AI TALENT HUB)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=410&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6706441f9c3d4.png"
      },
      {
        "id": "410-35880",
        "title": "Скидка 5% на курсы по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на курсы по промокоду на все курсы (не распространяется на курс ML ENGINEERING: ИТМО AI TALENT HUB)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=410&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6706441f9c3d4.png"
      }
    ]
  },
  {
    "id": "322",
    "name": "Joom",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c47ada40f64.png",
    "description": "Joom — это международный маркетплейс для покупок товаров со всего мира. Наша миссия помогать людям сделать процесс покупок легким, развлекательным и открыть безграничный доступ к качественным товарам. Компания Джум была ",
    "promocodesCount": 2,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "322-118167",
        "title": "Скидка на все!",
        "code": "adv1",
        "discount": "10%",
        "description": "10% на все! Не суммируется с акциями на сайте",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=322&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c47ada40f64.png"
      },
      {
        "id": "322-32051",
        "title": "Скидка 10% на все!",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все! Не суммируется с акциями на сайте",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=322&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c47ada40f64.png"
      }
    ]
  },
  {
    "id": "321",
    "name": "НИПКЭФ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c478b5a1d50.png",
    "description": "Национальный институт переподготовки и повышения квалификации кадров в сфере экономики и финансов проводит обучение в дистанционном формате по направлениям профессиональной переподготовки и повышения квалификации: Госуда",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "321-36715",
        "title": "Скидка 5% на любой курс по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на любой курс по промокоду. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=321&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c478b5a1d50.png"
      },
      {
        "id": "321-37672",
        "title": "Скидки на курсы до 50%",
        "code": "",
        "discount": "50%",
        "description": "Скидки до 50% на курсы + 3 электронных курса в подарок",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=321&a=79",
        "isActive": true,
        "createdAt": "2026-03-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c478b5a1d50.png"
      }
    ]
  },
  {
    "id": "320",
    "name": "ЦАППКК",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c476d91cf9e.png",
    "description": "Центральная академия профессиональной переподготовки и повышения квалификации кадров приглашает педагогов, тренеров, психологов, учителей, воспитателей, руководителей организаций пройти обучение на дистанционных курсах п",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "320-35121",
        "title": "Скидка до 65%!",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65% на курсы психологии и педагогикиКурс повышения квалификации в подарок!+4 электронных курса бесплатно",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=320&a=79",
        "isActive": true,
        "createdAt": "2025-11-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c476d91cf9e.png"
      },
      {
        "id": "320-36714",
        "title": "Скидка 5% на любой курс по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на любой курс по промокоду. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=320&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c476d91cf9e.png"
      },
      {
        "id": "320-37670",
        "title": "Скидки на курсы до 65%",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65% на курсы + 3 электронных курса в подарок",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=320&a=79",
        "isActive": true,
        "createdAt": "2026-03-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c476d91cf9e.png"
      }
    ]
  },
  {
    "id": "317",
    "name": "Абакус центр",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c4616867f86.png",
    "description": "Абакус центр — международный проект по развитию интеллекта и математического мышления детей от 4 лет, работающий с 2015 года в образовательных центрах и школах 25 стран, а также онлайн по всему миру. Обучение в наших цен",
    "promocodesCount": 0,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "315",
    "name": "Пиксель",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c455a94acea.png",
    "description": "Школа программирования и робототехники для детей \"Пиксель\" — это обучение кодингу, новые знакомства и перспектива в мире инноваций. Мы учим детей программированию, созданию игр, графическому и веб-дизайну, 3D-моделирован",
    "promocodesCount": 1,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "315-38544",
        "title": "Получите скидку на раннее бронирование в летнюю школу",
        "code": "",
        "discount": "2000₽",
        "description": "Получите скидку 2000 рублей на раннее бронирование на смены в дневной школеЛетняя городская школа по робототехнике и программированию для детей. Открыта запись на лето 2026 г. в Москве и Московской области",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=315&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c455a94acea.png"
      }
    ]
  },
  {
    "id": "314",
    "name": "Подружка",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png",
    "description": "«Подружка» — интернет-магазин косметики, парфюмерии и бытовой химии. Каталог включает тысячи наименований сертифицированной продукции ведущих мировых брендов и эксклюзивных марок. Здесь вы найдете продукты российского и ",
    "promocodesCount": 13,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "314-125719",
        "title": "Скидка 20% на заказ от 1500 руб.",
        "code": "ADVCAKE25",
        "discount": "20%",
        "description": "Скидка -20% на чек от 1500 руб, не суммируется c акциями на сайте.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-35770",
        "title": "​Скидка -20% на чек от 1500 руб.",
        "code": "",
        "discount": "20%",
        "description": "Скидка -20% на чек от 1500 руб, не суммируется c акциями на сайте.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38811",
        "title": "Скидки до 70% на любимые бренды!",
        "code": "",
        "discount": "70%",
        "description": "Скидки до 70% на любимые бренды! Выберите любые товары, участвующие в акции, и получите скидку до 70%.",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38812",
        "title": "Скидка 25% на маски и патчи бренда TENZERO",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на маски и патчи бренда TENZERO",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38813",
        "title": "Скидка 25% на весь ассортимент бренда MONDSUB",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на весь ассортимент бренда MONDSUB",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38814",
        "title": "Скидка 25% на весь ассортимент бренда KALLOS COSMETIC",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на весь ассортимент бренда KALLOS COSMETIC",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38815",
        "title": "Скидка 25% на весь ассортимент бренда A`PIEU",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на весь ассортимент бренда A`PIEU",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38816",
        "title": "Скидка 25% на весь ассортимент бренда Axis Y",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на весь ассортимент бренда Axis Y",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38817",
        "title": "Скидка 20% на весь ассортимент бренда SELFIELAB",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на весь ассортимент бренда SELFIELAB",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38818",
        "title": "Скидка 25% на весь ассортимент бренда GIS",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на весь ассортимент бренда GIS",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38819",
        "title": "Скидка 25% на весь ассортимент бренда SKINPHORIA",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на весь ассортимент бренда SKINPHORIA",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38820",
        "title": "Дезодоранты, мисты для тела: 1+1=3",
        "code": "",
        "discount": "Акция",
        "description": "При покупке 3х продуктов категории один из них (с наименьшей или равной стоимостью) в подарок. Выберите три любых дезодоранта и/или миста для тела и получите один из них бесплатно!",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      },
      {
        "id": "314-38821",
        "title": "LP CARE, LELEA: 1+1=3",
        "code": "",
        "discount": "Акция",
        "description": "При покупке 3х продуктов категории один из них (с наименьшей или равной стоимостью) в подарок. Выберите три любых продукта из категорий бумажные салфетки, ватные диски и туалетная бумага брендов LP CARE, LELEA и получите один из них бесплатно!",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=314&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3500366335.png"
      }
    ]
  },
  {
    "id": "313",
    "name": "Letu.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66a109fc98369.png",
    "description": "ЛЭТУАЛЬ - крупнейшая сеть магазинов парфюмерии и косметики в России. Около 1000 розничных магазинов и интернет-магазин letu.ru с доставкой во все города присутствия магазинов сети. На сайте представлено более 12 000 това",
    "promocodesCount": 0,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "308",
    "name": "366.ru",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3387473928.png",
    "description": "Аптечная сеть 36,6 – лидер в Московском регионе и одна из крупнейших аптечных сетей в стране. Компания существует почти три десятилетия, развивается и укрепляет свои позиции. Основная наша ценность – это человек, его сам",
    "promocodesCount": 1,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "308-38848",
        "title": "Скидка 50%",
        "code": "",
        "discount": "50%",
        "description": "Скидка до 50%Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на сезонные товары. А ещё по акции 1+1, 2+1 и с подарком за покупку.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=308&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3387473928.png"
      }
    ]
  },
  {
    "id": "306",
    "name": "Смотрёшка",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3313abac56.png",
    "description": "«Смотрёшка» – это интерактивное телевидение и онлайн-кинотеатры в одном приложении. Уникальная открытая ОТТ-платформа, с помощью которой операторы могут получить ТВ-сервис премиум-класса, а абоненты – удобное интерактивн",
    "promocodesCount": 4,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "306-125279",
        "title": "Скидка 100% на заказ",
        "code": "smotrism",
        "discount": "100%",
        "description": "Ваш подарок - подписка на 45 дней! Вас ждёт: • более 370 телеканалов на любой вкус; • более 6 500 фильмов и сериалов в разделе «Передачи». Дополнительно бесплатно можно подключить: • 30 дней просмотра кинотеатров: START, viju; • 14 дней просмотра кинотеатра кинотеатров: PREMIER, Смотрёшка Плюс; • 7 дней просмотра кинотеатра Amediateka.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=306&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3313abac56.png"
      },
      {
        "id": "306-34585",
        "title": "30 дней бесплатного доступа ко всему контенту! (а)",
        "code": "",
        "discount": "100%",
        "description": "30 дней подписки на весь контент Смотрешки только для новых пользователей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=306&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3313abac56.png"
      },
      {
        "id": "306-35255",
        "title": "45 дней бесплатного доступа на Смотрёшка - ТВ-каналы, раздел \"Передачи\".",
        "code": "",
        "discount": "Акция",
        "description": "Ваш подарок - подписка на 45 дней для новых пользователей!Вас ждёт:• более 370 телеканалов на любой вкус;• более 6 500 фильмов и сериалов в разделе «Передачи».Дополнительно бесплатно можно подключить:• 30 дней просмотра кинотеатров: START, viju;• 14 дней просмотра кинотеатра кинотеатров: PREMIER, Смотрёшка Плюс;• 7 дней просмотра кинотеатра Amediateka.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=306&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3313abac56.png"
      },
      {
        "id": "306-38499",
        "title": "90 дней бесплатного доступа на Смотрёшка",
        "code": "",
        "discount": "Акция",
        "description": "90 дней бесплатного доступа на СмотрёшкаТолько для новых пользователейДоступ к 370 ТВ-каналам и 6500 фильмам и сериалам в разделе \"Кино\".",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=306&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66c3313abac56.png"
      }
    ]
  },
  {
    "id": "303",
    "name": "РИВ ГОШ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png",
    "description": "РИВ ГОШ является одной из крупнейших федеральных сетей магазинов парфюмерии и косметики в сегменте люкс и премиум. Компания существует на рынке с 1995 года, сегодня насчитывает более 240 магазинов по всей России. В ассор",
    "promocodesCount": 8,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "303-126141",
        "title": "​Скидка 300 руб. на заказ от 3000 руб.",
        "code": "Sale300",
        "discount": "300₽",
        "description": "Скидка 300 руб. при покупке от 3000 руб. Суммируется со скидками, кроме специальных цен с окончанием 9,99,999. и товаров исключений: https://rivegauche.ru/promotion/PravilaCoupons",
        "expiryDate": "2026-07-01",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-134580",
        "title": "Скидка 6000 при покупке от 12000",
        "code": "ШОПИНГ",
        "discount": "50%",
        "description": "С 21 по 24 мая в наших офлайн и онлайн магазинах делим пополам всё. Добавляйте в отпускную косметичку солнцезащитные средства, цветочные и акватические ароматы, легкие сыворотки, эссенции и кремы для ухода за кожей лица и тела и многое другое на сумму от 12 000 рублей и получайте скидку 6 000 рублей по промокоду ШОПИНГ. Скидка по промокоду предоставляется от изначальной цены товара. Скидка по промокоду не суммируется: – со скидками по картам лояльности РИВ ГОШ, – экспресс-бонусами, – с любыми другими скидками, специальными ценами и купонами. Товары, участвующие в акции, отмечены специальным стикером: Скидка до -50% по коду. В корзине останется текущая скидка на продукт, если она выгоднее, чем скидка по промокоду. Скидка не действует при покупке подарочных карт, оплате услуг в экспресс имидж студиях и салонах красоты РИВ ГОШ, а также при покупке товаров брендов-исключений.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-35952",
        "title": "​Скидка 300 руб. при покупке от 3000 руб.",
        "code": "",
        "discount": "300₽",
        "description": "Скидка 300 руб. при покупке от 3000 руб. Суммируется со скидками, кроме специальных цен с окончанием 9,99,999. и товаров исключений: https://rivegauche.ru/promotion/PravilaCoupons",
        "expiryDate": "2026-07-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-38586",
        "title": "Скидка 50% на товары из специального раздела",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% на товары из специального раздела",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-38742",
        "title": "Скидка 15% для новых пользователей",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% для новых пользователей.Скидка по промокоду суммируется со скидками, действующими в момент покупки, в том числе: скидки по дисконтным картам РИВ ГОШ, скидки на товары в рамках клиентских дней и других акций, проходящих в интернет-магазине РИВ ГОШ.Не действует на РИВ ГОШ бокс, продукты по специальным ценам и марки-исключения: https://api.rivegauche.ru/medias6/-1704-.pdf?conte....К заказу можно применить только один промокод.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-38468",
        "title": "Скидка 1000 рублей при покупке от 8000",
        "code": "",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей при покупке от 8000.Скидка по промокоду суммируется со скидками, действующими в момент покупки, в том числе: скидки по дисконтным картам РИВ ГОШ, скидки на товары в рамках клиентских дней и других акций, проходящих в интернет-магазине РИВ ГОШ.Не действует на РИВ ГОШ бокс, продукты по специальным ценам и марки-исключения.К заказу можно применить только один промокод.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-39071",
        "title": "Скидка 6100 рублей при покупке от 12000",
        "code": "",
        "discount": "50%",
        "description": "Скидка 6100 рублей при покупке от 12000 рублей.Для всех пользователей.Скидка по промокоду предоставляется от изначальной цены товара.Скидка по промокоду не суммируется:– со скидками по картам лояльности РИВ ГОШ,– экспресс-бонусами,– с любыми другими скидками, специальными ценами и купонами.Товары, участвующие в акции, отмечены специальным стикером: Скидка до -50% по коду.В корзине останется текущая скидка на продукт, если она выгоднее, чем скидка по промокоду.Скидка не действует при покупке подарочных карт, оплате услуг в экспресс имидж студиях и салонах красоты РИВ ГОШ, а также при покупке товаров брендов-исключений.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      },
      {
        "id": "303-39072",
        "title": "Скидка 6000 при покупке от 12000",
        "code": "",
        "discount": "50%",
        "description": "С 21 по 24 мая в наших офлайн и онлайн магазинах делим пополам всё.Добавляйте в отпускную косметичку солнцезащитные средства, цветочные и акватические ароматы, легкие сыворотки, эссенции и кремы для ухода за кожей лица и тела и многое другое на сумму от 12 000 рублей и получайте скидку 6 000 рублей по промокоду ШОПИНГ.Скидка по промокоду предоставляется от изначальной цены товара.Скидка по промокоду не суммируется:– со скидками по картам лояльности РИВ ГОШ,– экспресс-бонусами,– с любыми другими скидками, специальными ценами и купонами.Товары, участвующие в акции, отмечены специальным стикером: Скидка до -50% по коду.В корзине останется текущая скидка на продукт, если она выгоднее, чем скидка по промокоду.Скидка не действует при покупке подарочных карт, оплате услуг в экспресс имидж студиях и салонах красоты РИВ ГОШ, а также при покупке товаров брендов-исключений.",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=303&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6662b2b2637b8.png"
      }
    ]
  },
  {
    "id": "295",
    "name": "ЕГЭLAND",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img661900d65abea.png",
    "description": "ЕГЭLAND — одна из крупнейших онлайн-школ в РФ. Мы ежегодно выпускаем более 40 тысяч успешных студентов. Помогаем сдать ЕГЭ на 80+ баллов. ЕГЭLAND — большая экосистема. Мы не только про ЕГЭ и образование, но и за коммьюни",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "295-121968",
        "title": "Скидка 20% на обучение",
        "code": "КЕЙК",
        "discount": "20%",
        "description": "Скидка 20% на подготовку к ЕГЭ по промокоду",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=295&a=79",
        "isActive": true,
        "createdAt": "2025-10-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img661900d65abea.png"
      },
      {
        "id": "295-34440",
        "title": "Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на подготовку к ЕГЭ по промокоду",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=295&a=79",
        "isActive": true,
        "createdAt": "2025-10-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img661900d65abea.png"
      },
      {
        "id": "295-38551",
        "title": "Скидка до 50% : готовьтесь к ЕГЭ по 2 предметам сразу со скидкой",
        "code": "",
        "discount": "50%",
        "description": "• Скидка 50% на обучение от 2-х предметов.• Подготовка на 80+ баллов ЕГЭ или «5» на ОГЭ (каждый третий ученик подтверждает результат!).• Опытные преподаватели – эксперты проверки ЕГЭ/ОГЭ.• Личные наставники, которые проверяют ДЗ и разбирают ошибки.• Современная платформа с ИИ-помощником и тренажёрами.• Неограниченный доступ ко всем материалам и записям уроков.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=295&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img661900d65abea.png"
      },
      {
        "id": "295-39028",
        "title": "Скидка 300 рублей",
        "code": "",
        "discount": "300₽",
        "description": "Скидка 300 рублей на каждый предмет программы подготовки к ЕГЭ и ОГЭ",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=295&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img661900d65abea.png"
      }
    ]
  },
  {
    "id": "294",
    "name": "Moscow Digital School",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618fe5718a54.png",
    "description": "Мы — образовательная платформа MDS (Moscow Digital School) . Сопровождаем своих студентов с момента знакомства и до реализации карьерных целей. Наша миссия — делиться знаниями, опытом и деловыми связями. Закончив обучени",
    "promocodesCount": 1,
    "category": "Компьютеры и интернет",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "294-37181",
        "title": "Курс в подарок при покупке флагманов!",
        "code": "",
        "discount": "Акция",
        "description": "При покупке флагманских курсов, тариф: Оптимальный и Премиальный:https://mosdigitals.ru/courses/software-lawyerhttps://mosdigitals.ru/courses/yurist-v-m-and-ahttps://mosdigitals.ru/courses/mezhdunarodnoe-prav...https://mosdigitals.ru/courses/data-protection-off...https://mosdigitals.ru/courses/blockchain-lawyerОдин из курсов в подарок:https://mosdigitals.ru/courses/effektivnye-peregov...https://mosdigitals.ru/courses/legal-designhttps://mosdigitals.ru/courses/personal_data",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=294&a=79",
        "isActive": true,
        "createdAt": "2026-03-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618fe5718a54.png"
      }
    ]
  },
  {
    "id": "293",
    "name": "4 колеса",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618f72bb091d.png",
    "description": "«4 колеса» — это интернет-магазин шин и дисков. Мы смогли организовать прямые отгрузки от производителей, так как это единственный доступный способ поставлять максимально «свежую» продукцию по лучшим ценам. Первую закупк",
    "promocodesCount": 3,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "293-129093",
        "title": "Скидка 3% на любой заказ",
        "code": "Affiliate3",
        "discount": "3%",
        "description": "Скидка 3% на любой заказ",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=293&a=79",
        "isActive": true,
        "createdAt": "2026-01-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618f72bb091d.png"
      },
      {
        "id": "293-33246",
        "title": "Скидка 20% на шиномонтаж",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на шиномонтаж при покупке шин.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=293&a=79",
        "isActive": true,
        "createdAt": "2025-09-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618f72bb091d.png"
      },
      {
        "id": "293-36295",
        "title": "Скидка 3% на любой заказ",
        "code": "",
        "discount": "3%",
        "description": "Скидка 3% на любой заказ",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=293&a=79",
        "isActive": true,
        "createdAt": "2026-01-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618f72bb091d.png"
      }
    ]
  },
  {
    "id": "292",
    "name": "Nappyclub",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618fa83245fe.png",
    "description": "На nappyclub.ru представлен самый широкий ассортимент подгузников и трусиков, а также другие товары, учитывающие все потребности мам и малышей. Наша собственная продукция продаётся только в интернете, что позволяет устан",
    "promocodesCount": 1,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "292-39102",
        "title": "Акция 5+1",
        "code": "",
        "discount": "1₽",
        "description": "Добавьте 5 товаров со страницы акции в корзину и получите в подарок еще 1 товар за 1 рубль",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=292&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6618fa83245fe.png"
      }
    ]
  },
  {
    "id": "291",
    "name": "Ароматный Мир",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png",
    "description": "«Ароматный Мир» появился на рынке продажи алкогольных напитков в октябре 1998 года и за свою историю прошел путь от одного магазина формата «кэш энд керри» до крупнейшей в России сети специализированных магазинов формата",
    "promocodesCount": 6,
    "category": "Потребительские товары",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "291-37195",
        "title": "Скидка 10% на первый заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на первый заказСкидка не распространяется на подарочные карты и сертификаты, стики и табак, устройства для нагревания табака, а также товары по минимальной розничной цене.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=291&a=79",
        "isActive": true,
        "createdAt": "2026-02-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png"
      },
      {
        "id": "291-37650",
        "title": "Покупай больше - плати меньше! Суперскидки до 20%",
        "code": "",
        "discount": "20%",
        "description": "-При покупке любых 5 бутылок со специальными ценниками вы получаете 12%. -При покупке любых 10 бутылок со специальными ценниками вы получаете 16%. -При покупке любых 14 бутылок со специальными ценниками вы получаете 20%Скидка действует только на напитки из «Коллекции АМ», не распространяется на пиво, табачную продукцию и безалкогольные товары. Скидка не суммируется с другими акциями и предложениями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=291&a=79",
        "isActive": true,
        "createdAt": "2026-03-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png"
      },
      {
        "id": "291-37754",
        "title": "Оплачивайте бонусами до 25%",
        "code": "",
        "discount": "25%",
        "description": "Трать баллы по максимуму! При любом онлайн-заказе через сайт или мобильное приложение доступна уникальная возможность оплачивать бонусами до 25% суммы покупки товаров*. *предложение не распространяется на товары из других акций и со значком «выгодно»",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=291&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png"
      },
      {
        "id": "291-38861",
        "title": "Скидка 5% на заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на заказДля всех пользователей.Действует на 1 покупку. Не суммируется с другими акциями.Действует на все товары.Без ограничения скидки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=291&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png"
      },
      {
        "id": "291-38864",
        "title": "Получи 1150 счастливых бонусов",
        "code": "",
        "discount": "Акция",
        "description": "Знаете, как легко увеличить свой бонусный счёт в Ароматном Мире? Два простых шага и 1150 бонусов ваши: 1. 1000 бонусов — за первую установку мобильного приложения и выпуск Винной карты 2. Еще 150 бонусов — за регистрацию в программе лояльности Винная карта. Просто. Удобно. Выгодно. Наполняйте настроение вкусом и покупки выгодой!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=291&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png"
      },
      {
        "id": "291-38863",
        "title": "Весенняя распродажа до 70%",
        "code": "",
        "discount": "70%",
        "description": "Оплачивайте бонусами товары с красными ценниками и экономьте до 70% с Винной картой*. * Акция не суммируется с другими спецпредложениями. Акция не действует в розничном магазине по адресу: Москва, Рублёвское ш., 16, корп. 1.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=291&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66169285de59d.png"
      }
    ]
  },
  {
    "id": "290",
    "name": "Созвездие Красоты",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66168d6a55659.png",
    "description": "beauty-shop – это интернет-магазин товаров для красоты и здоровья «Созвездие Красоты». Компания «Созвездие Красоты» была основана в 1992 году. С тех пор мы прошли путь от одного магазина до фирменной торговой сети в лучш",
    "promocodesCount": 4,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "290-115320",
        "title": "Скидка до 2000 руб. на заказ от 3000 руб.",
        "code": "SOK2026",
        "discount": "2000₽",
        "description": "Промокод дает скидку 500 рублей при покупке от 3000, 1100 рублей при покупке от 6000 рублей, скидку 2000 рублей при покупке от 10000 рублей. Распространяется на бренды Gezatone, Beauty Style, Kativa, Meoli, Happy Anne.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=290&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66168d6a55659.png"
      },
      {
        "id": "290-31257",
        "title": "​Скидка до 2000 рублей",
        "code": "",
        "discount": "2000₽",
        "description": "Промокод дает скидку 500 рублей при покупке от 3000, 1100 рублей при покупке от 6000 рублей, скидку 2000 рублей при покупке от 10000 рублей.Распространяется на бренды Gezatone, Beauty Style, Kativa, Meoli, Happy Anne.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=290&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66168d6a55659.png"
      },
      {
        "id": "290-36112",
        "title": "Выгодные скидки и предложения недели",
        "code": "",
        "discount": "Акция",
        "description": "Выгодные скидки и предложения недели",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=290&a=79",
        "isActive": true,
        "createdAt": "2026-02-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66168d6a55659.png"
      },
      {
        "id": "290-36480",
        "title": "Распродажа. скидки до 50%",
        "code": "",
        "discount": "50%",
        "description": "Распродажа. скидки до 50%",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=290&a=79",
        "isActive": true,
        "createdAt": "2026-02-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img66168d6a55659.png"
      }
    ]
  },
  {
    "id": "288",
    "name": "Бигам",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660ea0bc1b263.png",
    "description": "Бигам — это федеральная сеть Центров инструмента и техники. Наша специализация: продажа и обслуживание ручного, пневматического и электроинструмента, строительной и садовой техники, станков, сварочного и климатического о",
    "promocodesCount": 5,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "288-131113",
        "title": "Скидка 3% на заказ от 2000 руб. до 19999 руб.",
        "code": "advcake3%",
        "discount": "3%",
        "description": "Скидка 3% от суммы корзины 2000 рублей до 19999 рублей. Не действует на товары брендов Stihl, Remeza, Caiman.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=288&a=79",
        "isActive": true,
        "createdAt": "2026-02-18",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660ea0bc1b263.png"
      },
      {
        "id": "288-131112",
        "title": "Скидка 1000 руб. на заказ от 20000 руб.",
        "code": "advcake1000r",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей от суммы корзины 20000 рублей. Не действует на товары брендов Stihl, Remeza, Caiman.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=288&a=79",
        "isActive": true,
        "createdAt": "2026-02-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660ea0bc1b263.png"
      },
      {
        "id": "288-30886",
        "title": "Все акции интернет-магазина Bigam",
        "code": "",
        "discount": "Акция",
        "description": "Все актуальные акции интернет-магазина Bigam.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=288&a=79",
        "isActive": true,
        "createdAt": "2025-06-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660ea0bc1b263.png"
      },
      {
        "id": "288-37025",
        "title": "​Скидка 1000 руб. от 20000 руб.",
        "code": "",
        "discount": "1000₽",
        "description": "Скидка 1000 рублей от суммы корзины 20000 рублей. Не действует на товары брендов Stihl, Remeza, Caiman.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=288&a=79",
        "isActive": true,
        "createdAt": "2026-02-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660ea0bc1b263.png"
      },
      {
        "id": "288-37026",
        "title": "​Скидка 3% от 2000 руб. до 19999 руб.",
        "code": "",
        "discount": "3%",
        "description": "Скидка 3% от суммы корзины 2000 рублей до 19999 рублей. Не действует на товары брендов Stihl, Remeza, Caiman.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=288&a=79",
        "isActive": true,
        "createdAt": "2026-02-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660ea0bc1b263.png"
      }
    ]
  },
  {
    "id": "284",
    "name": "Билайн",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660d4cbe97c91.png",
    "description": "Интернет-магазин «Билайн» – это ecommerce направление одного из крупнейших операторов сотовой связи и широкополосного доступа в интернет в России и мире. В ассортименте магазина всегда можно найти последние новинки смарт",
    "promocodesCount": 0,
    "category": "Компьютеры и интернет",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "280",
    "name": "Tutu",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png",
    "description": "Описание: Tutu — сервис путешествий №1 в России, существующий на рынке более 20 лет. Сервис помогает путешественникам полностью организовать поездку — в одном месте сразу купить билеты на самолёт, поезд, автобус, электри",
    "promocodesCount": 10,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "280-134321",
        "title": "Скидка 25% на заказ",
        "code": "RELAX-25",
        "discount": "25%",
        "description": "Подборка загородных отелей с дополнительной скидкой 25% Для всех пользователей. Действует на 1 покупку. Суммируется с другими акциями. Максимальный размер скидки по промокоду 2000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-134319",
        "title": "Скидка 25% на заказ",
        "code": "TEPLO-25",
        "discount": "25%",
        "description": "Подборка отелей с дополнительной скидкой 25% Для всех пользователей. Действует на 1 покупку. Суммируется с другими акциями. Максимальный размер скидки по промокоду 2000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-134320",
        "title": "Скидка 25% на заказ",
        "code": "GOROD-25",
        "discount": "25%",
        "description": "Подборка отелей в Москве и Санкт-Петербурге с дополнительной скидкой 25% Для всех пользователей. Действует на 1 покупку. Суммируется с другими акциями. Максимальный размер скидки по промокоду 2000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-38721",
        "title": "Скидка 25% на отели на южных курортах",
        "code": "",
        "discount": "25%",
        "description": "Подборка отелей на южных курортах с дополнительной скидкой 25%Для всех пользователей. Действует на 1 покупку. Суммируется с другими акциями.Максимальный размер скидки по промокоду 2000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-38722",
        "title": "Скидка 25% на отели в Москве и Санкт-Петербурге",
        "code": "",
        "discount": "25%",
        "description": "Подборка отелей в Москве и Санкт-Петербурге с дополнительной скидкой 25%Для всех пользователей. Действует на 1 покупку. Суммируется с другими акциями.Максимальный размер скидки по промокоду 2000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-38723",
        "title": "Скидка 25% на загородные отели",
        "code": "",
        "discount": "25%",
        "description": "Подборка загородных отелей с дополнительной скидкой 25%Для всех пользователей. Действует на 1 покупку. Суммируется с другими акциями.Максимальный размер скидки по промокоду 2000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-39094",
        "title": "Скидки до 20% на авиабилеты за границу от AZAL",
        "code": "",
        "discount": "20%",
        "description": "Мощная распродажа Azal: скидки до 20% на авиабилеты заграницу",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-39095",
        "title": "Кешбэк 3% баллами с каждой покупки",
        "code": "",
        "discount": "3%",
        "description": "Путешествовать выгоднее с Туту Кошельком: кешбэк 3% баллами с каждой покупки",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-39096",
        "title": "Все выгодные предложения по билетам",
        "code": "",
        "discount": "Акция",
        "description": "Все выгодные предложения по билетам: цены ниже средних за последние 10 дней. Обновляем постоянно, заглядывайте чаще",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      },
      {
        "id": "280-39093",
        "title": "Скидки на ж/д билеты до -50%",
        "code": "",
        "discount": "50%",
        "description": "Выгодные билеты на поезда: скидки до 50%",
        "expiryDate": "2026-07-08",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=280&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660bcfe9424a8.png"
      }
    ]
  },
  {
    "id": "279",
    "name": "KRUPS",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img660a84de32cf6.png",
    "description": "С 1846 года история KRUPS отличалась инновациями, созданием смелых и знаковых продуктов, которые были разработаны для удовлетворения потребностей своих клиентов. Благодаря вам KRUPS продолжает писать свою историю, богату",
    "promocodesCount": 0,
    "category": "Кухонные принадлежности и бытовая техника",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "274",
    "name": "Курорт Красная Поляна",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png",
    "description": "Курорт Красная Поляна — живописное место в самом сердце Кавказских гор. Горный курорт привлекает туристов уникальной природой и разнообразием развлечений на круглый год. Зимой Курорт Красная Поляна превращается в рай для",
    "promocodesCount": 8,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "274-37508",
        "title": "Каникулы в горах. Проживание с выгодой 10% и бесплатные активности",
        "code": "",
        "discount": "10%",
        "description": "Предложение включает скидки на проживание и активности, бесплатные развлечения и прогулки.Выбирайте даты и приезжайте за впечатлениями!*Период проживания: 15.03.2026 – 31.05.2026Период бронирования: 18.02.2026 – 30.05.2026Выгодное проживание:-10% от базового тарифа с завтраком в отелях Курорта-10% от базового тарифа без питания в Комплексе апартаментовДети до 12 лет проживают бесплатноБесплатные активности Билет «Панорама Красной Поляны»подъем на высоту 2200 м для всех проживающих в номереАренда роликов или скейтборда в школе катания «Три вершины» (с 18.04.2026)1 час проката для всех проживающих в номереПосещение верёвочного парка (с 01.05.2026)1 маршрут на выбор для всех проживающих в номереПосещение Хаски-центра и Парка капибарвходные билеты для всех проживающих в номереВыгодные развлечения-30% на прокат горнолыжного оборудованияДействует в пунктах проката на уровнях 540 и 960-20% на занятия с инструкторомИндивидуальные, парные тренировки или групповые программыСпецтариф: Ферма северных оленей + Дача АльпачаПрогулка по парку «Лес чудес», знакомство с оленями и альпаками. Входной билет — 800 ₽. Дети до 4 лет — бесплатно.* Предложение действует во всех отелях и апартаментах курорта на Поляне 540 и Поляне 960. В зависимости от выбора в проживание могут быть включены завтраки, посещение спа-центра с бассейном, термального комплекса, тренажерного зала и др. Кроме того, от места проживания зависят ограничения по возрасту — уточняйте детали при бронировании.",
        "expiryDate": "2026-05-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-03-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-37709",
        "title": "Весна в апартаментах",
        "code": "",
        "discount": "Акция",
        "description": "Откройте для себя идеальный горный отдых в функциональных апартаментах с современной кухней и захватывающим видом на вершины. Все самое важное — в шаговой доступности: канатные дороги прямо у порога.Выбирайте идеальный формат под свой ритм:— Базовый тариф — для ценителей свободы;— С завтраком — для энергичного старта дня;— «Отдыхай и Катай» — номер плюс ски-пассы для максимального драйва;— «Каникулы в горах» — с дополнительными бонусами, которые сделают отдых еще ярче.Забронируйте сейчас по официальной цене и получите именно то место, где горы становятся ближе.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-03-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-37942",
        "title": "Весна в отелях",
        "code": "",
        "discount": "Акция",
        "description": "Откройте для себя идеальный горный отдых в премиальных отелях 4* и 5* с панорамным видом на вершины. Все самое важное — в шаговой доступности: канатные дороги прямо у порога.Выбирайте идеальный формат под свой ритм:— Базовый тариф — для ценителей свободы;— С завтраком — для энергичного старта дня;— «Отдыхай и Катай» — номер плюс ски-пассы для максимального драйва;— «Каникулы в горах» — с дополнительными бонусами, которые сделают отдых еще ярче.Забронируйте сейчас по официальной цене и получите именно то место, где горы становятся ближе.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-38039",
        "title": "Отель + Сочи Парк",
        "code": "",
        "discount": "100%",
        "description": "Один тариф — две выгоды: скидка на проживание и билет в Сочи ПаркВ пакетное предложение «Отель и Сочи Парк» входит проживание в номере выбранной категории и билет в Сочи Парк для каждого гостя. Доступные отели по тарифу:С завтракомКортъярд Марриотт 4*, Панорама by Mercure 4*Без завтракаКомплекс Апартаментов на Поляне 540Условия:Обязательна предоплата 100% за 1 ночьМинимальный период проживания — от 2 ночей Бесплатная отмена (не позднее чем за 24 часа до заезда)Предложение не суммируется с другими акциями отеляБилет в Сочи Парк включает:Посещение тематического парка в соответствии с графиком работы20+ аттракционов, шоу и развлекательных программ*Как получить и использовать билет в Сочи ПаркЗабронируйте отель по тарифу «Отель и Сочи Парк»Получите билеты на ресепшен отеля в день заселенияКаждый гость, указанный в бронировании, получает свой билет (1 раз за период проживания)Билет действителен только в даты вашего проживания в отелеДля маленьких гостей до 6 лет вход в парк бесплатный, если их сопровождает взрослый с действительным билетом по тарифу «Отель и Сочи Парк»1 взрослый может сопровождать максимум 3 детей до 6 лет.Спокойный отдых в горах и яркие аттракционы в Сочи Парке — микс впечатлений для всей семьи!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-38038",
        "title": "Три равно четыре!",
        "code": "",
        "discount": "Акция",
        "description": "Забронируй 3 ночи и получи четвертую ночь в подарок в апартаментах на Курорте Красная ПолянаЧТО ВХОДИТ В ПРЕДЛОЖЕНИЕ?*Проживание в апартаментах — в номере выбранной категории*Завтрак в формате шведского стола в отеле (не входит в стоимость, если проживаете в апартаментах Курорта Красная Поляна)*Бесплатный подъем между Поляной 540 и Поляной 960Обратите внимание: предложение действует, когда вы бронируете на сайте 4 ночи подряд. Только тогда одна из ночей становится бесплатной. Выгодного отдыха в сердце гор!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-38037",
        "title": "Раннее бронирование со скидкой до 15%",
        "code": "",
        "discount": "15%",
        "description": "Тариф включает:*Скидка 10% от открытого тарифа на проживание в номере выбранной категории при бронировании от 7 до 14 дней до даты заезда,*Скидка 15% от открытого тарифа на проживание в номере выбранной категории при бронировании от 15 дней и более до даты заезда,*Бесплатный вайфай*Бесплатный подъём по канатной дороге между уровнями Поляна 540 – Поляна 960Обязательна предоплата в размере 100% стоимости проживания.!В случае отмены или изменения бронирования после 00:00 часов дня заезда удерживается стоимость первых суток",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-04-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-38876",
        "title": "Тарифы для автомобилистов.",
        "code": "",
        "discount": "10%",
        "description": "Встречаем скидками и бесплатными опциямиПарковка на высоте 960 и 540 → 0 ₽ и 650 ₽Ранний заезд, поздний выезд → 0 ₽Скидки на всё меню отеля → –10%Ланч-боксы в дорогу → 0 ₽Скидки на массаж и спа → –10%Скидки на аренду кабриолетов → –10%Доступно для тарифов:✅ «Южная прописка»(для гостей из Южного и Северо-Кавказского округов +15% скидка на проживание)✅ «Каникулы в горах»(семейный тариф: дети до 12 лет бесплатно, канатные дороги, хаски-центр, парк капибар, скидки на ролики и инструктора)✅ «Отель + Сочи Парк»(при бронировании от 2 ночей — бесплатный билет в Сочи Парк каждому)",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      },
      {
        "id": "274-38877",
        "title": "Тариф \"Наполни свое лето\". Бесплатные активности",
        "code": "",
        "discount": "30%",
        "description": "Бесплатные активности (для каждого гостя в номере):Прогулочный билет «Панорама Красной Поляны» для взрослых (с 15 лет) и детей 7–14 летПосещение Хаски-центра (дети до 4 лет только в сопровождении родителей)Посещение парка «Капибара и друзья» (дети до 8 лет в сопровождении родителей)Один маршрут верёвочного парка:для гостей ростом от 140 см ‒ маршрут «Воздушный сноуборд»,для гостей ниже 140 см ‒ альтернативные маршруты или аттракционыСкидка 30% на аренду роликов или скейтборда (1 час проката для каждого гостя в номере)Отвезём на пляж и вернём обратно!Чтобы воспользоваться бесплатным трансфером на пляж (район Сочи Парк Отеля), запишитесь до 20:00 за день до поездки на ресепшене отеля.Пляжное оборудование (шезлонги, зонты) предоставляется за дополнительную плату.",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=274&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65f1bdd3cd341.png"
      }
    ]
  },
  {
    "id": "262",
    "name": "Codashop Affiliate Program",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65bb8e5c6bf1f.png",
    "description": "We make digital content accessible to every market. We run campaigns with game and digital content publishers to bring exciting and exclusive deals to users.",
    "promocodesCount": 0,
    "category": "Gaming",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "261",
    "name": "Lightinthebox",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65bb88a48d7c1.png",
    "description": "LightInTheBox.com world leader in selling consumer goods since 2006. We serve customers from over 190 countries. We feature a wide range of products: from cell-phones, to wedding dresses, faucets, and celebrity-inspired ",
    "promocodesCount": 0,
    "category": "E-commerce & Retail",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "260",
    "name": "InVideo",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6967c24bca069.png",
    "description": "InVideo helps you to transform your content into great videos. We serve media companies, small businesses, and brands to expand audience engagement through the power of video content. InVideo is ideal for marketers, publ",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "258",
    "name": "Airalo",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65bb7ce0efad6.png",
    "description": "Airalo is the world’s leading eSIM provider, trusted by millions of travelers to stay connected in 200+ destinations. With an Airalo eSIM, travelers can wave goodbye to the airport SIM scrabble and get online the moment ",
    "promocodesCount": 0,
    "category": "Путешествия",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "257",
    "name": "SPanel",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65b90a310e84b.png",
    "description": "SPanel is a cloud VPS management platform, and a full-scale cPanel/WHM alternative, allowing every website owner to easily manage servers, websites, websites, emails, etc., in a secure environment powered by our 24/7/365",
    "promocodesCount": 0,
    "category": "Software",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "256",
    "name": "НЦРДО",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8113d30a0e.png",
    "description": "НЦРДО — Национальный центральный институт развития дополнительного образования предлагает программы повышения квалификации и профессиональной переподготовки по направлениям: - Педагогика; - Психология; - Управление и эко",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "256-96026",
        "title": "Скидка 5% на заказ",
        "code": "advcake",
        "discount": "5%",
        "description": "Скидка 5% на любой курс (не суммируется с другими акциями)",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=256&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8113d30a0e.png"
      },
      {
        "id": "256-34910",
        "title": "Скидки до 123 000 рублей + 4 курса в подарок!",
        "code": "",
        "discount": "000₽",
        "description": "Скидки до 123 000 рублей на курсы по психологии + 4 курса в подарок*!*при сумме покупки от 60 000 рублей",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=256&a=79",
        "isActive": true,
        "createdAt": "2025-11-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8113d30a0e.png"
      },
      {
        "id": "256-27964",
        "title": "Скидка 5% на любой курс по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на любой курс по промокоду. Не суммируется с другими акциями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=256&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8113d30a0e.png"
      },
      {
        "id": "256-37671",
        "title": "Скидки на курсы до 60%",
        "code": "",
        "discount": "60%",
        "description": "Скидки до 60% на курсы + 3 электронных курса в подарок",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=256&a=79",
        "isActive": true,
        "createdAt": "2026-03-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8113d30a0e.png"
      }
    ]
  },
  {
    "id": "255",
    "name": "100 балльный репетитор",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8066946c08.png",
    "description": "100балльный репетитор - Платформа №1 по результатам подготовки учеников к ЕГЭ (по версии рейтинга Smart Ranking 2025). Готовим на оценку «5» к ОГЭ и на 90+ к ЕГЭ. Помогаем сдать экзамены без стресса и поступить в вуз меч",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "255-116293",
        "title": "Скидка 9% на месяц обучения.",
        "code": "CAKE9",
        "discount": "9%",
        "description": "Скидка 9% на первый месяц подготовки к ЕГЭ и ОГЭ. Распространяется только на новых клиентов. Не суммируется с другими предложениями.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=255&a=79",
        "isActive": true,
        "createdAt": "2025-07-07",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8066946c08.png"
      },
      {
        "id": "255-116271",
        "title": "Скидка 5% на годовой курс.",
        "code": "CAKE5",
        "discount": "5%",
        "description": "Скидка 5% на покупку годового курса по подготовке к ЕГЭ и ОГЭ. Действительна только для новых клиентов. Суммируется с другими предложениями.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=255&a=79",
        "isActive": true,
        "createdAt": "2025-07-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8066946c08.png"
      },
      {
        "id": "255-31816",
        "title": "Скидка 9% на месяц обучения",
        "code": "",
        "discount": "9%",
        "description": "Скидка 9% на первый месяц подготовки к ЕГЭ и ОГЭ. Распространяется только на новых клиентов. Не суммируется с другими предложениями.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=255&a=79",
        "isActive": true,
        "createdAt": "2025-07-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8066946c08.png"
      },
      {
        "id": "255-31815",
        "title": "Скидка 5% на годовой курс",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на покупку годового курса по подготовке к ЕГЭ и ОГЭ. Действительна только для новых клиентов. Суммируется с другими предложениями.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=255&a=79",
        "isActive": true,
        "createdAt": "2025-07-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65a8066946c08.png"
      }
    ]
  },
  {
    "id": "253",
    "name": "Jackery (United States)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img659d6849cf76d.png",
    "description": "Jackery was founded in 2012 by a group of adventurous engineers who believe in making electricity portable, clean, outdoors-oriented, and accessible.",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "252",
    "name": "Temu Affiliate Program",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img659d4a354db5a.png",
    "description": "Temu is an online marketplace that connects consumers with millions of sellers, manufacturers and brands around the world with the mission to empower them to live their best lives.",
    "promocodesCount": 0,
    "category": "E-commerce & Retail",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "249",
    "name": "ТВОЕ",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656f653bdfe4d.png",
    "description": "ТВОЕ – это российский бренд одежды, обуви и аксессуаров, это 27 лет на рынке, это более 300 магазинов в 4 странах СНГ и десятки тысяч довольных покупателей. ТВОЕ – это вещи для тебя! ТВОЕ создает изделия на собственных ф",
    "promocodesCount": 3,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "249-36141",
        "title": "Скидки до 87% на женскую одежду и обувь",
        "code": "",
        "discount": "87%",
        "description": "Скидки до 87% на выделенный ассортимент женской одежды и обуви",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=249&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656f653bdfe4d.png"
      },
      {
        "id": "249-36140",
        "title": "Скидки до 87% на мужскую одежду и обувь",
        "code": "",
        "discount": "87%",
        "description": "Скидки до 87 на выделенный ассортимент мужской одежды и обуви",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=249&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656f653bdfe4d.png"
      },
      {
        "id": "249-36142",
        "title": "Специальные коллекции одежды ТВОЕ",
        "code": "",
        "discount": "Акция",
        "description": "Специальные коллекции одежды ТВОЕ",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=249&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656f653bdfe4d.png"
      }
    ]
  },
  {
    "id": "246",
    "name": "Pentaschool",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef9819b489.png",
    "description": "Московская академия дизайн-профессий Pentaschool — это онлайн-платформа для обучения дизайну с нуля до PRO. Мы собрали программы от экспертов международного уровня. Более 50 программ обучения для начинающих и практикующи",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "246-130808",
        "title": "Скидка 5% для новых пользователей.",
        "code": "Directline",
        "discount": "5%",
        "description": "Скидка 5% для новых пользователей. Не суммируется c другими акциями. Исключение: акционная цена на сайте. Действует на все учебные программы.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=246&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef9819b489.png"
      },
      {
        "id": "246-115347",
        "title": "Скидка 5% для новых пользователей.",
        "code": "New5",
        "discount": "5%",
        "description": "Скидка 5% для новых пользователей. Не суммируется c другими акциями. Исключение: акционная цена на сайте. Действует на все учебные программы программы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=246&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef9819b489.png"
      },
      {
        "id": "246-31284",
        "title": "Скидка 5% для новых пользователей",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% для новых пользователей. Не суммируется c другими акциями. Исключение: акционная цена на сайте. Действует на все учебные программы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=246&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef9819b489.png"
      }
    ]
  },
  {
    "id": "245",
    "name": "Национальный социально-педагогический колледж(distant-college)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef842a41c4.png",
    "description": "В Национальном социально-педагогическом колледже каждый может получить образование дистанционно и в комфортных условиях. В 2023 году вошел в состав Федерального учебно-методического объединения по укрупненным группам спе",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "245-115245",
        "title": "Скидка 5% на любую программу.",
        "code": "Bonus5",
        "discount": "5%",
        "description": "Скидка 5% на любую образовательную программу для новых пользователей. Не суммируется с другими акциями. Исключение: акционная цена на сайте.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=245&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef842a41c4.png"
      },
      {
        "id": "245-31188",
        "title": "Скидка 5% на любую программу",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на первый семестр любой образовательной программы. Не суммируется с другими акциями. Исключение: акционная цена на сайте.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=245&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef842a41c4.png"
      }
    ]
  },
  {
    "id": "244",
    "name": "Институт прикладной психологии",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef55b238db.png",
    "description": "В Институте прикладной психологии в социальной сфере каждый сможет получить знания по психологии с нуля доступно, удобно и интересно. Мы взяли лучшее из очного и дистанционного форматов обучения и с помощью информационны",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "244-115349",
        "title": "Скидка 5% на все учебные программы.",
        "code": "Welcome5",
        "discount": "5%",
        "description": "Скидка 5% на все учебные программы для новых пользователей. Не суммируется c другими акциям на сайте. Введите промокод при оставлении заявки или сообщите его менеджеру",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=244&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef55b238db.png"
      },
      {
        "id": "244-133617",
        "title": "Скидка 10% на все учебные программы для новых пользователей",
        "code": "PSY10URWAY",
        "discount": "10%",
        "description": "Скидка 10%. Только для новых пользователей. Не суммируется с другими акциями. Действует на все курсы.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=244&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef55b238db.png"
      },
      {
        "id": "244-31286",
        "title": "Скидка 5% на все курсы",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на все учебные программы для новых пользователей. Не суммируется c другими акциям на сайте. Введите промокод при оставлении заявки или сообщите его менеджеру.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=244&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef55b238db.png"
      },
      {
        "id": "244-38311",
        "title": "Скидка 10% на все учебные программы для новых пользователей.",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10%.Только для новых пользователей.Не суммируется с другими акциями.Действует на все курсы.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=244&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef55b238db.png"
      }
    ]
  },
  {
    "id": "243",
    "name": "Цветы Тут",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef350b1851.png",
    "description": "Сервис по доставке цветов «Цветы Тут» - это высокое качество цветов, быстрая доставка в Москве и приятные цены. Наша миссия – сделать покупку и доставку цветов простой и приятной, для того, чтобы дарить улыбки и радость ",
    "promocodesCount": 3,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "243-125983",
        "title": "Скидка 10% на заказ",
        "code": "tsvetytyt10",
        "discount": "10%",
        "description": "Скидка 10% на все букеты с розами. Порадуйте себя или своих близких! Укажите промокод в поле комментарий при оформлении заказа.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=243&a=79",
        "isActive": true,
        "createdAt": "2025-12-24",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef350b1851.png"
      },
      {
        "id": "243-35872",
        "title": "Скидка 10% на все букеты с розами​",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все букеты с розами. Порадуйте себя или своих близких! Укажите промокод в поле комментарий при оформлении заказа.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=243&a=79",
        "isActive": true,
        "createdAt": "2025-12-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef350b1851.png"
      },
      {
        "id": "243-36113",
        "title": "Скидки на ряд товаров",
        "code": "",
        "discount": "Акция",
        "description": "Скидки на ряд товаров",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=243&a=79",
        "isActive": true,
        "createdAt": "2026-01-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ef350b1851.png"
      }
    ]
  },
  {
    "id": "242",
    "name": "Любимчик",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656eefe6f0c98.png",
    "description": "Любимчик - сеть зоомагазинов. У нас собрано более 10 тысяч товаров для животных: сухие и влажные корма для собак и кошек, игрушки, наполнители, лакомства, лекарства для разных животных. Преимущества для покупателей: - По",
    "promocodesCount": 2,
    "category": "Товары для животных",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "242-125364",
        "title": "Скидка ​10% на весь заказ от 2500р",
        "code": "ADVCAKE",
        "discount": "10%",
        "description": "Скидка 10% на весь заказ от 2500р",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tracktsp.com/click?o=242&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656eefe6f0c98.png"
      },
      {
        "id": "242-35456",
        "title": "Скидка ​10% на весь заказ от 2500р",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на весь заказ от 2500р",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tracktsp.com/click?o=242&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656eefe6f0c98.png"
      }
    ]
  },
  {
    "id": "240",
    "name": "Performance Food",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png",
    "description": "Performance Food специализируется на приготовлении и доставке здорового питания с использованием натуральных продуктов питания. Больше никаких изнурительных походов в магазин за едой, мучительных поисков нужных продуктов",
    "promocodesCount": 15,
    "category": "Потребительские товары",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "240-128275",
        "title": "Скидка 1900 руб. на заказ",
        "code": "AdvPF",
        "discount": "1900₽",
        "description": "Скидка 1900 рублей при заказе программы от 5 дней. Акция действует для новых пользователей на все меню, кроме программ: «Индивидуальное питание» и «Детокс».",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-01-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-131713",
        "title": "Скидка 1000 руб. на повторный заказ",
        "code": "ПОВТОРИМ",
        "discount": "1000₽",
        "description": "1000 рублей скидка на повторный заказ от 5 дней. На все программы питания кроме программы Индивидуальное и Детокс.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-131712",
        "title": "​Дарим 2 дня питания",
        "code": "НОВ2",
        "discount": "Акция",
        "description": "Дарим 2 дня питания на первый заказ на 7 дней. Кроме меню Индивидуальное и Постное.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-133606",
        "title": "15% - ДЕТОКС",
        "code": "ТВОЙДЕТОКС",
        "discount": "15%",
        "description": "15% скидка на программу ДЕТОКС. Легкий и вкусный способ сбросить до 5 кг. Только для новых клиентов. Можно использовать только 1 раз. Не суммируется с другими акциями и предложениями. Действует на всю линейку ДЕТОКС. Нет ограничений в сумме скидки в рублях.",
        "expiryDate": "2026-05-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-134249",
        "title": "Скидка 12%",
        "code": "ПЕРВЫЙ",
        "discount": "12%",
        "description": "Скидка 12% для новых пользователей Можно использовать только 1 раз. Не суммируется с другими акциями и предложениями. Действует на все программы питания, кроме \"Индивидуальное\". Нет ограничений в сумме скидки в рублях.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-36180",
        "title": "Скидка 1900 руб. на заказ программы",
        "code": "",
        "discount": "1900₽",
        "description": "Скидка 1900 рублей при заказе программы от 5 дней. Акция действует для новых пользователей на все меню, кроме программ: «Индивидуальное питание» и «Детокс».",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-01-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-37336",
        "title": "Купите сейчас - оплатите долями",
        "code": "",
        "discount": "Акция",
        "description": "Купите сейчас - оплатите долями. Меню 20 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-37334",
        "title": "Дарим 2 дня питания на первый заказ на 7 дней",
        "code": "",
        "discount": "Акция",
        "description": "Дарим 2 дня питания на первый заказ на 7 дней. Кроме меню Индивидуальное и Постное.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-37340",
        "title": "Бесплатная ежедневная доставка премиального меню",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Бесплатная ежедневная доставка премиальног меню в радиусе до 50 км от МКАД.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-37338",
        "title": "1000 рублей скидка на повторный заказ от 5 дней",
        "code": "",
        "discount": "1000₽",
        "description": "1000 рублей скидка на повторный заказ от 5 дней. На все программы питания кроме программы Индивидуальное и Детокс.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-37337",
        "title": "3% от вашего заказа в виде бонусов на ваш счет по программе лояльности",
        "code": "",
        "discount": "3%",
        "description": "3% от вашего заказа в виде бонусов на ваш счет по программе лояльности. которыми можно оплатить до 50% стоимости заказа.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-37685",
        "title": "Скидка 21% в моб. приложении",
        "code": "",
        "discount": "21%",
        "description": "Скидка 21% на первый заказ! На все программы питания! Только для новых пользователей в мобильном приложении.Макс. сумма скидки не ограничена. Мин. суммы заказа нет.",
        "expiryDate": "2026-08-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-03-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-38300",
        "title": "Детокс",
        "code": "",
        "discount": "Акция",
        "description": "Мой ДЕТОКС: сила, энергия, легкость",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-38299",
        "title": "Скидка 15% на программу ДЕТОКС",
        "code": "",
        "discount": "15%",
        "description": "15% скидка на программу ДЕТОКС. Легкий и вкусный способ сбросить до 5 кг.Только для новых клиентов. Можно использовать только 1 раз. Не суммируется с другими акциями и предложениями. Действует на всю линейку ДЕТОКС. Нет ограничений в сумме скидки в рублях.",
        "expiryDate": "2026-05-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-04-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      },
      {
        "id": "240-38582",
        "title": "Скидка 12%",
        "code": "",
        "discount": "12%",
        "description": "Скидка 12% для новых пользователей Можно использовать только 1 раз. Не суммируется с другими акциями и предложениями. Действует на все программы питания, кроме \"Индивидуальное\". Нет ограничений в сумме скидки в рублях.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=240&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656ee994467a2.png"
      }
    ]
  },
  {
    "id": "239",
    "name": "MirCli",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656e033d3d8c2.png",
    "description": "MirCli - климатическая компания, основанная в 2005 году. Основной деятельностью компании является поставка и монтаж климатической техники бытового и промышленного назначения. Мы осуществляем полный цикл услуг от проектир",
    "promocodesCount": 2,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "239-128916",
        "title": "Скидка 5% на заказ",
        "code": "MIRCLI_ADV",
        "discount": "5%",
        "description": "Создайте идеальный климат в доме с фиксированной скидкой 5% — профессиональная климатическая техника и услуги теперь доступнее.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=239&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656e033d3d8c2.png"
      },
      {
        "id": "239-36211",
        "title": "Скидка 5% на все товары",
        "code": "",
        "discount": "5%",
        "description": "Создайте идеальный климат в доме с фиксированной скидкой 5% — профессиональная климатическая техника и услуги теперь доступнее.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=239&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656e033d3d8c2.png"
      }
    ]
  },
  {
    "id": "237",
    "name": "Семицветик",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656dfdae7d434.png",
    "description": "Семицветик - крупный цветочный интернет-магазин и сильный бренд, известный многим в Петербурге и за его пределами. Мы работаем с 2006 года, и за это время создали более 1 600 000 цветочных композиций. За время работы мы ",
    "promocodesCount": 3,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "237-131903",
        "title": "Скидка 7% на заказ",
        "code": "advcake",
        "discount": "7%",
        "description": "Скидка 7% на все товары, применяется только на гео Санкт-Петербург",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=237&a=79",
        "isActive": true,
        "createdAt": "2026-03-10",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656dfdae7d434.png"
      },
      {
        "id": "237-36521",
        "title": "Букеты со скидками до 50%",
        "code": "",
        "discount": "50%",
        "description": "Подборка букетов со скидками до 50%",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=237&a=79",
        "isActive": true,
        "createdAt": "2026-01-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656dfdae7d434.png"
      },
      {
        "id": "237-37475",
        "title": "Скидка 7% на все товары",
        "code": "",
        "discount": "7%",
        "description": "Скидка 7% на все товары. Скидка применяется только на заказ в Санкт-Петербург.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=237&a=79",
        "isActive": true,
        "createdAt": "2026-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656dfdae7d434.png"
      }
    ]
  },
  {
    "id": "234",
    "name": "Страховой Дом ВСК",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656a0cb8c0e4f.png",
    "description": "Страховой Дом ВСК (САО «ВСК») осуществляет страховую деятельность с 11 февраля 1992 года и в настоящее время занимает ведущие позиции на рынке страховых услуг России. Высокий уровень работы компании четырежды отмечен бла",
    "promocodesCount": 0,
    "category": "Финансы и страхование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "230",
    "name": "Genotek",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png",
    "description": "Genotek — это медицинская высокотехнологичная компания. Мы оказываем услуги в сфере персональной и медицинской генетики. Наша миссия — предоставить клиентам доступ к генетической информации, которая повысит качество их ж",
    "promocodesCount": 26,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "230-128266",
        "title": "Скидка ​31% на исследование Генеалогия за 200 лет",
        "code": "gen200",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 200 лет",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128257",
        "title": "​Скидка 5% на ДНК тест Происхождение",
        "code": "pro5",
        "discount": "5%",
        "description": "Скидка 5% на ДНК тест Происхождение",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128265",
        "title": "Скидка 31% на исследование Генеалогия за 100 лет​",
        "code": "gen100",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 100 лет",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128252",
        "title": "Скидка 65% на генетический паспорт",
        "code": "CPA25",
        "discount": "65%",
        "description": "Промокод дает скидку 65% на заказ Генетического паспорта.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128260",
        "title": "Скидка 5% на ДНК тест Эффективность лекарств",
        "code": "pha5",
        "discount": "5%",
        "description": "Скидка 5% на ДНК тест Эффективность лекарств",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128267",
        "title": "Скидка ​31% на исследование Генеалогия за 200 лет (расширенная)",
        "code": "pro200",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 200 лет (расширенная)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128268",
        "title": "​Скидка 31% на исследование Генеалогия за 300 лет",
        "code": "gen300",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 300 лет",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128261",
        "title": "​Скидка 5% на ДНК-тест Способности и характер",
        "code": "cha5",
        "discount": "5%",
        "description": "Скидка 5% на ДНК-тест Способности и характер",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128264",
        "title": "Скидка ​38% на ДНК-тест Генетические исследования при планировании беременности",
        "code": "pla38",
        "discount": "38%",
        "description": "Скидка 38% на ДНК-тест Генетические исследования при планировании беременности",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128259",
        "title": "Скидка 5% на ДНК тест Риски заболеваний",
        "code": "pro10",
        "discount": "5%",
        "description": "Скидка 5% на ДНК тест Риски заболеваний",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128262",
        "title": "​Скидка 5% на ДНК-тест Питание",
        "code": "foo5",
        "discount": "5%",
        "description": "Скидка 5% на ДНК-тест Питание",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128258",
        "title": "Скидка 350 руб. на ДНК тест Полный геном",
        "code": "gen10",
        "discount": "350₽",
        "description": "Дополнительная скидка 350 руб. на ДНК тест Полный геном",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-128263",
        "title": "​Скидка 5% на ДНК-тест Спортивная генетика",
        "code": "spo5",
        "discount": "5%",
        "description": "Скидка 5% на ДНК-тест Спортивная генетика",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36158",
        "title": "-5% на ДНК тест Происхождение",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на ДНК тест Происхождение",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36156",
        "title": "-65% на заказ Генетического паспорта",
        "code": "",
        "discount": "65%",
        "description": "Промокод дает скидку 65% на заказ Генетического паспорта.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36163",
        "title": "-5% на ДНК-тест Питание",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на ДНК-тест Питание",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36171",
        "title": "-31% на исследование Генеалогия за 300 лет",
        "code": "",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 300 лет",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36170",
        "title": "-31% на исследование Генеалогия за 200 лет (расширенная)",
        "code": "",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 200 лет (расширенная)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36162",
        "title": "-5% на ДНК-тест Способности и характер",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на ДНК-тест Способности и характер",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36166",
        "title": "-38% на ДНК-тест Генетические исследования при планировании беременности",
        "code": "",
        "discount": "38%",
        "description": "Скидка 38% на ДНК-тест Генетические исследования при планировании беременности",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36167",
        "title": "-31% на исследование Генеалогия за 100 лет",
        "code": "",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 100 лет",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36161",
        "title": "-5% на ДНК тест Эффективность лекарств",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на ДНК тест Эффективность лекарств",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36160",
        "title": "-5% на ДНК тест Риски заболеваний",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на ДНК тест Риски заболеваний",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36164",
        "title": "-5% на ДНК-тест Спортивная генетика",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на ДНК-тест Спортивная генетика",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36159",
        "title": "-350 руб. на ДНК тест Полный геном",
        "code": "",
        "discount": "350₽",
        "description": "Дополнительная скидка 350 руб. на ДНК тест Полный геном",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      },
      {
        "id": "230-36169",
        "title": "-31% на исследование Генеалогия за 200 лет",
        "code": "",
        "discount": "31%",
        "description": "Скидка 31% на исследование Генеалогия за 200 лет",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=230&a=79",
        "isActive": true,
        "createdAt": "2026-01-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566544aea3d2.png"
      }
    ]
  },
  {
    "id": "228",
    "name": "DonPlafon",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664ef159dcc.png",
    "description": "DonPlafon на рынке уже более 10 лет и является одним из крупнейших гипермаркетов света в России. В каталоге интернет магазина donplafon.ru большой выбор люстр и светильников от лучших производителей. Преимущества для пок",
    "promocodesCount": 5,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "228-114955",
        "title": "Скидка 8% на заказ.",
        "code": "donkupon8",
        "discount": "8%",
        "description": "Скидка 8% на заказ. Не распространяется на товары брендов Arte Lamp, Divinare, Sonex, Odeon, Lumion, Novotech, Citilux, Lussole, Omnilux, Aployt, Reccagni Angelo, Eurosvet, Elektrostandard, Werkel, Bogates, TK Lighting, Maytoni, Freya, Voltega, Crystal Lux. Не суммируется с другими акциями на сайте. Промокод можно ввести только при переходе по ссылке площадки на которой он размещен.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=228&a=79",
        "isActive": true,
        "createdAt": "2025-06-10",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664ef159dcc.png"
      },
      {
        "id": "228-31027",
        "title": "Скидка 8% на заказ",
        "code": "",
        "discount": "8%",
        "description": "Скидка 8% на заказ. Не распространяется на товары брендов Arte Lamp, Divinare, Sonex, Odeon, Lumion, Novotech, Citilux, Lussole, Omnilux, Aployt, Reccagni Angelo, Eurosvet, Elektrostandard, Werkel, Bogates, TK Lighting, Maytoni, Freya, Voltega, Crystal Lux. Не суммируется с другими акциями на сайте. Промокод можно ввести только при переходе по ссылке площадки на которой он размещен.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=228&a=79",
        "isActive": true,
        "createdAt": "2025-06-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664ef159dcc.png"
      },
      {
        "id": "228-36233",
        "title": "15% на все, кроме citilux, maytoni, freya, voltega",
        "code": "",
        "discount": "15%",
        "description": "15% на все, кроме citilux, maytoni, freya, voltega. Для любого пользователя. Действует только на 1 заказ. Без ограничений по сумме.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=228&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664ef159dcc.png"
      },
      {
        "id": "228-16011",
        "title": "Получайте 6% бонусами СберСпасибо",
        "code": "",
        "discount": "6%",
        "description": "Накапливайте 6% бонусами СберСпасибо за каждую покупку (бонусы начисляются только при оплате картой на сайте)",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=228&a=79",
        "isActive": true,
        "createdAt": "2026-04-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664ef159dcc.png"
      },
      {
        "id": "228-26554",
        "title": "Скидка до 20% на люстры из Италии",
        "code": "",
        "discount": "20%",
        "description": "Скидки до 20% на люстры итальянского производства",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=228&a=79",
        "isActive": true,
        "createdAt": "2026-04-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664ef159dcc.png"
      }
    ]
  },
  {
    "id": "226",
    "name": "Аquanet",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png",
    "description": "Акванет – официальный дилер многих мировых брендов с широким спектром сантехнической продукции. Фирменные магазины и дилерская сеть с региональным складским запасом представлены в 109 городах России. Собственный транспор",
    "promocodesCount": 13,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "226-133454",
        "title": "Скидка 15% (общий)",
        "code": "15CAKE40000",
        "discount": "15%",
        "description": "Скидка 15% на товары брендов AQUANET, Allen Brau от 40000 руб. (кроме скидок и акций).",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-133453",
        "title": "Скидка 10% (общий)",
        "code": "10CAKE",
        "discount": "10%",
        "description": "Скидка 10% на товары брендов AQUANET, Allen Brau. Скидка на товары не по распродаже и не по акции",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37267",
        "title": "Скидка до -25% на душевые ограждения, смесители и поддоны Aquanet",
        "code": "",
        "discount": "25%",
        "description": "Лучший подарок для дома — уютная и красивая душевая. В Aquanet — скидки до 25% на душевые ограждения, смесители и поддоны. Радуйте себя и близких с выгодой.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37269",
        "title": "Скидка -25% на акриловые ванны, раковины и унитазы Allen Brau",
        "code": "",
        "discount": "25%",
        "description": "Allen Brau — немецкое качество с выгодой 25%. В Aquanet — специальное предложение на сантехнику Allen Brau: акриловые ванны, раковины и унитазы. Создайте интерьер премиум-класса по привлекательной цене.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37270",
        "title": "Скидка -25% на душевые системы и смесители, инсталляции Allen Brau",
        "code": "",
        "discount": "25%",
        "description": "Allen Brau со скидкой 25% в Aquanet! Душевые системы, смесители, инсталляции — для идеальной ванной по лучшим ценам.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37271",
        "title": "Скидка до -40% на коллекции мебели Priority, Glority, Liberty",
        "code": "",
        "discount": "40%",
        "description": "Скидки до 40% на мебель Priority, Glority, Liberty! Стильные коллекции для вашего дома по самым выгодным ценам.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37272",
        "title": "Распродажа мебели скидки до -50%",
        "code": "",
        "discount": "50%",
        "description": "Время создать дом мечты — с выгодой до 50%! В нашем магазине — масштабная распродажа мебели.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37274",
        "title": "Акции интернет-магазина AQUANET",
        "code": "",
        "discount": "Акция",
        "description": "Все актуальные акции интернет-магазина AQUANET в одном месте. Не упустите выгоду!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37266",
        "title": "Скидка -25% на акриловые ванны и керамику Aquanet",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на акриловые ванны и керамику в Aquanet! Обновите ванную комнату с максимальной выгодой. В акции — акриловые ванны, раковины, унитазы и керамическая плитка от ведущих брендов.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37265",
        "title": "Скидки до 70% на сантехнику и мебель для ванной",
        "code": "",
        "discount": "70%",
        "description": "Обновите ванную комнату с выгодой до 70%! В Aquanet.ru — скидки на сантехнику и мебель для ванной. Раковины, унитазы, тумбы, зеркала и аксессуары по самым низким ценам.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-37268",
        "title": "Скидка -25% на смесители, аксессуары, ограждения в черном цвете",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на чёрную сантехнику! Смесители, душевые ограждения, аксессуары — всё в трендовом чёрном цвете по специальным ценам. Стильно, современно, выгодно.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-38123",
        "title": "Скидка 15% (о)",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на товары брендов AQUANET, Allen Brau от 40000 руб. (кроме скидок и акций).",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      },
      {
        "id": "226-38122",
        "title": "Скидка 10% (о)",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на товары брендов AQUANET, Allen Brau. Скидка на товары не по распродаже и не по акции",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=226&a=79",
        "isActive": true,
        "createdAt": "2026-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664c6df126b.png"
      }
    ]
  },
  {
    "id": "225",
    "name": "Alter",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664a5c225a9.png",
    "description": "Alter — сервис подбора психологов на основе научного алгоритма, разработанного на базе Психологического института РАО*. Наша миссия: продвигать мировые стандарты психотерапии на российский рынок. Мы опираемся на научные ",
    "promocodesCount": 4,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "225-115339",
        "title": "Скидка 20% на первую сессию",
        "code": "advcake",
        "discount": "20%",
        "description": "Введите промокод при записи на консультацию и получите скидку 20%. Действует только на первую сессию с психологом.​",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=225&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664a5c225a9.png"
      },
      {
        "id": "225-10364",
        "title": "Подключитесь к офферу «Alter — сервис по подбору психолога».",
        "code": "",
        "discount": "90%",
        "description": "Осень – горячий сезон в нише ментального здоровья. Подключитесь к офферу «Alter — сервис по подбору психолога». Сервис соединяет клиентов со специалистами, которые лучше и быстрее всего помогут решить проблему. Ставка за привлеченного клиента от 600 ₽ до 1000 ₽, а аппрув стремится к 90%.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=225&a=79",
        "isActive": true,
        "createdAt": "2022-09-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664a5c225a9.png"
      },
      {
        "id": "225-31276",
        "title": "Скидка 20% на первую сессию с психологом!",
        "code": "",
        "discount": "20%",
        "description": "Введите промокод при записи на консультацию и получите скидку 20%. Действует только на первую сессию с психологом.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=225&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664a5c225a9.png"
      },
      {
        "id": "225-36563",
        "title": "Пройдите диагностическую сессию от Alter",
        "code": "",
        "discount": "490₽",
        "description": "За 490 рублей вы получаете консультацию с экспертом Alter + подарок (карту эмоций)Вы сможете разобраться в себе, увидеть причину трудностей и сформулировать свой запрос к психологуДиагностическая сессия Alter — это безопасный первый шаг в психотерапию: 30 минут онлайн, чтобы сформулировать запрос, понять подходящий метод и получить персональную подборку психологов.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=225&a=79",
        "isActive": true,
        "createdAt": "2026-01-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65664a5c225a9.png"
      }
    ]
  },
  {
    "id": "224",
    "name": "Аптеки Ригла",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png",
    "description": "Аптеки Ригла – это широкий ассортимент лекарственных средств, специальные цены, качественные оригинальные товары, быстрое оформление заказа и доставка. Это команда профессионалов, передовые технологии аптечного бизнеса, ",
    "promocodesCount": 19,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "224-28666",
        "title": "500 бонусов на День рождения!",
        "code": "",
        "discount": "20%",
        "description": "В честь Вашего дня рождения дарим Вам 500 бонусов на карту лояльности «Аптечная семья».Бонусы начисляются автоматически за 7 дней до Вашего дня рождения.Начисленные бонусы позволяют вам оплатить до 20% от стоимости товара.Срок действия бонусов составляет 14 дней с даты начисления.Бонусы можно использовать в аптеках и при заказе в интернет-аптеке.Ограничения по акции:-Для получения бонусов необходимо не менее чем за 8 дней до фактической даты рождения иметь:-Активированную карту «Аптечная Семья»;-Указанные в профиле Дату рождения и действующий E-mail;-Активную подписку на email-рассылку.В случае отсутствия перечисленных данных, вы можете указать их в Личном кабинете на сайте или при регистрации карты в аптеке. Изменение даты рождения в течение года не предусмотрено для повторного начисления бонусов.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2025-01-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-30790",
        "title": "Велком-бонусы новым клиентам!",
        "code": "",
        "discount": "30%",
        "description": "Дарим 700 бонусов всем новым клиентам!Карта лояльности «Аптечная семья» оформляется бесплатно.300 бонусов сразу за оформление карты лояльности в аптеке, на сайте или в мобильном приложении и подписку на уведомления (E-mail и/или Push)200 бонусов за первую покупку в течение 15 дней после получения карты200 бонусов за вторую покупку в течение 15 дней после первой покупкиВажно знать:При подписке на push убедитесь, что у вас включены уведомления от приложения «Ригла» в настройках вашего телефонаПри подписке на e-mail проверьте корректность указанного вами e-mail адресаКак потратить бонусы?У каждого начисления срок действия 15 дней с даты полученияОплачивайте бонусами до 30% стоимости покупкиИспользуйте бонусы при покупке любых товаров, кроме исключений**Проверить баланс можно в личном кабинете на сайте, в мобильном приложении или в аптеке Бонусы начисляются однократно, при отмене и повторном разрешении на уведомления бонусы не начисляютсяС картой лояльности «Аптечная семья» покупать выгодно!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2025-05-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-30911",
        "title": "500 бонусов за подписку",
        "code": "",
        "discount": "20%",
        "description": "Выберите один из способов и получите 500 бонусов на вашу карту лояльности «Аптечная семья»:Способ №1 Установите мобильное приложение «Ригла» и подпишитесь на pushШаг 1: Скачайте и установите приложение «Ригла» (если приложение у вас еще не установлено)Шаг 2: Подпишитесь на push-уведомления в разделе «Уведомления» в личном кабинетеШаг 3: Проверьте, что уведомления от приложения разрешены в настройках телефонаШаг 4: Получите 500 бонусов — информация о начислении придет в push-сообщенииСпособ №2 Подпишитесь на email-рассылкуШаг 1: Подпишитесь на email-рассылку в личном кабинете на сайте или в приложении «Ригла»шаг 2: Проверьте корректность указанного вами email-адресаШаг 3: Получите 500 бонусов — уведомление о начислении придет на вашу электронную почтуВажно знать:1 бонус = 1 рубльБонусами можно оплатить до 20% стоимости товара в аптеках, мобильном приложении или на сайте «Ригла»Срок действия бонусов — 30 дней с даты начисленияБонусы начисляются однократно на карту лояльности (500 бонусов можно получить только один раз, выбрав любой из двух способов)При удалении приложения и повторной установке, а также при отписке и повторной подписке на уведомления бонусы повторно не начисляются.Будьте в курсе лучших предложений от «Ригла» и получите 500 бонусов прямо сейчас!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2025-06-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-36964",
        "title": "Распродажа в первую и последнюю пятницу месяца",
        "code": "",
        "discount": "30%",
        "description": "Акция проводится в первую и последнюю пятницу ежемесячно в 2026 г. Скидка 30% предоставляется на выделенный ассортимент. Скидка не суммируется с другими акциями, кроме начисления и списания бонусов по программе лояльности «Аптечная семья».",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-02-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38748",
        "title": "Товар дня!",
        "code": "",
        "discount": "Акция",
        "description": "Горячая подборка товаров по специальным ценам!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38753",
        "title": "Специальные цены на Тева!",
        "code": "",
        "discount": "20%",
        "description": "Специальные цены, скидка 20% на выделенный ассортимент ТМ Тева.Дополнительные скидки на Товар дня действуют в выделенных регионах.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38751",
        "title": "Скидка до 50% на средства для комфортного пищеварения",
        "code": "",
        "discount": "50%",
        "description": "Выгодное предложение на средства для комфортного пищеварения. Становитесь участником бонусной программы «Аптечная семья», приобретайте товары со скидкой до 50% и возвращайте 5% стоимости на следующие покупки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38752",
        "title": "Скидка 50% на средства для ухода за полостью рта",
        "code": "",
        "discount": "50%",
        "description": "Выгодное предложение на средства для ухода за полостью рта. Становитесь участником бонусной программы «Аптечная семья» и приобретайте вторую упаковку товара со скидкой 50%.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38755",
        "title": "-20% на Фотодерм Биодерма!",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на выделенный ассортимент Фотодерм Биодерма.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38756",
        "title": "-25% на Виши!",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на выделенный ассортимент Виши.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38757",
        "title": "-20% на Ля Рош-позе!",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на средства гамм Цикапласт и Антгелиос Ля Рош-Позе.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38750",
        "title": "Скидка до 50% на средства для здоровья суставов",
        "code": "",
        "discount": "50%",
        "description": "Выгодное предложение на средства для здоровья суставов. Становитесь участником бонусной программы «Аптечная семья», приобретайте товары со скидкой до 50% и возвращайте 5% стоимости на следующие покупки.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38758",
        "title": "-25% на Эуцерин!",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на выделенный ассортимент Эуцерин.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38749",
        "title": "Стоп-цена май",
        "code": "",
        "discount": "Акция",
        "description": "Ассортимент товаров по фиксированной выгодной цене.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38759",
        "title": "-25% на Нивея!",
        "code": "",
        "discount": "25%",
        "description": "Скидка 25% на выделенный ассортимент Нивея.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38933",
        "title": "Скидка 20% на тонометры и термометры",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на тонометры и термометры бренда 4ForCare",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38934",
        "title": "-20% на гель-масло для душа!",
        "code": "",
        "discount": "20%",
        "description": "Cкидка 20% на акционный ассортимент торговой марки Аромабио!Это роскошный уход для вашей кожи! Подарите себе ощущение гладкости, здорового сияния и жизненной энергии.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38931",
        "title": "Скидка 30% на экспресс-тест Витамин Д3!",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на экспресс-тест Витамин Д3!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      },
      {
        "id": "224-38932",
        "title": "Скидка от 20 до 50% на шипучие витамины",
        "code": "",
        "discount": "50%",
        "description": "Скидки до 50% на шипучие витамины",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=224&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566480d62700.png"
      }
    ]
  },
  {
    "id": "223",
    "name": "Braun",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png",
    "description": "Braun – бренд, снискавший себе всемирную известность высоким качеством своей продукции. Уже много десятилетий мы производим для вас технику, которая совмещает в себе лаконичный дизайн и удобство в использовании. Бренд Br",
    "promocodesCount": 11,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "223-131794",
        "title": "Скидка 5% на заказ",
        "code": "sale5",
        "discount": "5%",
        "description": "Скидка 5% на заказ, действует только на товары в наличии, не применяется при оплате в рассрочку, не распространяется на товары \"Техника для кухни\" и \"Техника для дома\".",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-37452",
        "title": "​Скидка 5% на заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на заказ, действует только на товары в наличии, не применяется при оплате в рассрочку, не распространяется на товары \"Техника для кухни\" и \"Техника для дома\".",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-37921",
        "title": "Весенняя распродажа - скидки до 70%",
        "code": "",
        "discount": "70%",
        "description": "Braun дарит весенние скидки на технику для ухода. В каталоге — бритвы, эпиляторы и триммеры со скидками до 70%.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-37923",
        "title": "Бесплатная доставка",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Доставка заказов осуществляется БЕСПЛАТНО:-по Москве и Московской области - для заказов на сумму больше 15 000 р. и до 30 км от МКАД-по другим городам России - для заказов на сумму больше 15 000 р.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-37922",
        "title": "Покупайте больше, тратьте меньше!",
        "code": "",
        "discount": "10%",
        "description": "Представляем уникальную акцию на всю технику от Braun! Это ваш шанс приобрести высококачественные товары для кухни и ухода за собой по привлекательным ценам! При покупке 2-х товаров Braun, Вы получаете целых 5% скидки на товар с меньшей стоимостью в корзине! Но это еще не все! Если Вы решите добавить в корзину 3 товара Braun, ваша скидка увеличится до потрясающих 10%!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-38346",
        "title": "Поделите оплату на 4 платежа",
        "code": "",
        "discount": "Акция",
        "description": "Оплачивайте в момент покупки только первую часть Остальное — равными платежами раз в две недели.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-04-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-38347",
        "title": "Скидки до 62% - OUTLET Braun",
        "code": "",
        "discount": "62%",
        "description": "Подборка фирменной техники с выгодной ценой. Скидки до 62% на выделенный ассортимент товаров.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-04-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-38351",
        "title": "Подарочный сертфикат Braun",
        "code": "",
        "discount": "Акция",
        "description": "Электронный подарочный сертификат Braun придёт на email или в SMS точно в тот день и час, которые вы выберете. Вы можете добавить тёплое поздравление, чтобы подарок получился по‑настоящему личным. Сертификат предназначен для онлайн-оплаты любой покупки в официальном интернет‑магазине Braun.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-04-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-38350",
        "title": "Мили «Аэрофлот Бонус»",
        "code": "",
        "discount": "60₽",
        "description": "1 миля начисляется за каждые потраченные 60 рублей. Мили начисляются на все товары, купленные в интернет-магазине braun-russia.ru, не включая стоимость доставки товара, услуги премиального сервисного обслуживания и расширенной гарантии. Мили начисляются в течение 45 дней после оплаты и доставки товара.\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-04-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-38348",
        "title": "Экспресс-доставка",
        "code": "",
        "discount": "499₽",
        "description": "Экспресс-доставка по Москве в пределах МКАД. Режим доставки: ежедневно с 10:00 до 20:00.Условия доставки:-при оформлении заказа с 10:00 до 18:00-оплата онлайн-в пределах МКАД-от 2-х часов с момента подтверждения заказа_общий вес товара не более 15 кг-осуществляется после подтверждения менеджером интернет-магазина-стоимость доставки 499 руб. для товаров от 5000 руб., 799 руб. для товаров до 5000 руб.Точное время доставки согласовывается с покупателем.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-04-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      },
      {
        "id": "223-38349",
        "title": "Рассрочка 0%",
        "code": "",
        "discount": "0%",
        "description": "Отличная новость для поклонников Braun! Выбирайте любимую технику Braun — уже сейчас, а платите потом, без переплат Оформите рассрочку беспроцентно и без каких-либо переплат. Рассрочка предоставляется банком-партнёром на срок 6 месяцев и доступна для заказов на сумму более 15 000 рублей.Для оформления заказа с оплатой в рассрочку:-Положите в корзину выбранные товары.-Выберите способ оплаты «Купить в рассрочку», заполните другие поля формы и нажмите кнопку «Оформить заказ».-Дождитесь появления окна заявки на рассрочку. Заполните 4 шага заявки. Готово!-С вами свяжутся менеджер нашего магазина для подтверждения деталей заказа и менеджер банка для согласования рассрочки.-Курьер банка привезёт вам на подпись договор, и после этого мы отправим ваш заказ.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=223&a=79",
        "isActive": true,
        "createdAt": "2026-04-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656646af972e5.png"
      }
    ]
  },
  {
    "id": "222",
    "name": "BlackTyres",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566435a78ca5.png",
    "description": "Компания BlackTyres с 2006 года занимается продажей шин для автомобилей и мотоциклов, колесных дисков и сотни других автоаксессуаров через собственный интернет-магазин. Более того, BlackTyres – это сеть современных шинны",
    "promocodesCount": 2,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "222-38999",
        "title": "Распродажа шин! Скидки на ассортимент и шиномонтаж",
        "code": "",
        "discount": "10%",
        "description": "Распродажа шин! Скидки до 10%.Скидка 20% на шиномонтаж для выделенных товаров",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=222&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566435a78ca5.png"
      },
      {
        "id": "222-39000",
        "title": "Распродажа дисков! Скидки на ассортимент и шиномонтаж",
        "code": "",
        "discount": "7%",
        "description": "Распродажа дисков! Скидки до 7%.Скидка 20% на шиномонтаж для выделенных товаров",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=222&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566435a78ca5.png"
      }
    ]
  },
  {
    "id": "221",
    "name": "Здравсити",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png",
    "description": "Здравсити – это удобный и доступный цифровой сервис заказа лекарств и товаров для здоровья с самовывозом из ближайшей аптеки или доставкой до дома. Мы работаем в 82 регионах России и помогаем каждому жителю страны заботи",
    "promocodesCount": 12,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "221-31584",
        "title": "Бесплатная доставка товаров для животных",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "У нас прекрасная новость! Товары для домашних питомцев мы доставим совершенно бесплатно. Порадовать своего четвероногого друга стало удобнее! У нас есть витамины и добавки для животных, капли для глаз и ушей, противопаразитарные препараты и многое другое. Условие одно: в заказе должны быть только товары из раздела Ветаптека.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2025-07-03",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-37605",
        "title": "Ниже рынка",
        "code": "",
        "discount": "Акция",
        "description": "В этой подборке собраны товары с одними из самых низких цен на рынке. Данные основаны на собственной аналитике Здравсити. Успейте заказать — количество товаров ограничено. Предложение актуально для Москвы и Московской области.",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-03-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-37607",
        "title": "Лабораторные чекапы со скидкой до -15% теперь на Здравсити",
        "code": "",
        "discount": "15%",
        "description": "Здравсити. Медицина представляет новый сервис: лабораторные анализы ИНВИТРО со скидкой до -15%.Перейдите в раздел Анализы, выберите интересующее обследование по специальной цене до 31.05.2026 года.Позаботьтесь о себе по-настоящему выгодно!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-03-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-38026",
        "title": "Наши бренды - ваши скидки",
        "code": "",
        "discount": "20%",
        "description": "Знаете, какая у нас большая аптечная семья? Наверняка вы встречали в своем городе одну из аптек: «Ригла», \"Здравсити\", \"Будь здоров\". В нашей дружной семье собрались не только аптеки, но и бренды косметики и витаминов. Всего мы выпускаем более 700 наименований под 20 собственными марками. Используем самое лучшее: безопасные составы и строгий контроль качества. А знаете, что самое приятное? Недавно наши бренды получили заслуженное признание: MeDiva стала победителем престижной премии Private Label Awards 2025 среди лучших аптечных брендов страны, а витамины «Будь Здоров! Liposomal vitamins» заняли второе место в своей категории. На этой странице собрали все товары собственных торговых марок по выгодным ценам.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-38773",
        "title": "Стоп-цена май",
        "code": "",
        "discount": "Акция",
        "description": "Ассортимент товаров по фиксированной выгодной цене.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-38775",
        "title": "Купи комплект - сохрани бюджет",
        "code": "",
        "discount": "Акция",
        "description": "Выгодные комплекты товаров",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-38774",
        "title": "до -15% на ветпрепараты от блох и клещей",
        "code": "",
        "discount": "15%",
        "description": "Скидки до -15% на ветпрепараты от блох и клещей",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-39042",
        "title": "до -30% для здоровья вашей кожи",
        "code": "",
        "discount": "30%",
        "description": "Скидки до -30% для здоровья вашей кожи",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-39043",
        "title": "до -30% на защиту от укусов насекомых",
        "code": "",
        "discount": "30%",
        "description": "Скидки до -30% на защиту от укусов насекомых",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-39046",
        "title": "до -30% на всё для здоровья и красоты",
        "code": "",
        "discount": "30%",
        "description": "Скидки до -30% на всё для здоровья и красоты",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-39045",
        "title": "до -30% на средства от солнца",
        "code": "",
        "discount": "30%",
        "description": "Скидки до -30% на средства от солнца",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      },
      {
        "id": "221-39044",
        "title": "до -20% на препараты при аллергии",
        "code": "",
        "discount": "20%",
        "description": "Скидки до -20% на препараты при аллергии",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=221&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663c951be50.png"
      }
    ]
  },
  {
    "id": "219",
    "name": "Л’ОКСИТАН",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663ab73d3c0.png",
    "description": "Продукция Л’ОКСИТАН – это средства на основе натуральных и органических ингредиентов – экстрактов, эссенций и эфирных масел растений, тщательно контролируемого происхождения. Компания применяет только самые безопасные ме",
    "promocodesCount": 4,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "219-117999",
        "title": "Скидка 20% на заказ",
        "code": "promo20",
        "discount": "20%",
        "description": "Скидка 20% кроме сертификатов, спеццен, наборов исключения! Не суммируется с другими скидками и промокодами. Отменяет действией других акций.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=219&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663ab73d3c0.png"
      },
      {
        "id": "219-134614",
        "title": "Подарок при покупке от 6000 рублей",
        "code": "очищение",
        "discount": "6000₽",
        "description": "Идеальный попутчик для вашей кожи! Пенка для умывания Драгоценный Иммортель 50 мл в подарок при покупке от 6 000 р. Подарок: Очищающая пенка для умывания Драгоценный Иммортель 50 мл *Подарок при покупке на сумму от 6000р в одном чеке после применения всех скидок по промокоду ОЧИЩЕНИЕ в интернет-магазине loccitane.ru 21.05-01.06.26г. включительно. Подарок может отличаться от изображенного. Компания оставляет за собой право на замену подарка. Не распространяется на покупку подарочных и СПА-сертификатов, СПА-процедур. Отменяет действие др.скидок, акций и промокодов. Подробности на loccitane.ru/sales/. ООО«Л’Окситан Рус», 119049, г.Москва, ул.Шаболовка, д.10,к.2,1эт., пом.№I,ч.ком.№2, ОГРН1067746721239. Не является офертой. Реклама. Товар сертифицирован.",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=219&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663ab73d3c0.png"
      },
      {
        "id": "219-31995",
        "title": "Скидка 20%",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% кроме сертификатов, спеццен, наборов исключения! Не суммируется с другими скидками и промокодами. Отменяет действией других акций.*В интернет-магазине loccitane.ru (дата размещения промокода)-31.05.26 г. включительно. Скидка 20% на всё по промокоду promo20, кроме подарочных и СПА-сертификатов, СПА-процедур, продуктов и наборов по спец.ценам. Не суммируется с др.скидками и промокодами, отменяет другие акции. ООО«Л’Окситан Рус»,119049,г.Москва,ул.Шаболовка,д. 10,к.2,1эт., пом.№I,ч.ком.№2,ОГРН1067746721239. Не является офертой. Реклама. Товар сертифицирован.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=219&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663ab73d3c0.png"
      },
      {
        "id": "219-39103",
        "title": "Подарок при покупке от 6000 рублей",
        "code": "",
        "discount": "6000₽",
        "description": "Идеальный попутчик для вашей кожи!Пенка для умывания Драгоценный Иммортель 50 мл в подарок при покупке от 6 000 р.Подарок:Очищающая пенка для умывания Драгоценный Иммортель 50 мл*Подарок при покупке на сумму от 6000р в одном чеке после применения всех скидок по промокоду ОЧИЩЕНИЕ в интернет-магазине loccitane.ru 21.05-01.06.26г. включительно. Подарок может отличаться от изображенного. Компания оставляет за собой право на замену подарка. Не распространяется на покупку подарочных и СПА-сертификатов, СПА-процедур. Отменяет действие др.скидок, акций и промокодов. Подробности на loccitane.ru/sales/. ООО«Л’Окситан Рус», 119049, г.Москва, ул.Шаболовка, д.10,к.2,1эт., пом.№I,ч.ком.№2, ОГРН1067746721239. Не является офертой. Реклама. Товар сертифицирован.",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=219&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663ab73d3c0.png"
      }
    ]
  },
  {
    "id": "218",
    "name": "ИгроРай",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656638dd3c1d0.png",
    "description": "ИгроРай – интернет-маркет, специализирующийся на игровой продукции. Основные категории товаров: игровые консоли, видеоигры, конструкторы, фигурки персонажей, игровые гаджеты. Реализация продукции происходит через сайт ин",
    "promocodesCount": 1,
    "category": "Игры",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "218-39001",
        "title": "Скидки на игровые приставки, игры и аксессуары",
        "code": "",
        "discount": "Акция",
        "description": "Распродажа дня. Пополняемый раздел со скидками на игровые приставки, игры и аксессуары",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=218&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img656638dd3c1d0.png"
      }
    ]
  },
  {
    "id": "217",
    "name": "Justfood",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png",
    "description": "Ешьте правильно и вкусно! justfood – сервис доставки готового здорового питания с посчитанным КБЖУ. Преимущества для покупателей: • До 8 блюд в день без повторов • Без сахара и жарки на масле, минимум соли • Много овощей",
    "promocodesCount": 7,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "217-129017",
        "title": "Скидка 28% на заказ",
        "code": "cpa23",
        "discount": "28%",
        "description": "28% на первую покупку 5-7 дней здоровой еды. Не суммируется с другими предложениями.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      },
      {
        "id": "217-129027",
        "title": "Скидка 38% на заказ",
        "code": "adprosto",
        "discount": "38%",
        "description": "Скидки от 38% на первый месяц питания любой программы на сайте prostoeda.pro! Не суммируется с другими предложениями. Не распространяется на оплату частями. Промокод применяется на шаге оформления покупки после ввода номера телефона.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      },
      {
        "id": "217-132415",
        "title": "Скидка 26% + 2000 бонус!",
        "code": "ADV2000",
        "discount": "26%",
        "description": "Скидка 26% +2000 бонус! Действует на 2 первых заказа на сайте justfood, на любые программы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2026-03-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      },
      {
        "id": "217-31135",
        "title": "Скидка 28% на программы 5-7 дней",
        "code": "",
        "discount": "28%",
        "description": "Скидка 28% на программы 5-7 дней. Не суммируется с другими предложениями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2025-06-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      },
      {
        "id": "217-36234",
        "title": "Скидка 28% на программы 5-7 дней",
        "code": "",
        "discount": "28%",
        "description": "28% на первую покупку 5-7 дней здоровой еды. Не суммируется с другими предложениями.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      },
      {
        "id": "217-36236",
        "title": "​Скидки от 38% на первый месяц питания в prostoeda.pro",
        "code": "",
        "discount": "38%",
        "description": "Скидки от 38% на первый месяц питания любой программы на сайте prostoeda.pro! Не суммируется с другими предложениями. Не распространяется на оплату частями. Промокод применяется на шаге оформления покупки после ввода номера телефона.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2026-01-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      },
      {
        "id": "217-37838",
        "title": "Скидка 26% на первые 2 заказа + 2000 бонус!",
        "code": "",
        "discount": "26%",
        "description": "Скидка 26% +2000 бонус!Действует на 2 первых заказа на сайте justfood, на любые программы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=217&a=79",
        "isActive": true,
        "createdAt": "2026-03-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6566367ce3ebd.png"
      }
    ]
  },
  {
    "id": "216",
    "name": "Амедиатека",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png",
    "description": "Амедиатека - один из ведущих онлайн кинотеатров в России и странах СНГ, предлагающих клиентам Лучшие сериалы планеты* (По версии IMDB) таких студий, как HBO, HBO Max, Fox, Showtime, ABC Studios, Sony Pictures, Stars и мн",
    "promocodesCount": 6,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "216-123512",
        "title": "Скидка 50% за подписку 180 дней",
        "code": "series180",
        "discount": "50%",
        "description": "Скидка 50% за подписку 180 дней",
        "expiryDate": "2026-05-29",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=216&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png"
      },
      {
        "id": "216-123511",
        "title": "Скидка 50% за подписку 90 дней",
        "code": "series90",
        "discount": "50%",
        "description": "Скидка 50% за подписку 90 дней",
        "expiryDate": "2026-05-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=216&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png"
      },
      {
        "id": "216-34532",
        "title": "Скидка 50% за подписку 180 дней",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% за подписку 180 дней",
        "expiryDate": "2026-05-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=216&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png"
      },
      {
        "id": "216-34531",
        "title": "Скидка 50% за подписку 90 дней",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% за подписку 90 дней",
        "expiryDate": "2026-05-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=216&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png"
      },
      {
        "id": "216-34530",
        "title": "Скидка 50% на подписку 30 дней",
        "code": "",
        "discount": "50%",
        "description": "Скидка 50% на подписку 30 дней",
        "expiryDate": "2026-05-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=216&a=79",
        "isActive": true,
        "createdAt": "2026-05-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png"
      },
      {
        "id": "216-34533",
        "title": "Скидка 17% за подписку 365 дней",
        "code": "",
        "discount": "17%",
        "description": "Скидка 17% за подписку 365 дней",
        "expiryDate": "2026-05-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=216&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65663191a0db7.png"
      }
    ]
  },
  {
    "id": "214",
    "name": "Autospot",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6565edfd93c1f.png",
    "description": "Компания Autospot - это растущая интернет-площадка по продажам новых легковых автомобилей от официального дилера с максимальной выгодой для клиента. Наша задача сделать процесс покупки автомобиля максимально быстрым, про",
    "promocodesCount": 1,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "214-39049",
        "title": "Скидка до 80% на то",
        "code": "",
        "discount": "80%",
        "description": "Весенние скидки до 80% на ТО.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=214&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6565edfd93c1f.png"
      }
    ]
  },
  {
    "id": "212",
    "name": "Диван BOSS",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e21a0abf6b.png",
    "description": "Диван BOSS — крупная российская компания, производящая и реализующая мягкую и корпусную мебель для дома. Своё производство, а это значит, цены от производителя и огромный выбор мебели! Обширная логистика. Преимущества дл",
    "promocodesCount": 2,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "212-132333",
        "title": "Скидка до 3000 рублей (б)",
        "code": "БОСС26",
        "discount": "3000₽",
        "description": "Скидка 1 000 рублей при покупке от 50 000 до 69 999 руб. Скидка 2 000 рублей при покупке от 70 000 до 99 999 руб. Скидка 3 000 рублей при покупке от 100 000 руб.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=212&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e21a0abf6b.png"
      },
      {
        "id": "212-37759",
        "title": "Скидка до 3000 рублей (б)",
        "code": "",
        "discount": "3000₽",
        "description": "Скидка 1 000 рублей при покупке от 50 000 до 69 999 руб.Скидка 2 000 рублей при покупке от 70 000 до 99 999 руб.Скидка 3 000 рублей при покупке от 100 000 руб.Для всех клиентов.Действует без ограничений на количество покупок.Суммируется с другими акциями.Действует на все товары.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=212&a=79",
        "isActive": true,
        "createdAt": "2026-03-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e21a0abf6b.png"
      }
    ]
  },
  {
    "id": "211",
    "name": "Твой Дом",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png",
    "description": "Твой Дом - интернет-гипермаркет, сочетающий в себе тысячи популярных брендов и эксклюзивные товары для интересных дизайнерских решений. Мы динамично развиваемся и ежедневно обновляем ассортимент самых востребованных това",
    "promocodesCount": 12,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "211-122319",
        "title": "Скидка 5000 рублей при покупке от 50000 рублей",
        "code": "TDW5000",
        "discount": "5000₽",
        "description": "Общие условия: Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-122318",
        "title": "Скидка 2000 рублей при покупке от 20000 рублей",
        "code": "TDW2000",
        "discount": "2000₽",
        "description": "Общие условия: Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-122317",
        "title": "Скидка 1000 рублей при покупке от 10000 рублей",
        "code": "TDW1000",
        "discount": "1000₽",
        "description": "Общие условия: Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-122316",
        "title": "Скидка 500 рублей при покупке от 5000 рублей",
        "code": "TDW500",
        "discount": "500₽",
        "description": "Общие условия: Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-122320",
        "title": "Скидка 10000 рублей при покупке от 100000 рублей",
        "code": "TDW10000",
        "discount": "10000₽",
        "description": "Общие условия: Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-35593",
        "title": "Sale! Скидки! Товары по выгодные ценам",
        "code": "",
        "discount": "Акция",
        "description": "Sale! Скидки! Товары по выгодные ценам",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-02-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-38322",
        "title": "Скидка 20% на садовую мебель из тика!",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% Для всех пользователей. Действует на мебель из тика!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-34544",
        "title": "Скидка 2000 рублей при покупке от 20000 рублей",
        "code": "",
        "discount": "2000₽",
        "description": "Общие условия:Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-34546",
        "title": "Скидка 10000 рублей при покупке от 100000 рублей",
        "code": "",
        "discount": "10000₽",
        "description": "Общие условия:Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-34542",
        "title": "Скидка 500 рублей при покупке от 5000 рублей",
        "code": "",
        "discount": "500₽",
        "description": "Общие условия:Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-34543",
        "title": "Скидка 1000 рублей при покупке от 10000 рублей",
        "code": "",
        "discount": "1000₽",
        "description": "Общие условия:Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      },
      {
        "id": "211-34545",
        "title": "Скидка 5000 рублей при покупке от 50000 рублей",
        "code": "",
        "discount": "5000₽",
        "description": "Общие условия:Скидка не действует на товары с перечеркнутой ценой, а также категории: Подарочные карты, Продукты, Цифровая техника, Бытовая техника, Теле-аудио-видео, Бытовая химия, Садовая техника, а также бренды: BORK, Xiaomi, Citilux, Gipfel, Fissman",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=211&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655e1e0b346e8.png"
      }
    ]
  },
  {
    "id": "207",
    "name": "INCANTO",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png",
    "description": "INCANTO - итальянский магазин белья и одежды. Является одним из лидеров на мировом рынке Fashion-индустрии. Основа бренда - дизайн, отвечающий самым последним веяниям моды, инновационные технологии, высококачественные на",
    "promocodesCount": 13,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "207-115323",
        "title": "Скидка 5% на заказ от 7999 руб.",
        "code": "advcake",
        "discount": "5%",
        "description": "Скидка -5% на первый заказ при покупке от 7999р. Не суммируется с базовыми акциями акциями, но суммируется с товарами из раздела SALE",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2024-09-09",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-106930",
        "title": "Скидка 10% на заказ",
        "code": "LAST10",
        "discount": "10%",
        "description": "-10% на последний размер",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-31260",
        "title": "Скидка 5% на заказ от 7999 руб.",
        "code": "",
        "discount": "5%",
        "description": "Скидка -5% на первый заказ при покупке от 7999р. Не суммируется с базовыми акциями акциями, но суммируется с товарами из раздела SALE",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2024-09-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29803",
        "title": "Второе бюстгальтер со скидкой -30%",
        "code": "",
        "discount": "30%",
        "description": "При покупке двух бюстгальтеров - действует скидка 30% на второй товар!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29800",
        "title": "Второе боди со скидкой -30%",
        "code": "",
        "discount": "30%",
        "description": "При покупке двух боди , - действует скидка 30% на второй товар!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29802",
        "title": "Четвертая пара колготок в подарок!",
        "code": "",
        "discount": "Акция",
        "description": "При покупке трех пар колготок - четвертая в подарок! Акция сработает автоматически после добавления в корзину 4 единиц товаров, участвующих в акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29808",
        "title": "Подарочные сертификаты",
        "code": "",
        "discount": "Акция",
        "description": "Подарочные сертификаты",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29809",
        "title": "Трикотажные изделия: -30% на вторую единицу",
        "code": "",
        "discount": "30%",
        "description": "Трикотажные изделия: -30% на вторую единицу",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29806",
        "title": "-10% на последний размер",
        "code": "",
        "discount": "10%",
        "description": "-10% на последний размер",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29805",
        "title": "Акция на детские колготки 3+1!",
        "code": "",
        "discount": "Акция",
        "description": "При покупке трех колготок - четвертый в подарок!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-29799",
        "title": "Четвертые трусики в подарок",
        "code": "",
        "discount": "Акция",
        "description": "При покупке 3х изделий четвертое с наименьшей стоимостью - бесплатно.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-03-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-30731",
        "title": "3+1 на мужской ассортимент",
        "code": "",
        "discount": "Акция",
        "description": "При покупке трех изделий из категории мужского ассортимента - четвертое в подарок! Акция сработает автоматически после добавления в корзину 4 единиц товаров, участвующих в акции. Акция не распространяется на товары со скидкой.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-05-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      },
      {
        "id": "207-33637",
        "title": "Скидка 30% на 2е пижамное изделие",
        "code": "",
        "discount": "30%",
        "description": "Скидка 30% на 2е пижамное изделие из новой коллекции (кроме категории Шелк).",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=207&a=79",
        "isActive": true,
        "createdAt": "2025-09-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cff9a7534a.png"
      }
    ]
  },
  {
    "id": "206",
    "name": "RU-CENTER",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cfb9f1ff3e.png",
    "description": "RU-CENTER – крупный регистратор доменов и один из лучших хостинг-провайдеров. Кампания стала первой в топе хостингов России по данным сервиса Хостинг Пульс, показав лучшие значения в следующих категориях: -скорость запис",
    "promocodesCount": 1,
    "category": "Возможности для бизнеса",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "206-38625",
        "title": "Скидки до 40% с корпоративными тарифными планами",
        "code": "",
        "discount": "40%",
        "description": "Выберите один из тарифных планов и получите дополнительную скидку на оплату услуг! Также вам будут доступны абсолютно бесплатно услуги «Безопасность домена», «Мультиадминистрирование», «Мультидоступ» и выделенная служба поддержки.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=206&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cfb9f1ff3e.png"
      }
    ]
  },
  {
    "id": "205",
    "name": "BeFit",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png",
    "description": "BeFit - это доставка ПП рационов по Москве и Санкт-Петербургу. Компания BeFit занимается производством и доставкой здорового, сбалансированного питания, приготовленного на основе только натуральных и полезных продуктов. ",
    "promocodesCount": 11,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "205-115174",
        "title": "Скидка 1500 рублей на заказ",
        "code": "advcake",
        "discount": "1500₽",
        "description": "Скидка 1500 руб для новых пользователей на рационы до 2х недель. Не суммируется с другими акциями на сайте. Применяется самая выгодная акция для клиента",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-121950",
        "title": "Скидка 500 рублей на повторный заказ",
        "code": "RECAKE",
        "discount": "500₽",
        "description": "Скидка 500 рублей на повторный заказ. На повторный заказ, если с момента последнего заказа прошло больше месяца. Не суммируется с другими акциями на сайте. Применяется самая выгодная акция для клиента",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-10-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-127566",
        "title": "Скидка 15% на заказ",
        "code": "ADVSPORT",
        "discount": "15%",
        "description": "Скидка 15% на первый заказ. Не суммируется с другими акциями на сайте. Применяется самая выгодная акция для клиента",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-16652",
        "title": "Скидка 7,5% при заказе на месяц!",
        "code": "",
        "discount": "7.5%",
        "description": "Скидка 7,5% при заказе на месяц!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2024-07-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-16653",
        "title": "Скидка 5 % за заказ на 2 недели",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5 % за заказ на 2 недели",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2024-07-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-31137",
        "title": "Скидка 1500 рублей для новых пользователей",
        "code": "",
        "discount": "1500₽",
        "description": "Скидка 1500 руб для новых пользователей на рационы до 2х недель. Не суммируется с другими акциями на сайте. Применяется самая выгодная акция для клиента",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-34564",
        "title": "Скидка 13% для новых пользователей (а)",
        "code": "",
        "discount": "13%",
        "description": "Скидка 13% для новых пользователей. Не суммируется с другими акциями на сайте. Применяется самая выгодная акция для клиента.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-10-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-34432",
        "title": "Скидка 500 рублей на повторный заказ",
        "code": "",
        "discount": "500₽",
        "description": "Скидка 500 рублей на повторный заказ. На повторный заказ, если с момента последнего заказа прошло больше месяца. Не суммируется с другими акциями на сайте. Применяется самая выгодная акция для клиента",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-10-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-36025",
        "title": "Befit.Sport Готовое питание для спортсменов",
        "code": "",
        "discount": "Акция",
        "description": "Befit.Sport. От тренировок к победам — с рационами на весь день. Меню под ваш ритм тренировок. Управляйте питанием сами: увеличивайте белок или углеводы через замену блюд в конструкторе, исключайте ингредиенты. Даже после оформления заказа меню легко настроить!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-36030",
        "title": "Скидка 18% при заказе на 4 месяца",
        "code": "",
        "discount": "18%",
        "description": "Скидка 18% на питание при заказе любой программы на 4 месяца.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2025-12-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      },
      {
        "id": "205-39039",
        "title": "Флеш-акция: Скидка 16% на первый заказ",
        "code": "",
        "discount": "16%",
        "description": "Скидка 16% на первый заказ по промокоду, не суммируется с другими акциями.",
        "expiryDate": "2026-05-25",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=205&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img655cc01d6257a.png"
      }
    ]
  },
  {
    "id": "202",
    "name": "BRANDSHOP",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png",
    "description": "BRANDSHOP — мультибрендовый магазин одежды, обуви и аксессуаров, основанный в 2008 году. В ассортименте представлены коллекции adidas Originals, Stone Island, Nike, POLO Ralph Lauren, Air Jordan и множества других глобал",
    "promocodesCount": 6,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "202-115246",
        "title": "Скидка 5% на один заказ.",
        "code": "BRANDSHOP",
        "discount": "5%",
        "description": "Скидка 5% на один заказ. Не суммируется с другими скидками и не действует на товары из категорий «Sale» и «Релизные товары».",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=202&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png"
      },
      {
        "id": "202-115626",
        "title": "Скидка 5% на заказ",
        "code": "Advcake",
        "discount": "5%",
        "description": "Скидка 5% на один заказ. Не суммируется с другими скидками и не действует на товары из категорий «Sale» и «Релизные товары».",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=202&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png"
      },
      {
        "id": "202-121953",
        "title": "Скидка 5% на один заказ",
        "code": "BRANDSHOP",
        "discount": "5%",
        "description": "Скидка 5% на один заказ по промокоду, не суммируется с другими скидками и не действует на товары из категории Sale и релизные товары.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=202&a=79",
        "isActive": true,
        "createdAt": "2025-06-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png"
      },
      {
        "id": "202-134106",
        "title": "Скидка 5% на заказ",
        "code": "БРЕНДШОП",
        "discount": "5%",
        "description": "Скидка 5% на один заказ по промокоду, не суммируется с другими скидками и не действует на товары из категории Sale и релизные товары.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=202&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png"
      },
      {
        "id": "202-31990",
        "title": "Новинки",
        "code": "",
        "discount": "Акция",
        "description": "Новые поступления в интернет-магазине BRANDSHOP",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=202&a=79",
        "isActive": true,
        "createdAt": "2025-07-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png"
      },
      {
        "id": "202-38503",
        "title": "-5% на один заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на один заказ по промокоду, не суммируется с другими скидками и не действует на товары из категории Sale и релизные товары.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=202&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c6ae1667b.png"
      }
    ]
  },
  {
    "id": "201",
    "name": "ВинЛаб",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png",
    "description": "Сеть «ВинЛаб» входит в структуру NOVABEV GROUP — крупнейшей алкогольной компании в России, которая ведет свою историю с 1999 года. NOVABEV GROUP выпускает высококачественные продукты на 7 собственных заводах, некоторые и",
    "promocodesCount": 7,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "201-119736",
        "title": "Скидка 5% на заказ",
        "code": "5NADV8732",
        "discount": "5%",
        "description": "Скидка 5% на повторный заказ",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2025-08-25",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      },
      {
        "id": "201-120045",
        "title": "Скидка 10% на заказ",
        "code": "CAKENEW10",
        "discount": "10%",
        "description": "Скидка 10% на первый заказ",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2025-08-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      },
      {
        "id": "201-120046",
        "title": "Скидка 5% на заказ",
        "code": "CAKE5",
        "discount": "5%",
        "description": "Скидка 5% на повторный заказ",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2025-08-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      },
      {
        "id": "201-119737",
        "title": "Скидка 10% на заказ",
        "code": "10NADV8732",
        "discount": "10%",
        "description": "Скидка 10% на первый заказ",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2025-08-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      },
      {
        "id": "201-33082",
        "title": "Скидка 10% на первый заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на первый заказ",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2025-08-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      },
      {
        "id": "201-33081",
        "title": "Скидка 5% на повторный заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на повторный заказ",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2025-08-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      },
      {
        "id": "201-38587",
        "title": "Скидка 10% при покупке от 2 одинаковых товаров",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на покупку от 2 товаров из специальной подборки.",
        "expiryDate": "2026-05-26",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=201&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6544c461ad7e3.png"
      }
    ]
  },
  {
    "id": "195",
    "name": "Авито",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6543a7b6840a8.png",
    "description": "Авито — сайт частных объявлений № 1 в России. На Авито вы можете недорого снять квартиру, выбрав предложения без посредников. Каждый день тысячи людей ищут на Авито квартиры, а арендодатели — жильцов. Обеспечение безопас",
    "promocodesCount": 0,
    "category": "Возможности для бизнеса",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "193",
    "name": "Befree",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65439be1cacee.png",
    "description": "Befree — популярный российский бренд женской и мужской одежды. В сети более 269 магазинов по России и странам СНГ. География продаж — Россия, Беларусь, Армения и Казахстан. Преимущества для покупателей: - Большой ассорти",
    "promocodesCount": 0,
    "category": "Одежда и обувь",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "188",
    "name": "Профи.ру",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png",
    "description": "Профи — это сервис, который помогает клиентам и специалистам встретиться. Клиенты находят здесь профессионалов для решения любых задач — репетиторов, автоинструкторов, сантехников, парикмахеров. Всего на Профи более 2 30",
    "promocodesCount": 6,
    "category": "Возможности для бизнеса",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "188-16643",
        "title": "Зарабатывайте на том, что умеете",
        "code": "",
        "discount": "500₽",
        "description": "Для новых специалистов мастеров ремонта:Поможем получить первые заказы Начислим на счёт 500 бонусов при первом пополнении баланса на 500 ₽ 🎁 1 бонус равен 1 рублю.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=188&a=79",
        "isActive": true,
        "createdAt": "2023-11-27",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png"
      },
      {
        "id": "188-30539",
        "title": "Мобильное приложение",
        "code": "",
        "discount": "Акция",
        "description": "Лендинг для перехода в мобильное приложение",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=188&a=79",
        "isActive": true,
        "createdAt": "2025-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png"
      },
      {
        "id": "188-35922",
        "title": "Выбирай сантехников на Профи.ру!",
        "code": "",
        "discount": "Акция",
        "description": "Пусть \"Широка река\" останется песней с сантехниками Профи.ру!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=188&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png"
      },
      {
        "id": "188-35920",
        "title": "Выбирай грумеров на Профи.ру!",
        "code": "",
        "discount": "Акция",
        "description": "Лапки - не царапки с грумерами на Профи.ру.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=188&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png"
      },
      {
        "id": "188-35921",
        "title": "Выбирай психологов на Профи.ру!",
        "code": "",
        "discount": "Акция",
        "description": "Найди гармонию внутри с психологами Профи.ру!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=188&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png"
      },
      {
        "id": "188-37495",
        "title": "Выбирайте репетиторов к ЕГЭ на Профи.ру!",
        "code": "",
        "discount": "Акция",
        "description": "Готовьтесь к ЕГЭ с опытными репетиторами на Профи.ру. Выберите специалиста по нужному предмету и начните подготовку уже сегодня.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=188&a=79",
        "isActive": true,
        "createdAt": "2026-03-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img673c6b91f40ec.png"
      }
    ]
  },
  {
    "id": "187",
    "name": "Котофото",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65437c322accc.png",
    "description": "Котофото - онлайн-гипермаркет электроники, фототехники, мобильных гаджетов, ноутбуков, товаров для автомобилистов, бытовой техники, строительного инструмента, товаров для красоты и здоровья и многое другое. Ассортимент н",
    "promocodesCount": 4,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "187-130833",
        "title": "Скидка 300 руб. на заказ от 3000 руб.",
        "code": "CAKEMR",
        "discount": "300₽",
        "description": "Для заказов от 3000 рублей мы дарим скидку в размере 300 рублей. Просто соберите в корзину и примените промокод.",
        "expiryDate": "2026-11-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=187&a=79",
        "isActive": true,
        "createdAt": "2026-02-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65437c322accc.png"
      },
      {
        "id": "187-130834",
        "title": "Скидка 500 руб. на заказ от 7000 руб.",
        "code": "CAKEMR7",
        "discount": "500₽",
        "description": "Для заказов от 7000 рублей мы дарим скидку в размере 500 рублей. Просто соберите в корзину и примените промокод.",
        "expiryDate": "2026-11-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=187&a=79",
        "isActive": true,
        "createdAt": "2026-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65437c322accc.png"
      },
      {
        "id": "187-36859",
        "title": "Скидка 500 руб. на корзину от 7000 руб.",
        "code": "",
        "discount": "500₽",
        "description": "Для заказов от 7000 рублей мы дарим скидку в размере 500 рублей. Просто соберите в корзину и примените промокод.",
        "expiryDate": "2026-11-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=187&a=79",
        "isActive": true,
        "createdAt": "2026-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65437c322accc.png"
      },
      {
        "id": "187-36858",
        "title": "Скидка 300 руб. на корзину от 3000 руб.",
        "code": "",
        "discount": "300₽",
        "description": "Для заказов от 3000 рублей мы дарим скидку в размере 300 рублей. Просто соберите в корзину и примените промокод.",
        "expiryDate": "2026-11-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=187&a=79",
        "isActive": true,
        "createdAt": "2026-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65437c322accc.png"
      }
    ]
  },
  {
    "id": "181",
    "name": "Flor2u",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png",
    "description": "Flor2u.ru - сайт доставки цветов. Найди на сайте подходящий букет для любого повода и порадуй любимых, даже если вас разделяют тысячи километров! Преимущества для покупателей: - Одни из лидеров по доставке цветов - Работ",
    "promocodesCount": 9,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "181-126066",
        "title": "​Скидка 12% на заказ",
        "code": "FLOR2U",
        "discount": "12%",
        "description": "Скидка 12% на заказ",
        "expiryDate": "2026-08-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-3850",
        "title": "Цветы простоят больше 5 дней! Или заменим букет",
        "code": "",
        "discount": "Акция",
        "description": "Если цветы простоят менее 5 дней, то мы бесплатно заменим букет",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2021-06-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-8968",
        "title": "Распродажа!",
        "code": "",
        "discount": "40%",
        "description": "Подборка букетов со скидками до 40%",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2022-07-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-11039",
        "title": "Хиты продаж",
        "code": "",
        "discount": "Акция",
        "description": "Скидки в подборке с самыми популярными букетами",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2022-10-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-32009",
        "title": "Кэшбэк 10% с каждой покупки",
        "code": "",
        "discount": "10%",
        "description": "10% кэшбэка за каждый заказ — ваша выгода в каждом букете сразу в личном кабинете!",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-32008",
        "title": "Фото вашего букете перед доставкой",
        "code": "",
        "discount": "Акция",
        "description": "Ваш букет на фото перед доставкой. Не понравится — изменим!",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-32007",
        "title": "Бесплатная доставка днём",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Днём с 10:00 до 19:00 дарим не только цветы, но и бесплатную доставку!💐",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-32006",
        "title": "Доставка вашего заказа от 2 часов",
        "code": "",
        "discount": "Акция",
        "description": "Стараемся доставлять букеты в течении 2 часов, но время может немного варьироваться, чтобы ваш букет доехал в идеальном состоянии.",
        "expiryDate": "2026-09-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2025-07-23",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      },
      {
        "id": "181-35912",
        "title": "Скидка 12% на заказ",
        "code": "",
        "discount": "12%",
        "description": "Скидка 12% на заказ",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=181&a=79",
        "isActive": true,
        "createdAt": "2025-12-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654373014eed9.png"
      }
    ]
  },
  {
    "id": "180",
    "name": "Он и Она",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png",
    "description": "«Он и Она» - сексшоп №1 в России, убедитесь в этом, сделав хотя бы одну покупку в нашем интернет интим магазине эротических товаров. В ассортименте вы увидите только качественные бренды от ведущих мировых производителей ",
    "promocodesCount": 8,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "180-131696",
        "title": "Скидка 10% на заказ",
        "code": "ADVCAKE",
        "discount": "10%",
        "description": "Скидка 10% на все по промокоду. Не суммируется с другими акциями. Не суммируется с другими промокодами. Не работает на товары со скидкой.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-134330",
        "title": "-15% на первую покупку",
        "code": "NEW",
        "discount": "15%",
        "description": "Дарим скидку 15% по промокоду для первой покупки. Скидка действует только на ограниченное количество товаров, указанных на данной странице.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-33386",
        "title": "Бесплатная доставка от 2990 рублей",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Бесплатная доставка по Москве и МО при покупке от 2990 руб.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2025-09-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-33379",
        "title": "Все акции сайта",
        "code": "",
        "discount": "Акция",
        "description": "Все акции сайта в разделе",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2025-09-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-38794",
        "title": "До -40% на товары",
        "code": "",
        "discount": "40%",
        "description": "Скидка до 40% на товары из подборки. Успейте купить!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-37317",
        "title": "Скидка 10% на все",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на все по промокоду. Не суммируется с другими акциями. Не суммируется с другими промокодами. Не работает на товары со скидкой.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-38795",
        "title": "-15% на первую покупку",
        "code": "",
        "discount": "15%",
        "description": "Дарим скидку 15% по промокоду для первой покупки. Скидка действует только на ограниченное количество товаров, указанных на данной странице.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      },
      {
        "id": "180-38992",
        "title": "РАСПРОДАЖА до -40%",
        "code": "",
        "discount": "40%",
        "description": "Более 100 товаров со сниженными ценами ждут вас в разделе скидок! Заходите и берите то, что душе угодно до 31 мая включительно.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=180&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654370e8218d9.png"
      }
    ]
  },
  {
    "id": "179",
    "name": "Erborian",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d487f1b9.png",
    "description": "Erborian с французского переводится как \"травы востока\". В основе каждого нашего продукта лежат инновации и многовековой опыт корейской традиционной фармакологии. Мы создаем гибридные продукты, такие как культовые BB и C",
    "promocodesCount": 4,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "179-118071",
        "title": "Скидка 20% на заказ",
        "code": "ADVskidka20",
        "discount": "20%",
        "description": "Скидка 20% на все кроме travel-форматов, аксессуаров и спец. цен! Не суммируется с другими скидками и промокодами. Отменяет действией других акций",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=179&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d487f1b9.png"
      },
      {
        "id": "179-32004",
        "title": "-20% на все",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на все кроме travel-форматов, аксессуаров и спец. цен! Не суммируется с другими скидками и промокодами. Отменяет действией других акций",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=179&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d487f1b9.png"
      },
      {
        "id": "179-38917",
        "title": "До -50% на любимые товары наших клиентов",
        "code": "",
        "discount": "50%",
        "description": "Товары месяца Erborian май 2026 + все наборыСкидка 30%786347 BB крем для лица, тон Натурально-бежевый 15 мл788150 SUPER BB консилер, тон Светлый 10 мл786286 BB крем для лица, тон Светлый 15 мл786392 BB крем для лица, тон Золотистый 40 мл786958 BB крем для лица, тон Слоновая кость 40 мл780253 СС крем Совершенное сияние Cветлый 15 мл780260 СС крем Совершенное сияние Cветлый 45 мл784152 Бамбук Увлажняющая маска для лица 80 мл784336 Бамбук матирующий лосьон для сужения пор 190 мл786194 Бамбук суперсыворотка для лица 30 мл786637 Юзу сорбет сыворотка для кожи вокруг глаз 15 мл788273 Юзу cолнцезащитная сыворотка SPF 50+ для лица 30 млСкидка 40%780185 СС крем Совершенное сияние Золотистый 45 мл780178 СС крем Совершенное сияние Золотистый 15 мл787436 CC крем для тела 120 мл787481 SOS-гель для лица против несовершенств Центелла 9 мл*Скидки до 50% на ассортимент в разделе СКИДКИ в интернет-магазине erborian.ru и Erborian 04-31.05.26г. включительно. Не суммируется с др.скидками и промокодами, отменяет все др.акции. Подробности на: erborian.ru/sale/. ООО «Л’Окситан Рус», 119049, г.Москва, ул.Шаболовка, д.10, корп.2, 1эт., пом.№I, часть комн.№2, ОГРН1067746721239. Не является офертой. Реклама. Товар сертифицирован.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=179&a=79",
        "isActive": true,
        "createdAt": "2026-05-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d487f1b9.png"
      },
      {
        "id": "179-39038",
        "title": "-30% на все и подарок",
        "code": "",
        "discount": "30%",
        "description": "Расцветайте с Erborian! Скидка 30% и подарок при любой покупкеСостав подарка:6AA40135 Хлопковые салфетки*Скидка 30% только на товары Erborian и подарок при любой покупке в интернет-магазине erborian.ru 18-31.05.26г включительно. Скидка не распространяется на мини-форматы, аксессуары, наборы, подарочные сертификаты, не суммируется с др.скидками и промокодами, отменяет др.акции, не действует на продукцию Elemis, Thim и Grown Alchemist. Подарок может отличаться от изображенного. Компания оставляет за собой право на замену подарка. Один подарок в один заказ. Подробности на: erborian.ru/sales/ ООО«Л’Окситан Рус», 119049, г.Москва, ул.Шаболовка, д.10,к.2,1эт., пом.№I,ч.ком.№2, ОГРН1067746721239. Не является офертой. Реклама. Товар сертифицирован.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=179&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d487f1b9.png"
      }
    ]
  },
  {
    "id": "178",
    "name": "ГЛОБУС",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png",
    "description": "Интернет-магазин ГЛОБУС - это сервис доставки продуктов из гипермаркетов ГЛОБУС. Здесь более 45 000 наименований качественных продуктов и товаров. ГЛОБУС - продукты собственного производства, мясо, рыба, кулинария, пекар",
    "promocodesCount": 8,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "178-132428",
        "title": "Скидка 20% на заказ от 9990 руб.",
        "code": "asale2026h",
        "discount": "20%",
        "description": "Скидка 20% от 9990 рублей на товары хиты продаж из подборки \"Собственное производство\". Суммируются с акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-132419",
        "title": "Скидка 12% на заказ от 4500 руб.",
        "code": "a1226sale",
        "discount": "12%",
        "description": "Скидка 12% от 4500 рублей, но не более 900 рублей, кроме исключений Новый клиент.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-132424",
        "title": "Скидка 8% на заказ от 6890 руб.",
        "code": "a826sale",
        "discount": "8%",
        "description": "Скидка 8% на 1 заказ от 6890 рублей (кроме акц товаров, БТ и ЭЛ). Все клиенты.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-132432",
        "title": "Скидка 12% на заказ от 4900 руб.",
        "code": "avtula12",
        "discount": "12%",
        "description": "Скидка 12% от 4900 рублей на первый заказ - Тула, кроме исключений. Не более 1000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-37856",
        "title": "Скидка ​12% от 4500 руб.",
        "code": "",
        "discount": "12%",
        "description": "Скидка 12% от 4500 рублей, но не более 900 рублей, кроме исключений Новый клиент.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-37865",
        "title": "Скидка 20% от 9990 руб.",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% от 9990 рублей на товары хиты продаж из подборки \"Собственное производство\". Суммируются с акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-37861",
        "title": "​Скидка 8% от 6890 руб.",
        "code": "",
        "discount": "8%",
        "description": "Скидка 8% на 1 заказ от 6890 рублей (кроме акц товаров, БТ и ЭЛ). Все клиенты.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      },
      {
        "id": "178-37869",
        "title": "Скидка ​12% от 4900 руб. - Тула",
        "code": "",
        "discount": "12%",
        "description": "Скидка 12% от 4900 рублей на первый заказ - Тула, кроме исключений. Не более 1000 рублей.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=178&a=79",
        "isActive": true,
        "createdAt": "2026-03-27",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436d613f15d.png"
      }
    ]
  },
  {
    "id": "176",
    "name": "Mi-shop Xiaomi",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654363552e157.png",
    "description": "Xiaomi — компания уникальная и работает не так, как большинство китайских брендов электроники: есть подлинная философия дизайна, обеспечены высочайшие стандарты производства, разработана своя оригинальная оболочка для An",
    "promocodesCount": 3,
    "category": "Электроника",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "176-119957",
        "title": "Скидка 10% на заказ",
        "code": "MISHOP10",
        "discount": "10%",
        "description": "10% скидка но не более 1200/600/400 на смартфоны/умные устройства/аксессуары соответственно. Суммируется с другими акциями. Не работает в рассрочку. Не суммируется с подарками. Смартфоны от 20 000₽",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=176&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654363552e157.png"
      },
      {
        "id": "176-32028",
        "title": "Скидка 10% на заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% но не более 1200/600/400 рублей на смартфоны/умные устройства/аксессуары соответсвенно. Суммируется с другими акциями. Не работает в рассрочку. Не суммируется с подарками. Смартфоны от 20 000руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=176&a=79",
        "isActive": true,
        "createdAt": "2025-07-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654363552e157.png"
      },
      {
        "id": "176-38724",
        "title": "Скидка до 10000 рублей на выделенный ассортимент",
        "code": "",
        "discount": "10000₽",
        "description": "Скидка до 10000 рублей на выделенный ассортимент товаров Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=176&a=79",
        "isActive": true,
        "createdAt": "2026-05-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654363552e157.png"
      }
    ]
  },
  {
    "id": "175",
    "name": "СберЗдоровье",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436073d0c0f.png",
    "description": "СберЗдоровье – это быстрый и удобный online-сервис по поиску врачей. Сервис СберЗдоровье (ранее - DocDoc) появился в декабре 2011 года в Москве. Портал оказывает услуги по подбору врачей из клиник Москвы, Московской обла",
    "promocodesCount": 2,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "175-121644",
        "title": "Скидка 500 руб. на заказ",
        "code": "sale-adv-SH500",
        "discount": "500₽",
        "description": "Скидка 500 рублей на первый прием в Москве. Один пользователь может использовать один раз. Промокод вводится на сайте.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=175&a=79",
        "isActive": true,
        "createdAt": "2025-10-09",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436073d0c0f.png"
      },
      {
        "id": "175-34108",
        "title": "Скидка 500 рублей на первый прием в Москве и Санкт-Петербурге",
        "code": "",
        "discount": "500₽",
        "description": "Скидка 500 рублей на первый прием в Москве и в Санкт-Петербурге. Один пользователь может использовать один раз.Промокод вводится на сайте.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=175&a=79",
        "isActive": true,
        "createdAt": "2025-10-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65436073d0c0f.png"
      }
    ]
  },
  {
    "id": "172",
    "name": "LEOMAX",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435760f1fca.png",
    "description": "Группа компаний LEOMAX: Интернет-магазин leomax.ru и мобильное приложение LEOMAX - Эксклюзивные бренды одежды с капсульными коллекциями в размерной сетке до 74-го - Широкий ассортимент товаров категорий товаров \"красота ",
    "promocodesCount": 5,
    "category": "Дом",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "172-134362",
        "title": "Скидка 500р. на заказ",
        "code": "FIRSTAPP",
        "discount": "500₽",
        "description": "Скидка 500 рублей на первый заказ в приложении. Действует на 1 покупку. Не суммируется с другими акциями. Действует на все товары. Максимальный размер скидки по промокоду FIRSTAPP 500 рублей при заказе от 3000р",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=172&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435760f1fca.png"
      },
      {
        "id": "172-38826",
        "title": "Скидка 500 рублей",
        "code": "",
        "discount": "500₽",
        "description": "Скидка 500 рублей на первый заказ в приложении.Действует на 1 покупку. Не суммируется с другими акциями.Действует на все товары.Максимальный размер скидки по промокоду FIRSTAPP 500 рублей при заказе от 3000р",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=172&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435760f1fca.png"
      },
      {
        "id": "172-38827",
        "title": "Скидка 60%",
        "code": "",
        "discount": "60%",
        "description": "Скидка до 60% на ТОП товары LEOMAXДля всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на выделенный список товаров.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=172&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435760f1fca.png"
      },
      {
        "id": "172-38829",
        "title": "500 приветственных бонусов",
        "code": "",
        "discount": "3%",
        "description": "Программа лояльности Leomax Bonus500 приветственных бонусов за первый выкупленный заказ на любую сумму. Начисленные бонусы действительны в течение 60 дней с момента начисления.Cashback от 3% до 12% (в зависимости от уровня Статуса участника) бонусами со второго заказа. Начисленные бонусы действительны в течение 3-х месяцев с момента начисления.Бонусы не начисляются на стоимость доставки, а также сумму, оплаченную бонусами.Бонусы начисляются на следующий день после выкупа заказа.Бонусами можно оплатить до 15% заказа",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=172&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435760f1fca.png"
      },
      {
        "id": "172-38828",
        "title": "Скидка 5%",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на все заказы с 21:00 до 8:00Только для новых пользователей/Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциями.Не действует на товары с отметкой \"Распродажа\".",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=172&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435760f1fca.png"
      }
    ]
  },
  {
    "id": "171",
    "name": "Alpinabook",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654352dc37f78.png",
    "description": "Alpinabook.ru - интернет-магазин, где продаются книги по издательской цене. Место, где выбирать книги приятно и просто. В издательскую группу входят такие крупные издательства, как «Альпина Паблишер» и «Альпина Нон-фикшн",
    "promocodesCount": 4,
    "category": "Книги",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "171-115313",
        "title": "Скидка 10% на заказ.",
        "code": "UNI10",
        "discount": "10%",
        "description": "Скидка 10% на заказ на сайте Alpinabook.ru.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=171&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654352dc37f78.png"
      },
      {
        "id": "171-31248",
        "title": "Скидка 10% на заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на заказ на сайте Alpinabook.ru.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=171&a=79",
        "isActive": true,
        "createdAt": "2025-06-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654352dc37f78.png"
      },
      {
        "id": "171-36323",
        "title": "Бесплатная доставка",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "В пункты выдачи доставляем заказы бесплатно по всей России при заказе от 500 руб. Доставка курьером по Москве и Санкт-Петербургу бесплатно при заказе от 2000 рублей.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=171&a=79",
        "isActive": true,
        "createdAt": "2026-01-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654352dc37f78.png"
      },
      {
        "id": "171-37639",
        "title": "Клуб привилегий «Альпина Плюс»",
        "code": "",
        "discount": "50%",
        "description": "Станьте участником клуба привилегий «Альпина Плюс» и пользуйтесь всеми преимуществами расширенной подписки:-Скидка 50% на любые электронные книги;-Кэшбэк 100% от стоимости подписки бонусами. Тратьте бонусы на новые книги (до 30% от цены);-Доступ к огромной библиотеке — более 11 000 электронных и аудиокниг;-Лекции от экспертов (более 200 записанных лекций от признанных профессионалов в разных областях);-Еженедельные онлайн-встречи с авторами и экспертами из различных областей;-А также саммари, книги на английском языке, подкасты и многое другое.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=171&a=79",
        "isActive": true,
        "createdAt": "2026-03-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654352dc37f78.png"
      }
    ]
  },
  {
    "id": "170",
    "name": "СDEK.Shopping",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6543561ed8659.png",
    "description": "СDEK.Shopping — современная платформа, с помощью которой покупатели могут заказать товары известных зарубежных брендов по ценам ниже, чем на российском рынке, или найти уникальные продукты, которые недоступны в РФ. Мы со",
    "promocodesCount": 1,
    "category": "Дом",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "170-37925",
        "title": "Скидки до 66% бренда Adidas",
        "code": "",
        "discount": "66%",
        "description": "Кроссовки Adidas по выгодным ценам со скидками до 66%, выбирайте удобство и качество.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=170&a=79",
        "isActive": true,
        "createdAt": "2026-03-31",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6543561ed8659.png"
      }
    ]
  },
  {
    "id": "168",
    "name": "Cozy Home",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435a30a74ef.png",
    "description": "Присоединяйся к партнерской программе Cozy Home! СOZY HOME – Интернет-магазин текстиля и декора для дома. COZY HOME – это пространство уютных вещей. В ассортименте - постельное бельё и текстиль собственного производства,",
    "promocodesCount": 3,
    "category": "Для дома и сада",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "168-114586",
        "title": "Скидка 10% на заказ от 4500 руб.",
        "code": "advcake10",
        "discount": "10%",
        "description": "Скидка 10% на заказ от 4500 руб.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=168&a=79",
        "isActive": true,
        "createdAt": "2025-06-10",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435a30a74ef.png"
      },
      {
        "id": "168-31005",
        "title": "Скидка 10% на покупку от 4500 руб.",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на покупку от 4500 руб.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=168&a=79",
        "isActive": true,
        "createdAt": "2025-06-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435a30a74ef.png"
      },
      {
        "id": "168-35263",
        "title": "Скидка 1500 рублей на первый заказ в мобильном приложении",
        "code": "",
        "discount": "1500₽",
        "description": "Приглашаем в мир удобных и выгодных покупок прямо у вас в смартфоне! Скачайте мобильное приложение Cozy Home и получите скидку 1500 рублей на первый заказ. В мобильном приложении вы найдете все для вашего дома: большой выбор постельного белья, домашней одежды, косметических средств и ароматов, а также декора и аксессуаров. Удобный интерфейс приложения - легко находите нужные товары, фильтруйте по категориям и сравнивайте цены. Cozy Home — уют вашего дома!",
        "expiryDate": "2026-07-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=168&a=79",
        "isActive": true,
        "createdAt": "2025-12-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65435a30a74ef.png"
      }
    ]
  },
  {
    "id": "164",
    "name": "КЭСПА(Skillbox Английский)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654105324b4aa.png",
    "description": "КЭСПА – онлайн-школа английского языка, которая работает более 20 лет, а с недавнего времени стала частью Skillbox. При обучении учитываются индивидуальные особенности студента и разрабатывается персональная программа, к",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "164-38589",
        "title": "Первый урок всего за 99 руб.",
        "code": "",
        "discount": "99₽",
        "description": "На первом занятии за 99 руб. определим ваш уровень языка, подберем план обучения, который подходит именно вам",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=164&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654105324b4aa.png"
      },
      {
        "id": "164-38588",
        "title": "Бесплатная консультация по английскому перед обучением",
        "code": "",
        "discount": "Акция",
        "description": "Бесплатная 15-минутная консультация с менеджером «Skillbox Английский». Помогаем определить цель и выбрать направление обучения английскому — без упражнений и тестов.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=164&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img654105324b4aa.png"
      }
    ]
  },
  {
    "id": "162",
    "name": "НИИДПО",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ef2a1b38f.png",
    "description": "Национальный исследовательский институт дополнительного образования и профессионального обучения (НИИДПО) помогает освоить новую профессию и повысить квалификацию с 2015 года.На 2022 год количество образовательных програ",
    "promocodesCount": 5,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "162-119790",
        "title": "Скидка 5% на заказ",
        "code": "promo5",
        "discount": "5%",
        "description": "Скидка 5% для новых пользователей. Не суммируется c другими скидками, акциями и рассрочкой (исключение: акционная цена на сайте). Действует на все курсы",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=162&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ef2a1b38f.png"
      },
      {
        "id": "162-134327",
        "title": "Дополнительная скидка 11%",
        "code": "ДР_НИИДПО",
        "discount": "11%",
        "description": "Дополнительная скидка 11% и 2 мини-курса в подарок",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=162&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ef2a1b38f.png"
      },
      {
        "id": "162-31252",
        "title": "Скидка 5% на все курсы НИИДПО",
        "code": "",
        "discount": "5%",
        "description": "Промокод даёт скидку 5% для новых пользователей. Действует на все курсы НИИДПО!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=162&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ef2a1b38f.png"
      },
      {
        "id": "162-36600",
        "title": "2 мини-курса в подарок при покупке курса по психологии",
        "code": "",
        "discount": "Акция",
        "description": "Получите 2 мини-курса в подарок при покупке курса по психологии в НИИДПО",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=162&a=79",
        "isActive": true,
        "createdAt": "2026-01-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ef2a1b38f.png"
      },
      {
        "id": "162-38780",
        "title": "День Рождения НИИДПО",
        "code": "",
        "discount": "11%",
        "description": "Учебному центру 11 лет! Дарим дополнительную скидку 11% по промокоду ДР_НИИДПО, а также 2 мини-курса в подарок!",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=162&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ef2a1b38f.png"
      }
    ]
  },
  {
    "id": "161",
    "name": "Нетология",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png",
    "description": "Нетология — это образовательная платформа. Обучаем современным востребованным профессиям по направлениям: Маркетинг, Бизнес и управление, Дизайн и UX, Программирование, Аналитика и Data Science, EdTech, Хобби и саморазви",
    "promocodesCount": 10,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "161-129647",
        "title": "Скидка 5000 рублей на заказ",
        "code": "CODE5",
        "discount": "5000₽",
        "description": "Скидка 5000 рублей на любые профессии аналитики и программирования по промокоду CODE5 .Скидка по промокоду суммируется с другими акциями на сайте. Действует для новых и действующих клиентов.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-01-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-132421",
        "title": "-55% на курс о маркетплейсах по промокоду",
        "code": "SELLER55",
        "discount": "55%",
        "description": "Скидка 55% по промокоду на курс «Селлер на маркетплейсах» до конца мая.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-03-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-133364",
        "title": "Дополнительно -8% по промокоду",
        "code": "advcake",
        "discount": "8%",
        "description": "Дополнительная скидка 8% по промокоду на всё, кроме Высшего образования. Суммируется со скидками на сайте.",
        "expiryDate": "2028-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-134435",
        "title": "Скидка 60% по промокоду",
        "code": "NETOMAY60",
        "discount": "60%",
        "description": "Скидка 60% по промокоду на все курсы, кроме Высшего образования и курсов по направлению \"Дизайн\" до конца мая.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-134434",
        "title": "Скидка 55% по промокоду",
        "code": "NETOMAY55",
        "discount": "55%",
        "description": "Скидка 55% по промокоду на все курсы, кроме Высшего образования до конца мая.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-36406",
        "title": "Скидка 5000 рублей на любые профессии аналитики и программирования",
        "code": "",
        "discount": "5000₽",
        "description": "Скидка 5000 рублей на любые профессии аналитики и программирования по промокоду CODE5.Скидка по промокоду суммируется с другими акциями на сайте. Действует для новых и действующих клиентов.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-01-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-37859",
        "title": "Скидка 55% по промокоду на курс «Селлер на маркетплейсах»",
        "code": "",
        "discount": "55%",
        "description": "Скидка 55% по промокоду на курс «Селлер на маркетплейсах» до конца мая.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-03-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-38059",
        "title": "Дополнительная скидка -8% по промокоду",
        "code": "",
        "discount": "8%",
        "description": "Дополнительная скидка 8% по промокоду на всё, кроме Высшего образования. Суммируется со скидками на сайте.",
        "expiryDate": "2028-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-38892",
        "title": "Скидка 60% по промокоду",
        "code": "",
        "discount": "60%",
        "description": "Скидка 60% по промокоду на все курсы, кроме Высшего образования и курсов по направлению \"Дизайн\" до конца мая.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      },
      {
        "id": "161-38891",
        "title": "Скидка 55% по промокоду",
        "code": "",
        "discount": "55%",
        "description": "Скидка 55% по промокоду на все курсы, кроме Высшего образования до конца мая.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=161&a=79",
        "isActive": true,
        "createdAt": "2026-05-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540eb45d68d3.png"
      }
    ]
  },
  {
    "id": "160",
    "name": "НАДПО",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e6ba1e7ef.png",
    "description": "- Национальная Академии Дополнительного Профессионального Образования (НАДПО) - Специализируемся на дистанционных курсах переподготовки и повышения квалификации - Основной профиль Академии – психология, наши студенты мог",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "160-69964",
        "title": "Скидка 5% на заказ",
        "code": "ADVCAKE",
        "discount": "5%",
        "description": "5% скидка на любой курс. Суммируется со скидками на сайте. Промокод нужно назвать менеджеру по телефону. Для применения скидки оплатить заказ нужно до конца текущего месяца",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=160&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e6ba1e7ef.png"
      },
      {
        "id": "160-21111",
        "title": "Скидка 5% по промокоду",
        "code": "",
        "discount": "5%",
        "description": "5% скидка на любой курс. Суммируется со скидками на сайте. Промокод нужно назвать менеджеру по телефону. Для применения скидки оплатить заказ нужно до конца текущего месяца",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=160&a=79",
        "isActive": true,
        "createdAt": "2025-12-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e6ba1e7ef.png"
      },
      {
        "id": "160-37668",
        "title": "Скидки на курсы до 65%",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65% на курсы + 3 электронных курса в подарок",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=160&a=79",
        "isActive": true,
        "createdAt": "2026-03-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e6ba1e7ef.png"
      }
    ]
  },
  {
    "id": "159",
    "name": "Альфа-школа",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e3441881d.png",
    "description": "Онлайн-школа \"Альфа\" - занятия с репетитором на инновационной платформе. Индивидуальная программа под каждого ученика. Преимущества для покупателей: - Бесплатный вводный урок - У нас есть Лицензия, а это значит сможете п",
    "promocodesCount": 3,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "159-127351",
        "title": "Скидка 10% на заказ",
        "code": "adv15",
        "discount": "10%",
        "description": "10% Скидка на первую оплату любого тарифа. *Кроме рассрочки и тарифа \"\"легкий старт\". Скидка по промокоду не применяется в период проведения Акций школы.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=159&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e3441881d.png"
      },
      {
        "id": "159-36006",
        "title": "Скидка 10% на обучение",
        "code": "",
        "discount": "10%",
        "description": "10% Скидка на первую оплату любого тарифа. *Кроме рассрочки и тарифа \"\"легкий старт\". Скидка по промокоду не применяется в период проведения Акций школы.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=159&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e3441881d.png"
      },
      {
        "id": "159-38554",
        "title": "Скидка до 16% на обучение",
        "code": "",
        "discount": "16%",
        "description": "Скидка до 16% на пакеты занятий. Первый урок бесплатноРассрочка (без переплат, до 10 месяцев)Возможна плата материнским капиталомНалоговый вычет 13%",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=159&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e3441881d.png"
      }
    ]
  },
  {
    "id": "158",
    "name": "MAED",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e0f770667.png",
    "description": "M aed.ru - это лучшие практики маркетинга: кейсы и эффективные инструменты, учебные видео и статьи. Основан в 2013 году как дочерний проект Маркетинговой Группы «Комплето». Наша миссия – создание профессиональной маркети",
    "promocodesCount": 5,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "158-126040",
        "title": "​Скидка 5%",
        "code": "advcake",
        "discount": "5%",
        "description": "Скидка 5% от стоимости курсов по промокоду.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=158&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e0f770667.png"
      },
      {
        "id": "158-29838",
        "title": "Free-зона 💥- это зона с бесплатным полезностями для маркетологов",
        "code": "",
        "discount": "Акция",
        "description": "Free-зона 💥- это зона с бесплатным полезностями для маркетологов, или тех кто хочет стать маркетологом, сюда можно пускать холодный или теплый трафик🔥💫→ точки входа во фризону: баннеры на главной, в каталоге, ссылки в хэдере и футере→ все важные артефакты:⁃ главная: https://maed.ru/free⁃ страницы мини-курсов:https://maed.ru/free/smm-businesshttps://maed.ru/free/content-planhttps://maed.ru/free/how-to-create-offerhttps://maed.ru/free/competitorshttps://maed.ru/free/marketing-researchhttps://maed.ru/free/digital-directorhttps://maed.ru/free/abmhttps://maed.ru/free/crm-marketinghttps://maed.ru/free/marketplace",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=158&a=79",
        "isActive": true,
        "createdAt": "2025-03-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e0f770667.png"
      },
      {
        "id": "158-31431",
        "title": "Автовебинар по нейросетям!",
        "code": "",
        "discount": "Акция",
        "description": "Как внедрить ИИ в работу, какие результаты это дает и много другой Мега-полезной информации 💥Сэкономьте до 20 часов работы с помощью нейросетей Регистрируйтесь на бесплатный вебинар по нейросетям от академии маркетинга MAED. Получите топ-10 промптов маркетолога за регистрацию.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=158&a=79",
        "isActive": true,
        "createdAt": "2025-06-25",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e0f770667.png"
      },
      {
        "id": "158-35886",
        "title": "Скидка 5% от стоимости курсов",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% от стоимости курсов по промокоду.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=158&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e0f770667.png"
      },
      {
        "id": "158-39105",
        "title": "Курс в подарок при покупке профессии в MAED!",
        "code": "",
        "discount": "Акция",
        "description": "До 25 мая курс «Нейросети для маркетолога» — в подарок при покупке каждой профессии в MAED.Когда начинать обучение, если не сейчас?!🔆",
        "expiryDate": "2026-05-25",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=158&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540e0f770667.png"
      }
    ]
  },
  {
    "id": "157",
    "name": "Логомашина",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ce3428a27.png",
    "description": "Мы дизайн-студия Логомашина . Делаем айдентику для проектов со всего мира и обучаем новое поколение дизайнеров. За 8 лет работы более 1650 проектов для клиентов из 22 стран мира. Направления: брендинг, нейминг, раазработ",
    "promocodesCount": 5,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "157-125661",
        "title": "6 уроков бесплатно",
        "code": "TESTDRIVE",
        "discount": "Акция",
        "description": "Купон на бесплатные 6 уроков - TESTDRIVE",
        "expiryDate": "2026-09-01",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=157&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ce3428a27.png"
      },
      {
        "id": "157-125658",
        "title": "​Скидка 45%",
        "code": "LM45",
        "discount": "45%",
        "description": "Скидка до 45% на все профессии с помощью в трудоустройстве Cкидка не суммируется с другими акциями школы",
        "expiryDate": "2026-09-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=157&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ce3428a27.png"
      },
      {
        "id": "157-33475",
        "title": "Запуск бесплатного курса",
        "code": "",
        "discount": "Акция",
        "description": "Логомашина запустила БЕСПЛАТНЫЙ курс 🥳 для прогрева лидов с вашего канала трафика🔥🔥🔥Целых 6 уроков полезного контента + личное наставничество куратора😱Все для того, чтобы влюбить ваших лидов в профессию Дизайнера🥰За эти 6 уроков пользователь получит:📌Личный кабинет + 4 урока📌6 кейсов в портфолио (сайт, карточки МП, Рич контент, презентации, оформление соц. сетей) 📌Обратную связь от наставника📌Готовый Reels Кейс с работамиИ все это БЕСПЛАТНО с поддержкой нашего Куратора-эксперта (не ИИ, настоящий куратор)😉🔥Сайт бесплатного курса: https://study.logomachine.ru/test-drive-full🔥Флагманский курс (на который закрывает бесплатник): https://study.logomachine.ru/digital_era_11🔥Креативы для ваших площадок : https://drive.google.com/drive/folders/1FTGYX9YwUU...",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=157&a=79",
        "isActive": true,
        "createdAt": "2025-09-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ce3428a27.png"
      },
      {
        "id": "157-35730",
        "title": "Скидка 100% на тест-драйв профессии дизайнера с личным наставником",
        "code": "",
        "discount": "100%",
        "description": "Купон на бесплатные 6 уроков - TESTDRIVEУТП:Освойте основы дизайна за 6 бесплатных уроковhttps://study.logomachine.ru/test-drive-fullСтартуй в дизайн без вложений: 6 уроков и первые результаты6 уроков бесплатно – сделай свои первые дизайнерские работыБесплатный курс для начинающих дизайнеров",
        "expiryDate": "2026-09-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=157&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ce3428a27.png"
      },
      {
        "id": "157-35727",
        "title": "Скидка до 45% на обучение дизайну",
        "code": "",
        "discount": "45%",
        "description": "Скидка до 45% на все годовые курсыCкидка не суммируется с другими акциями школы",
        "expiryDate": "2026-09-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=157&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540ce3428a27.png"
      }
    ]
  },
  {
    "id": "155",
    "name": "Level One",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540c8e6c3c5b.png",
    "description": "Образовательная платформа Level One помогает разобраться в темах за пределами работы — от кино и психологии до стиля и финансовой грамотности. На одной платформе собраны десятки курсов и сотни лекций с вдохновляющими экс",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "155-134512",
        "title": "Скидка 15%",
        "code": "advcake",
        "discount": "15%",
        "description": "Скидка 15% на заказ по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=155&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540c8e6c3c5b.png"
      },
      {
        "id": "155-38977",
        "title": "Скидка 15% по промокоду",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на заказ по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=155&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540c8e6c3c5b.png"
      }
    ]
  },
  {
    "id": "154",
    "name": "Interra",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540c57da80eb.png",
    "description": "Освойте востребованную интернет-профессию на наших курсах Изучайте новую сферу с поддержкой куратора. Завершите обучение, получите удостоверение государственного образца и помощь в трудоустройстве. Преимущества для покуп",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "153",
    "name": "Хекслет",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540c3f9083cb.png",
    "description": "Хекслет — лучшая школа программирования по версии пользователей Хабра. Наши выпускники уже 10 лет трудоустраиваются в топовые IT-компании. Готовим разработчиков с учетом требований реальных работодателей и уверены в каче",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "152",
    "name": "Годограф",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540bf4b06997.png",
    "description": "Годограф - федеральная сеть учебных центров. Готовим к ЕГЭ и ОГЭ по лицензированной программе с учетом всех изменений, тонкостей и ловушек тестирования. Курсы ЕГЭ в Москве и МО или онлайн с 2012 года. Обеспечиваем компле",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "152-38990",
        "title": "Льготы при оплате обучения",
        "code": "",
        "discount": "Акция",
        "description": "При оплате обучения, возможно: Оформить налоговый вычет и вернуть до 33 800 Оплатить обучение материнским капиталом",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=152&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6540bf4b06997.png"
      }
    ]
  },
  {
    "id": "150",
    "name": "Вебиум",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fe600b5357.png",
    "description": "Вебиум — нескучная онлайн школа для тех, кто готовится к ЕГЭ и хочет во всем разобраться. Курсы подготовки и повторения тем ЕГЭ с акцентом на практику, формирование индивидуальной программу по результатам тестирования. П",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "150-38277",
        "title": "Бесплатные курсы для подготовки к экзаменам",
        "code": "",
        "discount": "99%",
        "description": "Разборы ОГЭ по биологии, профильная математика, подготовка по физике все это бесплатно только в онлайн школе Вебиум!",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=150&a=79",
        "isActive": true,
        "createdAt": "2026-04-09",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fe600b5357.png"
      }
    ]
  },
  {
    "id": "148",
    "name": "Videoforme",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fe44ed4f97.png",
    "description": "Videforme.ru - Международная школа профессий - это международная сеть образовательных центров, работающая в 5 странах и более 50-ти городах. С 2010 года в учебных центрах обучилось более 70 000 учеников. В школе можно пр",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "147",
    "name": "Verona models school",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fe1f7918b3.png",
    "description": "Верона - Самая крупна оффлайн-школа моделей №1 в Европе. Лауреаты премии Fashion Summer Awards “Лучшая школа моделей России”. Занятия ведут профессиональные преподаватели, многие из которых работали с российскими звёздам",
    "promocodesCount": 1,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "147-38967",
        "title": "Заполни анкету получи гарантированный подарок: Мини-курс по макияжу или же чек-лист \"Как мужчине попасть в модельное агентство\"",
        "code": "",
        "discount": "Акция",
        "description": "Заполни анкету получи гарантированный подарок: Мини-курс по макияжу или же чек-лист \"Как мужчине попасть в модельное агентство\"",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=147&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fe1f7918b3.png"
      }
    ]
  },
  {
    "id": "143",
    "name": "TutorOnline",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fd46739fdf.png",
    "description": "TutorOnline - сервис занятий с репетитором в формате Онлайн. Занятие проходит на сайте в виртуальной классной комнате (вайтборд), один на один с репетитором. Широкий список предметов (все школьные предметы, подготовка к ",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "143-126209",
        "title": "Скидка 10%",
        "code": "tutadv",
        "discount": "10%",
        "description": "Скидка 10% на первую оплату по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=143&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fd46739fdf.png"
      },
      {
        "id": "143-129787",
        "title": "Скидка 10%",
        "code": "edadeal",
        "discount": "10%",
        "description": "Скидка 10% на первую оплату по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=143&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fd46739fdf.png"
      },
      {
        "id": "143-35986",
        "title": "Скидка 10% на первую оплату",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на первую оплату по промокоду",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=143&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fd46739fdf.png"
      }
    ]
  },
  {
    "id": "142",
    "name": "TopAcademy",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fd280a2922.png",
    "description": "Компьютерная Академия TOP IT-образование, каким оно должно быт Готовим программистов, дизайнеров и системных инженеров, которых нельзя заменить искусственным интеллектом. Для этого, кроме глубоких профильных знаний, учим",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "137",
    "name": "Сотка",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fc2fad8eb7.png",
    "description": "Сотка - одна из самых быстрорастущих онлайн-школ которая готовит учеников к ЕГЭ и ОГЭ, помогает улучшить школьные оценки и обучает перспективным хобби по самой выгодной цене в России. Мы обучаем с любого текущего уровня,",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "136",
    "name": "Слёрм",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fbdf47386b.png",
    "description": "Образование для людей. Интенсивы, видеокурсы и корпоративное обучение от практикующих экспертов. Преимущества для покупателей: -Практическая работа на интенсивах и курсах приближена к реальным кейсам -Слёрм вырос из внут",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "136-29990",
        "title": "Выгодная подписка на кусы Слёрма",
        "code": "",
        "discount": "000₽",
        "description": "Всего 1 000 ₽ в день – и у вас есть доступ к 32 курсам по актуальным технологиям, от DevOps до Kubernetes и Docker!Выбирайте свой тариф:🔹 БАЗА: 2 месяца21 видеокурс16 250 ₽/мес (рассрочка 4 мес)Все курсы открываются сразу после оплаты💡 3 096 ₽ за один курс🔹 МЕГА: 3 месяца11 потоков и интенсивов + 21 видеокурс22 250 ₽/мес (рассрочка 4 мес)Видеокурсы доступны сразу, а для записи в потоки мы свяжемся с вами💡 2 782 ₽ за один курсПодписку можно продлить и продолжить обучение.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=136&a=79",
        "isActive": true,
        "createdAt": "2025-03-21",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fbdf47386b.png"
      }
    ]
  },
  {
    "id": "135",
    "name": "GeekBrains",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fbedf69ca6.png",
    "description": "Образовательная экосистема GeekBrains GeekBrains — это образовательная экосистема. В ней любой человек может получить востребованную специальность, развить навыки и начать работать в интернете. Мы помогаем с нуля освоить",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "135-108357",
        "title": "Скидка 7% на заказ",
        "code": "geekpromo",
        "discount": "7%",
        "description": "Дополнительная скидка 7%. Промокод необходимо назвать менеджеру по продажам",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=135&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fbedf69ca6.png"
      },
      {
        "id": "135-35599",
        "title": "Весенние скидки до 60%, ИИ для работы и 5 курсов в подарок",
        "code": "",
        "discount": "60%",
        "description": "Только сейчас можно получить любую профессию или повысить навыки со скидкой до 60%.А ещё — ИИ для работы и сразу 5 курса в подарок:— 2 курса по хард-скиллам— 2 курса по софт-скиллам— Год изучения английского языка",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=135&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fbedf69ca6.png"
      },
      {
        "id": "135-30020",
        "title": "Скидка по промокоду",
        "code": "",
        "discount": "7%",
        "description": "Получите дополнительную скидку 7% — просто введите промокод при оформлении заказа. Промокод нужно сообщить менеджеру на консультации.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=135&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fbedf69ca6.png"
      }
    ]
  },
  {
    "id": "134",
    "name": "Фоксфорд",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png",
    "description": "Фоксфорд — онлайн-школа для дошкольников, учеников 1−11 классов, учителей и родителей. Дошкольники и их родители найдут на платформе развивающие курсы, курсы подготовки к школе, курсы по изучению английского языка и заня",
    "promocodesCount": 9,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "134-117053",
        "title": "Скидка 10% на заказ",
        "code": "FOXFORD",
        "discount": "10%",
        "description": "Годовые курсы.10% на первую покупку",
        "expiryDate": "2026-07-03",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2025-07-10",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-117166",
        "title": "Скидка 10% на заказ",
        "code": "FOXFORDREP",
        "discount": "10%",
        "description": "Репетиторы. 10% на первую покупку",
        "expiryDate": "2026-07-03",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2025-07-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-125254",
        "title": "Скидка 44%",
        "code": "42T-0BW-WM8",
        "discount": "44%",
        "description": "Скидка в размере 44% на пакеты 4-8-16 занятий с репетитором по иностранным языкам для новых клиентов по промокоду Посадочная страница - https://foxford.ru/catalog?promo_code=42T-0BW-WM8 Иностранные языки в Фоксфорде — это: Английский язык Немецкий язык Французский язык Испанский язык Китайский язык Корейский язык Преимущества занятий с репетитором: Индивидуальный подход. Репетитор сформирует программу под ваш уровень и цели; Наши педагоги составят программу, которая учитывает характер и интересы ученика; Уже через несколько занятий вы увидите, как ваши вложения превращаются в реальные результаты; Говорите свободно с помощью того, что любите: учим языки через сериалы, музыку и погружение в культуру",
        "expiryDate": "2026-07-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2025-11-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-129706",
        "title": "Скидка 5%",
        "code": "FOXFORD5",
        "discount": "5%",
        "description": "Скидка 5%, только на первые оплаты, действует на курсы, курсы в группе, занятия с репетитором по всем предметам, суммируется с акциями на сайте",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2026-01-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-134579",
        "title": "Скидки до 50%",
        "code": "MAY25",
        "discount": "50%",
        "description": "Скидка 25% при покупке. Для всех пользователей. Без ограничений на количество покупок. Не суммируется с другими акциями. Действует на оплату нового учебного года в домашней школе",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2026-05-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-35184",
        "title": "Скидка 44% для новых клиентов на репетиторов по иностранным языкам",
        "code": "",
        "discount": "44%",
        "description": "Скидка в размере 44% на пакеты 4-8-16 занятий с репетитором по иностранным языкам для новых клиентов по промокодуПосадочная страница - https://foxford.ru/catalog?promo_code=42T-0BW-WM8Иностранные языки в Фоксфорде — это:Английский языкНемецкий языкФранцузский языкИспанский языкКитайский языкКорейский языкПреимущества занятий с репетитором:Индивидуальный подход. Репетитор сформирует программу под ваш уровень и цели;Наши педагоги составят программу, которая учитывает характер и интересы ученика;Уже через несколько занятий вы увидите, как ваши вложения превращаются в реальные результаты;Говорите свободно с помощью того, что любите: учим языки через сериалы, музыку и погружение в культуру",
        "expiryDate": "2026-07-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2025-11-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-36473",
        "title": "Скидка 5%",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% по промокоду, только на первые оплаты, действует на курсы, курсы в группе, занятия с репетитором по всем предметам, суммируется с акциями на сайте",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2026-01-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-37491",
        "title": "Скидка 15% на оплату Домашней школы в рассрочку",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на оплату Домашней школы на 26/27уч.год в рассрочку. Действует только для новых покупателей. Портальная акция действует без промокода.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2026-03-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      },
      {
        "id": "134-39070",
        "title": "Скидка до 50%",
        "code": "",
        "discount": "50%",
        "description": "Скидка 41% при покупке.Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на Курсы и курсы в группе.Скидка 25% рублей при покупке.Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на годовые курсы следующего учебного года.При покупке 2х курсов -30%; 3х курсов -35%; 4х курсов -50%Скидка 25% при покупке.Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на оплату нового учебного года в домашней школе.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=134&a=79",
        "isActive": true,
        "createdAt": "2026-05-20",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb80b5d6e2.png"
      }
    ]
  },
  {
    "id": "133",
    "name": "Fashion Factory",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb4af680c8.png",
    "description": "Школа бизнес-образования Fashion Factory основана в 2013 году Мы помогаем расти модному бизнесу. Формируем профессиональное сообщество и помогаем обмениваться опытом, создаем возможности сотрудничества и делимся контакта",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "133-130796",
        "title": "14 000 ₽ и второй курс в подарок при покупке в честь Дня всех влюбленных!",
        "code": "МОДА14",
        "discount": "000₽",
        "description": "Стилист в Fashion. В программе — типажи внешности, приёмы визуальной коррекции фигуры, работа с цветом, история моды XX века, психология стиля и общение с клиентами. Эксперт курса — Алексей Сухарев. Новый поток стартует 12 марта. Подробнее о курсе — по ссылке. ❤️ По промокоду МОДА14 дарим 14 000 ₽ и второй курс в подарок при покупке в честь Дня всех влюбленных!",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=133&a=79",
        "isActive": true,
        "createdAt": "2026-02-09",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb4af680c8.png"
      },
      {
        "id": "133-36800",
        "title": "Набор на курс \"Стилист в Fashion\"",
        "code": "",
        "discount": "000₽",
        "description": "В программе — типажи внешности, приёмы визуальной коррекции фигуры, работа с цветом, история моды XX века, психология стиля и общение с клиентами. Эксперт курса — Алексей Сухарев.Новый поток стартует 12 марта. Подробнее о курсе — по ссылке.❤️ По промокоду МОДА14 дарим 14 000 ₽ и второй курс в подарок при покупке в честь Дня всех влюбленных!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=133&a=79",
        "isActive": true,
        "createdAt": "2026-02-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fb4af680c8.png"
      }
    ]
  },
  {
    "id": "132",
    "name": "Skysmart",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653faee787918.png",
    "description": "Skysmart — это онлайн-школа от создателей Skyeng для учеников 1–11 классов и тех, кто только готовится к учебе. Сейчас мы обучаем английскому и математике. Подберем подходящего преподавателя, поможем понять и навсегда по",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "132-37827",
        "title": "Бесплатная школа программирования Skysmart!",
        "code": "",
        "discount": "Акция",
        "description": "Бесплатная школа программирования походит для родителей детей 7-17 лет, мы даём полезные материалы универсальные для любого возраста и уровня. Полезные материалы разделены на 4 блока:- Погружение в ИТ (ключевой), где мы погружаем ребёнка в программирование с помощью интерактивных видеоуроков- Кибербезопасность, где мы учим безопасно проводить время в интернете- Нейросети для решения повседневных и творческих задач- Профориентация, где мы предлагаем пройти тест на таланты и рассказываем о профессиях будущегоОсновные посылы:- Познакомим с основами ИТ, научим создавать игры и поможем понять, в каком ИТ-направлении развиваться- 18 полезных материалов для ребёнка по сфере ИТ: программирование, безопасность, профориентация и нейросети- Бесплатно попробуете сферу ИТ для ребёнка. 18 полезных материалов, чтобы начать.- Ребёнок попробует себя в роли настоящего программиста, сделает первые шаги, создаст первые программы самостоятельно, научится безопасно проводить время в Сети и познакомиться с профессиями будущего.- Ребенок занимается сам: готовые видеоуроки ведут его от начала до конца- 18 полезных материалов из сферы ИТ, чтобы ребёнок не сидел в телефоне. Интерактивные уроки для развития мышления и логики ребёнка бесплатно- Узнаете, какие таланты есть у вашего ребёнка и получите рекомендации по развитию с помощью профтестирования- В качестве бонуса ребенок получит файлы по профессиям будущего и лекцию для родителей о карьере ребенка, чтобы взрослые понимали, как помогать ребенку развиваться в IT.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=132&a=79",
        "isActive": true,
        "createdAt": "2026-03-24",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653faee787918.png"
      },
      {
        "id": "132-38966",
        "title": "Скидка до 40% для учебы вашего ребенка по всем школьным предметам и программированию, чтоб не забыть школьную программу и провести лето с пользой!",
        "code": "",
        "discount": "40%",
        "description": "Бесплатный детский онлайн-лагерь для детей 7-13 лет - увлечем нейросетями,дизайном, программированием и английским, чтобы ребёнок отдыхал интересно и проводил лето с пользой. Даты 1 смены: 01 июня — 30 июняРезультат, который получит ребенок в конце смены за месяц в лагере:- Узнает, как применять искусственный интеллект с пользой. Создаст собственное приложение с помощью умной программы.- Увлечётся английским.Пополнит запас полезной лексики о школе и научится применять её в жизни- Разработает свои первые игры.На языках программирования Scratch и Python. - Нарисует уникального персонажа. Создаст макет в графическом редакторе Figma, сможет сохранить его и показывать друзьям.- Поймёт ценность денег.Научится принимать более осознанные финансовые решения.- Создаст свой сценический образ.А заодно научится выражать мысли и увереннее отвечать в школе. Другие сейлз-поинты:- 5 лет организовываем онлайн-лагерь и помогаем проводить лето с пользой - более 6000 участников участвуют в лагере каждый год- более 10 лет на рынке онлайн-образования- более 50000 родителей доверяют нам обучение своих детей- Подключайтесь к мастер-классам дома или на даче: нужен только выход в интернет с ноутбука, планшета или телефона - Гибкая программа: мастер-классы идут весь месяц, участвуйте в том, что интересно",
        "expiryDate": "2026-06-15",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=132&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653faee787918.png"
      }
    ]
  },
  {
    "id": "131",
    "name": "Skyeng",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653faa2021230.png",
    "description": "Skyeng — крупнейшая в России образовательная компания. Входит в ТОП-30 самых дорогих компаний Рунета по версии Forbes и в ТОП-3 крупнейших EdTech-компаний России по версии РБК. Вы можете заниматься где угодно и когда удо",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "130",
    "name": "Skypro",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa68fc207a.png",
    "description": "Skypro — онлайн-университет рентабельного образования от создателей крупнейшей в Европе школе английского языка. Преимущества для покупателей: - Надежный и проверенный бренд Skyeng - Все преподаватели - практикующие спец",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "130-38988",
        "title": "1 год английского в подарок при покупке курса",
        "code": "",
        "discount": "100%",
        "description": "1 год английского в подарок при покупке курса",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=130&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa68fc207a.png"
      },
      {
        "id": "130-38989",
        "title": "Бесплатный курс по нейросетям при покупке основного курса",
        "code": "",
        "discount": "100%",
        "description": "Бесплатный курс по нейросетям при покупке основного курса",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=130&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa68fc207a.png"
      }
    ]
  },
  {
    "id": "129",
    "name": "Skillfactory",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa22e5fe3d.png",
    "description": "Онлайн-школа Skillfactory — прямой путь в IT-профессии как для новичков, так и для специалистов, меняющих сферу и повышающих квалификацию. Мы сфокусированы на Data Science, аналитике данных и программировании. У нас окол",
    "promocodesCount": 5,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "129-113338",
        "title": "Дополнительно 5% по промокоду",
        "code": "AFFILIATES",
        "discount": "5%",
        "description": "плюс 5% к скидке на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=129&a=79",
        "isActive": true,
        "createdAt": "2025-10-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa22e5fe3d.png"
      },
      {
        "id": "129-129052",
        "title": "Дополнительно 5% по промокоду",
        "code": "PARTNER",
        "discount": "5%",
        "description": "Дополнительная скидка 5% к цене на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=129&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa22e5fe3d.png"
      },
      {
        "id": "129-30829",
        "title": "Дополнительная скидка 5% по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Дополнительная скидка 5% к цене на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=129&a=79",
        "isActive": true,
        "createdAt": "2025-10-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa22e5fe3d.png"
      },
      {
        "id": "129-36259",
        "title": "Дополнительная скидка 5% по промокоду.",
        "code": "",
        "discount": "5%",
        "description": "Дополнительная скидка 5% к цене на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=129&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa22e5fe3d.png"
      },
      {
        "id": "129-38001",
        "title": "Скидки до 60% и 5 курсов в подарок",
        "code": "",
        "discount": "60%",
        "description": "Всем студентам:— скидки до 60% на каждый курс (тарифы: базовый 50%, оптимальный 55%, вип 60%);— 5 курсов про заботу о себе в подарок: по английскому, soft skills, нейросетям, тайм- и стресс-менеджменту.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=129&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653fa22e5fe3d.png"
      }
    ]
  },
  {
    "id": "127",
    "name": "Инглекс",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png",
    "description": "Инглекс» — онлайн-школа английского языка, основанная в 2011 году. За 13 лет мы выпустили более 24 000 учеников. Сейчас у нас обучается 5 000 студентов. Выпускники успешно проходят собеседования в иностранных компаниях, ",
    "promocodesCount": 6,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "127-66290",
        "title": "3 урока английского в подарок при первой покупке",
        "code": "ADVCAKE3",
        "discount": "Акция",
        "description": "Дарим 3 урока в подарок при первой покупке пакета от 10 уроков новым учеников с русскоязычным преподавателем",
        "expiryDate": "2027-01-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=127&a=79",
        "isActive": true,
        "createdAt": "2024-06-17",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png"
      },
      {
        "id": "127-89538",
        "title": "3 урока английского в подарок при покупке",
        "code": "START",
        "discount": "Акция",
        "description": "Дарим 3 урока в подарок при первой покупке пакета от 10 уроков новым учеником с русскоязычным преподавателем",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=127&a=79",
        "isActive": true,
        "createdAt": "2024-06-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png"
      },
      {
        "id": "127-114134",
        "title": "Скидка 40% на первую покупку",
        "code": "ADVCAKE",
        "discount": "40%",
        "description": "Скидка 40% на любой пакет занятий. Скидка действует на первую оплату новым клиентам школы. Скидка распространяется только на русскоязычных преподавателей. Предложение не суммируется с другими акциями. Промокод необходимо ввести при оформлении заявки или назвать менеджеру.",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=127&a=79",
        "isActive": true,
        "createdAt": "2025-06-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png"
      },
      {
        "id": "127-114135",
        "title": "Скидка 40% на первую покупку",
        "code": "SALE40",
        "discount": "40%",
        "description": "Скидка 40% на любой пакет занятий. Скидка действует на первую оплату новым клиентам школы. Скидка распространяется только на русскоязычных преподавателей. Предложение не суммируется с другими акциями. Промокод необходимо ввести при оформлении заявки или назвать менеджеру.",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=127&a=79",
        "isActive": true,
        "createdAt": "2025-06-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png"
      },
      {
        "id": "127-20490",
        "title": "3 урока английского с преподавателем в подарок по промокоду",
        "code": "",
        "discount": "Акция",
        "description": "Дарим 3 урока в подарок при первой покупке пакета от 10 уроков новым учеником с русскоязычным преподавателем",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=127&a=79",
        "isActive": true,
        "createdAt": "2024-06-17",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png"
      },
      {
        "id": "127-30945",
        "title": "Скидка 40% по промокоду на первую покупку",
        "code": "",
        "discount": "40%",
        "description": "Скидка 40% на любой пакет занятий. Скидка действует на первую оплату новым клиентам школы. Скидка распространяется только на русскоязычных преподавателей. Предложение не суммируется с другими акциями. Промокод необходимо ввести при оформлении заявки или назвать менеджеру.",
        "expiryDate": "2027-01-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=127&a=79",
        "isActive": true,
        "createdAt": "2025-06-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f967a411e1.png"
      }
    ]
  },
  {
    "id": "124",
    "name": "Эдюсон",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a99858c14db.png",
    "description": "Академия Эдюсон — это ведущий сервис онлайн-обучения, который готовит специалистов в современных профессиях и помогает освоить востребованные на рынке труда навыки. С 2013 года Эдюсон создает решения, которые помогли обу",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "124-134526",
        "title": "Скидка 5% на заказ",
        "code": "SALE2026",
        "discount": "5%",
        "description": "Скидка 5% рублей, действует для всех пользователей. Без ограничений на количество покупок. Суммируется с другими акциями. Действует на все товары.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=124&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a99858c14db.png"
      },
      {
        "id": "124-134615",
        "title": "Скидка 11% на заказ",
        "code": "МАЙ11",
        "discount": "11%",
        "description": "Скидка 11% на курсы HR, Аналитика и Отраслевое направление Для всех пользователей. Без ограничений на количество покупок. Суммируется с другими акциями на сайте.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=124&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a99858c14db.png"
      },
      {
        "id": "124-39006",
        "title": "Скидка 5% на все курсы!",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% рублей, действует для всех пользователей. Без ограничений на количество покупок. Суммируется с другими акциями.Действует на все товары.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=124&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a99858c14db.png"
      },
      {
        "id": "124-39104",
        "title": "Дополнительная скидка 11% на популярные направления",
        "code": "",
        "discount": "11%",
        "description": "Скидка 11% на курсы HR, Аналитика и Отраслевое направлениеДля всех пользователей. Без ограничений на количество покупок. Суммируется с другими акциями на сайте.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=124&a=79",
        "isActive": true,
        "createdAt": "2026-05-21",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69a99858c14db.png"
      }
    ]
  },
  {
    "id": "123",
    "name": "EdPro",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png",
    "description": "EdPro — онлайн-академия дополнительного образования, образовательные программы ориентированы на формирование профессиональных навыков, применимых в реальной жизни. Академия ведет деятельность на основании государственной",
    "promocodesCount": 6,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "123-29017",
        "title": "Бесплатный вебинар: Как стать сексологом?",
        "code": "",
        "discount": "Акция",
        "description": "Освойте новую профессию и станьте экспертом в сексологии;Обретите уверенность и познайте свою сексуальность;Узнайте, почему сексология — идеальная профессия для женщины;",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=123&a=79",
        "isActive": true,
        "createdAt": "2025-02-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png"
      },
      {
        "id": "123-29015",
        "title": "Бесплатный открытый вебинар: Как стать востребованным коучем с аккредитацией в 147 странах мира",
        "code": "",
        "discount": "Акция",
        "description": "Узнаете, кто такие коучи и почему они зарабатывают до 150 тысяч рублей за сессиюПолучите пошаговый план старта в профессии коучаПоймете, где брать первых клиентов и сколько можно зарабатыватьБонусы для участников вебинара: Пошаговый план старта в новой профессии коуча и Карьерный гид для начинающих в коучинге",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=123&a=79",
        "isActive": true,
        "createdAt": "2025-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png"
      },
      {
        "id": "123-29014",
        "title": "Бесплатный эфир: Как интерес к нутрициологии сделать профессией",
        "code": "",
        "discount": "000₽",
        "description": "Вы узнаете, что нужно сделать, чтобы стать востребованным нутрициологом с нуля и выйти на стабильный доход от 100 000 руб. в месяц за первые 3 месяца работы.Бронируйте бесплатное место и получите Гайд «Карьерный гид начинающего нутрициолога» в подарок**Вы получите сразу после регистрации",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=123&a=79",
        "isActive": true,
        "createdAt": "2025-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png"
      },
      {
        "id": "123-29019",
        "title": "Бесплатный вебинар Сергея Вялова: Желчь и ферменты.",
        "code": "",
        "discount": "000₽",
        "description": "За 2 часа вы узнаете нужно ли гнать желчь и сколько ферментов понадобится для того, чтобы пищеварение работало правильно.Подарок сразу после регистрации - Гайд по диагностике и восстановлению желчеоттока.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=123&a=79",
        "isActive": true,
        "createdAt": "2025-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png"
      },
      {
        "id": "123-29016",
        "title": "Бесплатная онлайн-конференция: Здоровье всей семьи",
        "code": "",
        "discount": "000₽",
        "description": "Получите эффективные инструменты профилактики и лечения заболеваний от ведущих нутрициологов и врачей, а после регистрации получите гайд «25 нутрицевтиков для всей семьи» в подарок!",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=123&a=79",
        "isActive": true,
        "createdAt": "2025-02-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png"
      },
      {
        "id": "123-30239",
        "title": "Бесплатная онлайн-конференция: Старт в психологии",
        "code": "",
        "discount": "Акция",
        "description": "Онлайн-конференция для тех, кто хочет глубже разобраться в психологии и узнать, как стать профессионалом в этой областиСпециальный гость - Лабковский Михаил",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=123&a=79",
        "isActive": true,
        "createdAt": "2025-04-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f8dfb212ca.png"
      }
    ]
  },
  {
    "id": "122",
    "name": "SEKTA SCHOOL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f82b52c218.png",
    "description": "еШкола идеального тела #SEKTA — курсы здорового питания и разумного фитнеса онлайн. Занимайтесь в удобное время и в удобном месте; Онлайн или с тренером в зале; Без голода и переедания; Под чутким контролем кураторов; С ",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "120",
    "name": "XYZ SCHOOL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f7bb77acd3.png",
    "description": "Онлайн-школа XYZ учит всем аспектам создания игр — от концепт-арта и 3D-графики до геймдизайна и программирования. Их инструкторы — действующие профессионалы индустрии: они работают в таких компаниях, как Blizzard, Peopl",
    "promocodesCount": 2,
    "category": "Игры",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "120-131339",
        "title": "​Скидка 5% на заказ",
        "code": "ADVXYZ",
        "discount": "5%",
        "description": "Скидка 5% на заказ",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=120&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f7bb77acd3.png"
      },
      {
        "id": "120-37115",
        "title": "Скидка 5% на заказ",
        "code": "",
        "discount": "5%",
        "description": "Скидка 5% на заказ",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=120&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f7bb77acd3.png"
      }
    ]
  },
  {
    "id": "118",
    "name": "PSYCHODEMIA",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653f74eb730fb.png",
    "description": "Психодемия — онлайн-школа психологических профессий. Проводит более 20 курсов по психологическому консультированию, коучингу, сексологии, HR и другим направлениям. В основе программ — практические занятия, где студенты п",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "117",
    "name": "PRODUCTSTAR",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653c16195b49c.png",
    "description": "ProductStar — международный онлайн-университет с экспертизой в продуктовом менеджменте, аналитике, маркетинге и программировании: более 10 лет обучаем IT-профессиям. Компания ProductStar выросла из ProductCamp - это межд",
    "promocodesCount": 4,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "117-38979",
        "title": "Скидка до 60% на курсы",
        "code": "",
        "discount": "60%",
        "description": "Скидка до 60%, действует на все курсы. Для всех пользователей. Без ограничений на количество покупок.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=117&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653c16195b49c.png"
      },
      {
        "id": "117-38980",
        "title": "Гостевой доступ за 1 рубль!",
        "code": "",
        "discount": "99%",
        "description": "4 практических онлайн-события каждый месяцБиблиотека практик и гайдов для развития и решения конкретных задачВозможности для общения в комьюнити-чате, база визиток и таргет-кофе с другими участникамиПрограмма развития на год в формате полезной рассылки",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=117&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653c16195b49c.png"
      },
      {
        "id": "117-38982",
        "title": "Скидка 10% при прохождении бесплатного курса за 7 дней",
        "code": "",
        "discount": "10%",
        "description": "Пройди бесплатную часть курса и получи скидку 10% на покупку курса",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=117&a=79",
        "isActive": true,
        "createdAt": "2026-05-14",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653c16195b49c.png"
      },
      {
        "id": "117-39033",
        "title": "Найдете дешевле — снизим цену",
        "code": "",
        "discount": "60%",
        "description": "Покажите курс конкурента с более низкой ценой и получите скидку на обучение в ProductStar",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=117&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653c16195b49c.png"
      }
    ]
  },
  {
    "id": "116",
    "name": "Академия Красоты Эколь(СПБ)",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b8ba018888.png",
    "description": "Ecolespb.ru - это Санкт-Петербургская Школа Красоты, сеть учебных центров по обучению специалистов Индустрии красоты. Многолетний опыт в сфере образования и интенсивные программы обучения позволяют школе давать профессию",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "116-29974",
        "title": "Скидка 40%",
        "code": "",
        "discount": "40%",
        "description": "Оставьте заявку на сайте - получите скидку 40%",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=116&a=79",
        "isActive": true,
        "createdAt": "2025-03-20",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b8ba018888.png"
      }
    ]
  },
  {
    "id": "115",
    "name": "City Business School",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b84b45bf6c.png",
    "description": "City Business School – лидер рынка дистанционного бизнес-образования в России и СНГ В 2019 году City Business School вошла в топ-9 российских бизнес-школ по версии «Независимого народного рейтинга», организованного порта",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "115-21434",
        "title": "Бесплатный курс вводный МВА",
        "code": "",
        "discount": "Акция",
        "description": "Оцените текущий уровень компетенцийОпределите направления профессионального развитияРазработаете эффективный карьерный планПолучите ваш первый сертификат МВA",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=115&a=79",
        "isActive": true,
        "createdAt": "2024-07-08",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b84b45bf6c.png"
      },
      {
        "id": "115-38875",
        "title": "Скидка 7%",
        "code": "",
        "discount": "7%",
        "description": "Дополнительная скидка 7% по промокодуCуммируется с другими акционными предложениями",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=115&a=79",
        "isActive": true,
        "createdAt": "2026-05-07",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b84b45bf6c.png"
      }
    ]
  },
  {
    "id": "113",
    "name": "Contented",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b7c962cde2.png",
    "description": "Contented —крупнейшая профильная школа дизайна *по версии Smart Ranking от 2023 года. Учим дизайнерским профессиями и навыкам по направлениям UX/UI и веб-дизайн, графический дизайн, 3D-дизайн, моушн-дизайн, дизайн интерь",
    "promocodesCount": 5,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "113-113339",
        "title": "плюс 5% к скидке на сайте",
        "code": "AFFILIATES",
        "discount": "5%",
        "description": "плюс 5% к скидке на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=113&a=79",
        "isActive": true,
        "createdAt": "2025-10-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b7c962cde2.png"
      },
      {
        "id": "113-129054",
        "title": "Дополнительно 5% по промокоду",
        "code": "PARTNER",
        "discount": "5%",
        "description": "Дополнительная скидка 5% к цене на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=113&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b7c962cde2.png"
      },
      {
        "id": "113-30830",
        "title": "Дополнительно 5% по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Дополнительная скидка 5% к цене на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=113&a=79",
        "isActive": true,
        "createdAt": "2025-10-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b7c962cde2.png"
      },
      {
        "id": "113-36260",
        "title": "Дополнительная скидка 5% по промокоду.",
        "code": "",
        "discount": "5%",
        "description": "Дополнительная скидка 5% к цене на сайте",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=113&a=79",
        "isActive": true,
        "createdAt": "2026-01-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b7c962cde2.png"
      },
      {
        "id": "113-38002",
        "title": "Скидки до 60% и 5 курсов в подарок",
        "code": "",
        "discount": "60%",
        "description": "Всем студентам:— скидки до 60% на каждый курс (тарифы: базовый 50%, оптимальный 55%, вип 60%);— 5 курсов про заботу о себе в подарок: по английскому, soft skills, нейросетям, тайм- и стресс-менеджменту.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=113&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b7c962cde2.png"
      }
    ]
  },
  {
    "id": "111",
    "name": "CODDY",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b77ff3dc40.png",
    "description": "Запишите своего ребенка на курсы CODDY® и подарите ему возможность освоить современные технологии и перспективные навыки программирования и дизайна. Обучение востребованным цифровым навыкам в школе CODDY – прекрасная инв",
    "promocodesCount": 1,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "111-38546",
        "title": "Занимайтесь в CODDY и получайте подарки за достижения",
        "code": "",
        "discount": "Акция",
        "description": "Система наград CODDY состоит из 70 уровней. Пройдите весь путь и соберите все подарки от любимой школы.В нашей линейке более 90 уникальных и актуальных курсов с проектным уклоном - от начинающего уровня до продвинутого.Выбирайте свой курс, занимайтесь и получайте награды!",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=111&a=79",
        "isActive": true,
        "createdAt": "2026-04-29",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b77ff3dc40.png"
      }
    ]
  },
  {
    "id": "110",
    "name": "Бруноям",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b6ee03d57d.png",
    "description": "Бруноям — это практический подход к образованию. Мы делаем курсы для тех, кто хочет получить новую профессию, сменить сферу деятельности или решить свою бизнес-задачу. Обучаем разработке, маркетингу, дизайну и аналитике.",
    "promocodesCount": 2,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "110-134431",
        "title": "Скидки до 50%",
        "code": "МАЙ",
        "discount": "50%",
        "description": "Дополнительная скидка 10%",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=110&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b6ee03d57d.png"
      },
      {
        "id": "110-38884",
        "title": "Скидки до 50% + 3 курса в подарок",
        "code": "",
        "discount": "50%",
        "description": "Скидки до 50% + три курса в подарок.Подробные условия акции доступны по ссылке",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=110&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b6ee03d57d.png"
      }
    ]
  },
  {
    "id": "109",
    "name": "BONNIE & SLIDE",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b6b674e927.png",
    "description": "BONNIE & SLIDE — это креативная и дизайн-студия, которая специализируется исключительно на создании презентаций. Мы учим делать презентации, которые срывают банк. Креатив, дизайн и визуализация презентаций и обучение их ",
    "promocodesCount": 0,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "108",
    "name": "Bang Bang Education",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b669997b95.png",
    "description": "BBE — это школа креативных дисциплин и сообщество для тех, кто хочет состояться в индустрии. Программы создают ведущие специалисты-практики — те, кто формирует визуальную культуру сегодня. Каждый может выбрать подход, ко",
    "promocodesCount": 3,
    "category": "Образование",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "108-117575",
        "title": "Скидка 5000 руб. на обучение",
        "code": "ADVBBE_CPA",
        "discount": "5000₽",
        "description": "Дополнительная скидка 5000 руб. на все профессии школы, либо 1500 руб. на курсы дороже 15000 руб. Промокод нужно назвать менеджеру отдела продаж по телефону.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=108&a=79",
        "isActive": true,
        "createdAt": "2025-07-18",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b669997b95.png"
      },
      {
        "id": "108-31946",
        "title": "Дополнительная скидка на обучение по промокоду",
        "code": "",
        "discount": "5000₽",
        "description": "Дополнительная скидка 5000 руб. на все профессии школы, либо 1500 руб. на курсы дороже 15000 руб. Промокод нужно назвать менеджеру отдела продаж по телефону.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=108&a=79",
        "isActive": true,
        "createdAt": "2025-07-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b669997b95.png"
      },
      {
        "id": "108-38399",
        "title": "Скидка до 55% + вторая профессия в подарок",
        "code": "",
        "discount": "55%",
        "description": "Скидки до 55% на обучение и вторая профессия в подарок.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=108&a=79",
        "isActive": true,
        "createdAt": "2026-04-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653b669997b95.png"
      }
    ]
  },
  {
    "id": "104",
    "name": "АльфаБанк Дебетовая карта",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img653160c8b17bf.png",
    "description": "Дебетовая Альфа-Карта Бесплатная. Всегда, без условий Кешбэк до 100% на категорию в барабане суперкешбэка, 5% в трёх категориях на выбор и 1% на всё Бесплатная доставка До 12% годовых по накопительному Альфа-Счёту Перево",
    "promocodesCount": 0,
    "category": "Финансы и страхование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "103",
    "name": "АльфаБанк Кредитная карта",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6530fd98e41af.png",
    "description": "Кредитная карта Целый год без % 365 дней без % на любые покупки в первые 30 дней Бесплатное обслуживание в первый год Снятие до 50 000 ₽ наличными бесплатно каждый месяц 60 дней без % на снятие наличных и переводы Суперк",
    "promocodesCount": 0,
    "category": "Финансы и страхование",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "100",
    "name": "Автокод",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img651bd89135d80.png",
    "description": "Сервис “Автокод - проверка автомобиля с гарантией” - лидирующий сервис в России по проверке истории автомобиля. \"Автокод\" – первый официальный сервис, предоставляющий полный и правдивый отчет по истории владения и эксплу",
    "promocodesCount": 0,
    "category": "Автомобили",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "98",
    "name": "Miniopros RU CIS CPL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64d910371c5a0.png",
    "description": "Миниопрос - телеграм-бот, который помогает изучать мнения, потребности, поведение и предпочтения людей для того, чтобы известные бренды создавали крутые продукты и рекламу. Наши клиенты - банки, FMCG, e-com, фарм-компани",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "97",
    "name": "Williams Et Oliver",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65aa8315b01a5.png",
    "description": "Williams Et Oliver - сеть магазинов правильных вещей для кухни, где собрана разнообразная, оригинальная и удобная кухонная посуда для ценителей кулинарного искусства. Выставленные на продажу предметы, собраны со всего ми",
    "promocodesCount": 5,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "97-123930",
        "title": "Скидка 30% на заказ",
        "code": "ADVCAKE",
        "discount": "30%",
        "description": "По промокоду скидка 30% от суммы заказа, но не более 2000 рублей. Не действует на товары со скидкой. Не суммируется с другими акциями. Есть ограничения по максимальному размеру скидки на бренды/категории.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=97&a=79",
        "isActive": true,
        "createdAt": "2025-11-11",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65aa8315b01a5.png"
      },
      {
        "id": "97-34828",
        "title": "Скидка 30%",
        "code": "",
        "discount": "30%",
        "description": "По промокоду скидка 30% от суммы заказа, но не более 2000 рублей. Не действует на товары со скидкой. Не суммируется с другими акциями. Есть ограничения по максимальному размеру скидки на бренды/категории.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=97&a=79",
        "isActive": true,
        "createdAt": "2025-11-11",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65aa8315b01a5.png"
      },
      {
        "id": "97-38808",
        "title": "Скидка 20% на гриль-кольцо",
        "code": "",
        "discount": "20%",
        "description": "Приобретайте гриль-кольцо GALA со скидкой 20%",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=97&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65aa8315b01a5.png"
      },
      {
        "id": "97-38810",
        "title": "Gefy со скидкой 25%",
        "code": "",
        "discount": "25%",
        "description": "Умные аксессуары для кухни Gefy со скидкой 25%Большинство товаров изготавливаются из нержавеющей стали марки 18/10 и имеют пятилетнюю гарантию. Внимание к каждой детали гарантирует высокое и стабильное качество продукции.",
        "expiryDate": "2026-06-05",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=97&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65aa8315b01a5.png"
      },
      {
        "id": "97-38809",
        "title": "Распродажа",
        "code": "",
        "discount": "Акция",
        "description": "Распродажа в Williams Oliver - успей приобрести по выгодной цене",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=97&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img65aa8315b01a5.png"
      }
    ]
  },
  {
    "id": "94",
    "name": "Huggies",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64bf9f8ba9254.png",
    "description": "Huggies – американский бренд одноразовых подгузников и детских салфеток, выпускаемый компанией Kimberly-Clark. Huggies предлагает высококачественные товары для ухода за нежной кожей малыша с момента рождения и до приучен",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "30",
    "name": "ОЧКАРИК",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6488b42bc33a7.png",
    "description": "«Очкарик» — бренд с богатым прошлым. Оптическая сеть родилась в 2001 году на базе Московского объединения «Оптика», история которого насчитывает более 90 лет. Но это не значит, что «Очкарик» живет понятиями прошлого века",
    "promocodesCount": 3,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "30-36903",
        "title": "Дарим 300 руб. на покупку раствора Acuvue Revitalens",
        "code": "",
        "discount": "300₽",
        "description": "Для участников программы MyACUVUE®, которые не успели пройти подбор контактных линз, но имеют опыт их ношения более или менее одного года (проставляется при регистрации в программе MyACUVUE®), доступен купон номиналом 300 рублей на покупку раствора Acuvue Revitalens объемом 300 мл или 360 мл.",
        "expiryDate": "2026-12-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=30&a=79",
        "isActive": true,
        "createdAt": "2026-02-12",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6488b42bc33a7.png"
      },
      {
        "id": "30-36902",
        "title": "Будете в выигрыше. Вот увидите",
        "code": "",
        "discount": "10%",
        "description": "Must-have* любого «очкарика» – контактные линзы, корригирующие и солнцезащитные очки.Рассказываем, как приобрести всё и сразу! Вы можете получить скидку 10% на:-Корригирующие очки при покупке солнцезащитных очков или двух и более упаковок контактных линз.-Солнцезащитные очки при покупке корригирующих очков или двух и более упаковок контактных линз.-Одну упаковку контактных линз при покупке корригирующих или солнцезащитных очков. Бесплатная проверка зрения как бонус.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=30&a=79",
        "isActive": true,
        "createdAt": "2026-02-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6488b42bc33a7.png"
      },
      {
        "id": "30-36901",
        "title": "Видеть всё в корригирующих очках за 999 руб.",
        "code": "",
        "discount": "999₽",
        "description": "В корригирующих очках за 999 рублей вы можете смотреть на мир смело, по-своему, наслаждаясь его красотой в мельчайших деталях.В стоимость входят:-проверка зрения;-оправа;-линзы ведущих производителей;-сборка.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=30&a=79",
        "isActive": true,
        "createdAt": "2026-02-12",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6488b42bc33a7.png"
      }
    ]
  },
  {
    "id": "28",
    "name": "В.Опрос",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6846c76fd1bdc.png",
    "description": "Интернет-анкета – это проект, с помощью которого компании узнают ваше мнение об их товарах и услугах.",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "27",
    "name": "Web Offer Planner5D.Com [All GEO]",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6421942aad25f.png",
    "description": "Planner 5D - это кроссплатформенный инструмент для дизайна интерьера, используемый во всем мире. Мы используем машинное обучение, искусственный интеллект и другие передовые технологические решения, чтобы сделать планиров",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "26",
    "name": "Banggood",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img642150046d38d.png",
    "description": "Banggood.com is a leading Chinese e-commerce platform, providing high-quality products at competitive prices with exceptional service. From electronics to fashion and home goods, Banggood is your ultimate shopping destin",
    "promocodesCount": 0,
    "category": "E-commerce & Retail",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "25",
    "name": "Planner5D || Design School [All GEO]",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img641feb2b2ffec.png",
    "description": "Planner 5D - это кроссплатформенный инструмент для дизайна интерьера, используемый во всем мире. Мы используем машинное обучение, искусственный интеллект и другие передовые технологические решения, чтобы сделать планиров",
    "promocodesCount": 0,
    "category": "Возможности для бизнеса",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "22",
    "name": "ALIEXPRESS",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img641f98cd566d6.png",
    "description": "Description: Founded in April 2010, AliExpress is a global market which many consumers are in Russia, United States and Brazil. The platform allows customers from all over the world to buy straight from the wholesalers a",
    "promocodesCount": 0,
    "category": "Дети",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "21",
    "name": "LA REDOUTE",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png",
    "description": "La Redoute - одна из крупнейших компаний электронной торговли в мире. Широкий ассортимент стильной французской одежды, обуви, нижнего белья, текстиля для дома, дизайнерской мебели приносит с собой радость французского шо",
    "promocodesCount": 10,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "21-133899",
        "title": "Скидка -52% на любой заказ на сайте и в приложении, действует на всё, кроме товаров с надписью \"\"финальная цена\"\"",
        "code": "wow2025",
        "discount": "52%",
        "description": "Скидка -52% на любой заказ на сайте и в приложении, действует на всё, кроме товаров с надписью \"\"финальная цена\"\"",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-133894",
        "title": "Скидка -53% на первый заказ на сайте и в приложении, действует на всё, кроме товаров с надписью \"\"финальная цена\"\"\"",
        "code": "NEWCLIENT",
        "discount": "53%",
        "description": "Скидка -53% на первый заказ на сайте и в приложении, действует на всё, кроме товаров с надписью \"\"финальная цена\"\"\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-37631",
        "title": "Скидки до 65% на женскую одежду из коллекции Anne Weyburn",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65% на женскую одежду из коллекции Anne Weyburn при покупке от 5000р.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-03-16",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-37820",
        "title": "Скидки до 38% на выделенный ассортимент садовой мебели",
        "code": "",
        "discount": "38%",
        "description": "Скидки до 38% на ассортимент садовой мебели",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-03-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-37852",
        "title": "Скидки до 65% на женскую одежду",
        "code": "",
        "discount": "65%",
        "description": "Скидки до 65% на выделеный ассортимент женской одежды",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-03-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-37839",
        "title": "Скидки до 70% на спальный текстиль",
        "code": "",
        "discount": "70%",
        "description": "Скидки до 70% на выделенный ассортимент постельного белья",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-03-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-38444",
        "title": "Скидка 52% на любой заказ",
        "code": "",
        "discount": "52%",
        "description": "Скидка 52% для всех пользователей. Без ограничений на количество покупок. Не суммируется с другими акциями.действует на всё, кроме товаров с надписью \"финальная цена\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-38443",
        "title": "Скидка 53% на первый заказ",
        "code": "",
        "discount": "53%",
        "description": "Скидка 53% на первый заказ.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на всё, кроме товаров с надписью \"финальная цена\"",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-04-22",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-38713",
        "title": "Скидка до 50% на женские наряды",
        "code": "",
        "discount": "50%",
        "description": "Скидка до 50 % при покупке от 5000 рублей.Для всех пользователей.Без ограничений на количество покупок. Суммируется с другими акциямиДействует на выделеннвй ассортимент товаров",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      },
      {
        "id": "21-39024",
        "title": "Скидка до 50% на брендовую мебель",
        "code": "",
        "discount": "50%",
        "description": "Скидка до 50% на брендовую мебель при покупке от 5000р.Для всех пользователей.Без ограничений на количество покупок. Действует на выделенный ассортимент товаров",
        "expiryDate": "2026-08-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=21&a=79",
        "isActive": true,
        "createdAt": "2026-05-15",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400542f80cbb.png"
      }
    ]
  },
  {
    "id": "20",
    "name": "СТАРАЯ ФЕРМА",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png",
    "description": "Старая ферма - это более 10000 товаров в ассортименте, более 700 отличных отзывов, бесплатная доставка от 1000 рублей по Москве и 3 км за МКАД, быстрая обработка заказов, конкурентные цены (постоянно мониторим рынок и ко",
    "promocodesCount": 19,
    "category": "Товары для животных",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "20-125258",
        "title": "10% скидка за любой заказ",
        "code": "Biospotix10",
        "discount": "10%",
        "description": "Biospotix 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125257",
        "title": "10% скидка за любой заказ",
        "code": "BIOGANCE10",
        "discount": "10%",
        "description": "BIOGANCE 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125259",
        "title": "10% скидка за любой заказ",
        "code": "kitcat10",
        "discount": "10%",
        "description": "kit cat 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125261",
        "title": "10% скидка за любой заказ",
        "code": "Catmania10",
        "discount": "10%",
        "description": "Catmania 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125262",
        "title": "10% скидка за любой заказ",
        "code": "EveryDay10",
        "discount": "10%",
        "description": "Every Day 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125263",
        "title": "10% скидка за любой заказ",
        "code": "Rogz10",
        "discount": "10%",
        "description": "Rogz 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125264",
        "title": "10% скидка за любой заказ",
        "code": "HappyDaily10",
        "discount": "10%",
        "description": "Happy Daily 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125265",
        "title": "10% скидка за любой заказ",
        "code": "Forza10",
        "discount": "10%",
        "description": "Forza10 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125266",
        "title": "10% скидка за любой заказ",
        "code": "Мираторг10",
        "discount": "10%",
        "description": "Мираторг 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125255",
        "title": "10% скидка за любой заказ",
        "code": "CHICOPEE10",
        "discount": "10%",
        "description": "CHICOPEE 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125256",
        "title": "10% скидка за любой заказ",
        "code": "OASY10",
        "discount": "10%",
        "description": "OASY 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125260",
        "title": "10% скидка за любой заказ",
        "code": "Catsway10",
        "discount": "10%",
        "description": "Cats way 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-125267",
        "title": "10% скидка за любой заказ",
        "code": "Woofa10",
        "discount": "10%",
        "description": "Woofa 10% скидка за любой заказ",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-129729",
        "title": "Скидка 5% на заказ",
        "code": "ЕЩЕ5",
        "discount": "5%",
        "description": "Скидка действует только для авторизованных клиентов на первые 3 заказа. В акции участвует выделенный ассортимент. Магазин оставляет за собой право досрочного завершения акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2026-01-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-130291",
        "title": "Скидка 15% на заказ",
        "code": "СФ15",
        "discount": "15%",
        "description": "Скидка -15% на корма, игрушки и аксессуары с промокодом. Промокод не суммируется с другими акциями и не действует на антипаразитарные препараты. Примените промокод в корзине при оформлении заказа. Акция действует на первый заказ.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2026-02-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-35185",
        "title": "10% скидка за любой заказ на бренд кормов",
        "code": "",
        "discount": "10%",
        "description": "10% скидка за любой заказ на бренд кормов",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2025-12-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-36507",
        "title": "Скидка 5% на первые 3 заказа по промокоду",
        "code": "",
        "discount": "5%",
        "description": "Скидка действует только для авторизованных клиентов на первые 3 заказа. В акции участвует выделенный ассортимент. Магазин оставляет за собой право досрочного завершения акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2026-01-26",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-36614",
        "title": "-15% на корма, игрушки и аксессуары с промокодом",
        "code": "",
        "discount": "15%",
        "description": "Скидка -15% на корма, игрушки и аксессуары с промокодом. Промокод не суммируется с другими акциями и не действует на антипаразитарные препараты. Примените промокод в корзине при оформлении заказа. Акция действует на первый заказ.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2026-02-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      },
      {
        "id": "20-37275",
        "title": "Биохакерская новинка для эффективного долголетия питомцев",
        "code": "",
        "discount": "Акция",
        "description": "Биохакерская новинка для эффективного долголетия питомцев. В акции участвует выделенный ассортимент. Магазин оставляет за собой право досрочного завершения акции.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=20&a=79",
        "isActive": true,
        "createdAt": "2026-03-02",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img6400527cb6473.png"
      }
    ]
  },
  {
    "id": "19",
    "name": "БЕТХОВЕН",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png",
    "description": "Девиз компании «Бетховен» : «Заходи сам, приводи хозяина!». Это значит, что в любом из магазинов «Бетховен» будут рады не только покупателю, но и его питомцу. В ассортименте интернет - магазина представлены товары по сле",
    "promocodesCount": 11,
    "category": "Товары для животных",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "19-115364",
        "title": "Скидка 20% на заказ",
        "code": "NDCMRT1SU",
        "discount": "20%",
        "description": "Скидка 20% на заказ товаров собственной торговой марки от 1500 рублей (суммарная скидка не должна превышать 20%), бренды: DUKE'S FARM, MORE, TUNDRA, PRO CAT, PRO DOG, СЧАСТЛИВЫЙ ГУРМАН, HAPPY FRIEND, ОБЖОРКА, CATSBY, FOXIE",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2025-03-31",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-129785",
        "title": "Скидка 15% на заказ",
        "code": "SALE15",
        "discount": "15%",
        "description": "Скидка 15% на заказ от 5000 рублей. Скидка не распространяется на товары торговых марок CESAR, FELIX, FRISKIES, CHAPPI, KITEKAT, NATURE'S TABLE, PURINA ONE, PEDIGREE, PERFECT FIT, SHEBA, WHISKAS, MAGNET AND STEEL, CATSAN, БАРСИК, 3ООНИК, ГУРМЭ, Pro Plan. Бонусы за покупку товаров по акции не начисляются. Сумма покупки добавляется в накопления на бонусную карту. Скидка не суммируется с другими акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-01-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-129786",
        "title": "Скидка 10% на заказ",
        "code": "SALE10",
        "discount": "10%",
        "description": "Скидка 10% на заказ от 1500 рублей. Скидка не распространяется на товары торговых марок CESAR, FELIX, FRISKIES, CHAPPI, KITEKAT, NATURE'S TABLE, PURINA ONE, PEDIGREE, PERFECT FIT, SHEBA, WHISKAS, MAGNET AND STEEL, CATSAN, БАРСИК, 3ООНИК, ГУРМЭ, Pro Plan. Бонусы за покупку товаров по акции не начисляются. Сумма покупки добавляется в накопления на бонусную карту. Скидка не суммируется с другими акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-01-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-31301",
        "title": "Скидка 20% на заказ от 1500 руб.",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на заказ товаров собственной торговой марки от 1500 рублей (суммарная скидка не должна превышать 20%), бренды: DUKE'S FARM, MORE, TUNDRA, PRO CAT, PRO DOG, СЧАСТЛИВЫЙ ГУРМАН, HAPPY FRIEND, ОБЖОРКА, CATSBY, FOXIE",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2025-03-31",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-35349",
        "title": "CHOMPER -85% на игрушки для кошек",
        "code": "",
        "discount": "85%",
        "description": "Порадуйте своего питомца увлекательными и безопасными игрушками по рекордно низкой цене.",
        "expiryDate": "2026-06-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2025-12-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-35348",
        "title": "CHOMPER -80% на игрушки для собак",
        "code": "",
        "discount": "80%",
        "description": "Подарите питомцу радость игры с выгодой — прочные и безопасные игрушки теперь доступны по суперцене.",
        "expiryDate": "2026-06-29",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2025-12-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-36539",
        "title": "Скидка 10% на заказ от 1500 руб.",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на заказ от 1500 рублей. Скидка не распространяется на товары торговых марок CESAR, FELIX, FRISKIES, CHAPPI, KITEKAT, NATURE'S TABLE, PURINA ONE, PEDIGREE, PERFECT FIT, SHEBA, WHISKAS, MAGNET AND STEEL, CATSAN, БАРСИК, 3ООНИК, ГУРМЭ, Pro Plan. Бонусы за покупку товаров по акции не начисляются. Сумма покупки добавляется в накопления на бонусную карту. Скидка не суммируется с другими акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-01-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-36538",
        "title": "Скидка 15% на заказ от 5000 руб.",
        "code": "",
        "discount": "15%",
        "description": "Скидка 15% на заказ от 5000 рублей. Скидка не распространяется на товары торговых марок CESAR, FELIX, FRISKIES, CHAPPI, KITEKAT, NATURE'S TABLE, PURINA ONE, PEDIGREE, PERFECT FIT, SHEBA, WHISKAS, MAGNET AND STEEL, CATSAN, БАРСИК, 3ООНИК, ГУРМЭ, Pro Plan. Бонусы за покупку товаров по акции не начисляются. Сумма покупки добавляется в накопления на бонусную карту. Скидка не суммируется с другими акциями.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-01-28",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-36697",
        "title": "FOXIE до -40% на мягкие места для животных",
        "code": "",
        "discount": "40%",
        "description": "FOXIE: Комфорт для любимца по специальной цене. Скидки до 40% на лежаки и домики. Забота проявляется в деталях. Создайте для своего питомца идеальное место для сна и отдыха из коллекции FOXIE.",
        "expiryDate": "2026-06-26",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-02-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-37315",
        "title": "Скидки до 50% на препараты от клещей, блох и гельминтов",
        "code": "",
        "discount": "50%",
        "description": "Клещи, блохи, глисты — больше не страшно. Лучшие препараты по лучшим ценам.",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      },
      {
        "id": "19-37905",
        "title": "Cкидка 350 руб. на заказ от 2500 руб.",
        "code": "",
        "discount": "350₽",
        "description": "Скидка 350 руб от 2500 на все товары, кроме на товары торговых марок CESAR, FELIX, FRISKIES, CHAPPI, KITEKAT, NATURE'S TABLE, PURINA ONE, PEDIGREE, PERFECT FIT, SHEBA, WHISKAS, MAGNET AND STEEL, CATSAN, БАРСИК, 3ООНИК, ГУРМЭ, Pro Plan. Не будет суммироваться с другими скидками и акциями",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=19&a=79",
        "isActive": true,
        "createdAt": "2026-04-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img69298a6acb785.png"
      }
    ]
  },
  {
    "id": "18",
    "name": "LEVEL KITCHEN",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png",
    "description": "Level Kitchen — лидер рынка по производству и доставке готовых рационов полезного питания. Меню разработано шеф-поваром совместно с командой диетологов. Главная цель сервиса — приготовление вкусной и полезной пищи с расч",
    "promocodesCount": 19,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "18-123219",
        "title": "Скидка 1400 руб. на заказ",
        "code": "AdvLK",
        "discount": "1400₽",
        "description": "Скидка 1400 рублей на первый заказ полезного и вкусного питания от 5 дней. Попробуйте сбалансированное питание с выгодой — заботьтесь о здоровье без лишних затрат.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-131707",
        "title": "Скидка 10% на заказ",
        "code": "СТАРТ",
        "discount": "10%",
        "description": "Скидка 10% для новых пользователей на все программы, кроме программы wеlcome.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-131706",
        "title": "Скидка 1200 руб. на заказ",
        "code": "ПРО1200",
        "discount": "1200₽",
        "description": "1200 рублей скидка на первый заказ нового меню ПРО с повышенным содержанием белка и клетчатки для вашего результата. От 5 дней. Москва и МО.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-131705",
        "title": "Скидка 35% на заказ",
        "code": "LK35",
        "discount": "35%",
        "description": "Скидка 35%! Пробное меню за 2275 руб. Для новых пользователей.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-131704",
        "title": "Скидка 500 руб. на заказ",
        "code": "ПОВТОРИМ",
        "discount": "500₽",
        "description": "Скидка 500 рублей на все программы для постоянных клиентов. При заказе от 5 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-132540",
        "title": "Скидка до 26%",
        "code": "ЦЕЛЬ",
        "discount": "26%",
        "description": "Первый заказ 6 дней программы ПРО всего за 8900 руб по промокоду. Рацион с повышенным содержанием белка по очень выгодной цене. Только для новых клиентов.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-34650",
        "title": "Скидка ​1400 руб. на первый заказ от 5 дней (о)",
        "code": "",
        "discount": "1400₽",
        "description": "Скидка 1400 рублей на первый заказ полезного и вкусного питания от 5 дней. Попробуйте сбалансированное питание с выгодой — заботьтесь о здоровье без лишних затрат.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-34765",
        "title": "2 дня в подарок к первому заказу или скидка 400 руб. на повторный",
        "code": "",
        "discount": "400₽",
        "description": "2 дня в подарок к первому заказу на 6 дней или 400 рублей скидка на повторный заказ. На все программы. Только в Москве и Санкт-Петербурге.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2025-11-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37326",
        "title": "Скидка 10% на первый заказ!",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% для новых пользователей на все программы, кроме программы wеlcome.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37321",
        "title": "Скидка 35%",
        "code": "",
        "discount": "35%",
        "description": "Скидка 35%! Пробное меню за 2275 руб. Для новых пользователей.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37322",
        "title": "Купите сейчас - оплатите долями",
        "code": "",
        "discount": "Акция",
        "description": "Купите сейчас - оплатите долями. Меню 30 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37324",
        "title": "Пригласите друга и получите 2500 бонусов на счет",
        "code": "",
        "discount": "Акция",
        "description": "Получите 2500 бонусов за приведенного друга после совершение им 1 заказа.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37325",
        "title": "Кешбэк 3% по программе лояльности",
        "code": "",
        "discount": "3%",
        "description": "Кешбэк 3% от вашего заказа по программе лояльности, которым можно оплатить до 50% стоимости заказа.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37320",
        "title": "Скидка 500 рублей на все программы для постоянных клиентов",
        "code": "",
        "discount": "500₽",
        "description": "Скидка 500 рублей на все программы для постоянных клиентов. При заказе от 5 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37323",
        "title": "​1200 рублей скидка на первый заказ нового меню ПРО",
        "code": "",
        "discount": "1200₽",
        "description": "1200 рублей скидка на первый заказ нового меню ПРО с повышенным содержанием белка и клетчатки для вашего результата. От 5 дней. Москва и МО.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37463",
        "title": "Питайся правильно вместе с LK",
        "code": "",
        "discount": "Акция",
        "description": "Питайся правильно вместе с LevelKitchen",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37683",
        "title": "Скидка 20% в моб. приложении",
        "code": "",
        "discount": "20%",
        "description": "Скидка 20% на первый заказ! На все программы питания! Только для новых пользователей в мобильном приложении.Макс. сумма скидки не ограничена. Мин. суммы заказа нет.",
        "expiryDate": "2026-08-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37906",
        "title": "Скидка до 35% на все программы",
        "code": "",
        "discount": "35%",
        "description": "До -35% скидки на все программы. Чем дольше программа, тем больше скидка.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      },
      {
        "id": "18-37914",
        "title": "Скидка до 26%",
        "code": "",
        "discount": "26%",
        "description": "Первый заказ 6 дней программы ПРО всего за 8900 руб по промокоду. Рацион с повышенным содержанием белка по очень выгодной цене. Только для новых клиентов.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=18&a=79",
        "isActive": true,
        "createdAt": "2026-03-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64005016a61ff.png"
      }
    ]
  },
  {
    "id": "16",
    "name": "TEFAL",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png",
    "description": "Tefal - международная торговая марка бытовых приборов и посуды, существующая на рынке более 70 лет. Компания предоставляет инновационную, удобную и высоко-технологичную продукцию для домашнего быта, включая посуду, кухон",
    "promocodesCount": 6,
    "category": "Дом",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "16-134413",
        "title": "Скидка 10% на заказ",
        "code": "AF_fixpromo",
        "discount": "10%",
        "description": "Скидка 10% Для всех пользователей. Без ограничений на количество покупок. Не суммируется с другими акциями. Действует на все товары.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=16&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png"
      },
      {
        "id": "16-134552",
        "title": "Скидки до 60% по промокоду",
        "code": "ЛЕТО26",
        "discount": "60%",
        "description": "Скидка по промокоду суммируется с ценой, указанной на сайте, и действует только на товары с акционной страницы. Скидка не суммируется с другими акциями, баллами программы лояльности и товарами с финальной ценой.Акция действует до 28 мая включительно.",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=16&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png"
      },
      {
        "id": "16-30096",
        "title": "Набор посуды Tefal ingenio в подарок",
        "code": "",
        "discount": "Акция",
        "description": "паровая система Tefal Care For You и набор посуды Tefal Ingenio в подарок!На товары с финальной ценой не применяются баллы программы лояльности и промокоды. Акция действительна, пока подарок есть в наличии.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=16&a=79",
        "isActive": true,
        "createdAt": "2025-03-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png"
      },
      {
        "id": "16-30094",
        "title": "набор посуды Tefal Ingenio Emotions из 5 предметов в подарок",
        "code": "",
        "discount": "Акция",
        "description": "При покупке кофемашины Krups набор посуды Tefal Ingenio Emotions из 5 предметов в подарок! Баллы программы лояльности и промокоды не применяются.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=16&a=79",
        "isActive": true,
        "createdAt": "2025-03-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png"
      },
      {
        "id": "16-38847",
        "title": "Скидка 10%",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10%Для всех пользователей.Без ограничений на количество покупок. Не суммируется с другими акциями.Действует на все товары.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=16&a=79",
        "isActive": true,
        "createdAt": "2026-05-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png"
      },
      {
        "id": "16-39037",
        "title": "Скидки до 60% по промокоду",
        "code": "",
        "discount": "60%",
        "description": "Скидка по промокоду суммируется с ценой, указанной на сайте, и действует только на товары с акционной страницы.Скидка не суммируется с другими акциями, баллами программы лояльности и товарами с финальной ценой.Акция действует до 28 мая включительно.",
        "expiryDate": "2026-05-28",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=16&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004d4e7c647.png"
      }
    ]
  },
  {
    "id": "15",
    "name": "MY FOOD",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png",
    "description": "My Food – готовые рационы питания на каждый день по подписке. Две линейки на выбор: Classic — классика домашней кухни; Travel —полноценный тур по уникальным и мировым блюдам. От 440 руб./день. Присутствуем в 13 городах: ",
    "promocodesCount": 13,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "15-123203",
        "title": "Скидка 11% на заказ",
        "code": "AdvMF",
        "discount": "11%",
        "description": "Скидка 11% на первый заказ программы ПРОСТО. Попробуйте сбалансированное питание с выгодой — завтраки, обеды и ужины теперь еще доступнее.",
        "expiryDate": "2026-06-30",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-131710",
        "title": "Скидка ЛАЙТ и ПРОСТО",
        "code": "СТАРТ",
        "discount": "20%",
        "description": "20% скидка на программу ЛАЙТ на первый заказ. 10% скидка на линейку ПРОСТО на первый заказ. Попробуйте и потом не остановитесь!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-131709",
        "title": "Программа ПРОСТО за 2990 руб.",
        "code": "ХОЧУ",
        "discount": "2990₽",
        "description": "Программа ПРОСТО 3 блюда на 6 дней всего за 2990 руб. Только для новых клиентов.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-131708",
        "title": "Скидка 300 руб. на заказ",
        "code": "ПОВТОРИМ",
        "discount": "300₽",
        "description": "Скидка 300 рублей на программу ЛАЙТ для постоянных клиентов. На меню от 5 дней. и скидка 300 рублей на программу ПРОСТО для постоянных клиентов. На меню от 6 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-34645",
        "title": "Скидка 11% на первый заказ программы ПРОСТО",
        "code": "",
        "discount": "11%",
        "description": "Скидка 11% на первый заказ программы ПРОСТО. Попробуйте сбалансированное питание с выгодой — завтраки, обеды и ужины теперь еще доступнее.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2025-11-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-34764",
        "title": "Скидка 13% на первый заказ или 400 рублей на повторный",
        "code": "",
        "discount": "13%",
        "description": "13% скидка на первый заказ программы ПРОСТО от 6 дней или 400 рублей скидка на повторный заказ от 6 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2025-11-10",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37330",
        "title": "Купите сейчас - оплатите долями",
        "code": "",
        "discount": "Акция",
        "description": "Купите сейчас - оплатите долями. Меню 30 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37332",
        "title": "Бесплатная доставка в 25+ городов",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Осуществляем бесплатную доставку в 25+ городах.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37329",
        "title": "Скидка на программу ЛАЙТ",
        "code": "",
        "discount": "20%",
        "description": "20% скидка на программу ЛАЙТ на первый заказ. Попробуйте и потом не остановитесь!",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37328",
        "title": "Программа ПРОСТО 3 блюда на 6 дней всего за 2990 руб.",
        "code": "",
        "discount": "2990₽",
        "description": "Программа ПРОСТО 3 блюда на 6 дней всего за 2990 руб. Только для новых клиентов.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37333",
        "title": "Получайте от 3% за заказ в виде бонусов в личном кабинете",
        "code": "",
        "discount": "3%",
        "description": "За каждый заказ вам будут начислены бонусы от 3% от суммы заказа. Бонусами можно оплатить до 50% от суммы заказа, кроме рациона ПРОСТО.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37327",
        "title": "​Скидка 300 рублей на программы ЛАЙТ и ПРОСТО",
        "code": "",
        "discount": "300₽",
        "description": "Скидка 300 рублей на программу ЛАЙТ для постоянных клиентов. На меню от 5 дней. и скидка 300 рублей на программу ПРОСТО для постоянных клиентов. На меню от 6 дней.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      },
      {
        "id": "15-37545",
        "title": "Линейка ПРОСТО",
        "code": "",
        "discount": "19990₽",
        "description": "Линейка ПРОСТО. Месяц еды от 19990 руб. Сытное и вкусное меню, чтобы не готовить.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=15&a=79",
        "isActive": true,
        "createdAt": "2026-03-13",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img64004bd45c8f9.png"
      }
    ]
  },
  {
    "id": "12",
    "name": "BIBLIOTEKA AROMATOV",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png",
    "description": "БИБЛИОТЕКА АРОМАТОВ — онлайн-магазин необычной парфюмерии. Ароматы Demeter завезены из Нью-Йорка, а собственный российский бренд выпускает ароматы для дома (свечи, диффузоры и рум-спреи), и продукты ухода за собой (гели ",
    "promocodesCount": 11,
    "category": "Здоровье и красота",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "12-130366",
        "title": "Скидка 30% на заказ",
        "code": "ДВА",
        "discount": "30%",
        "description": "При покупке одеколона Demeter 30 мл — одеколон biblioteka aromatov или Demeter со скидкой 30%. При покупке одеколона biblioteka aromatov 30 мл — второй от biblioteka aromatov со скидкой 30%. В фирменных магазинах Москвы и Петербурга: 1) Выберите 2 одеколона 30 мл. 2) Назовите консультанту слово «ДВА» 3) Оплатите 1 одеколон и получите скидку на второй 30%! Максимальное количество одеколонов в подарок со скидкой 30% - пять штук (при добавлении в корзину пяти флаконов). Предложение не суммируется с другими скидками и подарками. Не действует на товары из раздела Распродажа. Количество товаров ограничено, только определенный ассортимент.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-134285",
        "title": "3=4 при заказе от 6000 ₽ - только для постоянных клиентов по персональному промокоду",
        "code": "FOURGIFT",
        "discount": "6000₽",
        "description": "Только на повторную покупку клиенту приходит на почту эксклюзивный промокод FOURGIFT на продукт за 1 ₽ при покупке минимум четырёх продуктов на сумму от 6000 ₽!Промокод появится в корзине после первого заказа, а также отобразится в личном кабинете в разделе «Промокоды». При этом у первого заказа должен быть статус «Выполнен». Проверить статус вы можете также в личном кабинете. Чтобы воспользоваться подарком, перейдите в корзину, блок «Промокоды», и примените код. Если вы уже делали первый заказ, проверьте доступность промокода в корзине или личном кабинете.Только на повторную покупку клиенту приходит на почту эксклюзивный промокод FOURGIFT на продукт за 1 ₽ при покупке минимум четырёх продуктов на сумму от 6000 ₽! Промокод появится в корзине после первого заказа, а также отобразится в личном кабинете в разделе «Промокоды». При этом у первого заказа должен быть статус «Выполнен». Проверить статус вы можете также в личном кабинете. Чтобы воспользоваться подарком, перейдите в корзину, блок «Промокоды», и примените код.Если вы уже делали первый заказ, проверьте доступность промокода в корзине или личном кабинете.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-134332",
        "title": "Дарим «5 хитов Demeter» за первый заказ от 3 000 ₽! Введите промокод в корзине.",
        "code": "AROMA26",
        "discount": "000₽",
        "description": "Дарим «5 хитов Demeter» за первый заказ от 3 000 ₽! Введите промокод в корзине.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-37183",
        "title": "Гид по подаркам",
        "code": "",
        "discount": "Акция",
        "description": "Пройдите короткий тест, чтобы:- Найти в подарок то, что нужно- Удивить и порадовать- Сэкономить время",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-31955",
        "title": "Бесплатная доставка",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Бесплатная доставка или скидка на доставку до пунктов выдачи:1. Соберите корзину на сумму от 2500 ₽;2. При оформлении заказа выберите доставку до одного из пунктов выдачи: 5Post, Яндекс Доставка, Магнит Пост или СДЭК;3. Доставка будет для вас полностью бесплатной!Бесплатная доставка или скидка на доставку курьером при заказе от 4500 ₽:1. Соберите корзину на сумму от 4500 ₽.2. При оформлении заказа выберите одну из доставок курьером: Logsis, Интеграл, Яндекс Доставка или СДЭК;3. Доставка будет для вас со скидкой 450 ₽ или бесплатной!",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-37182",
        "title": "Предзаказ - экономия 10%",
        "code": "",
        "discount": "10%",
        "description": "Экономия 10% от стоимости новинки или бестселлера просто за то, что вы сделали заказ заранее. Не нужно следить за обновлениями и наличием – желаемый товар уже зарезервирован для вас. Гарантированная отправка в указанные сроки: ваш заказ будет отправлен сразу, как только поступит на склад, еще до появления на сайте. Оформите предзаказ сегодня и наслаждайтесь покупкой без стресса и предпраздничной суеты.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-38291",
        "title": "Больше заказ – больше выбор подарков!",
        "code": "",
        "discount": "3000₽",
        "description": "Чем выше сумма заказа, тем больше подарков на выбор!Получайте подарки за сумму заказа:- От 3000 ₽ - масляные духи 3 мл;- От 5000 ₽ - эксклюзивная свеча 50 г;- От 7000 ₽ - набор пробников из 5 ароматов;- От 10000 ₽ - свеча 90 г.Добавьте в корзину любые продукты на необходимую сумму. Подарок появится в корзине автоматически над вашим списком покупок! Выберите желаемый формат подарка и его ароматЗнакомьтесь с новыми ароматами, пополняйте коллекцию и создавайте собственные парфюмерные шедевры, смешивая их между собой.Не суммируется с другими подарками и акциями. Количество подарков ограничено. Сумма покупки учитывается после применения всех скидок (по промокоду и иные скидки).",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-36680",
        "title": "-30% на второй одеколон",
        "code": "",
        "discount": "30%",
        "description": "При покупке одеколона Demeter 30 мл — одеколон biblioteka aromatov или Demeter со скидкой 30%.При покупке одеколона biblioteka aromatov 30 мл — второй от biblioteka aromatov со скидкой 30%.1. Добавьте в корзину один одеколон 30 мл. Выберите понравившийся аромат одного из брендов: biblioteka aromatov 30 мл или Demeter 30 мл.2. Введите промокод. Скопируйте код ДВА и добавьте его в поле «Промокод» в корзине.3. Получите второй одеколон со скидкой –30%. После ввода промокода второй одеколон автоматически появится в корзине. Выберите его аромат из предложенного списка.Максимальное количество одеколонов в подарок со скидкой 30% - пять штук (при добавлении в корзину пяти флаконов). Предложение не суммируется с другими скидками и подарками. Не действует на товары из раздела Распродажа. Количество товаров ограничено, только определенный ассортимент.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-38608",
        "title": "3=4 при заказе от 6000 ₽ - только для постоянных клиентов по персональному промокоду",
        "code": "",
        "discount": "6000₽",
        "description": "Только на повторную покупку клиенту приходит на почту эксклюзивный промокод FOURGIFT на продукт за 1 ₽ при покупке минимум четырёх продуктов на сумму от 6000 ₽!Промокод появится в корзине после первого заказа, а также отобразится в личном кабинете в разделе «Промокоды». При этом у первого заказа должен быть статус «Выполнен». Проверить статус вы можете также в личном кабинете. Чтобы воспользоваться подарком, перейдите в корзину, блок «Промокоды», и примените код.Если вы уже делали первый заказ, проверьте доступность промокода в корзине или личном кабинете.Только на повторную покупку клиенту приходит на почту эксклюзивный промокод FOURGIFT на продукт за 1 ₽ при покупке минимум четырёх продуктов на сумму от 6000 ₽!Промокод появится в корзине после первого заказа, а также отобразится в личном кабинете в разделе «Промокоды». При этом у первого заказа должен быть статус «Выполнен». Проверить статус вы можете также в личном кабинете. Чтобы воспользоваться подарком, перейдите в корзину, блок «Промокоды», и примените код.Если вы уже делали первый заказ, проверьте доступность промокода в корзине или личном кабинете.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-36681",
        "title": "Получите 2 семпла в подарок!",
        "code": "",
        "discount": "1500₽",
        "description": "Чтобы принять участие в акции на сайте:1. Зарегистрируйтесь.Пройдите регистрацию и подтвердите её по электронной почте.2. Получите письмо с промокодомНа вашу почту придёт письмо «Ваш подарок: 2 мини-аромата!». Если письмо не пришло, проверьте папки «Спам» или «Промоакции».3. Добавьте в корзину товары на сумму от 1500 ₽Это могут быть любые продукты из ассортимента, кроме семплов и сертификатов. Стоимость доставки в итоговой сумме корзины не учитывается.4. Примените промокод5. Чтобы использовать промокод, вы можете перейти по ссылке из письма на сайт и он автоматически сработает в корзине. Вы также можете скопировать его из письма и добавить в поле «Промокод» в корзине.Ароматы семплов фиксированные, количество подарков ограничено. Не суммируется с другими скидками и подарками. Срок действия промокода — 3 дня. Компания оставляет за собой право изменять сроки и правила проведения акции в одностороннем порядке.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-04-30",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      },
      {
        "id": "12-38798",
        "title": "Дарим «5 хитов Demeter» за первый заказ от 3 000 ₽! Введите промокод в корзине.",
        "code": "",
        "discount": "000₽",
        "description": "Дарим «5 хитов Demeter» за первый заказ от 3 000 ₽! Введите промокод в корзине.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=12&a=79",
        "isActive": true,
        "createdAt": "2026-05-05",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff168bb296a.png"
      }
    ]
  },
  {
    "id": "9",
    "name": "SHOPPINGLIVE",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png",
    "description": "Shopping Live — это интернет- и телемагазин, входящий в европейский холдинг HSE24 Group. На Shopping Live представлены те же товары, что и в телемагазинах HSE24 в Германии, Австрии, Италии, Швейцарии. Shopping Live полно",
    "promocodesCount": 12,
    "category": "Дом",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "9-134189",
        "title": "Скидка 500 руб. на заказ от 3999 руб.",
        "code": "ШОПИНГЛАЙВ-500М",
        "discount": "500₽",
        "description": "Новым клиентам скидка на первый заказ 500 руб. от 3 999 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-134190",
        "title": "Скидка 20% на заказ",
        "code": "ШОПИНГЛАЙВ-20М",
        "discount": "20%",
        "description": "Новым клиентам скидка на первый заказ 20% от 7 999 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-30282",
        "title": "Косметика из Германии. Скидки до 47%. Подарите вашей коже лучший уход.",
        "code": "",
        "discount": "47%",
        "description": "Косметика из Германии. Скидки до 47%. Подарите вашей коже лучший уход.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2025-04-04",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-30338",
        "title": "Блестящее настроение. Скидки на украшения от 50% до 75%",
        "code": "",
        "discount": "50%",
        "description": "Блестящее настроение. Скидки на украшения от 50% до 75%",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2025-04-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-30337",
        "title": "Модная распродажа. Cкидки до 90%",
        "code": "",
        "discount": "90%",
        "description": "Модная распродажа. Cкидки до 90%",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2025-04-08",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-35590",
        "title": "Скидки до 80%",
        "code": "",
        "discount": "80%",
        "description": "Любимые бренды по сказочным ценам. Скидки до 80%. Только на Shopping Live.",
        "expiryDate": "2026-06-30",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2025-12-09",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-37148",
        "title": "Бесплатная доставка от 2999 руб. при оплате на сайте картой или СБП",
        "code": "",
        "discount": "Бесплатная доставка",
        "description": "Бесплатная доставка при оплате онлайн! Закажите на Shopping Live от 2999 ₽, оплатите картой или СБП на сайте - и доставка в подарок. Выбирайте и экономьте.",
        "expiryDate": "2026-12-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-02-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-37343",
        "title": "Скидки до 80%. Встречаем весну с любимыми брендами",
        "code": "",
        "discount": "80%",
        "description": "Встречаем весну с любимыми брендами: мода, красота, дом, подарки — всё для вас и ваших близких.",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-03-03",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-37769",
        "title": "Стиль вне времени. Новая коллекция на Shopping Live",
        "code": "",
        "discount": "Акция",
        "description": "GLENFIELD: стиль вне времени. Новая коллекция на Shopping Live",
        "expiryDate": "2026-06-01",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-03-24",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-38521",
        "title": "Скидка 500 руб. от 3999 руб. на первый заказ",
        "code": "",
        "discount": "500₽",
        "description": "Новым клиентам скидка на первый заказ 500 руб. от 3 999 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-38522",
        "title": "Скидка 20% от 7999 руб. на первый заказ",
        "code": "",
        "discount": "20%",
        "description": "Новым клиентам скидка на первый заказ 20% от 7 999 руб.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-05-01",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      },
      {
        "id": "9-39041",
        "title": "КИБЕРПОНЕДЕЛЬНИК на сайте Shopping Live – суперскидки на товары всех категорий",
        "code": "",
        "discount": "90%",
        "description": "КИБЕРПОНЕДЕЛЬНИК на сайте Shopping Live – суперскидки до 90% на товары всех категорий",
        "expiryDate": "2026-05-25",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=9&a=79",
        "isActive": true,
        "createdAt": "2026-05-18",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff07f46448b.png"
      }
    ]
  },
  {
    "id": "7",
    "name": "Издательство Манн, Иванов и Фербер",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff00f591cbc.png",
    "description": "Издательство МИФ воплощает самые вдохновляющие идеи. С 2005 года выпускает полезные книги по саморазвитию, творчеству, бизнесу и маркетингу, ЗОЖу, и расширяющие кругозор, а также крутые книги для детей и родителей. Преим",
    "promocodesCount": 3,
    "category": "Книги",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": [
      {
        "id": "7-119063",
        "title": "Скидка 10% на заказ",
        "code": "advcake",
        "discount": "10%",
        "description": "Скидка 10% на заказ, но не более 50% в сумме.",
        "expiryDate": "2026-05-31",
        "isExclusive": true,
        "partnerUrl": "https://tspirittr.com/click?o=7&a=79",
        "isActive": true,
        "createdAt": "2025-08-06",
        "isTopDeal": true,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff00f591cbc.png"
      },
      {
        "id": "7-32873",
        "title": "Скидка 10% на заказ",
        "code": "",
        "discount": "10%",
        "description": "Скидка 10% на заказ на сайте mann-ivanov-ferber.ru, но не более 50% в сумме.",
        "expiryDate": "2026-05-31",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=7&a=79",
        "isActive": true,
        "createdAt": "2025-08-06",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff00f591cbc.png"
      },
      {
        "id": "7-39048",
        "title": "Скидка 30% на заказ",
        "code": "",
        "discount": "30%",
        "description": "— скидка 30% на все книги для зарегистрированных пользователей (за исключением книг, на которые установлена фиксированная акционная цена, и книг, не участвующих в акции)— фиксированная акционная цена установлена на книги из подборки.Количество книг, участвующих в акции, ограничено. Издательство вправе менять список акционных товаров по фиксированным ценам и цены на эти товары.В акции не участвуют книжные боксы «Как поймать монстра», «Подарок книголюбу», книги: «Снежная королева», «Свобода в квадрате», «Игра для двоих».",
        "expiryDate": "2026-05-24",
        "isExclusive": false,
        "partnerUrl": "https://tspirittr.com/click?o=7&a=79",
        "isActive": true,
        "createdAt": "2026-05-19",
        "isTopDeal": false,
        "image": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63ff00f591cbc.png"
      }
    ]
  },
  {
    "id": "4",
    "name": "INTERNETOPROS",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63edd19123377.png",
    "description": "Исследовательский проект InternetOpros.ru — онлайн-платформа, которая дает возможность пользователям зарегистрироваться и высказывать свое мнение. Преимущества для покупателей : Бесплатная регистрация. Участие в интересн",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": false,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  },
  {
    "id": "2",
    "name": "DHGATE",
    "logo": "https://s3.eu-central-1.amazonaws.com/storage.scaleo.io/offers/img63edd28f1a01f.png",
    "description": "DHgate - крупнейшая трансграничная торговая платформа B2B в Китае Более 30 миллионов товаров и 50 тысяч товарных обновлений ежедневно. DHGate представляет товары самого разного ассортимента и качества по очень низким цен",
    "promocodesCount": 0,
    "category": "Другое",
    "subcategory": "",
    "rating": 0,
    "isPopular": true,
    "isActive": true,
    "createdAt": "2026-05-22T15:44:29.033Z",
    "promos": []
  }
];
